/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "https://buffettisiteassets.blob.core.windows.net/buffetti-assets2025/consulenza/20260609/dist/assets/frontend/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/*!****************************!*\
  !*** ./Scripts/vendors.js ***!
  \****************************/
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	__webpack_require__(/*! jquery */ 8); // jquery
	__webpack_require__(/*! imports!common/support-old-jquery */ 1541);
	__webpack_require__(/*! imports!bootstrap/js/button */ 1542); // bootstrap/js/button
	__webpack_require__(/*! imports!bootstrap/js/transition */ 1547); // bootstrap/js/transition
	__webpack_require__(/*! imports!bootstrap/js/collapse */ 1543); // bootstrap/js/collapse
	__webpack_require__(/*! imports!bootstrap/js/dropdown */ 1544); // bootstrap/js/dropdown
	__webpack_require__(/*! imports!bootstrap/js/tab */ 1546); // bootstrap/js/tab
	__webpack_require__(/*! imports!bootstrap/js/modal */ 1545); // bootstrap/js/modal
	__webpack_require__(/*! guillotine */ 1530); // guillotine
	// require('swfobject'); // swfobject
	__webpack_require__(/*! js-cookie */ 93); // js-cookie
	// external dependencies not installed with npm
	__webpack_require__(/*! imports!./vendor/jqueryvalidate/jquery.validate-1.11.1.js */ 513); // jquery.validate v1.11.1
	__webpack_require__(/*! imports!./vendor/jqueryvalidate/jquery.validate.unobtrusive.js */ 1539); // jquery.validate vX.X.X
	__webpack_require__(/*! imports!./vendor/jqueryajax/jquery.unobtrusive-ajax.js */ 1537); // jquery.unobtrusive-ajax vX.X.X
	__webpack_require__(/*! imports!./vendor/jquerydotdotdot/jquery.dotdotdot.js */ 1538); // jquery.dotdotdot v1.7.4
	__webpack_require__(/*! imports!./vendor/isOnScreen/jquery.isonscreen.js */ 1536);
	__webpack_require__(/*! imports!./vendor/babel-polyfill/polyfill.js */ 1535);
	__webpack_require__(/*! imports!flexslider */ 1548); // flexslider v2.5.0
	// require('imports!jquery-mousewheel');
	// custom libs
	__webpack_require__(/*! imports!common/jquery.validate.directio.js */ 1540)(); // jquery.validate.directio

/***/ }),

/***/ 8:
/*!*************************!*\
  !*** external "jQuery" ***!
  \*************************/
/***/ (function(module, exports) {

	module.exports = jQuery;

/***/ }),

/***/ 1540:
/*!****************************************************************************!*\
  !*** ./~/imports-loader!./Scripts/libs/common/jquery.validate.directio.js ***!
  \****************************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	'use strict';
	
	var _jquery = __webpack_require__(/*! jquery */ 8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	__webpack_require__(/*! imports!jqueryvalidate/jquery.validate-1.11.1.js */ 513);
	
	function addDateValidation() {
		// CHECKBOX must be true
		_jquery2.default.validator.addMethod('required_group', function (value, element) {
			// var $module = $(element).parents('form');
			// recupero il messaggio impostato nel model tramite l'annotation [required]
			var checkCustomError = (0, _jquery2.default)(element).data('val-required');
			_jquery2.default.validator.messages.required_group = checkCustomError;
			return (0, _jquery2.default)(element).prop('checked');
		}, '');
	
		_jquery2.default.validator.addClassRules('required-checkbox', { required_group: true });
		// /CHECKBOX
	
		// DATE
		var $dateElements = (0, _jquery2.default)('.ui-date-picker');
		if ($dateElements !== undefined && $dateElements.length > 0) {
			// $dateElements.datepicker({dateFormat: 'dd/mm/yy'});
	
			_jquery2.default.validator.addMethod('date', function validateDate(value, element) {
				// console.log('validate date with value:' + value);
				if (this.optional(element)) {
					return true;
				}
				var result = false;
				try {
					_jquery2.default.datepicker.parseDate('dd/mm/yy', value);
					result = true;
				} catch (err) {
					result = false;
				}
				return result;
			}, '');
		}
	
		// /DATE
	
		// DATETIME
		var $datetimeElements = (0, _jquery2.default)('.ui-datetime-picker');
		if ($datetimeElements !== undefined && $datetimeElements.length > 0) {
			// $datetimeElements.datepicker({dateFormat: 'dd-mm-yy'});
			_jquery2.default.validator.addMethod('datetime', function validateDateTime(value, element) {
				if (this.optional(element)) {
					return true;
				}
				var result = false;
				try {
					_jquery2.default.datepicker.parseDate('yy-mm-dd', value);
					result = true;
				} catch (err) {
					result = false;
				}
				return result;
			}, '');
		}
	}
	
	module.exports = addDateValidation;


/***/ }),

/***/ 1541:
/*!**********************************************************************!*\
  !*** ./~/imports-loader!./Scripts/libs/common/support-old-jquery.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	'use strict';
	
	var _jquery = __webpack_require__(/*! jquery */ 8);
	
	var _jquery2 = _interopRequireDefault(_jquery);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// support old jquery feature
	// this feature was used inside jquery.validate.unobtrusive
	_jquery2.default.fn.live = function liveFallback(types, data, fn) {
		(0, _jquery2.default)(this.context).on(types, this.selector, data, fn);
		return this;
	};
	
	// this feature was used inside jquery.validate-1.11.1
	/* eslint-disable prefer-rest-params */
	var oldSelf = _jquery2.default.fn.andSelf || _jquery2.default.fn.addBack;
	_jquery2.default.fn.andSelf = function andSelfFallback() {
		// migrateWarn("jQuery.fn.andSelf() replaced by jQuery.fn.addBack()");
		return oldSelf.apply(this, arguments);
	};
	
	// this feature was used inside jquery validate
	var oldParseJSON = _jquery2.default.parseJSON;
	_jquery2.default.parseJSON = function parseJSONFallback(json) {
		if (!json && json !== null) {
			// migrateWarn("jQuery.parseJSON requires a valid JSON string");
			return null;
		}
		return oldParseJSON.apply(this, arguments);
	};


/***/ }),

/***/ 1535:
/*!**********************************************************************!*\
  !*** ./~/imports-loader!./Scripts/vendor/babel-polyfill/polyfill.js ***!
  \**********************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	var require;var require;/* WEBPACK VAR INJECTION */(function(global, process) {/*** IMPORTS FROM imports-loader ***/
	
	
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	(function e(t, n, r) {
	  function s(o, u) {
	    if (!n[o]) {
	      if (!t[o]) {
	        var a = typeof require == "function" && require;if (!u && a) return require(o, !0);if (i) return i(o, !0);var f = new Error("Cannot find module '" + o + "'");throw f.code = "MODULE_NOT_FOUND", f;
	      }var l = n[o] = { exports: {} };t[o][0].call(l.exports, function (e) {
	        var n = t[o][1][e];return s(n ? n : e);
	      }, l, l.exports, e, t, n, r);
	    }return n[o].exports;
	  }var i = typeof require == "function" && require;for (var o = 0; o < r.length; o++) {
	    s(r[o]);
	  }return s;
	})({ 1: [function (_dereq_, module, exports) {
	    (function (global) {
	      "use strict";
	
	      _dereq_(295);
	
	      _dereq_(296);
	
	      _dereq_(2);
	
	      if (global._babelPolyfill) {
	        throw new Error("only one instance of babel-polyfill is allowed");
	      }
	      global._babelPolyfill = true;
	
	      var DEFINE_PROPERTY = "defineProperty";
	      function define(O, key, value) {
	        O[key] || Object[DEFINE_PROPERTY](O, key, {
	          writable: true,
	          configurable: true,
	          value: value
	        });
	      }
	
	      define(String.prototype, "padLeft", "".padStart);
	      define(String.prototype, "padRight", "".padEnd);
	
	      "pop,reverse,shift,keys,values,entries,indexOf,every,some,forEach,map,filter,find,findIndex,includes,join,slice,concat,push,splice,unshift,sort,lastIndexOf,reduce,reduceRight,copyWithin,fill".split(",").forEach(function (key) {
	        [][key] && define(Array, key, Function.call.bind([][key]));
	      });
	    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	  }, { "2": 2, "295": 295, "296": 296 }], 2: [function (_dereq_, module, exports) {
	    _dereq_(119);
	    module.exports = _dereq_(23).RegExp.escape;
	  }, { "119": 119, "23": 23 }], 3: [function (_dereq_, module, exports) {
	    module.exports = function (it) {
	      if (typeof it != 'function') throw TypeError(it + ' is not a function!');
	      return it;
	    };
	  }, {}], 4: [function (_dereq_, module, exports) {
	    var cof = _dereq_(18);
	    module.exports = function (it, msg) {
	      if (typeof it != 'number' && cof(it) != 'Number') throw TypeError(msg);
	      return +it;
	    };
	  }, { "18": 18 }], 5: [function (_dereq_, module, exports) {
	    // 22.1.3.31 Array.prototype[@@unscopables]
	    var UNSCOPABLES = _dereq_(117)('unscopables'),
	        ArrayProto = Array.prototype;
	    if (ArrayProto[UNSCOPABLES] == undefined) _dereq_(40)(ArrayProto, UNSCOPABLES, {});
	    module.exports = function (key) {
	      ArrayProto[UNSCOPABLES][key] = true;
	    };
	  }, { "117": 117, "40": 40 }], 6: [function (_dereq_, module, exports) {
	    module.exports = function (it, Constructor, name, forbiddenField) {
	      if (!(it instanceof Constructor) || forbiddenField !== undefined && forbiddenField in it) {
	        throw TypeError(name + ': incorrect invocation!');
	      }return it;
	    };
	  }, {}], 7: [function (_dereq_, module, exports) {
	    var isObject = _dereq_(49);
	    module.exports = function (it) {
	      if (!isObject(it)) throw TypeError(it + ' is not an object!');
	      return it;
	    };
	  }, { "49": 49 }], 8: [function (_dereq_, module, exports) {
	    // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	    'use strict';
	
	    var toObject = _dereq_(109),
	        toIndex = _dereq_(105),
	        toLength = _dereq_(108);
	
	    module.exports = [].copyWithin || function copyWithin(target /*= 0*/, start /*= 0, end = @length*/) {
	      var O = toObject(this),
	          len = toLength(O.length),
	          to = toIndex(target, len),
	          from = toIndex(start, len),
	          end = arguments.length > 2 ? arguments[2] : undefined,
	          count = Math.min((end === undefined ? len : toIndex(end, len)) - from, len - to),
	          inc = 1;
	      if (from < to && to < from + count) {
	        inc = -1;
	        from += count - 1;
	        to += count - 1;
	      }
	      while (count-- > 0) {
	        if (from in O) O[to] = O[from];else delete O[to];
	        to += inc;
	        from += inc;
	      }return O;
	    };
	  }, { "105": 105, "108": 108, "109": 109 }], 9: [function (_dereq_, module, exports) {
	    // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	    'use strict';
	
	    var toObject = _dereq_(109),
	        toIndex = _dereq_(105),
	        toLength = _dereq_(108);
	    module.exports = function fill(value /*, start = 0, end = @length */) {
	      var O = toObject(this),
	          length = toLength(O.length),
	          aLen = arguments.length,
	          index = toIndex(aLen > 1 ? arguments[1] : undefined, length),
	          end = aLen > 2 ? arguments[2] : undefined,
	          endPos = end === undefined ? length : toIndex(end, length);
	      while (endPos > index) {
	        O[index++] = value;
	      }return O;
	    };
	  }, { "105": 105, "108": 108, "109": 109 }], 10: [function (_dereq_, module, exports) {
	    var forOf = _dereq_(37);
	
	    module.exports = function (iter, ITERATOR) {
	      var result = [];
	      forOf(iter, false, result.push, result, ITERATOR);
	      return result;
	    };
	  }, { "37": 37 }], 11: [function (_dereq_, module, exports) {
	    // false -> Array#indexOf
	    // true  -> Array#includes
	    var toIObject = _dereq_(107),
	        toLength = _dereq_(108),
	        toIndex = _dereq_(105);
	    module.exports = function (IS_INCLUDES) {
	      return function ($this, el, fromIndex) {
	        var O = toIObject($this),
	            length = toLength(O.length),
	            index = toIndex(fromIndex, length),
	            value;
	        // Array#includes uses SameValueZero equality algorithm
	        if (IS_INCLUDES && el != el) while (length > index) {
	          value = O[index++];
	          if (value != value) return true;
	          // Array#toIndex ignores holes, Array#includes - not
	        } else for (; length > index; index++) {
	          if (IS_INCLUDES || index in O) {
	            if (O[index] === el) return IS_INCLUDES || index || 0;
	          }
	        }return !IS_INCLUDES && -1;
	      };
	    };
	  }, { "105": 105, "107": 107, "108": 108 }], 12: [function (_dereq_, module, exports) {
	    // 0 -> Array#forEach
	    // 1 -> Array#map
	    // 2 -> Array#filter
	    // 3 -> Array#some
	    // 4 -> Array#every
	    // 5 -> Array#find
	    // 6 -> Array#findIndex
	    var ctx = _dereq_(25),
	        IObject = _dereq_(45),
	        toObject = _dereq_(109),
	        toLength = _dereq_(108),
	        asc = _dereq_(15);
	    module.exports = function (TYPE, $create) {
	      var IS_MAP = TYPE == 1,
	          IS_FILTER = TYPE == 2,
	          IS_SOME = TYPE == 3,
	          IS_EVERY = TYPE == 4,
	          IS_FIND_INDEX = TYPE == 6,
	          NO_HOLES = TYPE == 5 || IS_FIND_INDEX,
	          create = $create || asc;
	      return function ($this, callbackfn, that) {
	        var O = toObject($this),
	            self = IObject(O),
	            f = ctx(callbackfn, that, 3),
	            length = toLength(self.length),
	            index = 0,
	            result = IS_MAP ? create($this, length) : IS_FILTER ? create($this, 0) : undefined,
	            val,
	            res;
	        for (; length > index; index++) {
	          if (NO_HOLES || index in self) {
	            val = self[index];
	            res = f(val, index, O);
	            if (TYPE) {
	              if (IS_MAP) result[index] = res; // map
	              else if (res) switch (TYPE) {
	                  case 3:
	                    return true; // some
	                  case 5:
	                    return val; // find
	                  case 6:
	                    return index; // findIndex
	                  case 2:
	                    result.push(val); // filter
	                } else if (IS_EVERY) return false; // every
	            }
	          }
	        }return IS_FIND_INDEX ? -1 : IS_SOME || IS_EVERY ? IS_EVERY : result;
	      };
	    };
	  }, { "108": 108, "109": 109, "15": 15, "25": 25, "45": 45 }], 13: [function (_dereq_, module, exports) {
	    var aFunction = _dereq_(3),
	        toObject = _dereq_(109),
	        IObject = _dereq_(45),
	        toLength = _dereq_(108);
	
	    module.exports = function (that, callbackfn, aLen, memo, isRight) {
	      aFunction(callbackfn);
	      var O = toObject(that),
	          self = IObject(O),
	          length = toLength(O.length),
	          index = isRight ? length - 1 : 0,
	          i = isRight ? -1 : 1;
	      if (aLen < 2) for (;;) {
	        if (index in self) {
	          memo = self[index];
	          index += i;
	          break;
	        }
	        index += i;
	        if (isRight ? index < 0 : length <= index) {
	          throw TypeError('Reduce of empty array with no initial value');
	        }
	      }
	      for (; isRight ? index >= 0 : length > index; index += i) {
	        if (index in self) {
	          memo = callbackfn(memo, self[index], index, O);
	        }
	      }return memo;
	    };
	  }, { "108": 108, "109": 109, "3": 3, "45": 45 }], 14: [function (_dereq_, module, exports) {
	    var isObject = _dereq_(49),
	        isArray = _dereq_(47),
	        SPECIES = _dereq_(117)('species');
	
	    module.exports = function (original) {
	      var C;
	      if (isArray(original)) {
	        C = original.constructor;
	        // cross-realm fallback
	        if (typeof C == 'function' && (C === Array || isArray(C.prototype))) C = undefined;
	        if (isObject(C)) {
	          C = C[SPECIES];
	          if (C === null) C = undefined;
	        }
	      }return C === undefined ? Array : C;
	    };
	  }, { "117": 117, "47": 47, "49": 49 }], 15: [function (_dereq_, module, exports) {
	    // 9.4.2.3 ArraySpeciesCreate(originalArray, length)
	    var speciesConstructor = _dereq_(14);
	
	    module.exports = function (original, length) {
	      return new (speciesConstructor(original))(length);
	    };
	  }, { "14": 14 }], 16: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var aFunction = _dereq_(3),
	        isObject = _dereq_(49),
	        invoke = _dereq_(44),
	        arraySlice = [].slice,
	        factories = {};
	
	    var construct = function construct(F, len, args) {
	      if (!(len in factories)) {
	        for (var n = [], i = 0; i < len; i++) {
	          n[i] = 'a[' + i + ']';
	        }factories[len] = Function('F,a', 'return new F(' + n.join(',') + ')');
	      }return factories[len](F, args);
	    };
	
	    module.exports = Function.bind || function bind(that /*, args... */) {
	      var fn = aFunction(this),
	          partArgs = arraySlice.call(arguments, 1);
	      var bound = function bound() /* args... */{
	        var args = partArgs.concat(arraySlice.call(arguments));
	        return this instanceof bound ? construct(fn, args.length, args) : invoke(fn, args, that);
	      };
	      if (isObject(fn.prototype)) bound.prototype = fn.prototype;
	      return bound;
	    };
	  }, { "3": 3, "44": 44, "49": 49 }], 17: [function (_dereq_, module, exports) {
	    // getting tag from 19.1.3.6 Object.prototype.toString()
	    var cof = _dereq_(18),
	        TAG = _dereq_(117)('toStringTag')
	    // ES3 wrong here
	    ,
	        ARG = cof(function () {
	      return arguments;
	    }()) == 'Arguments';
	
	    // fallback for IE11 Script Access Denied error
	    var tryGet = function tryGet(it, key) {
	      try {
	        return it[key];
	      } catch (e) {/* empty */}
	    };
	
	    module.exports = function (it) {
	      var O, T, B;
	      return it === undefined ? 'Undefined' : it === null ? 'Null'
	      // @@toStringTag case
	      : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
	      // builtinTag case
	      : ARG ? cof(O)
	      // ES3 arguments fallback
	      : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
	    };
	  }, { "117": 117, "18": 18 }], 18: [function (_dereq_, module, exports) {
	    var toString = {}.toString;
	
	    module.exports = function (it) {
	      return toString.call(it).slice(8, -1);
	    };
	  }, {}], 19: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var dP = _dereq_(67).f,
	        create = _dereq_(66),
	        redefineAll = _dereq_(86),
	        ctx = _dereq_(25),
	        anInstance = _dereq_(6),
	        defined = _dereq_(27),
	        forOf = _dereq_(37),
	        $iterDefine = _dereq_(53),
	        step = _dereq_(55),
	        setSpecies = _dereq_(91),
	        DESCRIPTORS = _dereq_(28),
	        fastKey = _dereq_(62).fastKey,
	        SIZE = DESCRIPTORS ? '_s' : 'size';
	
	    var getEntry = function getEntry(that, key) {
	      // fast case
	      var index = fastKey(key),
	          entry;
	      if (index !== 'F') return that._i[index];
	      // frozen object case
	      for (entry = that._f; entry; entry = entry.n) {
	        if (entry.k == key) return entry;
	      }
	    };
	
	    module.exports = {
	      getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	        var C = wrapper(function (that, iterable) {
	          anInstance(that, C, NAME, '_i');
	          that._i = create(null); // index
	          that._f = undefined; // first entry
	          that._l = undefined; // last entry
	          that[SIZE] = 0; // size
	          if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        });
	        redefineAll(C.prototype, {
	          // 23.1.3.1 Map.prototype.clear()
	          // 23.2.3.2 Set.prototype.clear()
	          clear: function clear() {
	            for (var that = this, data = that._i, entry = that._f; entry; entry = entry.n) {
	              entry.r = true;
	              if (entry.p) entry.p = entry.p.n = undefined;
	              delete data[entry.i];
	            }
	            that._f = that._l = undefined;
	            that[SIZE] = 0;
	          },
	          // 23.1.3.3 Map.prototype.delete(key)
	          // 23.2.3.4 Set.prototype.delete(value)
	          'delete': function _delete(key) {
	            var that = this,
	                entry = getEntry(that, key);
	            if (entry) {
	              var next = entry.n,
	                  prev = entry.p;
	              delete that._i[entry.i];
	              entry.r = true;
	              if (prev) prev.n = next;
	              if (next) next.p = prev;
	              if (that._f == entry) that._f = next;
	              if (that._l == entry) that._l = prev;
	              that[SIZE]--;
	            }return !!entry;
	          },
	          // 23.2.3.6 Set.prototype.forEach(callbackfn, thisArg = undefined)
	          // 23.1.3.5 Map.prototype.forEach(callbackfn, thisArg = undefined)
	          forEach: function forEach(callbackfn /*, that = undefined */) {
	            anInstance(this, C, 'forEach');
	            var f = ctx(callbackfn, arguments.length > 1 ? arguments[1] : undefined, 3),
	                entry;
	            while (entry = entry ? entry.n : this._f) {
	              f(entry.v, entry.k, this);
	              // revert to the last existing entry
	              while (entry && entry.r) {
	                entry = entry.p;
	              }
	            }
	          },
	          // 23.1.3.7 Map.prototype.has(key)
	          // 23.2.3.7 Set.prototype.has(value)
	          has: function has(key) {
	            return !!getEntry(this, key);
	          }
	        });
	        if (DESCRIPTORS) dP(C.prototype, 'size', {
	          get: function get() {
	            return defined(this[SIZE]);
	          }
	        });
	        return C;
	      },
	      def: function def(that, key, value) {
	        var entry = getEntry(that, key),
	            prev,
	            index;
	        // change existing entry
	        if (entry) {
	          entry.v = value;
	          // create new entry
	        } else {
	          that._l = entry = {
	            i: index = fastKey(key, true), // <- index
	            k: key, // <- key
	            v: value, // <- value
	            p: prev = that._l, // <- previous entry
	            n: undefined, // <- next entry
	            r: false // <- removed
	          };
	          if (!that._f) that._f = entry;
	          if (prev) prev.n = entry;
	          that[SIZE]++;
	          // add to index
	          if (index !== 'F') that._i[index] = entry;
	        }return that;
	      },
	      getEntry: getEntry,
	      setStrong: function setStrong(C, NAME, IS_MAP) {
	        // add .keys, .values, .entries, [@@iterator]
	        // 23.1.3.4, 23.1.3.8, 23.1.3.11, 23.1.3.12, 23.2.3.5, 23.2.3.8, 23.2.3.10, 23.2.3.11
	        $iterDefine(C, NAME, function (iterated, kind) {
	          this._t = iterated; // target
	          this._k = kind; // kind
	          this._l = undefined; // previous
	        }, function () {
	          var that = this,
	              kind = that._k,
	              entry = that._l;
	          // revert to the last existing entry
	          while (entry && entry.r) {
	            entry = entry.p;
	          } // get next entry
	          if (!that._t || !(that._l = entry = entry ? entry.n : that._t._f)) {
	            // or finish the iteration
	            that._t = undefined;
	            return step(1);
	          }
	          // return step by kind
	          if (kind == 'keys') return step(0, entry.k);
	          if (kind == 'values') return step(0, entry.v);
	          return step(0, [entry.k, entry.v]);
	        }, IS_MAP ? 'entries' : 'values', !IS_MAP, true);
	
	        // add [@@species], 23.1.2.2, 23.2.2.2
	        setSpecies(NAME);
	      }
	    };
	  }, { "25": 25, "27": 27, "28": 28, "37": 37, "53": 53, "55": 55, "6": 6, "62": 62, "66": 66, "67": 67, "86": 86, "91": 91 }], 20: [function (_dereq_, module, exports) {
	    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
	    var classof = _dereq_(17),
	        from = _dereq_(10);
	    module.exports = function (NAME) {
	      return function toJSON() {
	        if (classof(this) != NAME) throw TypeError(NAME + "#toJSON isn't generic");
	        return from(this);
	      };
	    };
	  }, { "10": 10, "17": 17 }], 21: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var redefineAll = _dereq_(86),
	        getWeak = _dereq_(62).getWeak,
	        anObject = _dereq_(7),
	        isObject = _dereq_(49),
	        anInstance = _dereq_(6),
	        forOf = _dereq_(37),
	        createArrayMethod = _dereq_(12),
	        $has = _dereq_(39),
	        arrayFind = createArrayMethod(5),
	        arrayFindIndex = createArrayMethod(6),
	        id = 0;
	
	    // fallback for uncaught frozen keys
	    var uncaughtFrozenStore = function uncaughtFrozenStore(that) {
	      return that._l || (that._l = new UncaughtFrozenStore());
	    };
	    var UncaughtFrozenStore = function UncaughtFrozenStore() {
	      this.a = [];
	    };
	    var findUncaughtFrozen = function findUncaughtFrozen(store, key) {
	      return arrayFind(store.a, function (it) {
	        return it[0] === key;
	      });
	    };
	    UncaughtFrozenStore.prototype = {
	      get: function get(key) {
	        var entry = findUncaughtFrozen(this, key);
	        if (entry) return entry[1];
	      },
	      has: function has(key) {
	        return !!findUncaughtFrozen(this, key);
	      },
	      set: function set(key, value) {
	        var entry = findUncaughtFrozen(this, key);
	        if (entry) entry[1] = value;else this.a.push([key, value]);
	      },
	      'delete': function _delete(key) {
	        var index = arrayFindIndex(this.a, function (it) {
	          return it[0] === key;
	        });
	        if (~index) this.a.splice(index, 1);
	        return !!~index;
	      }
	    };
	
	    module.exports = {
	      getConstructor: function getConstructor(wrapper, NAME, IS_MAP, ADDER) {
	        var C = wrapper(function (that, iterable) {
	          anInstance(that, C, NAME, '_i');
	          that._i = id++; // collection id
	          that._l = undefined; // leak store for uncaught frozen objects
	          if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	        });
	        redefineAll(C.prototype, {
	          // 23.3.3.2 WeakMap.prototype.delete(key)
	          // 23.4.3.3 WeakSet.prototype.delete(value)
	          'delete': function _delete(key) {
	            if (!isObject(key)) return false;
	            var data = getWeak(key);
	            if (data === true) return uncaughtFrozenStore(this)['delete'](key);
	            return data && $has(data, this._i) && delete data[this._i];
	          },
	          // 23.3.3.4 WeakMap.prototype.has(key)
	          // 23.4.3.4 WeakSet.prototype.has(value)
	          has: function has(key) {
	            if (!isObject(key)) return false;
	            var data = getWeak(key);
	            if (data === true) return uncaughtFrozenStore(this).has(key);
	            return data && $has(data, this._i);
	          }
	        });
	        return C;
	      },
	      def: function def(that, key, value) {
	        var data = getWeak(anObject(key), true);
	        if (data === true) uncaughtFrozenStore(that).set(key, value);else data[that._i] = value;
	        return that;
	      },
	      ufstore: uncaughtFrozenStore
	    };
	  }, { "12": 12, "37": 37, "39": 39, "49": 49, "6": 6, "62": 62, "7": 7, "86": 86 }], 22: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var global = _dereq_(38),
	        $export = _dereq_(32),
	        redefine = _dereq_(87),
	        redefineAll = _dereq_(86),
	        meta = _dereq_(62),
	        forOf = _dereq_(37),
	        anInstance = _dereq_(6),
	        isObject = _dereq_(49),
	        fails = _dereq_(34),
	        $iterDetect = _dereq_(54),
	        setToStringTag = _dereq_(92),
	        inheritIfRequired = _dereq_(43);
	
	    module.exports = function (NAME, wrapper, methods, common, IS_MAP, IS_WEAK) {
	      var Base = global[NAME],
	          C = Base,
	          ADDER = IS_MAP ? 'set' : 'add',
	          proto = C && C.prototype,
	          O = {};
	      var fixMethod = function fixMethod(KEY) {
	        var fn = proto[KEY];
	        redefine(proto, KEY, KEY == 'delete' ? function (a) {
	          return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	        } : KEY == 'has' ? function has(a) {
	          return IS_WEAK && !isObject(a) ? false : fn.call(this, a === 0 ? 0 : a);
	        } : KEY == 'get' ? function get(a) {
	          return IS_WEAK && !isObject(a) ? undefined : fn.call(this, a === 0 ? 0 : a);
	        } : KEY == 'add' ? function add(a) {
	          fn.call(this, a === 0 ? 0 : a);return this;
	        } : function set(a, b) {
	          fn.call(this, a === 0 ? 0 : a, b);return this;
	        });
	      };
	      if (typeof C != 'function' || !(IS_WEAK || proto.forEach && !fails(function () {
	        new C().entries().next();
	      }))) {
	        // create collection constructor
	        C = common.getConstructor(wrapper, NAME, IS_MAP, ADDER);
	        redefineAll(C.prototype, methods);
	        meta.NEED = true;
	      } else {
	        var instance = new C()
	        // early implementations not supports chaining
	        ,
	            HASNT_CHAINING = instance[ADDER](IS_WEAK ? {} : -0, 1) != instance
	        // V8 ~  Chromium 40- weak-collections throws on primitives, but should return false
	        ,
	            THROWS_ON_PRIMITIVES = fails(function () {
	          instance.has(1);
	        })
	        // most early implementations doesn't supports iterables, most modern - not close it correctly
	        ,
	            ACCEPT_ITERABLES = $iterDetect(function (iter) {
	          new C(iter);
	        }) // eslint-disable-line no-new
	        // for early implementations -0 and +0 not the same
	        ,
	            BUGGY_ZERO = !IS_WEAK && fails(function () {
	          // V8 ~ Chromium 42- fails only with 5+ elements
	          var $instance = new C(),
	              index = 5;
	          while (index--) {
	            $instance[ADDER](index, index);
	          }return !$instance.has(-0);
	        });
	        if (!ACCEPT_ITERABLES) {
	          C = wrapper(function (target, iterable) {
	            anInstance(target, C, NAME);
	            var that = inheritIfRequired(new Base(), target, C);
	            if (iterable != undefined) forOf(iterable, IS_MAP, that[ADDER], that);
	            return that;
	          });
	          C.prototype = proto;
	          proto.constructor = C;
	        }
	        if (THROWS_ON_PRIMITIVES || BUGGY_ZERO) {
	          fixMethod('delete');
	          fixMethod('has');
	          IS_MAP && fixMethod('get');
	        }
	        if (BUGGY_ZERO || HASNT_CHAINING) fixMethod(ADDER);
	        // weak collections should not contains .clear method
	        if (IS_WEAK && proto.clear) delete proto.clear;
	      }
	
	      setToStringTag(C, NAME);
	
	      O[NAME] = C;
	      $export($export.G + $export.W + $export.F * (C != Base), O);
	
	      if (!IS_WEAK) common.setStrong(C, NAME, IS_MAP);
	
	      return C;
	    };
	  }, { "32": 32, "34": 34, "37": 37, "38": 38, "43": 43, "49": 49, "54": 54, "6": 6, "62": 62, "86": 86, "87": 87, "92": 92 }], 23: [function (_dereq_, module, exports) {
	    var core = module.exports = { version: '2.4.0' };
	    if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef
	  }, {}], 24: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $defineProperty = _dereq_(67),
	        createDesc = _dereq_(85);
	
	    module.exports = function (object, index, value) {
	      if (index in object) $defineProperty.f(object, index, createDesc(0, value));else object[index] = value;
	    };
	  }, { "67": 67, "85": 85 }], 25: [function (_dereq_, module, exports) {
	    // optional / simple context binding
	    var aFunction = _dereq_(3);
	    module.exports = function (fn, that, length) {
	      aFunction(fn);
	      if (that === undefined) return fn;
	      switch (length) {
	        case 1:
	          return function (a) {
	            return fn.call(that, a);
	          };
	        case 2:
	          return function (a, b) {
	            return fn.call(that, a, b);
	          };
	        case 3:
	          return function (a, b, c) {
	            return fn.call(that, a, b, c);
	          };
	      }
	      return function () /* ...args */{
	        return fn.apply(that, arguments);
	      };
	    };
	  }, { "3": 3 }], 26: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var anObject = _dereq_(7),
	        toPrimitive = _dereq_(110),
	        NUMBER = 'number';
	
	    module.exports = function (hint) {
	      if (hint !== 'string' && hint !== NUMBER && hint !== 'default') throw TypeError('Incorrect hint');
	      return toPrimitive(anObject(this), hint != NUMBER);
	    };
	  }, { "110": 110, "7": 7 }], 27: [function (_dereq_, module, exports) {
	    // 7.2.1 RequireObjectCoercible(argument)
	    module.exports = function (it) {
	      if (it == undefined) throw TypeError("Can't call method on  " + it);
	      return it;
	    };
	  }, {}], 28: [function (_dereq_, module, exports) {
	    // Thank's IE8 for his funny defineProperty
	    module.exports = !_dereq_(34)(function () {
	      return Object.defineProperty({}, 'a', { get: function get() {
	          return 7;
	        } }).a != 7;
	    });
	  }, { "34": 34 }], 29: [function (_dereq_, module, exports) {
	    var isObject = _dereq_(49),
	        document = _dereq_(38).document
	    // in old IE typeof document.createElement is 'object'
	    ,
	        is = isObject(document) && isObject(document.createElement);
	    module.exports = function (it) {
	      return is ? document.createElement(it) : {};
	    };
	  }, { "38": 38, "49": 49 }], 30: [function (_dereq_, module, exports) {
	    // IE 8- don't enum bug keys
	    module.exports = 'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'.split(',');
	  }, {}], 31: [function (_dereq_, module, exports) {
	    // all enumerable object keys, includes symbols
	    var getKeys = _dereq_(76),
	        gOPS = _dereq_(73),
	        pIE = _dereq_(77);
	    module.exports = function (it) {
	      var result = getKeys(it),
	          getSymbols = gOPS.f;
	      if (getSymbols) {
	        var symbols = getSymbols(it),
	            isEnum = pIE.f,
	            i = 0,
	            key;
	        while (symbols.length > i) {
	          if (isEnum.call(it, key = symbols[i++])) result.push(key);
	        }
	      }return result;
	    };
	  }, { "73": 73, "76": 76, "77": 77 }], 32: [function (_dereq_, module, exports) {
	    var global = _dereq_(38),
	        core = _dereq_(23),
	        hide = _dereq_(40),
	        redefine = _dereq_(87),
	        ctx = _dereq_(25),
	        PROTOTYPE = 'prototype';
	
	    var $export = function $export(type, name, source) {
	      var IS_FORCED = type & $export.F,
	          IS_GLOBAL = type & $export.G,
	          IS_STATIC = type & $export.S,
	          IS_PROTO = type & $export.P,
	          IS_BIND = type & $export.B,
	          target = IS_GLOBAL ? global : IS_STATIC ? global[name] || (global[name] = {}) : (global[name] || {})[PROTOTYPE],
	          exports = IS_GLOBAL ? core : core[name] || (core[name] = {}),
	          expProto = exports[PROTOTYPE] || (exports[PROTOTYPE] = {}),
	          key,
	          own,
	          out,
	          exp;
	      if (IS_GLOBAL) source = name;
	      for (key in source) {
	        // contains in native
	        own = !IS_FORCED && target && target[key] !== undefined;
	        // export native or passed
	        out = (own ? target : source)[key];
	        // bind timers to global for call from export context
	        exp = IS_BIND && own ? ctx(out, global) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
	        // extend global
	        if (target) redefine(target, key, out, type & $export.U);
	        // export
	        if (exports[key] != out) hide(exports, key, exp);
	        if (IS_PROTO && expProto[key] != out) expProto[key] = out;
	      }
	    };
	    global.core = core;
	    // type bitmap
	    $export.F = 1; // forced
	    $export.G = 2; // global
	    $export.S = 4; // static
	    $export.P = 8; // proto
	    $export.B = 16; // bind
	    $export.W = 32; // wrap
	    $export.U = 64; // safe
	    $export.R = 128; // real proto method for `library` 
	    module.exports = $export;
	  }, { "23": 23, "25": 25, "38": 38, "40": 40, "87": 87 }], 33: [function (_dereq_, module, exports) {
	    var MATCH = _dereq_(117)('match');
	    module.exports = function (KEY) {
	      var re = /./;
	      try {
	        '/./'[KEY](re);
	      } catch (e) {
	        try {
	          re[MATCH] = false;
	          return !'/./'[KEY](re);
	        } catch (f) {/* empty */}
	      }return true;
	    };
	  }, { "117": 117 }], 34: [function (_dereq_, module, exports) {
	    module.exports = function (exec) {
	      try {
	        return !!exec();
	      } catch (e) {
	        return true;
	      }
	    };
	  }, {}], 35: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var hide = _dereq_(40),
	        redefine = _dereq_(87),
	        fails = _dereq_(34),
	        defined = _dereq_(27),
	        wks = _dereq_(117);
	
	    module.exports = function (KEY, length, exec) {
	      var SYMBOL = wks(KEY),
	          fns = exec(defined, SYMBOL, ''[KEY]),
	          strfn = fns[0],
	          rxfn = fns[1];
	      if (fails(function () {
	        var O = {};
	        O[SYMBOL] = function () {
	          return 7;
	        };
	        return ''[KEY](O) != 7;
	      })) {
	        redefine(String.prototype, KEY, strfn);
	        hide(RegExp.prototype, SYMBOL, length == 2
	        // 21.2.5.8 RegExp.prototype[@@replace](string, replaceValue)
	        // 21.2.5.11 RegExp.prototype[@@split](string, limit)
	        ? function (string, arg) {
	          return rxfn.call(string, this, arg);
	        }
	        // 21.2.5.6 RegExp.prototype[@@match](string)
	        // 21.2.5.9 RegExp.prototype[@@search](string)
	        : function (string) {
	          return rxfn.call(string, this);
	        });
	      }
	    };
	  }, { "117": 117, "27": 27, "34": 34, "40": 40, "87": 87 }], 36: [function (_dereq_, module, exports) {
	    'use strict';
	    // 21.2.5.3 get RegExp.prototype.flags
	
	    var anObject = _dereq_(7);
	    module.exports = function () {
	      var that = anObject(this),
	          result = '';
	      if (that.global) result += 'g';
	      if (that.ignoreCase) result += 'i';
	      if (that.multiline) result += 'm';
	      if (that.unicode) result += 'u';
	      if (that.sticky) result += 'y';
	      return result;
	    };
	  }, { "7": 7 }], 37: [function (_dereq_, module, exports) {
	    var ctx = _dereq_(25),
	        call = _dereq_(51),
	        isArrayIter = _dereq_(46),
	        anObject = _dereq_(7),
	        toLength = _dereq_(108),
	        getIterFn = _dereq_(118),
	        BREAK = {},
	        RETURN = {};
	    var exports = module.exports = function (iterable, entries, fn, that, ITERATOR) {
	      var iterFn = ITERATOR ? function () {
	        return iterable;
	      } : getIterFn(iterable),
	          f = ctx(fn, that, entries ? 2 : 1),
	          index = 0,
	          length,
	          step,
	          iterator,
	          result;
	      if (typeof iterFn != 'function') throw TypeError(iterable + ' is not iterable!');
	      // fast case for arrays with default iterator
	      if (isArrayIter(iterFn)) for (length = toLength(iterable.length); length > index; index++) {
	        result = entries ? f(anObject(step = iterable[index])[0], step[1]) : f(iterable[index]);
	        if (result === BREAK || result === RETURN) return result;
	      } else for (iterator = iterFn.call(iterable); !(step = iterator.next()).done;) {
	        result = call(iterator, f, step.value, entries);
	        if (result === BREAK || result === RETURN) return result;
	      }
	    };
	    exports.BREAK = BREAK;
	    exports.RETURN = RETURN;
	  }, { "108": 108, "118": 118, "25": 25, "46": 46, "51": 51, "7": 7 }], 38: [function (_dereq_, module, exports) {
	    // https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	    var global = module.exports = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	    if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef
	  }, {}], 39: [function (_dereq_, module, exports) {
	    var hasOwnProperty = {}.hasOwnProperty;
	    module.exports = function (it, key) {
	      return hasOwnProperty.call(it, key);
	    };
	  }, {}], 40: [function (_dereq_, module, exports) {
	    var dP = _dereq_(67),
	        createDesc = _dereq_(85);
	    module.exports = _dereq_(28) ? function (object, key, value) {
	      return dP.f(object, key, createDesc(1, value));
	    } : function (object, key, value) {
	      object[key] = value;
	      return object;
	    };
	  }, { "28": 28, "67": 67, "85": 85 }], 41: [function (_dereq_, module, exports) {
	    module.exports = _dereq_(38).document && document.documentElement;
	  }, { "38": 38 }], 42: [function (_dereq_, module, exports) {
	    module.exports = !_dereq_(28) && !_dereq_(34)(function () {
	      return Object.defineProperty(_dereq_(29)('div'), 'a', { get: function get() {
	          return 7;
	        } }).a != 7;
	    });
	  }, { "28": 28, "29": 29, "34": 34 }], 43: [function (_dereq_, module, exports) {
	    var isObject = _dereq_(49),
	        setPrototypeOf = _dereq_(90).set;
	    module.exports = function (that, target, C) {
	      var P,
	          S = target.constructor;
	      if (S !== C && typeof S == 'function' && (P = S.prototype) !== C.prototype && isObject(P) && setPrototypeOf) {
	        setPrototypeOf(that, P);
	      }return that;
	    };
	  }, { "49": 49, "90": 90 }], 44: [function (_dereq_, module, exports) {
	    // fast apply, http://jsperf.lnkit.com/fast-apply/5
	    module.exports = function (fn, args, that) {
	      var un = that === undefined;
	      switch (args.length) {
	        case 0:
	          return un ? fn() : fn.call(that);
	        case 1:
	          return un ? fn(args[0]) : fn.call(that, args[0]);
	        case 2:
	          return un ? fn(args[0], args[1]) : fn.call(that, args[0], args[1]);
	        case 3:
	          return un ? fn(args[0], args[1], args[2]) : fn.call(that, args[0], args[1], args[2]);
	        case 4:
	          return un ? fn(args[0], args[1], args[2], args[3]) : fn.call(that, args[0], args[1], args[2], args[3]);
	      }return fn.apply(that, args);
	    };
	  }, {}], 45: [function (_dereq_, module, exports) {
	    // fallback for non-array-like ES3 and non-enumerable old V8 strings
	    var cof = _dereq_(18);
	    module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
	      return cof(it) == 'String' ? it.split('') : Object(it);
	    };
	  }, { "18": 18 }], 46: [function (_dereq_, module, exports) {
	    // check on default Array iterator
	    var Iterators = _dereq_(56),
	        ITERATOR = _dereq_(117)('iterator'),
	        ArrayProto = Array.prototype;
	
	    module.exports = function (it) {
	      return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
	    };
	  }, { "117": 117, "56": 56 }], 47: [function (_dereq_, module, exports) {
	    // 7.2.2 IsArray(argument)
	    var cof = _dereq_(18);
	    module.exports = Array.isArray || function isArray(arg) {
	      return cof(arg) == 'Array';
	    };
	  }, { "18": 18 }], 48: [function (_dereq_, module, exports) {
	    // 20.1.2.3 Number.isInteger(number)
	    var isObject = _dereq_(49),
	        floor = Math.floor;
	    module.exports = function isInteger(it) {
	      return !isObject(it) && isFinite(it) && floor(it) === it;
	    };
	  }, { "49": 49 }], 49: [function (_dereq_, module, exports) {
	    module.exports = function (it) {
	      return (typeof it === "undefined" ? "undefined" : _typeof(it)) === 'object' ? it !== null : typeof it === 'function';
	    };
	  }, {}], 50: [function (_dereq_, module, exports) {
	    // 7.2.8 IsRegExp(argument)
	    var isObject = _dereq_(49),
	        cof = _dereq_(18),
	        MATCH = _dereq_(117)('match');
	    module.exports = function (it) {
	      var isRegExp;
	      return isObject(it) && ((isRegExp = it[MATCH]) !== undefined ? !!isRegExp : cof(it) == 'RegExp');
	    };
	  }, { "117": 117, "18": 18, "49": 49 }], 51: [function (_dereq_, module, exports) {
	    // call something on iterator step with safe closing on error
	    var anObject = _dereq_(7);
	    module.exports = function (iterator, fn, value, entries) {
	      try {
	        return entries ? fn(anObject(value)[0], value[1]) : fn(value);
	        // 7.4.6 IteratorClose(iterator, completion)
	      } catch (e) {
	        var ret = iterator['return'];
	        if (ret !== undefined) anObject(ret.call(iterator));
	        throw e;
	      }
	    };
	  }, { "7": 7 }], 52: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var create = _dereq_(66),
	        descriptor = _dereq_(85),
	        setToStringTag = _dereq_(92),
	        IteratorPrototype = {};
	
	    // 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
	    _dereq_(40)(IteratorPrototype, _dereq_(117)('iterator'), function () {
	      return this;
	    });
	
	    module.exports = function (Constructor, NAME, next) {
	      Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
	      setToStringTag(Constructor, NAME + ' Iterator');
	    };
	  }, { "117": 117, "40": 40, "66": 66, "85": 85, "92": 92 }], 53: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var LIBRARY = _dereq_(58),
	        $export = _dereq_(32),
	        redefine = _dereq_(87),
	        hide = _dereq_(40),
	        has = _dereq_(39),
	        Iterators = _dereq_(56),
	        $iterCreate = _dereq_(52),
	        setToStringTag = _dereq_(92),
	        getPrototypeOf = _dereq_(74),
	        ITERATOR = _dereq_(117)('iterator'),
	        BUGGY = !([].keys && 'next' in [].keys()) // Safari has buggy iterators w/o `next`
	    ,
	        FF_ITERATOR = '@@iterator',
	        KEYS = 'keys',
	        VALUES = 'values';
	
	    var returnThis = function returnThis() {
	      return this;
	    };
	
	    module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
	      $iterCreate(Constructor, NAME, next);
	      var getMethod = function getMethod(kind) {
	        if (!BUGGY && kind in proto) return proto[kind];
	        switch (kind) {
	          case KEYS:
	            return function keys() {
	              return new Constructor(this, kind);
	            };
	          case VALUES:
	            return function values() {
	              return new Constructor(this, kind);
	            };
	        }return function entries() {
	          return new Constructor(this, kind);
	        };
	      };
	      var TAG = NAME + ' Iterator',
	          DEF_VALUES = DEFAULT == VALUES,
	          VALUES_BUG = false,
	          proto = Base.prototype,
	          $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT],
	          $default = $native || getMethod(DEFAULT),
	          $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined,
	          $anyNative = NAME == 'Array' ? proto.entries || $native : $native,
	          methods,
	          key,
	          IteratorPrototype;
	      // Fix native
	      if ($anyNative) {
	        IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
	        if (IteratorPrototype !== Object.prototype) {
	          // Set @@toStringTag to native iterators
	          setToStringTag(IteratorPrototype, TAG, true);
	          // fix for some old engines
	          if (!LIBRARY && !has(IteratorPrototype, ITERATOR)) hide(IteratorPrototype, ITERATOR, returnThis);
	        }
	      }
	      // fix Array#{values, @@iterator}.name in V8 / FF
	      if (DEF_VALUES && $native && $native.name !== VALUES) {
	        VALUES_BUG = true;
	        $default = function values() {
	          return $native.call(this);
	        };
	      }
	      // Define iterator
	      if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
	        hide(proto, ITERATOR, $default);
	      }
	      // Plug for library
	      Iterators[NAME] = $default;
	      Iterators[TAG] = returnThis;
	      if (DEFAULT) {
	        methods = {
	          values: DEF_VALUES ? $default : getMethod(VALUES),
	          keys: IS_SET ? $default : getMethod(KEYS),
	          entries: $entries
	        };
	        if (FORCED) for (key in methods) {
	          if (!(key in proto)) redefine(proto, key, methods[key]);
	        } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
	      }
	      return methods;
	    };
	  }, { "117": 117, "32": 32, "39": 39, "40": 40, "52": 52, "56": 56, "58": 58, "74": 74, "87": 87, "92": 92 }], 54: [function (_dereq_, module, exports) {
	    var ITERATOR = _dereq_(117)('iterator'),
	        SAFE_CLOSING = false;
	
	    try {
	      var riter = [7][ITERATOR]();
	      riter['return'] = function () {
	        SAFE_CLOSING = true;
	      };
	      Array.from(riter, function () {
	        throw 2;
	      });
	    } catch (e) {/* empty */}
	
	    module.exports = function (exec, skipClosing) {
	      if (!skipClosing && !SAFE_CLOSING) return false;
	      var safe = false;
	      try {
	        var arr = [7],
	            iter = arr[ITERATOR]();
	        iter.next = function () {
	          return { done: safe = true };
	        };
	        arr[ITERATOR] = function () {
	          return iter;
	        };
	        exec(arr);
	      } catch (e) {/* empty */}
	      return safe;
	    };
	  }, { "117": 117 }], 55: [function (_dereq_, module, exports) {
	    module.exports = function (done, value) {
	      return { value: value, done: !!done };
	    };
	  }, {}], 56: [function (_dereq_, module, exports) {
	    module.exports = {};
	  }, {}], 57: [function (_dereq_, module, exports) {
	    var getKeys = _dereq_(76),
	        toIObject = _dereq_(107);
	    module.exports = function (object, el) {
	      var O = toIObject(object),
	          keys = getKeys(O),
	          length = keys.length,
	          index = 0,
	          key;
	      while (length > index) {
	        if (O[key = keys[index++]] === el) return key;
	      }
	    };
	  }, { "107": 107, "76": 76 }], 58: [function (_dereq_, module, exports) {
	    module.exports = false;
	  }, {}], 59: [function (_dereq_, module, exports) {
	    // 20.2.2.14 Math.expm1(x)
	    var $expm1 = Math.expm1;
	    module.exports = !$expm1
	    // Old FF bug
	    || $expm1(10) > 22025.465794806719 || $expm1(10) < 22025.4657948067165168
	    // Tor Browser bug
	    || $expm1(-2e-17) != -2e-17 ? function expm1(x) {
	      return (x = +x) == 0 ? x : x > -1e-6 && x < 1e-6 ? x + x * x / 2 : Math.exp(x) - 1;
	    } : $expm1;
	  }, {}], 60: [function (_dereq_, module, exports) {
	    // 20.2.2.20 Math.log1p(x)
	    module.exports = Math.log1p || function log1p(x) {
	      return (x = +x) > -1e-8 && x < 1e-8 ? x - x * x / 2 : Math.log(1 + x);
	    };
	  }, {}], 61: [function (_dereq_, module, exports) {
	    // 20.2.2.28 Math.sign(x)
	    module.exports = Math.sign || function sign(x) {
	      return (x = +x) == 0 || x != x ? x : x < 0 ? -1 : 1;
	    };
	  }, {}], 62: [function (_dereq_, module, exports) {
	    var META = _dereq_(114)('meta'),
	        isObject = _dereq_(49),
	        has = _dereq_(39),
	        setDesc = _dereq_(67).f,
	        id = 0;
	    var isExtensible = Object.isExtensible || function () {
	      return true;
	    };
	    var FREEZE = !_dereq_(34)(function () {
	      return isExtensible(Object.preventExtensions({}));
	    });
	    var setMeta = function setMeta(it) {
	      setDesc(it, META, { value: {
	          i: 'O' + ++id, // object ID
	          w: {} // weak collections IDs
	        } });
	    };
	    var fastKey = function fastKey(it, create) {
	      // return primitive with prefix
	      if (!isObject(it)) return (typeof it === "undefined" ? "undefined" : _typeof(it)) == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
	      if (!has(it, META)) {
	        // can't set metadata to uncaught frozen object
	        if (!isExtensible(it)) return 'F';
	        // not necessary to add metadata
	        if (!create) return 'E';
	        // add missing metadata
	        setMeta(it);
	        // return object ID
	      }return it[META].i;
	    };
	    var getWeak = function getWeak(it, create) {
	      if (!has(it, META)) {
	        // can't set metadata to uncaught frozen object
	        if (!isExtensible(it)) return true;
	        // not necessary to add metadata
	        if (!create) return false;
	        // add missing metadata
	        setMeta(it);
	        // return hash weak collections IDs
	      }return it[META].w;
	    };
	    // add metadata on freeze-family methods calling
	    var onFreeze = function onFreeze(it) {
	      if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
	      return it;
	    };
	    var meta = module.exports = {
	      KEY: META,
	      NEED: false,
	      fastKey: fastKey,
	      getWeak: getWeak,
	      onFreeze: onFreeze
	    };
	  }, { "114": 114, "34": 34, "39": 39, "49": 49, "67": 67 }], 63: [function (_dereq_, module, exports) {
	    var Map = _dereq_(149),
	        $export = _dereq_(32),
	        shared = _dereq_(94)('metadata'),
	        store = shared.store || (shared.store = new (_dereq_(255))());
	
	    var getOrCreateMetadataMap = function getOrCreateMetadataMap(target, targetKey, create) {
	      var targetMetadata = store.get(target);
	      if (!targetMetadata) {
	        if (!create) return undefined;
	        store.set(target, targetMetadata = new Map());
	      }
	      var keyMetadata = targetMetadata.get(targetKey);
	      if (!keyMetadata) {
	        if (!create) return undefined;
	        targetMetadata.set(targetKey, keyMetadata = new Map());
	      }return keyMetadata;
	    };
	    var ordinaryHasOwnMetadata = function ordinaryHasOwnMetadata(MetadataKey, O, P) {
	      var metadataMap = getOrCreateMetadataMap(O, P, false);
	      return metadataMap === undefined ? false : metadataMap.has(MetadataKey);
	    };
	    var ordinaryGetOwnMetadata = function ordinaryGetOwnMetadata(MetadataKey, O, P) {
	      var metadataMap = getOrCreateMetadataMap(O, P, false);
	      return metadataMap === undefined ? undefined : metadataMap.get(MetadataKey);
	    };
	    var ordinaryDefineOwnMetadata = function ordinaryDefineOwnMetadata(MetadataKey, MetadataValue, O, P) {
	      getOrCreateMetadataMap(O, P, true).set(MetadataKey, MetadataValue);
	    };
	    var ordinaryOwnMetadataKeys = function ordinaryOwnMetadataKeys(target, targetKey) {
	      var metadataMap = getOrCreateMetadataMap(target, targetKey, false),
	          keys = [];
	      if (metadataMap) metadataMap.forEach(function (_, key) {
	        keys.push(key);
	      });
	      return keys;
	    };
	    var toMetaKey = function toMetaKey(it) {
	      return it === undefined || (typeof it === "undefined" ? "undefined" : _typeof(it)) == 'symbol' ? it : String(it);
	    };
	    var exp = function exp(O) {
	      $export($export.S, 'Reflect', O);
	    };
	
	    module.exports = {
	      store: store,
	      map: getOrCreateMetadataMap,
	      has: ordinaryHasOwnMetadata,
	      get: ordinaryGetOwnMetadata,
	      set: ordinaryDefineOwnMetadata,
	      keys: ordinaryOwnMetadataKeys,
	      key: toMetaKey,
	      exp: exp
	    };
	  }, { "149": 149, "255": 255, "32": 32, "94": 94 }], 64: [function (_dereq_, module, exports) {
	    var global = _dereq_(38),
	        macrotask = _dereq_(104).set,
	        Observer = global.MutationObserver || global.WebKitMutationObserver,
	        process = global.process,
	        Promise = global.Promise,
	        isNode = _dereq_(18)(process) == 'process';
	
	    module.exports = function () {
	      var head, last, notify;
	
	      var flush = function flush() {
	        var parent, fn;
	        if (isNode && (parent = process.domain)) parent.exit();
	        while (head) {
	          fn = head.fn;
	          head = head.next;
	          try {
	            fn();
	          } catch (e) {
	            if (head) notify();else last = undefined;
	            throw e;
	          }
	        }last = undefined;
	        if (parent) parent.enter();
	      };
	
	      // Node.js
	      if (isNode) {
	        notify = function notify() {
	          process.nextTick(flush);
	        };
	        // browsers with MutationObserver
	      } else if (Observer) {
	        var toggle = true,
	            node = document.createTextNode('');
	        new Observer(flush).observe(node, { characterData: true }); // eslint-disable-line no-new
	        notify = function notify() {
	          node.data = toggle = !toggle;
	        };
	        // environments with maybe non-completely correct, but existent Promise
	      } else if (Promise && Promise.resolve) {
	        var promise = Promise.resolve();
	        notify = function notify() {
	          promise.then(flush);
	        };
	        // for other environments - macrotask based on:
	        // - setImmediate
	        // - MessageChannel
	        // - window.postMessag
	        // - onreadystatechange
	        // - setTimeout
	      } else {
	        notify = function notify() {
	          // strange IE + webpack dev server bug - use .call(global)
	          macrotask.call(global, flush);
	        };
	      }
	
	      return function (fn) {
	        var task = { fn: fn, next: undefined };
	        if (last) last.next = task;
	        if (!head) {
	          head = task;
	          notify();
	        }last = task;
	      };
	    };
	  }, { "104": 104, "18": 18, "38": 38 }], 65: [function (_dereq_, module, exports) {
	    'use strict';
	    // 19.1.2.1 Object.assign(target, source, ...)
	
	    var getKeys = _dereq_(76),
	        gOPS = _dereq_(73),
	        pIE = _dereq_(77),
	        toObject = _dereq_(109),
	        IObject = _dereq_(45),
	        $assign = Object.assign;
	
	    // should work with symbols and should have deterministic property order (V8 bug)
	    module.exports = !$assign || _dereq_(34)(function () {
	      var A = {},
	          B = {},
	          S = Symbol(),
	          K = 'abcdefghijklmnopqrst';
	      A[S] = 7;
	      K.split('').forEach(function (k) {
	        B[k] = k;
	      });
	      return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
	    }) ? function assign(target, source) {
	      // eslint-disable-line no-unused-vars
	      var T = toObject(target),
	          aLen = arguments.length,
	          index = 1,
	          getSymbols = gOPS.f,
	          isEnum = pIE.f;
	      while (aLen > index) {
	        var S = IObject(arguments[index++]),
	            keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S),
	            length = keys.length,
	            j = 0,
	            key;
	        while (length > j) {
	          if (isEnum.call(S, key = keys[j++])) T[key] = S[key];
	        }
	      }return T;
	    } : $assign;
	  }, { "109": 109, "34": 34, "45": 45, "73": 73, "76": 76, "77": 77 }], 66: [function (_dereq_, module, exports) {
	    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	    var anObject = _dereq_(7),
	        dPs = _dereq_(68),
	        enumBugKeys = _dereq_(30),
	        IE_PROTO = _dereq_(93)('IE_PROTO'),
	        Empty = function Empty() {/* empty */},
	        PROTOTYPE = 'prototype';
	
	    // Create object with fake `null` prototype: use iframe Object with cleared prototype
	    var _createDict = function createDict() {
	      // Thrash, waste and sodomy: IE GC bug
	      var iframe = _dereq_(29)('iframe'),
	          i = enumBugKeys.length,
	          lt = '<',
	          gt = '>',
	          iframeDocument;
	      iframe.style.display = 'none';
	      _dereq_(41).appendChild(iframe);
	      iframe.src = 'javascript:'; // eslint-disable-line no-script-url
	      // createDict = iframe.contentWindow.Object;
	      // html.removeChild(iframe);
	      iframeDocument = iframe.contentWindow.document;
	      iframeDocument.open();
	      iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
	      iframeDocument.close();
	      _createDict = iframeDocument.F;
	      while (i--) {
	        delete _createDict[PROTOTYPE][enumBugKeys[i]];
	      }return _createDict();
	    };
	
	    module.exports = Object.create || function create(O, Properties) {
	      var result;
	      if (O !== null) {
	        Empty[PROTOTYPE] = anObject(O);
	        result = new Empty();
	        Empty[PROTOTYPE] = null;
	        // add "__proto__" for Object.getPrototypeOf polyfill
	        result[IE_PROTO] = O;
	      } else result = _createDict();
	      return Properties === undefined ? result : dPs(result, Properties);
	    };
	  }, { "29": 29, "30": 30, "41": 41, "68": 68, "7": 7, "93": 93 }], 67: [function (_dereq_, module, exports) {
	    var anObject = _dereq_(7),
	        IE8_DOM_DEFINE = _dereq_(42),
	        toPrimitive = _dereq_(110),
	        dP = Object.defineProperty;
	
	    exports.f = _dereq_(28) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
	      anObject(O);
	      P = toPrimitive(P, true);
	      anObject(Attributes);
	      if (IE8_DOM_DEFINE) try {
	        return dP(O, P, Attributes);
	      } catch (e) {/* empty */}
	      if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
	      if ('value' in Attributes) O[P] = Attributes.value;
	      return O;
	    };
	  }, { "110": 110, "28": 28, "42": 42, "7": 7 }], 68: [function (_dereq_, module, exports) {
	    var dP = _dereq_(67),
	        anObject = _dereq_(7),
	        getKeys = _dereq_(76);
	
	    module.exports = _dereq_(28) ? Object.defineProperties : function defineProperties(O, Properties) {
	      anObject(O);
	      var keys = getKeys(Properties),
	          length = keys.length,
	          i = 0,
	          P;
	      while (length > i) {
	        dP.f(O, P = keys[i++], Properties[P]);
	      }return O;
	    };
	  }, { "28": 28, "67": 67, "7": 7, "76": 76 }], 69: [function (_dereq_, module, exports) {
	    // Forced replacement prototype accessors methods
	    module.exports = _dereq_(58) || !_dereq_(34)(function () {
	      var K = Math.random();
	      // In FF throws only define methods
	      __defineSetter__.call(null, K, function () {/* empty */});
	      delete _dereq_(38)[K];
	    });
	  }, { "34": 34, "38": 38, "58": 58 }], 70: [function (_dereq_, module, exports) {
	    var pIE = _dereq_(77),
	        createDesc = _dereq_(85),
	        toIObject = _dereq_(107),
	        toPrimitive = _dereq_(110),
	        has = _dereq_(39),
	        IE8_DOM_DEFINE = _dereq_(42),
	        gOPD = Object.getOwnPropertyDescriptor;
	
	    exports.f = _dereq_(28) ? gOPD : function getOwnPropertyDescriptor(O, P) {
	      O = toIObject(O);
	      P = toPrimitive(P, true);
	      if (IE8_DOM_DEFINE) try {
	        return gOPD(O, P);
	      } catch (e) {/* empty */}
	      if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
	    };
	  }, { "107": 107, "110": 110, "28": 28, "39": 39, "42": 42, "77": 77, "85": 85 }], 71: [function (_dereq_, module, exports) {
	    // fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
	    var toIObject = _dereq_(107),
	        gOPN = _dereq_(72).f,
	        toString = {}.toString;
	
	    var windowNames = (typeof window === "undefined" ? "undefined" : _typeof(window)) == 'object' && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [];
	
	    var getWindowNames = function getWindowNames(it) {
	      try {
	        return gOPN(it);
	      } catch (e) {
	        return windowNames.slice();
	      }
	    };
	
	    module.exports.f = function getOwnPropertyNames(it) {
	      return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
	    };
	  }, { "107": 107, "72": 72 }], 72: [function (_dereq_, module, exports) {
	    // 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
	    var $keys = _dereq_(75),
	        hiddenKeys = _dereq_(30).concat('length', 'prototype');
	
	    exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
	      return $keys(O, hiddenKeys);
	    };
	  }, { "30": 30, "75": 75 }], 73: [function (_dereq_, module, exports) {
	    exports.f = Object.getOwnPropertySymbols;
	  }, {}], 74: [function (_dereq_, module, exports) {
	    // 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
	    var has = _dereq_(39),
	        toObject = _dereq_(109),
	        IE_PROTO = _dereq_(93)('IE_PROTO'),
	        ObjectProto = Object.prototype;
	
	    module.exports = Object.getPrototypeOf || function (O) {
	      O = toObject(O);
	      if (has(O, IE_PROTO)) return O[IE_PROTO];
	      if (typeof O.constructor == 'function' && O instanceof O.constructor) {
	        return O.constructor.prototype;
	      }return O instanceof Object ? ObjectProto : null;
	    };
	  }, { "109": 109, "39": 39, "93": 93 }], 75: [function (_dereq_, module, exports) {
	    var has = _dereq_(39),
	        toIObject = _dereq_(107),
	        arrayIndexOf = _dereq_(11)(false),
	        IE_PROTO = _dereq_(93)('IE_PROTO');
	
	    module.exports = function (object, names) {
	      var O = toIObject(object),
	          i = 0,
	          result = [],
	          key;
	      for (key in O) {
	        if (key != IE_PROTO) has(O, key) && result.push(key);
	      } // Don't enum bug & hidden keys
	      while (names.length > i) {
	        if (has(O, key = names[i++])) {
	          ~arrayIndexOf(result, key) || result.push(key);
	        }
	      }return result;
	    };
	  }, { "107": 107, "11": 11, "39": 39, "93": 93 }], 76: [function (_dereq_, module, exports) {
	    // 19.1.2.14 / 15.2.3.14 Object.keys(O)
	    var $keys = _dereq_(75),
	        enumBugKeys = _dereq_(30);
	
	    module.exports = Object.keys || function keys(O) {
	      return $keys(O, enumBugKeys);
	    };
	  }, { "30": 30, "75": 75 }], 77: [function (_dereq_, module, exports) {
	    exports.f = {}.propertyIsEnumerable;
	  }, {}], 78: [function (_dereq_, module, exports) {
	    // most Object methods by ES6 should accept primitives
	    var $export = _dereq_(32),
	        core = _dereq_(23),
	        fails = _dereq_(34);
	    module.exports = function (KEY, exec) {
	      var fn = (core.Object || {})[KEY] || Object[KEY],
	          exp = {};
	      exp[KEY] = exec(fn);
	      $export($export.S + $export.F * fails(function () {
	        fn(1);
	      }), 'Object', exp);
	    };
	  }, { "23": 23, "32": 32, "34": 34 }], 79: [function (_dereq_, module, exports) {
	    var getKeys = _dereq_(76),
	        toIObject = _dereq_(107),
	        isEnum = _dereq_(77).f;
	    module.exports = function (isEntries) {
	      return function (it) {
	        var O = toIObject(it),
	            keys = getKeys(O),
	            length = keys.length,
	            i = 0,
	            result = [],
	            key;
	        while (length > i) {
	          if (isEnum.call(O, key = keys[i++])) {
	            result.push(isEntries ? [key, O[key]] : O[key]);
	          }
	        }return result;
	      };
	    };
	  }, { "107": 107, "76": 76, "77": 77 }], 80: [function (_dereq_, module, exports) {
	    // all object keys, includes non-enumerable and symbols
	    var gOPN = _dereq_(72),
	        gOPS = _dereq_(73),
	        anObject = _dereq_(7),
	        Reflect = _dereq_(38).Reflect;
	    module.exports = Reflect && Reflect.ownKeys || function ownKeys(it) {
	      var keys = gOPN.f(anObject(it)),
	          getSymbols = gOPS.f;
	      return getSymbols ? keys.concat(getSymbols(it)) : keys;
	    };
	  }, { "38": 38, "7": 7, "72": 72, "73": 73 }], 81: [function (_dereq_, module, exports) {
	    var $parseFloat = _dereq_(38).parseFloat,
	        $trim = _dereq_(102).trim;
	
	    module.exports = 1 / $parseFloat(_dereq_(103) + '-0') !== -Infinity ? function parseFloat(str) {
	      var string = $trim(String(str), 3),
	          result = $parseFloat(string);
	      return result === 0 && string.charAt(0) == '-' ? -0 : result;
	    } : $parseFloat;
	  }, { "102": 102, "103": 103, "38": 38 }], 82: [function (_dereq_, module, exports) {
	    var $parseInt = _dereq_(38).parseInt,
	        $trim = _dereq_(102).trim,
	        ws = _dereq_(103),
	        hex = /^[\-+]?0[xX]/;
	
	    module.exports = $parseInt(ws + '08') !== 8 || $parseInt(ws + '0x16') !== 22 ? function parseInt(str, radix) {
	      var string = $trim(String(str), 3);
	      return $parseInt(string, radix >>> 0 || (hex.test(string) ? 16 : 10));
	    } : $parseInt;
	  }, { "102": 102, "103": 103, "38": 38 }], 83: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var path = _dereq_(84),
	        invoke = _dereq_(44),
	        aFunction = _dereq_(3);
	    module.exports = function () /* ...pargs */{
	      var fn = aFunction(this),
	          length = arguments.length,
	          pargs = Array(length),
	          i = 0,
	          _ = path._,
	          holder = false;
	      while (length > i) {
	        if ((pargs[i] = arguments[i++]) === _) holder = true;
	      }return function () /* ...args */{
	        var that = this,
	            aLen = arguments.length,
	            j = 0,
	            k = 0,
	            args;
	        if (!holder && !aLen) return invoke(fn, pargs, that);
	        args = pargs.slice();
	        if (holder) for (; length > j; j++) {
	          if (args[j] === _) args[j] = arguments[k++];
	        }while (aLen > k) {
	          args.push(arguments[k++]);
	        }return invoke(fn, args, that);
	      };
	    };
	  }, { "3": 3, "44": 44, "84": 84 }], 84: [function (_dereq_, module, exports) {
	    module.exports = _dereq_(38);
	  }, { "38": 38 }], 85: [function (_dereq_, module, exports) {
	    module.exports = function (bitmap, value) {
	      return {
	        enumerable: !(bitmap & 1),
	        configurable: !(bitmap & 2),
	        writable: !(bitmap & 4),
	        value: value
	      };
	    };
	  }, {}], 86: [function (_dereq_, module, exports) {
	    var redefine = _dereq_(87);
	    module.exports = function (target, src, safe) {
	      for (var key in src) {
	        redefine(target, key, src[key], safe);
	      }return target;
	    };
	  }, { "87": 87 }], 87: [function (_dereq_, module, exports) {
	    var global = _dereq_(38),
	        hide = _dereq_(40),
	        has = _dereq_(39),
	        SRC = _dereq_(114)('src'),
	        TO_STRING = 'toString',
	        $toString = Function[TO_STRING],
	        TPL = ('' + $toString).split(TO_STRING);
	
	    _dereq_(23).inspectSource = function (it) {
	      return $toString.call(it);
	    };
	
	    (module.exports = function (O, key, val, safe) {
	      var isFunction = typeof val == 'function';
	      if (isFunction) has(val, 'name') || hide(val, 'name', key);
	      if (O[key] === val) return;
	      if (isFunction) has(val, SRC) || hide(val, SRC, O[key] ? '' + O[key] : TPL.join(String(key)));
	      if (O === global) {
	        O[key] = val;
	      } else {
	        if (!safe) {
	          delete O[key];
	          hide(O, key, val);
	        } else {
	          if (O[key]) O[key] = val;else hide(O, key, val);
	        }
	      }
	      // add fake Function#toString for correct work wrapped methods / constructors with methods like LoDash isNative
	    })(Function.prototype, TO_STRING, function toString() {
	      return typeof this == 'function' && this[SRC] || $toString.call(this);
	    });
	  }, { "114": 114, "23": 23, "38": 38, "39": 39, "40": 40 }], 88: [function (_dereq_, module, exports) {
	    module.exports = function (regExp, replace) {
	      var replacer = replace === Object(replace) ? function (part) {
	        return replace[part];
	      } : replace;
	      return function (it) {
	        return String(it).replace(regExp, replacer);
	      };
	    };
	  }, {}], 89: [function (_dereq_, module, exports) {
	    // 7.2.9 SameValue(x, y)
	    module.exports = Object.is || function is(x, y) {
	      return x === y ? x !== 0 || 1 / x === 1 / y : x != x && y != y;
	    };
	  }, {}], 90: [function (_dereq_, module, exports) {
	    // Works with __proto__ only. Old v8 can't work with null proto objects.
	    /* eslint-disable no-proto */
	    var isObject = _dereq_(49),
	        anObject = _dereq_(7);
	    var check = function check(O, proto) {
	      anObject(O);
	      if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
	    };
	    module.exports = {
	      set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
	      function (test, buggy, set) {
	        try {
	          set = _dereq_(25)(Function.call, _dereq_(70).f(Object.prototype, '__proto__').set, 2);
	          set(test, []);
	          buggy = !(test instanceof Array);
	        } catch (e) {
	          buggy = true;
	        }
	        return function setPrototypeOf(O, proto) {
	          check(O, proto);
	          if (buggy) O.__proto__ = proto;else set(O, proto);
	          return O;
	        };
	      }({}, false) : undefined),
	      check: check
	    };
	  }, { "25": 25, "49": 49, "7": 7, "70": 70 }], 91: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var global = _dereq_(38),
	        dP = _dereq_(67),
	        DESCRIPTORS = _dereq_(28),
	        SPECIES = _dereq_(117)('species');
	
	    module.exports = function (KEY) {
	      var C = global[KEY];
	      if (DESCRIPTORS && C && !C[SPECIES]) dP.f(C, SPECIES, {
	        configurable: true,
	        get: function get() {
	          return this;
	        }
	      });
	    };
	  }, { "117": 117, "28": 28, "38": 38, "67": 67 }], 92: [function (_dereq_, module, exports) {
	    var def = _dereq_(67).f,
	        has = _dereq_(39),
	        TAG = _dereq_(117)('toStringTag');
	
	    module.exports = function (it, tag, stat) {
	      if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
	    };
	  }, { "117": 117, "39": 39, "67": 67 }], 93: [function (_dereq_, module, exports) {
	    var shared = _dereq_(94)('keys'),
	        uid = _dereq_(114);
	    module.exports = function (key) {
	      return shared[key] || (shared[key] = uid(key));
	    };
	  }, { "114": 114, "94": 94 }], 94: [function (_dereq_, module, exports) {
	    var global = _dereq_(38),
	        SHARED = '__core-js_shared__',
	        store = global[SHARED] || (global[SHARED] = {});
	    module.exports = function (key) {
	      return store[key] || (store[key] = {});
	    };
	  }, { "38": 38 }], 95: [function (_dereq_, module, exports) {
	    // 7.3.20 SpeciesConstructor(O, defaultConstructor)
	    var anObject = _dereq_(7),
	        aFunction = _dereq_(3),
	        SPECIES = _dereq_(117)('species');
	    module.exports = function (O, D) {
	      var C = anObject(O).constructor,
	          S;
	      return C === undefined || (S = anObject(C)[SPECIES]) == undefined ? D : aFunction(S);
	    };
	  }, { "117": 117, "3": 3, "7": 7 }], 96: [function (_dereq_, module, exports) {
	    var fails = _dereq_(34);
	
	    module.exports = function (method, arg) {
	      return !!method && fails(function () {
	        arg ? method.call(null, function () {}, 1) : method.call(null);
	      });
	    };
	  }, { "34": 34 }], 97: [function (_dereq_, module, exports) {
	    var toInteger = _dereq_(106),
	        defined = _dereq_(27);
	    // true  -> String#at
	    // false -> String#codePointAt
	    module.exports = function (TO_STRING) {
	      return function (that, pos) {
	        var s = String(defined(that)),
	            i = toInteger(pos),
	            l = s.length,
	            a,
	            b;
	        if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
	        a = s.charCodeAt(i);
	        return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff ? TO_STRING ? s.charAt(i) : a : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
	      };
	    };
	  }, { "106": 106, "27": 27 }], 98: [function (_dereq_, module, exports) {
	    // helper for String#{startsWith, endsWith, includes}
	    var isRegExp = _dereq_(50),
	        defined = _dereq_(27);
	
	    module.exports = function (that, searchString, NAME) {
	      if (isRegExp(searchString)) throw TypeError('String#' + NAME + " doesn't accept regex!");
	      return String(defined(that));
	    };
	  }, { "27": 27, "50": 50 }], 99: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        fails = _dereq_(34),
	        defined = _dereq_(27),
	        quot = /"/g;
	    // B.2.3.2.1 CreateHTML(string, tag, attribute, value)
	    var createHTML = function createHTML(string, tag, attribute, value) {
	      var S = String(defined(string)),
	          p1 = '<' + tag;
	      if (attribute !== '') p1 += ' ' + attribute + '="' + String(value).replace(quot, '&quot;') + '"';
	      return p1 + '>' + S + '</' + tag + '>';
	    };
	    module.exports = function (NAME, exec) {
	      var O = {};
	      O[NAME] = exec(createHTML);
	      $export($export.P + $export.F * fails(function () {
	        var test = ''[NAME]('"');
	        return test !== test.toLowerCase() || test.split('"').length > 3;
	      }), 'String', O);
	    };
	  }, { "27": 27, "32": 32, "34": 34 }], 100: [function (_dereq_, module, exports) {
	    // https://github.com/tc39/proposal-string-pad-start-end
	    var toLength = _dereq_(108),
	        repeat = _dereq_(101),
	        defined = _dereq_(27);
	
	    module.exports = function (that, maxLength, fillString, left) {
	      var S = String(defined(that)),
	          stringLength = S.length,
	          fillStr = fillString === undefined ? ' ' : String(fillString),
	          intMaxLength = toLength(maxLength);
	      if (intMaxLength <= stringLength || fillStr == '') return S;
	      var fillLen = intMaxLength - stringLength,
	          stringFiller = repeat.call(fillStr, Math.ceil(fillLen / fillStr.length));
	      if (stringFiller.length > fillLen) stringFiller = stringFiller.slice(0, fillLen);
	      return left ? stringFiller + S : S + stringFiller;
	    };
	  }, { "101": 101, "108": 108, "27": 27 }], 101: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var toInteger = _dereq_(106),
	        defined = _dereq_(27);
	
	    module.exports = function repeat(count) {
	      var str = String(defined(this)),
	          res = '',
	          n = toInteger(count);
	      if (n < 0 || n == Infinity) throw RangeError("Count can't be negative");
	      for (; n > 0; (n >>>= 1) && (str += str)) {
	        if (n & 1) res += str;
	      }return res;
	    };
	  }, { "106": 106, "27": 27 }], 102: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        defined = _dereq_(27),
	        fails = _dereq_(34),
	        spaces = _dereq_(103),
	        space = '[' + spaces + ']',
	        non = "\u200B\x85",
	        ltrim = RegExp('^' + space + space + '*'),
	        rtrim = RegExp(space + space + '*$');
	
	    var exporter = function exporter(KEY, exec, ALIAS) {
	      var exp = {};
	      var FORCE = fails(function () {
	        return !!spaces[KEY]() || non[KEY]() != non;
	      });
	      var fn = exp[KEY] = FORCE ? exec(trim) : spaces[KEY];
	      if (ALIAS) exp[ALIAS] = fn;
	      $export($export.P + $export.F * FORCE, 'String', exp);
	    };
	
	    // 1 -> String#trimLeft
	    // 2 -> String#trimRight
	    // 3 -> String#trim
	    var trim = exporter.trim = function (string, TYPE) {
	      string = String(defined(string));
	      if (TYPE & 1) string = string.replace(ltrim, '');
	      if (TYPE & 2) string = string.replace(rtrim, '');
	      return string;
	    };
	
	    module.exports = exporter;
	  }, { "103": 103, "27": 27, "32": 32, "34": 34 }], 103: [function (_dereq_, module, exports) {
	    module.exports = "\t\n\x0B\f\r \xA0\u1680\u180E\u2000\u2001\u2002\u2003" + "\u2004\u2005\u2006\u2007\u2008\u2009\u200A\u202F\u205F\u3000\u2028\u2029\uFEFF";
	  }, {}], 104: [function (_dereq_, module, exports) {
	    var ctx = _dereq_(25),
	        invoke = _dereq_(44),
	        html = _dereq_(41),
	        cel = _dereq_(29),
	        global = _dereq_(38),
	        process = global.process,
	        setTask = global.setImmediate,
	        clearTask = global.clearImmediate,
	        MessageChannel = global.MessageChannel,
	        counter = 0,
	        queue = {},
	        ONREADYSTATECHANGE = 'onreadystatechange',
	        defer,
	        channel,
	        port;
	    var run = function run() {
	      var id = +this;
	      if (queue.hasOwnProperty(id)) {
	        var fn = queue[id];
	        delete queue[id];
	        fn();
	      }
	    };
	    var listener = function listener(event) {
	      run.call(event.data);
	    };
	    // Node.js 0.9+ & IE10+ has setImmediate, otherwise:
	    if (!setTask || !clearTask) {
	      setTask = function setImmediate(fn) {
	        var args = [],
	            i = 1;
	        while (arguments.length > i) {
	          args.push(arguments[i++]);
	        }queue[++counter] = function () {
	          invoke(typeof fn == 'function' ? fn : Function(fn), args);
	        };
	        defer(counter);
	        return counter;
	      };
	      clearTask = function clearImmediate(id) {
	        delete queue[id];
	      };
	      // Node.js 0.8-
	      if (_dereq_(18)(process) == 'process') {
	        defer = function defer(id) {
	          process.nextTick(ctx(run, id, 1));
	        };
	        // Browsers with MessageChannel, includes WebWorkers
	      } else if (MessageChannel) {
	        channel = new MessageChannel();
	        port = channel.port2;
	        channel.port1.onmessage = listener;
	        defer = ctx(port.postMessage, port, 1);
	        // Browsers with postMessage, skip WebWorkers
	        // IE8 has postMessage, but it's sync & typeof its postMessage is 'object'
	      } else if (global.addEventListener && typeof postMessage == 'function' && !global.importScripts) {
	        defer = function defer(id) {
	          global.postMessage(id + '', '*');
	        };
	        global.addEventListener('message', listener, false);
	        // IE8-
	      } else if (ONREADYSTATECHANGE in cel('script')) {
	        defer = function defer(id) {
	          html.appendChild(cel('script'))[ONREADYSTATECHANGE] = function () {
	            html.removeChild(this);
	            run.call(id);
	          };
	        };
	        // Rest old browsers
	      } else {
	        defer = function defer(id) {
	          setTimeout(ctx(run, id, 1), 0);
	        };
	      }
	    }
	    module.exports = {
	      set: setTask,
	      clear: clearTask
	    };
	  }, { "18": 18, "25": 25, "29": 29, "38": 38, "41": 41, "44": 44 }], 105: [function (_dereq_, module, exports) {
	    var toInteger = _dereq_(106),
	        max = Math.max,
	        min = Math.min;
	    module.exports = function (index, length) {
	      index = toInteger(index);
	      return index < 0 ? max(index + length, 0) : min(index, length);
	    };
	  }, { "106": 106 }], 106: [function (_dereq_, module, exports) {
	    // 7.1.4 ToInteger
	    var ceil = Math.ceil,
	        floor = Math.floor;
	    module.exports = function (it) {
	      return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
	    };
	  }, {}], 107: [function (_dereq_, module, exports) {
	    // to indexed object, toObject with fallback for non-array-like ES3 strings
	    var IObject = _dereq_(45),
	        defined = _dereq_(27);
	    module.exports = function (it) {
	      return IObject(defined(it));
	    };
	  }, { "27": 27, "45": 45 }], 108: [function (_dereq_, module, exports) {
	    // 7.1.15 ToLength
	    var toInteger = _dereq_(106),
	        min = Math.min;
	    module.exports = function (it) {
	      return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
	    };
	  }, { "106": 106 }], 109: [function (_dereq_, module, exports) {
	    // 7.1.13 ToObject(argument)
	    var defined = _dereq_(27);
	    module.exports = function (it) {
	      return Object(defined(it));
	    };
	  }, { "27": 27 }], 110: [function (_dereq_, module, exports) {
	    // 7.1.1 ToPrimitive(input [, PreferredType])
	    var isObject = _dereq_(49);
	    // instead of the ES6 spec version, we didn't implement @@toPrimitive case
	    // and the second argument - flag - preferred type is a string
	    module.exports = function (it, S) {
	      if (!isObject(it)) return it;
	      var fn, val;
	      if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	      if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
	      if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
	      throw TypeError("Can't convert object to primitive value");
	    };
	  }, { "49": 49 }], 111: [function (_dereq_, module, exports) {
	    'use strict';
	
	    if (_dereq_(28)) {
	      var LIBRARY = _dereq_(58),
	          global = _dereq_(38),
	          fails = _dereq_(34),
	          $export = _dereq_(32),
	          $typed = _dereq_(113),
	          $buffer = _dereq_(112),
	          ctx = _dereq_(25),
	          anInstance = _dereq_(6),
	          propertyDesc = _dereq_(85),
	          hide = _dereq_(40),
	          redefineAll = _dereq_(86),
	          toInteger = _dereq_(106),
	          toLength = _dereq_(108),
	          toIndex = _dereq_(105),
	          toPrimitive = _dereq_(110),
	          has = _dereq_(39),
	          same = _dereq_(89),
	          classof = _dereq_(17),
	          isObject = _dereq_(49),
	          toObject = _dereq_(109),
	          isArrayIter = _dereq_(46),
	          create = _dereq_(66),
	          getPrototypeOf = _dereq_(74),
	          gOPN = _dereq_(72).f,
	          getIterFn = _dereq_(118),
	          uid = _dereq_(114),
	          wks = _dereq_(117),
	          createArrayMethod = _dereq_(12),
	          createArrayIncludes = _dereq_(11),
	          speciesConstructor = _dereq_(95),
	          ArrayIterators = _dereq_(130),
	          Iterators = _dereq_(56),
	          $iterDetect = _dereq_(54),
	          setSpecies = _dereq_(91),
	          arrayFill = _dereq_(9),
	          arrayCopyWithin = _dereq_(8),
	          $DP = _dereq_(67),
	          $GOPD = _dereq_(70),
	          dP = $DP.f,
	          gOPD = $GOPD.f,
	          RangeError = global.RangeError,
	          TypeError = global.TypeError,
	          Uint8Array = global.Uint8Array,
	          ARRAY_BUFFER = 'ArrayBuffer',
	          SHARED_BUFFER = 'Shared' + ARRAY_BUFFER,
	          BYTES_PER_ELEMENT = 'BYTES_PER_ELEMENT',
	          PROTOTYPE = 'prototype',
	          ArrayProto = Array[PROTOTYPE],
	          $ArrayBuffer = $buffer.ArrayBuffer,
	          $DataView = $buffer.DataView,
	          arrayForEach = createArrayMethod(0),
	          arrayFilter = createArrayMethod(2),
	          arraySome = createArrayMethod(3),
	          arrayEvery = createArrayMethod(4),
	          arrayFind = createArrayMethod(5),
	          arrayFindIndex = createArrayMethod(6),
	          arrayIncludes = createArrayIncludes(true),
	          arrayIndexOf = createArrayIncludes(false),
	          arrayValues = ArrayIterators.values,
	          arrayKeys = ArrayIterators.keys,
	          arrayEntries = ArrayIterators.entries,
	          arrayLastIndexOf = ArrayProto.lastIndexOf,
	          arrayReduce = ArrayProto.reduce,
	          arrayReduceRight = ArrayProto.reduceRight,
	          arrayJoin = ArrayProto.join,
	          arraySort = ArrayProto.sort,
	          arraySlice = ArrayProto.slice,
	          arrayToString = ArrayProto.toString,
	          arrayToLocaleString = ArrayProto.toLocaleString,
	          ITERATOR = wks('iterator'),
	          TAG = wks('toStringTag'),
	          TYPED_CONSTRUCTOR = uid('typed_constructor'),
	          DEF_CONSTRUCTOR = uid('def_constructor'),
	          ALL_CONSTRUCTORS = $typed.CONSTR,
	          TYPED_ARRAY = $typed.TYPED,
	          VIEW = $typed.VIEW,
	          WRONG_LENGTH = 'Wrong length!';
	
	      var $map = createArrayMethod(1, function (O, length) {
	        return allocate(speciesConstructor(O, O[DEF_CONSTRUCTOR]), length);
	      });
	
	      var LITTLE_ENDIAN = fails(function () {
	        return new Uint8Array(new Uint16Array([1]).buffer)[0] === 1;
	      });
	
	      var FORCED_SET = !!Uint8Array && !!Uint8Array[PROTOTYPE].set && fails(function () {
	        new Uint8Array(1).set({});
	      });
	
	      var strictToLength = function strictToLength(it, SAME) {
	        if (it === undefined) throw TypeError(WRONG_LENGTH);
	        var number = +it,
	            length = toLength(it);
	        if (SAME && !same(number, length)) throw RangeError(WRONG_LENGTH);
	        return length;
	      };
	
	      var toOffset = function toOffset(it, BYTES) {
	        var offset = toInteger(it);
	        if (offset < 0 || offset % BYTES) throw RangeError('Wrong offset!');
	        return offset;
	      };
	
	      var validate = function validate(it) {
	        if (isObject(it) && TYPED_ARRAY in it) return it;
	        throw TypeError(it + ' is not a typed array!');
	      };
	
	      var allocate = function allocate(C, length) {
	        if (!(isObject(C) && TYPED_CONSTRUCTOR in C)) {
	          throw TypeError('It is not a typed array constructor!');
	        }return new C(length);
	      };
	
	      var speciesFromList = function speciesFromList(O, list) {
	        return fromList(speciesConstructor(O, O[DEF_CONSTRUCTOR]), list);
	      };
	
	      var fromList = function fromList(C, list) {
	        var index = 0,
	            length = list.length,
	            result = allocate(C, length);
	        while (length > index) {
	          result[index] = list[index++];
	        }return result;
	      };
	
	      var addGetter = function addGetter(it, key, internal) {
	        dP(it, key, { get: function get() {
	            return this._d[internal];
	          } });
	      };
	
	      var $from = function from(source /*, mapfn, thisArg */) {
	        var O = toObject(source),
	            aLen = arguments.length,
	            mapfn = aLen > 1 ? arguments[1] : undefined,
	            mapping = mapfn !== undefined,
	            iterFn = getIterFn(O),
	            i,
	            length,
	            values,
	            result,
	            step,
	            iterator;
	        if (iterFn != undefined && !isArrayIter(iterFn)) {
	          for (iterator = iterFn.call(O), values = [], i = 0; !(step = iterator.next()).done; i++) {
	            values.push(step.value);
	          }O = values;
	        }
	        if (mapping && aLen > 2) mapfn = ctx(mapfn, arguments[2], 2);
	        for (i = 0, length = toLength(O.length), result = allocate(this, length); length > i; i++) {
	          result[i] = mapping ? mapfn(O[i], i) : O[i];
	        }
	        return result;
	      };
	
	      var $of = function of() /*...items*/{
	        var index = 0,
	            length = arguments.length,
	            result = allocate(this, length);
	        while (length > index) {
	          result[index] = arguments[index++];
	        }return result;
	      };
	
	      // iOS Safari 6.x fails here
	      var TO_LOCALE_BUG = !!Uint8Array && fails(function () {
	        arrayToLocaleString.call(new Uint8Array(1));
	      });
	
	      var $toLocaleString = function toLocaleString() {
	        return arrayToLocaleString.apply(TO_LOCALE_BUG ? arraySlice.call(validate(this)) : validate(this), arguments);
	      };
	
	      var proto = {
	        copyWithin: function copyWithin(target, start /*, end */) {
	          return arrayCopyWithin.call(validate(this), target, start, arguments.length > 2 ? arguments[2] : undefined);
	        },
	        every: function every(callbackfn /*, thisArg */) {
	          return arrayEvery(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        fill: function fill(value /*, start, end */) {
	          // eslint-disable-line no-unused-vars
	          return arrayFill.apply(validate(this), arguments);
	        },
	        filter: function filter(callbackfn /*, thisArg */) {
	          return speciesFromList(this, arrayFilter(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined));
	        },
	        find: function find(predicate /*, thisArg */) {
	          return arrayFind(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        findIndex: function findIndex(predicate /*, thisArg */) {
	          return arrayFindIndex(validate(this), predicate, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        forEach: function forEach(callbackfn /*, thisArg */) {
	          arrayForEach(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        indexOf: function indexOf(searchElement /*, fromIndex */) {
	          return arrayIndexOf(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        includes: function includes(searchElement /*, fromIndex */) {
	          return arrayIncludes(validate(this), searchElement, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        join: function join(separator) {
	          // eslint-disable-line no-unused-vars
	          return arrayJoin.apply(validate(this), arguments);
	        },
	        lastIndexOf: function lastIndexOf(searchElement /*, fromIndex */) {
	          // eslint-disable-line no-unused-vars
	          return arrayLastIndexOf.apply(validate(this), arguments);
	        },
	        map: function map(mapfn /*, thisArg */) {
	          return $map(validate(this), mapfn, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        reduce: function reduce(callbackfn /*, initialValue */) {
	          // eslint-disable-line no-unused-vars
	          return arrayReduce.apply(validate(this), arguments);
	        },
	        reduceRight: function reduceRight(callbackfn /*, initialValue */) {
	          // eslint-disable-line no-unused-vars
	          return arrayReduceRight.apply(validate(this), arguments);
	        },
	        reverse: function reverse() {
	          var that = this,
	              length = validate(that).length,
	              middle = Math.floor(length / 2),
	              index = 0,
	              value;
	          while (index < middle) {
	            value = that[index];
	            that[index++] = that[--length];
	            that[length] = value;
	          }return that;
	        },
	        some: function some(callbackfn /*, thisArg */) {
	          return arraySome(validate(this), callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	        },
	        sort: function sort(comparefn) {
	          return arraySort.call(validate(this), comparefn);
	        },
	        subarray: function subarray(begin, end) {
	          var O = validate(this),
	              length = O.length,
	              $begin = toIndex(begin, length);
	          return new (speciesConstructor(O, O[DEF_CONSTRUCTOR]))(O.buffer, O.byteOffset + $begin * O.BYTES_PER_ELEMENT, toLength((end === undefined ? length : toIndex(end, length)) - $begin));
	        }
	      };
	
	      var $slice = function slice(start, end) {
	        return speciesFromList(this, arraySlice.call(validate(this), start, end));
	      };
	
	      var $set = function set(arrayLike /*, offset */) {
	        validate(this);
	        var offset = toOffset(arguments[1], 1),
	            length = this.length,
	            src = toObject(arrayLike),
	            len = toLength(src.length),
	            index = 0;
	        if (len + offset > length) throw RangeError(WRONG_LENGTH);
	        while (index < len) {
	          this[offset + index] = src[index++];
	        }
	      };
	
	      var $iterators = {
	        entries: function entries() {
	          return arrayEntries.call(validate(this));
	        },
	        keys: function keys() {
	          return arrayKeys.call(validate(this));
	        },
	        values: function values() {
	          return arrayValues.call(validate(this));
	        }
	      };
	
	      var isTAIndex = function isTAIndex(target, key) {
	        return isObject(target) && target[TYPED_ARRAY] && (typeof key === "undefined" ? "undefined" : _typeof(key)) != 'symbol' && key in target && String(+key) == String(key);
	      };
	      var $getDesc = function getOwnPropertyDescriptor(target, key) {
	        return isTAIndex(target, key = toPrimitive(key, true)) ? propertyDesc(2, target[key]) : gOPD(target, key);
	      };
	      var $setDesc = function defineProperty(target, key, desc) {
	        if (isTAIndex(target, key = toPrimitive(key, true)) && isObject(desc) && has(desc, 'value') && !has(desc, 'get') && !has(desc, 'set')
	        // TODO: add validation descriptor w/o calling accessors
	        && !desc.configurable && (!has(desc, 'writable') || desc.writable) && (!has(desc, 'enumerable') || desc.enumerable)) {
	          target[key] = desc.value;
	          return target;
	        } else return dP(target, key, desc);
	      };
	
	      if (!ALL_CONSTRUCTORS) {
	        $GOPD.f = $getDesc;
	        $DP.f = $setDesc;
	      }
	
	      $export($export.S + $export.F * !ALL_CONSTRUCTORS, 'Object', {
	        getOwnPropertyDescriptor: $getDesc,
	        defineProperty: $setDesc
	      });
	
	      if (fails(function () {
	        arrayToString.call({});
	      })) {
	        arrayToString = arrayToLocaleString = function toString() {
	          return arrayJoin.call(this);
	        };
	      }
	
	      var $TypedArrayPrototype$ = redefineAll({}, proto);
	      redefineAll($TypedArrayPrototype$, $iterators);
	      hide($TypedArrayPrototype$, ITERATOR, $iterators.values);
	      redefineAll($TypedArrayPrototype$, {
	        slice: $slice,
	        set: $set,
	        constructor: function constructor() {/* noop */},
	        toString: arrayToString,
	        toLocaleString: $toLocaleString
	      });
	      addGetter($TypedArrayPrototype$, 'buffer', 'b');
	      addGetter($TypedArrayPrototype$, 'byteOffset', 'o');
	      addGetter($TypedArrayPrototype$, 'byteLength', 'l');
	      addGetter($TypedArrayPrototype$, 'length', 'e');
	      dP($TypedArrayPrototype$, TAG, {
	        get: function get() {
	          return this[TYPED_ARRAY];
	        }
	      });
	
	      module.exports = function (KEY, BYTES, wrapper, CLAMPED) {
	        CLAMPED = !!CLAMPED;
	        var NAME = KEY + (CLAMPED ? 'Clamped' : '') + 'Array',
	            ISNT_UINT8 = NAME != 'Uint8Array',
	            GETTER = 'get' + KEY,
	            SETTER = 'set' + KEY,
	            TypedArray = global[NAME],
	            Base = TypedArray || {},
	            TAC = TypedArray && getPrototypeOf(TypedArray),
	            FORCED = !TypedArray || !$typed.ABV,
	            O = {},
	            TypedArrayPrototype = TypedArray && TypedArray[PROTOTYPE];
	        var getter = function getter(that, index) {
	          var data = that._d;
	          return data.v[GETTER](index * BYTES + data.o, LITTLE_ENDIAN);
	        };
	        var setter = function setter(that, index, value) {
	          var data = that._d;
	          if (CLAMPED) value = (value = Math.round(value)) < 0 ? 0 : value > 0xff ? 0xff : value & 0xff;
	          data.v[SETTER](index * BYTES + data.o, value, LITTLE_ENDIAN);
	        };
	        var addElement = function addElement(that, index) {
	          dP(that, index, {
	            get: function get() {
	              return getter(this, index);
	            },
	            set: function set(value) {
	              return setter(this, index, value);
	            },
	            enumerable: true
	          });
	        };
	        if (FORCED) {
	          TypedArray = wrapper(function (that, data, $offset, $length) {
	            anInstance(that, TypedArray, NAME, '_d');
	            var index = 0,
	                offset = 0,
	                buffer,
	                byteLength,
	                length,
	                klass;
	            if (!isObject(data)) {
	              length = strictToLength(data, true);
	              byteLength = length * BYTES;
	              buffer = new $ArrayBuffer(byteLength);
	            } else if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	              buffer = data;
	              offset = toOffset($offset, BYTES);
	              var $len = data.byteLength;
	              if ($length === undefined) {
	                if ($len % BYTES) throw RangeError(WRONG_LENGTH);
	                byteLength = $len - offset;
	                if (byteLength < 0) throw RangeError(WRONG_LENGTH);
	              } else {
	                byteLength = toLength($length) * BYTES;
	                if (byteLength + offset > $len) throw RangeError(WRONG_LENGTH);
	              }
	              length = byteLength / BYTES;
	            } else if (TYPED_ARRAY in data) {
	              return fromList(TypedArray, data);
	            } else {
	              return $from.call(TypedArray, data);
	            }
	            hide(that, '_d', {
	              b: buffer,
	              o: offset,
	              l: byteLength,
	              e: length,
	              v: new $DataView(buffer)
	            });
	            while (index < length) {
	              addElement(that, index++);
	            }
	          });
	          TypedArrayPrototype = TypedArray[PROTOTYPE] = create($TypedArrayPrototype$);
	          hide(TypedArrayPrototype, 'constructor', TypedArray);
	        } else if (!$iterDetect(function (iter) {
	          // V8 works with iterators, but fails in many other cases
	          // https://code.google.com/p/v8/issues/detail?id=4552
	          new TypedArray(null); // eslint-disable-line no-new
	          new TypedArray(iter); // eslint-disable-line no-new
	        }, true)) {
	          TypedArray = wrapper(function (that, data, $offset, $length) {
	            anInstance(that, TypedArray, NAME);
	            var klass;
	            // `ws` module bug, temporarily remove validation length for Uint8Array
	            // https://github.com/websockets/ws/pull/645
	            if (!isObject(data)) return new Base(strictToLength(data, ISNT_UINT8));
	            if (data instanceof $ArrayBuffer || (klass = classof(data)) == ARRAY_BUFFER || klass == SHARED_BUFFER) {
	              return $length !== undefined ? new Base(data, toOffset($offset, BYTES), $length) : $offset !== undefined ? new Base(data, toOffset($offset, BYTES)) : new Base(data);
	            }
	            if (TYPED_ARRAY in data) return fromList(TypedArray, data);
	            return $from.call(TypedArray, data);
	          });
	          arrayForEach(TAC !== Function.prototype ? gOPN(Base).concat(gOPN(TAC)) : gOPN(Base), function (key) {
	            if (!(key in TypedArray)) hide(TypedArray, key, Base[key]);
	          });
	          TypedArray[PROTOTYPE] = TypedArrayPrototype;
	          if (!LIBRARY) TypedArrayPrototype.constructor = TypedArray;
	        }
	        var $nativeIterator = TypedArrayPrototype[ITERATOR],
	            CORRECT_ITER_NAME = !!$nativeIterator && ($nativeIterator.name == 'values' || $nativeIterator.name == undefined),
	            $iterator = $iterators.values;
	        hide(TypedArray, TYPED_CONSTRUCTOR, true);
	        hide(TypedArrayPrototype, TYPED_ARRAY, NAME);
	        hide(TypedArrayPrototype, VIEW, true);
	        hide(TypedArrayPrototype, DEF_CONSTRUCTOR, TypedArray);
	
	        if (CLAMPED ? new TypedArray(1)[TAG] != NAME : !(TAG in TypedArrayPrototype)) {
	          dP(TypedArrayPrototype, TAG, {
	            get: function get() {
	              return NAME;
	            }
	          });
	        }
	
	        O[NAME] = TypedArray;
	
	        $export($export.G + $export.W + $export.F * (TypedArray != Base), O);
	
	        $export($export.S, NAME, {
	          BYTES_PER_ELEMENT: BYTES,
	          from: $from,
	          of: $of
	        });
	
	        if (!(BYTES_PER_ELEMENT in TypedArrayPrototype)) hide(TypedArrayPrototype, BYTES_PER_ELEMENT, BYTES);
	
	        $export($export.P, NAME, proto);
	
	        setSpecies(NAME);
	
	        $export($export.P + $export.F * FORCED_SET, NAME, { set: $set });
	
	        $export($export.P + $export.F * !CORRECT_ITER_NAME, NAME, $iterators);
	
	        $export($export.P + $export.F * (TypedArrayPrototype.toString != arrayToString), NAME, { toString: arrayToString });
	
	        $export($export.P + $export.F * fails(function () {
	          new TypedArray(1).slice();
	        }), NAME, { slice: $slice });
	
	        $export($export.P + $export.F * (fails(function () {
	          return [1, 2].toLocaleString() != new TypedArray([1, 2]).toLocaleString();
	        }) || !fails(function () {
	          TypedArrayPrototype.toLocaleString.call([1, 2]);
	        })), NAME, { toLocaleString: $toLocaleString });
	
	        Iterators[NAME] = CORRECT_ITER_NAME ? $nativeIterator : $iterator;
	        if (!LIBRARY && !CORRECT_ITER_NAME) hide(TypedArrayPrototype, ITERATOR, $iterator);
	      };
	    } else module.exports = function () {/* empty */};
	  }, { "105": 105, "106": 106, "108": 108, "109": 109, "11": 11, "110": 110, "112": 112, "113": 113, "114": 114, "117": 117, "118": 118, "12": 12, "130": 130, "17": 17, "25": 25, "28": 28, "32": 32, "34": 34, "38": 38, "39": 39, "40": 40, "46": 46, "49": 49, "54": 54, "56": 56, "58": 58, "6": 6, "66": 66, "67": 67, "70": 70, "72": 72, "74": 74, "8": 8, "85": 85, "86": 86, "89": 89, "9": 9, "91": 91, "95": 95 }], 112: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var global = _dereq_(38),
	        DESCRIPTORS = _dereq_(28),
	        LIBRARY = _dereq_(58),
	        $typed = _dereq_(113),
	        hide = _dereq_(40),
	        redefineAll = _dereq_(86),
	        fails = _dereq_(34),
	        anInstance = _dereq_(6),
	        toInteger = _dereq_(106),
	        toLength = _dereq_(108),
	        gOPN = _dereq_(72).f,
	        dP = _dereq_(67).f,
	        arrayFill = _dereq_(9),
	        setToStringTag = _dereq_(92),
	        ARRAY_BUFFER = 'ArrayBuffer',
	        DATA_VIEW = 'DataView',
	        PROTOTYPE = 'prototype',
	        WRONG_LENGTH = 'Wrong length!',
	        WRONG_INDEX = 'Wrong index!',
	        $ArrayBuffer = global[ARRAY_BUFFER],
	        $DataView = global[DATA_VIEW],
	        Math = global.Math,
	        RangeError = global.RangeError,
	        Infinity = global.Infinity,
	        BaseBuffer = $ArrayBuffer,
	        abs = Math.abs,
	        pow = Math.pow,
	        floor = Math.floor,
	        log = Math.log,
	        LN2 = Math.LN2,
	        BUFFER = 'buffer',
	        BYTE_LENGTH = 'byteLength',
	        BYTE_OFFSET = 'byteOffset',
	        $BUFFER = DESCRIPTORS ? '_b' : BUFFER,
	        $LENGTH = DESCRIPTORS ? '_l' : BYTE_LENGTH,
	        $OFFSET = DESCRIPTORS ? '_o' : BYTE_OFFSET;
	
	    // IEEE754 conversions based on https://github.com/feross/ieee754
	    var packIEEE754 = function packIEEE754(value, mLen, nBytes) {
	      var buffer = Array(nBytes),
	          eLen = nBytes * 8 - mLen - 1,
	          eMax = (1 << eLen) - 1,
	          eBias = eMax >> 1,
	          rt = mLen === 23 ? pow(2, -24) - pow(2, -77) : 0,
	          i = 0,
	          s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0,
	          e,
	          m,
	          c;
	      value = abs(value);
	      if (value != value || value === Infinity) {
	        m = value != value ? 1 : 0;
	        e = eMax;
	      } else {
	        e = floor(log(value) / LN2);
	        if (value * (c = pow(2, -e)) < 1) {
	          e--;
	          c *= 2;
	        }
	        if (e + eBias >= 1) {
	          value += rt / c;
	        } else {
	          value += rt * pow(2, 1 - eBias);
	        }
	        if (value * c >= 2) {
	          e++;
	          c /= 2;
	        }
	        if (e + eBias >= eMax) {
	          m = 0;
	          e = eMax;
	        } else if (e + eBias >= 1) {
	          m = (value * c - 1) * pow(2, mLen);
	          e = e + eBias;
	        } else {
	          m = value * pow(2, eBias - 1) * pow(2, mLen);
	          e = 0;
	        }
	      }
	      for (; mLen >= 8; buffer[i++] = m & 255, m /= 256, mLen -= 8) {}
	      e = e << mLen | m;
	      eLen += mLen;
	      for (; eLen > 0; buffer[i++] = e & 255, e /= 256, eLen -= 8) {}
	      buffer[--i] |= s * 128;
	      return buffer;
	    };
	    var unpackIEEE754 = function unpackIEEE754(buffer, mLen, nBytes) {
	      var eLen = nBytes * 8 - mLen - 1,
	          eMax = (1 << eLen) - 1,
	          eBias = eMax >> 1,
	          nBits = eLen - 7,
	          i = nBytes - 1,
	          s = buffer[i--],
	          e = s & 127,
	          m;
	      s >>= 7;
	      for (; nBits > 0; e = e * 256 + buffer[i], i--, nBits -= 8) {}
	      m = e & (1 << -nBits) - 1;
	      e >>= -nBits;
	      nBits += mLen;
	      for (; nBits > 0; m = m * 256 + buffer[i], i--, nBits -= 8) {}
	      if (e === 0) {
	        e = 1 - eBias;
	      } else if (e === eMax) {
	        return m ? NaN : s ? -Infinity : Infinity;
	      } else {
	        m = m + pow(2, mLen);
	        e = e - eBias;
	      }return (s ? -1 : 1) * m * pow(2, e - mLen);
	    };
	
	    var unpackI32 = function unpackI32(bytes) {
	      return bytes[3] << 24 | bytes[2] << 16 | bytes[1] << 8 | bytes[0];
	    };
	    var packI8 = function packI8(it) {
	      return [it & 0xff];
	    };
	    var packI16 = function packI16(it) {
	      return [it & 0xff, it >> 8 & 0xff];
	    };
	    var packI32 = function packI32(it) {
	      return [it & 0xff, it >> 8 & 0xff, it >> 16 & 0xff, it >> 24 & 0xff];
	    };
	    var packF64 = function packF64(it) {
	      return packIEEE754(it, 52, 8);
	    };
	    var packF32 = function packF32(it) {
	      return packIEEE754(it, 23, 4);
	    };
	
	    var addGetter = function addGetter(C, key, internal) {
	      dP(C[PROTOTYPE], key, { get: function get() {
	          return this[internal];
	        } });
	    };
	
	    var get = function get(view, bytes, index, isLittleEndian) {
	      var numIndex = +index,
	          intIndex = toInteger(numIndex);
	      if (numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	      var store = view[$BUFFER]._b,
	          start = intIndex + view[$OFFSET],
	          pack = store.slice(start, start + bytes);
	      return isLittleEndian ? pack : pack.reverse();
	    };
	    var set = function set(view, bytes, index, conversion, value, isLittleEndian) {
	      var numIndex = +index,
	          intIndex = toInteger(numIndex);
	      if (numIndex != intIndex || intIndex < 0 || intIndex + bytes > view[$LENGTH]) throw RangeError(WRONG_INDEX);
	      var store = view[$BUFFER]._b,
	          start = intIndex + view[$OFFSET],
	          pack = conversion(+value);
	      for (var i = 0; i < bytes; i++) {
	        store[start + i] = pack[isLittleEndian ? i : bytes - i - 1];
	      }
	    };
	
	    var validateArrayBufferArguments = function validateArrayBufferArguments(that, length) {
	      anInstance(that, $ArrayBuffer, ARRAY_BUFFER);
	      var numberLength = +length,
	          byteLength = toLength(numberLength);
	      if (numberLength != byteLength) throw RangeError(WRONG_LENGTH);
	      return byteLength;
	    };
	
	    if (!$typed.ABV) {
	      $ArrayBuffer = function ArrayBuffer(length) {
	        var byteLength = validateArrayBufferArguments(this, length);
	        this._b = arrayFill.call(Array(byteLength), 0);
	        this[$LENGTH] = byteLength;
	      };
	
	      $DataView = function DataView(buffer, byteOffset, byteLength) {
	        anInstance(this, $DataView, DATA_VIEW);
	        anInstance(buffer, $ArrayBuffer, DATA_VIEW);
	        var bufferLength = buffer[$LENGTH],
	            offset = toInteger(byteOffset);
	        if (offset < 0 || offset > bufferLength) throw RangeError('Wrong offset!');
	        byteLength = byteLength === undefined ? bufferLength - offset : toLength(byteLength);
	        if (offset + byteLength > bufferLength) throw RangeError(WRONG_LENGTH);
	        this[$BUFFER] = buffer;
	        this[$OFFSET] = offset;
	        this[$LENGTH] = byteLength;
	      };
	
	      if (DESCRIPTORS) {
	        addGetter($ArrayBuffer, BYTE_LENGTH, '_l');
	        addGetter($DataView, BUFFER, '_b');
	        addGetter($DataView, BYTE_LENGTH, '_l');
	        addGetter($DataView, BYTE_OFFSET, '_o');
	      }
	
	      redefineAll($DataView[PROTOTYPE], {
	        getInt8: function getInt8(byteOffset) {
	          return get(this, 1, byteOffset)[0] << 24 >> 24;
	        },
	        getUint8: function getUint8(byteOffset) {
	          return get(this, 1, byteOffset)[0];
	        },
	        getInt16: function getInt16(byteOffset /*, littleEndian */) {
	          var bytes = get(this, 2, byteOffset, arguments[1]);
	          return (bytes[1] << 8 | bytes[0]) << 16 >> 16;
	        },
	        getUint16: function getUint16(byteOffset /*, littleEndian */) {
	          var bytes = get(this, 2, byteOffset, arguments[1]);
	          return bytes[1] << 8 | bytes[0];
	        },
	        getInt32: function getInt32(byteOffset /*, littleEndian */) {
	          return unpackI32(get(this, 4, byteOffset, arguments[1]));
	        },
	        getUint32: function getUint32(byteOffset /*, littleEndian */) {
	          return unpackI32(get(this, 4, byteOffset, arguments[1])) >>> 0;
	        },
	        getFloat32: function getFloat32(byteOffset /*, littleEndian */) {
	          return unpackIEEE754(get(this, 4, byteOffset, arguments[1]), 23, 4);
	        },
	        getFloat64: function getFloat64(byteOffset /*, littleEndian */) {
	          return unpackIEEE754(get(this, 8, byteOffset, arguments[1]), 52, 8);
	        },
	        setInt8: function setInt8(byteOffset, value) {
	          set(this, 1, byteOffset, packI8, value);
	        },
	        setUint8: function setUint8(byteOffset, value) {
	          set(this, 1, byteOffset, packI8, value);
	        },
	        setInt16: function setInt16(byteOffset, value /*, littleEndian */) {
	          set(this, 2, byteOffset, packI16, value, arguments[2]);
	        },
	        setUint16: function setUint16(byteOffset, value /*, littleEndian */) {
	          set(this, 2, byteOffset, packI16, value, arguments[2]);
	        },
	        setInt32: function setInt32(byteOffset, value /*, littleEndian */) {
	          set(this, 4, byteOffset, packI32, value, arguments[2]);
	        },
	        setUint32: function setUint32(byteOffset, value /*, littleEndian */) {
	          set(this, 4, byteOffset, packI32, value, arguments[2]);
	        },
	        setFloat32: function setFloat32(byteOffset, value /*, littleEndian */) {
	          set(this, 4, byteOffset, packF32, value, arguments[2]);
	        },
	        setFloat64: function setFloat64(byteOffset, value /*, littleEndian */) {
	          set(this, 8, byteOffset, packF64, value, arguments[2]);
	        }
	      });
	    } else {
	      if (!fails(function () {
	        new $ArrayBuffer(); // eslint-disable-line no-new
	      }) || !fails(function () {
	        new $ArrayBuffer(.5); // eslint-disable-line no-new
	      })) {
	        $ArrayBuffer = function ArrayBuffer(length) {
	          return new BaseBuffer(validateArrayBufferArguments(this, length));
	        };
	        var ArrayBufferProto = $ArrayBuffer[PROTOTYPE] = BaseBuffer[PROTOTYPE];
	        for (var keys = gOPN(BaseBuffer), j = 0, key; keys.length > j;) {
	          if (!((key = keys[j++]) in $ArrayBuffer)) hide($ArrayBuffer, key, BaseBuffer[key]);
	        };
	        if (!LIBRARY) ArrayBufferProto.constructor = $ArrayBuffer;
	      }
	      // iOS Safari 7.x bug
	      var view = new $DataView(new $ArrayBuffer(2)),
	          $setInt8 = $DataView[PROTOTYPE].setInt8;
	      view.setInt8(0, 2147483648);
	      view.setInt8(1, 2147483649);
	      if (view.getInt8(0) || !view.getInt8(1)) redefineAll($DataView[PROTOTYPE], {
	        setInt8: function setInt8(byteOffset, value) {
	          $setInt8.call(this, byteOffset, value << 24 >> 24);
	        },
	        setUint8: function setUint8(byteOffset, value) {
	          $setInt8.call(this, byteOffset, value << 24 >> 24);
	        }
	      }, true);
	    }
	    setToStringTag($ArrayBuffer, ARRAY_BUFFER);
	    setToStringTag($DataView, DATA_VIEW);
	    hide($DataView[PROTOTYPE], $typed.VIEW, true);
	    exports[ARRAY_BUFFER] = $ArrayBuffer;
	    exports[DATA_VIEW] = $DataView;
	  }, { "106": 106, "108": 108, "113": 113, "28": 28, "34": 34, "38": 38, "40": 40, "58": 58, "6": 6, "67": 67, "72": 72, "86": 86, "9": 9, "92": 92 }], 113: [function (_dereq_, module, exports) {
	    var global = _dereq_(38),
	        hide = _dereq_(40),
	        uid = _dereq_(114),
	        TYPED = uid('typed_array'),
	        VIEW = uid('view'),
	        ABV = !!(global.ArrayBuffer && global.DataView),
	        CONSTR = ABV,
	        i = 0,
	        l = 9,
	        Typed;
	
	    var TypedArrayConstructors = 'Int8Array,Uint8Array,Uint8ClampedArray,Int16Array,Uint16Array,Int32Array,Uint32Array,Float32Array,Float64Array'.split(',');
	
	    while (i < l) {
	      if (Typed = global[TypedArrayConstructors[i++]]) {
	        hide(Typed.prototype, TYPED, true);
	        hide(Typed.prototype, VIEW, true);
	      } else CONSTR = false;
	    }
	
	    module.exports = {
	      ABV: ABV,
	      CONSTR: CONSTR,
	      TYPED: TYPED,
	      VIEW: VIEW
	    };
	  }, { "114": 114, "38": 38, "40": 40 }], 114: [function (_dereq_, module, exports) {
	    var id = 0,
	        px = Math.random();
	    module.exports = function (key) {
	      return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
	    };
	  }, {}], 115: [function (_dereq_, module, exports) {
	    var global = _dereq_(38),
	        core = _dereq_(23),
	        LIBRARY = _dereq_(58),
	        wksExt = _dereq_(116),
	        defineProperty = _dereq_(67).f;
	    module.exports = function (name) {
	      var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
	      if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
	    };
	  }, { "116": 116, "23": 23, "38": 38, "58": 58, "67": 67 }], 116: [function (_dereq_, module, exports) {
	    exports.f = _dereq_(117);
	  }, { "117": 117 }], 117: [function (_dereq_, module, exports) {
	    var store = _dereq_(94)('wks'),
	        uid = _dereq_(114),
	        _Symbol = _dereq_(38).Symbol,
	        USE_SYMBOL = typeof _Symbol == 'function';
	
	    var $exports = module.exports = function (name) {
	      return store[name] || (store[name] = USE_SYMBOL && _Symbol[name] || (USE_SYMBOL ? _Symbol : uid)('Symbol.' + name));
	    };
	
	    $exports.store = store;
	  }, { "114": 114, "38": 38, "94": 94 }], 118: [function (_dereq_, module, exports) {
	    var classof = _dereq_(17),
	        ITERATOR = _dereq_(117)('iterator'),
	        Iterators = _dereq_(56);
	    module.exports = _dereq_(23).getIteratorMethod = function (it) {
	      if (it != undefined) return it[ITERATOR] || it['@@iterator'] || Iterators[classof(it)];
	    };
	  }, { "117": 117, "17": 17, "23": 23, "56": 56 }], 119: [function (_dereq_, module, exports) {
	    // https://github.com/benjamingr/RexExp.escape
	    var $export = _dereq_(32),
	        $re = _dereq_(88)(/[\\^$*+?.()|[\]{}]/g, '\\$&');
	
	    $export($export.S, 'RegExp', { escape: function escape(it) {
	        return $re(it);
	      } });
	  }, { "32": 32, "88": 88 }], 120: [function (_dereq_, module, exports) {
	    // 22.1.3.3 Array.prototype.copyWithin(target, start, end = this.length)
	    var $export = _dereq_(32);
	
	    $export($export.P, 'Array', { copyWithin: _dereq_(8) });
	
	    _dereq_(5)('copyWithin');
	  }, { "32": 32, "5": 5, "8": 8 }], 121: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $every = _dereq_(12)(4);
	
	    $export($export.P + $export.F * !_dereq_(96)([].every, true), 'Array', {
	      // 22.1.3.5 / 15.4.4.16 Array.prototype.every(callbackfn [, thisArg])
	      every: function every(callbackfn /* , thisArg */) {
	        return $every(this, callbackfn, arguments[1]);
	      }
	    });
	  }, { "12": 12, "32": 32, "96": 96 }], 122: [function (_dereq_, module, exports) {
	    // 22.1.3.6 Array.prototype.fill(value, start = 0, end = this.length)
	    var $export = _dereq_(32);
	
	    $export($export.P, 'Array', { fill: _dereq_(9) });
	
	    _dereq_(5)('fill');
	  }, { "32": 32, "5": 5, "9": 9 }], 123: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $filter = _dereq_(12)(2);
	
	    $export($export.P + $export.F * !_dereq_(96)([].filter, true), 'Array', {
	      // 22.1.3.7 / 15.4.4.20 Array.prototype.filter(callbackfn [, thisArg])
	      filter: function filter(callbackfn /* , thisArg */) {
	        return $filter(this, callbackfn, arguments[1]);
	      }
	    });
	  }, { "12": 12, "32": 32, "96": 96 }], 124: [function (_dereq_, module, exports) {
	    'use strict';
	    // 22.1.3.9 Array.prototype.findIndex(predicate, thisArg = undefined)
	
	    var $export = _dereq_(32),
	        $find = _dereq_(12)(6),
	        KEY = 'findIndex',
	        forced = true;
	    // Shouldn't skip holes
	    if (KEY in []) Array(1)[KEY](function () {
	      forced = false;
	    });
	    $export($export.P + $export.F * forced, 'Array', {
	      findIndex: function findIndex(callbackfn /*, that = undefined */) {
	        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	      }
	    });
	    _dereq_(5)(KEY);
	  }, { "12": 12, "32": 32, "5": 5 }], 125: [function (_dereq_, module, exports) {
	    'use strict';
	    // 22.1.3.8 Array.prototype.find(predicate, thisArg = undefined)
	
	    var $export = _dereq_(32),
	        $find = _dereq_(12)(5),
	        KEY = 'find',
	        forced = true;
	    // Shouldn't skip holes
	    if (KEY in []) Array(1)[KEY](function () {
	      forced = false;
	    });
	    $export($export.P + $export.F * forced, 'Array', {
	      find: function find(callbackfn /*, that = undefined */) {
	        return $find(this, callbackfn, arguments.length > 1 ? arguments[1] : undefined);
	      }
	    });
	    _dereq_(5)(KEY);
	  }, { "12": 12, "32": 32, "5": 5 }], 126: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $forEach = _dereq_(12)(0),
	        STRICT = _dereq_(96)([].forEach, true);
	
	    $export($export.P + $export.F * !STRICT, 'Array', {
	      // 22.1.3.10 / 15.4.4.18 Array.prototype.forEach(callbackfn [, thisArg])
	      forEach: function forEach(callbackfn /* , thisArg */) {
	        return $forEach(this, callbackfn, arguments[1]);
	      }
	    });
	  }, { "12": 12, "32": 32, "96": 96 }], 127: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var ctx = _dereq_(25),
	        $export = _dereq_(32),
	        toObject = _dereq_(109),
	        call = _dereq_(51),
	        isArrayIter = _dereq_(46),
	        toLength = _dereq_(108),
	        createProperty = _dereq_(24),
	        getIterFn = _dereq_(118);
	
	    $export($export.S + $export.F * !_dereq_(54)(function (iter) {
	      Array.from(iter);
	    }), 'Array', {
	      // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
	      from: function from(arrayLike /*, mapfn = undefined, thisArg = undefined*/) {
	        var O = toObject(arrayLike),
	            C = typeof this == 'function' ? this : Array,
	            aLen = arguments.length,
	            mapfn = aLen > 1 ? arguments[1] : undefined,
	            mapping = mapfn !== undefined,
	            index = 0,
	            iterFn = getIterFn(O),
	            length,
	            result,
	            step,
	            iterator;
	        if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
	        // if object isn't iterable or it's array with default iterator - use simple case
	        if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
	          for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
	            createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
	          }
	        } else {
	          length = toLength(O.length);
	          for (result = new C(length); length > index; index++) {
	            createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
	          }
	        }
	        result.length = index;
	        return result;
	      }
	    });
	  }, { "108": 108, "109": 109, "118": 118, "24": 24, "25": 25, "32": 32, "46": 46, "51": 51, "54": 54 }], 128: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $indexOf = _dereq_(11)(false),
	        $native = [].indexOf,
	        NEGATIVE_ZERO = !!$native && 1 / [1].indexOf(1, -0) < 0;
	
	    $export($export.P + $export.F * (NEGATIVE_ZERO || !_dereq_(96)($native)), 'Array', {
	      // 22.1.3.11 / 15.4.4.14 Array.prototype.indexOf(searchElement [, fromIndex])
	      indexOf: function indexOf(searchElement /*, fromIndex = 0 */) {
	        return NEGATIVE_ZERO
	        // convert -0 to +0
	        ? $native.apply(this, arguments) || 0 : $indexOf(this, searchElement, arguments[1]);
	      }
	    });
	  }, { "11": 11, "32": 32, "96": 96 }], 129: [function (_dereq_, module, exports) {
	    // 22.1.2.2 / 15.4.3.2 Array.isArray(arg)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Array', { isArray: _dereq_(47) });
	  }, { "32": 32, "47": 47 }], 130: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var addToUnscopables = _dereq_(5),
	        step = _dereq_(55),
	        Iterators = _dereq_(56),
	        toIObject = _dereq_(107);
	
	    // 22.1.3.4 Array.prototype.entries()
	    // 22.1.3.13 Array.prototype.keys()
	    // 22.1.3.29 Array.prototype.values()
	    // 22.1.3.30 Array.prototype[@@iterator]()
	    module.exports = _dereq_(53)(Array, 'Array', function (iterated, kind) {
	      this._t = toIObject(iterated); // target
	      this._i = 0; // next index
	      this._k = kind; // kind
	      // 22.1.5.2.1 %ArrayIteratorPrototype%.next()
	    }, function () {
	      var O = this._t,
	          kind = this._k,
	          index = this._i++;
	      if (!O || index >= O.length) {
	        this._t = undefined;
	        return step(1);
	      }
	      if (kind == 'keys') return step(0, index);
	      if (kind == 'values') return step(0, O[index]);
	      return step(0, [index, O[index]]);
	    }, 'values');
	
	    // argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
	    Iterators.Arguments = Iterators.Array;
	
	    addToUnscopables('keys');
	    addToUnscopables('values');
	    addToUnscopables('entries');
	  }, { "107": 107, "5": 5, "53": 53, "55": 55, "56": 56 }], 131: [function (_dereq_, module, exports) {
	    'use strict';
	    // 22.1.3.13 Array.prototype.join(separator)
	
	    var $export = _dereq_(32),
	        toIObject = _dereq_(107),
	        arrayJoin = [].join;
	
	    // fallback for not array-like strings
	    $export($export.P + $export.F * (_dereq_(45) != Object || !_dereq_(96)(arrayJoin)), 'Array', {
	      join: function join(separator) {
	        return arrayJoin.call(toIObject(this), separator === undefined ? ',' : separator);
	      }
	    });
	  }, { "107": 107, "32": 32, "45": 45, "96": 96 }], 132: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        toIObject = _dereq_(107),
	        toInteger = _dereq_(106),
	        toLength = _dereq_(108),
	        $native = [].lastIndexOf,
	        NEGATIVE_ZERO = !!$native && 1 / [1].lastIndexOf(1, -0) < 0;
	
	    $export($export.P + $export.F * (NEGATIVE_ZERO || !_dereq_(96)($native)), 'Array', {
	      // 22.1.3.14 / 15.4.4.15 Array.prototype.lastIndexOf(searchElement [, fromIndex])
	      lastIndexOf: function lastIndexOf(searchElement /*, fromIndex = @[*-1] */) {
	        // convert -0 to +0
	        if (NEGATIVE_ZERO) return $native.apply(this, arguments) || 0;
	        var O = toIObject(this),
	            length = toLength(O.length),
	            index = length - 1;
	        if (arguments.length > 1) index = Math.min(index, toInteger(arguments[1]));
	        if (index < 0) index = length + index;
	        for (; index >= 0; index--) {
	          if (index in O) if (O[index] === searchElement) return index || 0;
	        }return -1;
	      }
	    });
	  }, { "106": 106, "107": 107, "108": 108, "32": 32, "96": 96 }], 133: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $map = _dereq_(12)(1);
	
	    $export($export.P + $export.F * !_dereq_(96)([].map, true), 'Array', {
	      // 22.1.3.15 / 15.4.4.19 Array.prototype.map(callbackfn [, thisArg])
	      map: function map(callbackfn /* , thisArg */) {
	        return $map(this, callbackfn, arguments[1]);
	      }
	    });
	  }, { "12": 12, "32": 32, "96": 96 }], 134: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        createProperty = _dereq_(24);
	
	    // WebKit Array.of isn't generic
	    $export($export.S + $export.F * _dereq_(34)(function () {
	      function F() {}
	      return !(Array.of.call(F) instanceof F);
	    }), 'Array', {
	      // 22.1.2.3 Array.of( ...items)
	      of: function of() /* ...args */{
	        var index = 0,
	            aLen = arguments.length,
	            result = new (typeof this == 'function' ? this : Array)(aLen);
	        while (aLen > index) {
	          createProperty(result, index, arguments[index++]);
	        }result.length = aLen;
	        return result;
	      }
	    });
	  }, { "24": 24, "32": 32, "34": 34 }], 135: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $reduce = _dereq_(13);
	
	    $export($export.P + $export.F * !_dereq_(96)([].reduceRight, true), 'Array', {
	      // 22.1.3.19 / 15.4.4.22 Array.prototype.reduceRight(callbackfn [, initialValue])
	      reduceRight: function reduceRight(callbackfn /* , initialValue */) {
	        return $reduce(this, callbackfn, arguments.length, arguments[1], true);
	      }
	    });
	  }, { "13": 13, "32": 32, "96": 96 }], 136: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $reduce = _dereq_(13);
	
	    $export($export.P + $export.F * !_dereq_(96)([].reduce, true), 'Array', {
	      // 22.1.3.18 / 15.4.4.21 Array.prototype.reduce(callbackfn [, initialValue])
	      reduce: function reduce(callbackfn /* , initialValue */) {
	        return $reduce(this, callbackfn, arguments.length, arguments[1], false);
	      }
	    });
	  }, { "13": 13, "32": 32, "96": 96 }], 137: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        html = _dereq_(41),
	        cof = _dereq_(18),
	        toIndex = _dereq_(105),
	        toLength = _dereq_(108),
	        arraySlice = [].slice;
	
	    // fallback for not array-like ES3 strings and DOM objects
	    $export($export.P + $export.F * _dereq_(34)(function () {
	      if (html) arraySlice.call(html);
	    }), 'Array', {
	      slice: function slice(begin, end) {
	        var len = toLength(this.length),
	            klass = cof(this);
	        end = end === undefined ? len : end;
	        if (klass == 'Array') return arraySlice.call(this, begin, end);
	        var start = toIndex(begin, len),
	            upTo = toIndex(end, len),
	            size = toLength(upTo - start),
	            cloned = Array(size),
	            i = 0;
	        for (; i < size; i++) {
	          cloned[i] = klass == 'String' ? this.charAt(start + i) : this[start + i];
	        }return cloned;
	      }
	    });
	  }, { "105": 105, "108": 108, "18": 18, "32": 32, "34": 34, "41": 41 }], 138: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $some = _dereq_(12)(3);
	
	    $export($export.P + $export.F * !_dereq_(96)([].some, true), 'Array', {
	      // 22.1.3.23 / 15.4.4.17 Array.prototype.some(callbackfn [, thisArg])
	      some: function some(callbackfn /* , thisArg */) {
	        return $some(this, callbackfn, arguments[1]);
	      }
	    });
	  }, { "12": 12, "32": 32, "96": 96 }], 139: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        aFunction = _dereq_(3),
	        toObject = _dereq_(109),
	        fails = _dereq_(34),
	        $sort = [].sort,
	        test = [1, 2, 3];
	
	    $export($export.P + $export.F * (fails(function () {
	      // IE8-
	      test.sort(undefined);
	    }) || !fails(function () {
	      // V8 bug
	      test.sort(null);
	      // Old WebKit
	    }) || !_dereq_(96)($sort)), 'Array', {
	      // 22.1.3.25 Array.prototype.sort(comparefn)
	      sort: function sort(comparefn) {
	        return comparefn === undefined ? $sort.call(toObject(this)) : $sort.call(toObject(this), aFunction(comparefn));
	      }
	    });
	  }, { "109": 109, "3": 3, "32": 32, "34": 34, "96": 96 }], 140: [function (_dereq_, module, exports) {
	    _dereq_(91)('Array');
	  }, { "91": 91 }], 141: [function (_dereq_, module, exports) {
	    // 20.3.3.1 / 15.9.4.4 Date.now()
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Date', { now: function now() {
	        return new Date().getTime();
	      } });
	  }, { "32": 32 }], 142: [function (_dereq_, module, exports) {
	    'use strict';
	    // 20.3.4.36 / 15.9.5.43 Date.prototype.toISOString()
	
	    var $export = _dereq_(32),
	        fails = _dereq_(34),
	        getTime = Date.prototype.getTime;
	
	    var lz = function lz(num) {
	      return num > 9 ? num : '0' + num;
	    };
	
	    // PhantomJS / old WebKit has a broken implementations
	    $export($export.P + $export.F * (fails(function () {
	      return new Date(-5e13 - 1).toISOString() != '0385-07-25T07:06:39.999Z';
	    }) || !fails(function () {
	      new Date(NaN).toISOString();
	    })), 'Date', {
	      toISOString: function toISOString() {
	        if (!isFinite(getTime.call(this))) throw RangeError('Invalid time value');
	        var d = this,
	            y = d.getUTCFullYear(),
	            m = d.getUTCMilliseconds(),
	            s = y < 0 ? '-' : y > 9999 ? '+' : '';
	        return s + ('00000' + Math.abs(y)).slice(s ? -6 : -4) + '-' + lz(d.getUTCMonth() + 1) + '-' + lz(d.getUTCDate()) + 'T' + lz(d.getUTCHours()) + ':' + lz(d.getUTCMinutes()) + ':' + lz(d.getUTCSeconds()) + '.' + (m > 99 ? m : '0' + lz(m)) + 'Z';
	      }
	    });
	  }, { "32": 32, "34": 34 }], 143: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        toObject = _dereq_(109),
	        toPrimitive = _dereq_(110);
	
	    $export($export.P + $export.F * _dereq_(34)(function () {
	      return new Date(NaN).toJSON() !== null || Date.prototype.toJSON.call({ toISOString: function toISOString() {
	          return 1;
	        } }) !== 1;
	    }), 'Date', {
	      toJSON: function toJSON(key) {
	        var O = toObject(this),
	            pv = toPrimitive(O);
	        return typeof pv == 'number' && !isFinite(pv) ? null : O.toISOString();
	      }
	    });
	  }, { "109": 109, "110": 110, "32": 32, "34": 34 }], 144: [function (_dereq_, module, exports) {
	    var TO_PRIMITIVE = _dereq_(117)('toPrimitive'),
	        proto = Date.prototype;
	
	    if (!(TO_PRIMITIVE in proto)) _dereq_(40)(proto, TO_PRIMITIVE, _dereq_(26));
	  }, { "117": 117, "26": 26, "40": 40 }], 145: [function (_dereq_, module, exports) {
	    var DateProto = Date.prototype,
	        INVALID_DATE = 'Invalid Date',
	        TO_STRING = 'toString',
	        $toString = DateProto[TO_STRING],
	        getTime = DateProto.getTime;
	    if (new Date(NaN) + '' != INVALID_DATE) {
	      _dereq_(87)(DateProto, TO_STRING, function toString() {
	        var value = getTime.call(this);
	        return value === value ? $toString.call(this) : INVALID_DATE;
	      });
	    }
	  }, { "87": 87 }], 146: [function (_dereq_, module, exports) {
	    // 19.2.3.2 / 15.3.4.5 Function.prototype.bind(thisArg, args...)
	    var $export = _dereq_(32);
	
	    $export($export.P, 'Function', { bind: _dereq_(16) });
	  }, { "16": 16, "32": 32 }], 147: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var isObject = _dereq_(49),
	        getPrototypeOf = _dereq_(74),
	        HAS_INSTANCE = _dereq_(117)('hasInstance'),
	        FunctionProto = Function.prototype;
	    // 19.2.3.6 Function.prototype[@@hasInstance](V)
	    if (!(HAS_INSTANCE in FunctionProto)) _dereq_(67).f(FunctionProto, HAS_INSTANCE, { value: function value(O) {
	        if (typeof this != 'function' || !isObject(O)) return false;
	        if (!isObject(this.prototype)) return O instanceof this;
	        // for environment w/o native `@@hasInstance` logic enough `instanceof`, but add this:
	        while (O = getPrototypeOf(O)) {
	          if (this.prototype === O) return true;
	        }return false;
	      } });
	  }, { "117": 117, "49": 49, "67": 67, "74": 74 }], 148: [function (_dereq_, module, exports) {
	    var dP = _dereq_(67).f,
	        createDesc = _dereq_(85),
	        has = _dereq_(39),
	        FProto = Function.prototype,
	        nameRE = /^\s*function ([^ (]*)/,
	        NAME = 'name';
	
	    var isExtensible = Object.isExtensible || function () {
	      return true;
	    };
	
	    // 19.2.4.2 name
	    NAME in FProto || _dereq_(28) && dP(FProto, NAME, {
	      configurable: true,
	      get: function get() {
	        try {
	          var that = this,
	              name = ('' + that).match(nameRE)[1];
	          has(that, NAME) || !isExtensible(that) || dP(that, NAME, createDesc(5, name));
	          return name;
	        } catch (e) {
	          return '';
	        }
	      }
	    });
	  }, { "28": 28, "39": 39, "67": 67, "85": 85 }], 149: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var strong = _dereq_(19);
	
	    // 23.1 Map Objects
	    module.exports = _dereq_(22)('Map', function (get) {
	      return function Map() {
	        return get(this, arguments.length > 0 ? arguments[0] : undefined);
	      };
	    }, {
	      // 23.1.3.6 Map.prototype.get(key)
	      get: function get(key) {
	        var entry = strong.getEntry(this, key);
	        return entry && entry.v;
	      },
	      // 23.1.3.9 Map.prototype.set(key, value)
	      set: function set(key, value) {
	        return strong.def(this, key === 0 ? 0 : key, value);
	      }
	    }, strong, true);
	  }, { "19": 19, "22": 22 }], 150: [function (_dereq_, module, exports) {
	    // 20.2.2.3 Math.acosh(x)
	    var $export = _dereq_(32),
	        log1p = _dereq_(60),
	        sqrt = Math.sqrt,
	        $acosh = Math.acosh;
	
	    $export($export.S + $export.F * !($acosh
	    // V8 bug: https://code.google.com/p/v8/issues/detail?id=3509
	    && Math.floor($acosh(Number.MAX_VALUE)) == 710
	    // Tor Browser bug: Math.acosh(Infinity) -> NaN 
	    && $acosh(Infinity) == Infinity), 'Math', {
	      acosh: function acosh(x) {
	        return (x = +x) < 1 ? NaN : x > 94906265.62425156 ? Math.log(x) + Math.LN2 : log1p(x - 1 + sqrt(x - 1) * sqrt(x + 1));
	      }
	    });
	  }, { "32": 32, "60": 60 }], 151: [function (_dereq_, module, exports) {
	    // 20.2.2.5 Math.asinh(x)
	    var $export = _dereq_(32),
	        $asinh = Math.asinh;
	
	    function asinh(x) {
	      return !isFinite(x = +x) || x == 0 ? x : x < 0 ? -asinh(-x) : Math.log(x + Math.sqrt(x * x + 1));
	    }
	
	    // Tor Browser bug: Math.asinh(0) -> -0 
	    $export($export.S + $export.F * !($asinh && 1 / $asinh(0) > 0), 'Math', { asinh: asinh });
	  }, { "32": 32 }], 152: [function (_dereq_, module, exports) {
	    // 20.2.2.7 Math.atanh(x)
	    var $export = _dereq_(32),
	        $atanh = Math.atanh;
	
	    // Tor Browser bug: Math.atanh(-0) -> 0 
	    $export($export.S + $export.F * !($atanh && 1 / $atanh(-0) < 0), 'Math', {
	      atanh: function atanh(x) {
	        return (x = +x) == 0 ? x : Math.log((1 + x) / (1 - x)) / 2;
	      }
	    });
	  }, { "32": 32 }], 153: [function (_dereq_, module, exports) {
	    // 20.2.2.9 Math.cbrt(x)
	    var $export = _dereq_(32),
	        sign = _dereq_(61);
	
	    $export($export.S, 'Math', {
	      cbrt: function cbrt(x) {
	        return sign(x = +x) * Math.pow(Math.abs(x), 1 / 3);
	      }
	    });
	  }, { "32": 32, "61": 61 }], 154: [function (_dereq_, module, exports) {
	    // 20.2.2.11 Math.clz32(x)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      clz32: function clz32(x) {
	        return (x >>>= 0) ? 31 - Math.floor(Math.log(x + 0.5) * Math.LOG2E) : 32;
	      }
	    });
	  }, { "32": 32 }], 155: [function (_dereq_, module, exports) {
	    // 20.2.2.12 Math.cosh(x)
	    var $export = _dereq_(32),
	        exp = Math.exp;
	
	    $export($export.S, 'Math', {
	      cosh: function cosh(x) {
	        return (exp(x = +x) + exp(-x)) / 2;
	      }
	    });
	  }, { "32": 32 }], 156: [function (_dereq_, module, exports) {
	    // 20.2.2.14 Math.expm1(x)
	    var $export = _dereq_(32),
	        $expm1 = _dereq_(59);
	
	    $export($export.S + $export.F * ($expm1 != Math.expm1), 'Math', { expm1: $expm1 });
	  }, { "32": 32, "59": 59 }], 157: [function (_dereq_, module, exports) {
	    // 20.2.2.16 Math.fround(x)
	    var $export = _dereq_(32),
	        sign = _dereq_(61),
	        pow = Math.pow,
	        EPSILON = pow(2, -52),
	        EPSILON32 = pow(2, -23),
	        MAX32 = pow(2, 127) * (2 - EPSILON32),
	        MIN32 = pow(2, -126);
	
	    var roundTiesToEven = function roundTiesToEven(n) {
	      return n + 1 / EPSILON - 1 / EPSILON;
	    };
	
	    $export($export.S, 'Math', {
	      fround: function fround(x) {
	        var $abs = Math.abs(x),
	            $sign = sign(x),
	            a,
	            result;
	        if ($abs < MIN32) return $sign * roundTiesToEven($abs / MIN32 / EPSILON32) * MIN32 * EPSILON32;
	        a = (1 + EPSILON32 / EPSILON) * $abs;
	        result = a - (a - $abs);
	        if (result > MAX32 || result != result) return $sign * Infinity;
	        return $sign * result;
	      }
	    });
	  }, { "32": 32, "61": 61 }], 158: [function (_dereq_, module, exports) {
	    // 20.2.2.17 Math.hypot([value1[, value2[, … ]]])
	    var $export = _dereq_(32),
	        abs = Math.abs;
	
	    $export($export.S, 'Math', {
	      hypot: function hypot(value1, value2) {
	        // eslint-disable-line no-unused-vars
	        var sum = 0,
	            i = 0,
	            aLen = arguments.length,
	            larg = 0,
	            arg,
	            div;
	        while (i < aLen) {
	          arg = abs(arguments[i++]);
	          if (larg < arg) {
	            div = larg / arg;
	            sum = sum * div * div + 1;
	            larg = arg;
	          } else if (arg > 0) {
	            div = arg / larg;
	            sum += div * div;
	          } else sum += arg;
	        }
	        return larg === Infinity ? Infinity : larg * Math.sqrt(sum);
	      }
	    });
	  }, { "32": 32 }], 159: [function (_dereq_, module, exports) {
	    // 20.2.2.18 Math.imul(x, y)
	    var $export = _dereq_(32),
	        $imul = Math.imul;
	
	    // some WebKit versions fails with big numbers, some has wrong arity
	    $export($export.S + $export.F * _dereq_(34)(function () {
	      return $imul(0xffffffff, 5) != -5 || $imul.length != 2;
	    }), 'Math', {
	      imul: function imul(x, y) {
	        var UINT16 = 0xffff,
	            xn = +x,
	            yn = +y,
	            xl = UINT16 & xn,
	            yl = UINT16 & yn;
	        return 0 | xl * yl + ((UINT16 & xn >>> 16) * yl + xl * (UINT16 & yn >>> 16) << 16 >>> 0);
	      }
	    });
	  }, { "32": 32, "34": 34 }], 160: [function (_dereq_, module, exports) {
	    // 20.2.2.21 Math.log10(x)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      log10: function log10(x) {
	        return Math.log(x) / Math.LN10;
	      }
	    });
	  }, { "32": 32 }], 161: [function (_dereq_, module, exports) {
	    // 20.2.2.20 Math.log1p(x)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', { log1p: _dereq_(60) });
	  }, { "32": 32, "60": 60 }], 162: [function (_dereq_, module, exports) {
	    // 20.2.2.22 Math.log2(x)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      log2: function log2(x) {
	        return Math.log(x) / Math.LN2;
	      }
	    });
	  }, { "32": 32 }], 163: [function (_dereq_, module, exports) {
	    // 20.2.2.28 Math.sign(x)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', { sign: _dereq_(61) });
	  }, { "32": 32, "61": 61 }], 164: [function (_dereq_, module, exports) {
	    // 20.2.2.30 Math.sinh(x)
	    var $export = _dereq_(32),
	        expm1 = _dereq_(59),
	        exp = Math.exp;
	
	    // V8 near Chromium 38 has a problem with very small numbers
	    $export($export.S + $export.F * _dereq_(34)(function () {
	      return !Math.sinh(-2e-17) != -2e-17;
	    }), 'Math', {
	      sinh: function sinh(x) {
	        return Math.abs(x = +x) < 1 ? (expm1(x) - expm1(-x)) / 2 : (exp(x - 1) - exp(-x - 1)) * (Math.E / 2);
	      }
	    });
	  }, { "32": 32, "34": 34, "59": 59 }], 165: [function (_dereq_, module, exports) {
	    // 20.2.2.33 Math.tanh(x)
	    var $export = _dereq_(32),
	        expm1 = _dereq_(59),
	        exp = Math.exp;
	
	    $export($export.S, 'Math', {
	      tanh: function tanh(x) {
	        var a = expm1(x = +x),
	            b = expm1(-x);
	        return a == Infinity ? 1 : b == Infinity ? -1 : (a - b) / (exp(x) + exp(-x));
	      }
	    });
	  }, { "32": 32, "59": 59 }], 166: [function (_dereq_, module, exports) {
	    // 20.2.2.34 Math.trunc(x)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      trunc: function trunc(it) {
	        return (it > 0 ? Math.floor : Math.ceil)(it);
	      }
	    });
	  }, { "32": 32 }], 167: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var global = _dereq_(38),
	        has = _dereq_(39),
	        cof = _dereq_(18),
	        inheritIfRequired = _dereq_(43),
	        toPrimitive = _dereq_(110),
	        fails = _dereq_(34),
	        gOPN = _dereq_(72).f,
	        gOPD = _dereq_(70).f,
	        dP = _dereq_(67).f,
	        $trim = _dereq_(102).trim,
	        NUMBER = 'Number',
	        $Number = global[NUMBER],
	        Base = $Number,
	        proto = $Number.prototype
	    // Opera ~12 has broken Object#toString
	    ,
	        BROKEN_COF = cof(_dereq_(66)(proto)) == NUMBER,
	        TRIM = 'trim' in String.prototype;
	
	    // 7.1.3 ToNumber(argument)
	    var toNumber = function toNumber(argument) {
	      var it = toPrimitive(argument, false);
	      if (typeof it == 'string' && it.length > 2) {
	        it = TRIM ? it.trim() : $trim(it, 3);
	        var first = it.charCodeAt(0),
	            third,
	            radix,
	            maxCode;
	        if (first === 43 || first === 45) {
	          third = it.charCodeAt(2);
	          if (third === 88 || third === 120) return NaN; // Number('+0x1') should be NaN, old V8 fix
	        } else if (first === 48) {
	          switch (it.charCodeAt(1)) {
	            case 66:case 98:
	              radix = 2;maxCode = 49;break; // fast equal /^0b[01]+$/i
	            case 79:case 111:
	              radix = 8;maxCode = 55;break; // fast equal /^0o[0-7]+$/i
	            default:
	              return +it;
	          }
	          for (var digits = it.slice(2), i = 0, l = digits.length, code; i < l; i++) {
	            code = digits.charCodeAt(i);
	            // parseInt parses a string to a first unavailable symbol
	            // but ToNumber should return NaN if a string contains unavailable symbols
	            if (code < 48 || code > maxCode) return NaN;
	          }return parseInt(digits, radix);
	        }
	      }return +it;
	    };
	
	    if (!$Number(' 0o1') || !$Number('0b1') || $Number('+0x1')) {
	      $Number = function Number(value) {
	        var it = arguments.length < 1 ? 0 : value,
	            that = this;
	        return that instanceof $Number
	        // check on 1..constructor(foo) case
	        && (BROKEN_COF ? fails(function () {
	          proto.valueOf.call(that);
	        }) : cof(that) != NUMBER) ? inheritIfRequired(new Base(toNumber(it)), that, $Number) : toNumber(it);
	      };
	      for (var keys = _dereq_(28) ? gOPN(Base) : (
	      // ES3:
	      'MAX_VALUE,MIN_VALUE,NaN,NEGATIVE_INFINITY,POSITIVE_INFINITY,' +
	      // ES6 (in case, if modules with ES6 Number statics required before):
	      'EPSILON,isFinite,isInteger,isNaN,isSafeInteger,MAX_SAFE_INTEGER,' + 'MIN_SAFE_INTEGER,parseFloat,parseInt,isInteger').split(','), j = 0, key; keys.length > j; j++) {
	        if (has(Base, key = keys[j]) && !has($Number, key)) {
	          dP($Number, key, gOPD(Base, key));
	        }
	      }
	      $Number.prototype = proto;
	      proto.constructor = $Number;
	      _dereq_(87)(global, NUMBER, $Number);
	    }
	  }, { "102": 102, "110": 110, "18": 18, "28": 28, "34": 34, "38": 38, "39": 39, "43": 43, "66": 66, "67": 67, "70": 70, "72": 72, "87": 87 }], 168: [function (_dereq_, module, exports) {
	    // 20.1.2.1 Number.EPSILON
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Number', { EPSILON: Math.pow(2, -52) });
	  }, { "32": 32 }], 169: [function (_dereq_, module, exports) {
	    // 20.1.2.2 Number.isFinite(number)
	    var $export = _dereq_(32),
	        _isFinite = _dereq_(38).isFinite;
	
	    $export($export.S, 'Number', {
	      isFinite: function isFinite(it) {
	        return typeof it == 'number' && _isFinite(it);
	      }
	    });
	  }, { "32": 32, "38": 38 }], 170: [function (_dereq_, module, exports) {
	    // 20.1.2.3 Number.isInteger(number)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Number', { isInteger: _dereq_(48) });
	  }, { "32": 32, "48": 48 }], 171: [function (_dereq_, module, exports) {
	    // 20.1.2.4 Number.isNaN(number)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Number', {
	      isNaN: function isNaN(number) {
	        return number != number;
	      }
	    });
	  }, { "32": 32 }], 172: [function (_dereq_, module, exports) {
	    // 20.1.2.5 Number.isSafeInteger(number)
	    var $export = _dereq_(32),
	        isInteger = _dereq_(48),
	        abs = Math.abs;
	
	    $export($export.S, 'Number', {
	      isSafeInteger: function isSafeInteger(number) {
	        return isInteger(number) && abs(number) <= 0x1fffffffffffff;
	      }
	    });
	  }, { "32": 32, "48": 48 }], 173: [function (_dereq_, module, exports) {
	    // 20.1.2.6 Number.MAX_SAFE_INTEGER
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Number', { MAX_SAFE_INTEGER: 0x1fffffffffffff });
	  }, { "32": 32 }], 174: [function (_dereq_, module, exports) {
	    // 20.1.2.10 Number.MIN_SAFE_INTEGER
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Number', { MIN_SAFE_INTEGER: -0x1fffffffffffff });
	  }, { "32": 32 }], 175: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        $parseFloat = _dereq_(81);
	    // 20.1.2.12 Number.parseFloat(string)
	    $export($export.S + $export.F * (Number.parseFloat != $parseFloat), 'Number', { parseFloat: $parseFloat });
	  }, { "32": 32, "81": 81 }], 176: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        $parseInt = _dereq_(82);
	    // 20.1.2.13 Number.parseInt(string, radix)
	    $export($export.S + $export.F * (Number.parseInt != $parseInt), 'Number', { parseInt: $parseInt });
	  }, { "32": 32, "82": 82 }], 177: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        toInteger = _dereq_(106),
	        aNumberValue = _dereq_(4),
	        repeat = _dereq_(101),
	        $toFixed = 1..toFixed,
	        floor = Math.floor,
	        data = [0, 0, 0, 0, 0, 0],
	        ERROR = 'Number.toFixed: incorrect invocation!',
	        ZERO = '0';
	
	    var multiply = function multiply(n, c) {
	      var i = -1,
	          c2 = c;
	      while (++i < 6) {
	        c2 += n * data[i];
	        data[i] = c2 % 1e7;
	        c2 = floor(c2 / 1e7);
	      }
	    };
	    var divide = function divide(n) {
	      var i = 6,
	          c = 0;
	      while (--i >= 0) {
	        c += data[i];
	        data[i] = floor(c / n);
	        c = c % n * 1e7;
	      }
	    };
	    var numToString = function numToString() {
	      var i = 6,
	          s = '';
	      while (--i >= 0) {
	        if (s !== '' || i === 0 || data[i] !== 0) {
	          var t = String(data[i]);
	          s = s === '' ? t : s + repeat.call(ZERO, 7 - t.length) + t;
	        }
	      }return s;
	    };
	    var pow = function pow(x, n, acc) {
	      return n === 0 ? acc : n % 2 === 1 ? pow(x, n - 1, acc * x) : pow(x * x, n / 2, acc);
	    };
	    var log = function log(x) {
	      var n = 0,
	          x2 = x;
	      while (x2 >= 4096) {
	        n += 12;
	        x2 /= 4096;
	      }
	      while (x2 >= 2) {
	        n += 1;
	        x2 /= 2;
	      }return n;
	    };
	
	    $export($export.P + $export.F * (!!$toFixed && (0.00008.toFixed(3) !== '0.000' || 0.9.toFixed(0) !== '1' || 1.255.toFixed(2) !== '1.25' || 1000000000000000128..toFixed(0) !== '1000000000000000128') || !_dereq_(34)(function () {
	      // V8 ~ Android 4.3-
	      $toFixed.call({});
	    })), 'Number', {
	      toFixed: function toFixed(fractionDigits) {
	        var x = aNumberValue(this, ERROR),
	            f = toInteger(fractionDigits),
	            s = '',
	            m = ZERO,
	            e,
	            z,
	            j,
	            k;
	        if (f < 0 || f > 20) throw RangeError(ERROR);
	        if (x != x) return 'NaN';
	        if (x <= -1e21 || x >= 1e21) return String(x);
	        if (x < 0) {
	          s = '-';
	          x = -x;
	        }
	        if (x > 1e-21) {
	          e = log(x * pow(2, 69, 1)) - 69;
	          z = e < 0 ? x * pow(2, -e, 1) : x / pow(2, e, 1);
	          z *= 0x10000000000000;
	          e = 52 - e;
	          if (e > 0) {
	            multiply(0, z);
	            j = f;
	            while (j >= 7) {
	              multiply(1e7, 0);
	              j -= 7;
	            }
	            multiply(pow(10, j, 1), 0);
	            j = e - 1;
	            while (j >= 23) {
	              divide(1 << 23);
	              j -= 23;
	            }
	            divide(1 << j);
	            multiply(1, 1);
	            divide(2);
	            m = numToString();
	          } else {
	            multiply(0, z);
	            multiply(1 << -e, 0);
	            m = numToString() + repeat.call(ZERO, f);
	          }
	        }
	        if (f > 0) {
	          k = m.length;
	          m = s + (k <= f ? '0.' + repeat.call(ZERO, f - k) + m : m.slice(0, k - f) + '.' + m.slice(k - f));
	        } else {
	          m = s + m;
	        }return m;
	      }
	    });
	  }, { "101": 101, "106": 106, "32": 32, "34": 34, "4": 4 }], 178: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $fails = _dereq_(34),
	        aNumberValue = _dereq_(4),
	        $toPrecision = 1..toPrecision;
	
	    $export($export.P + $export.F * ($fails(function () {
	      // IE7-
	      return $toPrecision.call(1, undefined) !== '1';
	    }) || !$fails(function () {
	      // V8 ~ Android 4.3-
	      $toPrecision.call({});
	    })), 'Number', {
	      toPrecision: function toPrecision(precision) {
	        var that = aNumberValue(this, 'Number#toPrecision: incorrect invocation!');
	        return precision === undefined ? $toPrecision.call(that) : $toPrecision.call(that, precision);
	      }
	    });
	  }, { "32": 32, "34": 34, "4": 4 }], 179: [function (_dereq_, module, exports) {
	    // 19.1.3.1 Object.assign(target, source)
	    var $export = _dereq_(32);
	
	    $export($export.S + $export.F, 'Object', { assign: _dereq_(65) });
	  }, { "32": 32, "65": 65 }], 180: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32);
	    // 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
	    $export($export.S, 'Object', { create: _dereq_(66) });
	  }, { "32": 32, "66": 66 }], 181: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32);
	    // 19.1.2.3 / 15.2.3.7 Object.defineProperties(O, Properties)
	    $export($export.S + $export.F * !_dereq_(28), 'Object', { defineProperties: _dereq_(68) });
	  }, { "28": 28, "32": 32, "68": 68 }], 182: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32);
	    // 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
	    $export($export.S + $export.F * !_dereq_(28), 'Object', { defineProperty: _dereq_(67).f });
	  }, { "28": 28, "32": 32, "67": 67 }], 183: [function (_dereq_, module, exports) {
	    // 19.1.2.5 Object.freeze(O)
	    var isObject = _dereq_(49),
	        meta = _dereq_(62).onFreeze;
	
	    _dereq_(78)('freeze', function ($freeze) {
	      return function freeze(it) {
	        return $freeze && isObject(it) ? $freeze(meta(it)) : it;
	      };
	    });
	  }, { "49": 49, "62": 62, "78": 78 }], 184: [function (_dereq_, module, exports) {
	    // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	    var toIObject = _dereq_(107),
	        $getOwnPropertyDescriptor = _dereq_(70).f;
	
	    _dereq_(78)('getOwnPropertyDescriptor', function () {
	      return function getOwnPropertyDescriptor(it, key) {
	        return $getOwnPropertyDescriptor(toIObject(it), key);
	      };
	    });
	  }, { "107": 107, "70": 70, "78": 78 }], 185: [function (_dereq_, module, exports) {
	    // 19.1.2.7 Object.getOwnPropertyNames(O)
	    _dereq_(78)('getOwnPropertyNames', function () {
	      return _dereq_(71).f;
	    });
	  }, { "71": 71, "78": 78 }], 186: [function (_dereq_, module, exports) {
	    // 19.1.2.9 Object.getPrototypeOf(O)
	    var toObject = _dereq_(109),
	        $getPrototypeOf = _dereq_(74);
	
	    _dereq_(78)('getPrototypeOf', function () {
	      return function getPrototypeOf(it) {
	        return $getPrototypeOf(toObject(it));
	      };
	    });
	  }, { "109": 109, "74": 74, "78": 78 }], 187: [function (_dereq_, module, exports) {
	    // 19.1.2.11 Object.isExtensible(O)
	    var isObject = _dereq_(49);
	
	    _dereq_(78)('isExtensible', function ($isExtensible) {
	      return function isExtensible(it) {
	        return isObject(it) ? $isExtensible ? $isExtensible(it) : true : false;
	      };
	    });
	  }, { "49": 49, "78": 78 }], 188: [function (_dereq_, module, exports) {
	    // 19.1.2.12 Object.isFrozen(O)
	    var isObject = _dereq_(49);
	
	    _dereq_(78)('isFrozen', function ($isFrozen) {
	      return function isFrozen(it) {
	        return isObject(it) ? $isFrozen ? $isFrozen(it) : false : true;
	      };
	    });
	  }, { "49": 49, "78": 78 }], 189: [function (_dereq_, module, exports) {
	    // 19.1.2.13 Object.isSealed(O)
	    var isObject = _dereq_(49);
	
	    _dereq_(78)('isSealed', function ($isSealed) {
	      return function isSealed(it) {
	        return isObject(it) ? $isSealed ? $isSealed(it) : false : true;
	      };
	    });
	  }, { "49": 49, "78": 78 }], 190: [function (_dereq_, module, exports) {
	    // 19.1.3.10 Object.is(value1, value2)
	    var $export = _dereq_(32);
	    $export($export.S, 'Object', { is: _dereq_(89) });
	  }, { "32": 32, "89": 89 }], 191: [function (_dereq_, module, exports) {
	    // 19.1.2.14 Object.keys(O)
	    var toObject = _dereq_(109),
	        $keys = _dereq_(76);
	
	    _dereq_(78)('keys', function () {
	      return function keys(it) {
	        return $keys(toObject(it));
	      };
	    });
	  }, { "109": 109, "76": 76, "78": 78 }], 192: [function (_dereq_, module, exports) {
	    // 19.1.2.15 Object.preventExtensions(O)
	    var isObject = _dereq_(49),
	        meta = _dereq_(62).onFreeze;
	
	    _dereq_(78)('preventExtensions', function ($preventExtensions) {
	      return function preventExtensions(it) {
	        return $preventExtensions && isObject(it) ? $preventExtensions(meta(it)) : it;
	      };
	    });
	  }, { "49": 49, "62": 62, "78": 78 }], 193: [function (_dereq_, module, exports) {
	    // 19.1.2.17 Object.seal(O)
	    var isObject = _dereq_(49),
	        meta = _dereq_(62).onFreeze;
	
	    _dereq_(78)('seal', function ($seal) {
	      return function seal(it) {
	        return $seal && isObject(it) ? $seal(meta(it)) : it;
	      };
	    });
	  }, { "49": 49, "62": 62, "78": 78 }], 194: [function (_dereq_, module, exports) {
	    // 19.1.3.19 Object.setPrototypeOf(O, proto)
	    var $export = _dereq_(32);
	    $export($export.S, 'Object', { setPrototypeOf: _dereq_(90).set });
	  }, { "32": 32, "90": 90 }], 195: [function (_dereq_, module, exports) {
	    'use strict';
	    // 19.1.3.6 Object.prototype.toString()
	
	    var classof = _dereq_(17),
	        test = {};
	    test[_dereq_(117)('toStringTag')] = 'z';
	    if (test + '' != '[object z]') {
	      _dereq_(87)(Object.prototype, 'toString', function toString() {
	        return '[object ' + classof(this) + ']';
	      }, true);
	    }
	  }, { "117": 117, "17": 17, "87": 87 }], 196: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        $parseFloat = _dereq_(81);
	    // 18.2.4 parseFloat(string)
	    $export($export.G + $export.F * (parseFloat != $parseFloat), { parseFloat: $parseFloat });
	  }, { "32": 32, "81": 81 }], 197: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        $parseInt = _dereq_(82);
	    // 18.2.5 parseInt(string, radix)
	    $export($export.G + $export.F * (parseInt != $parseInt), { parseInt: $parseInt });
	  }, { "32": 32, "82": 82 }], 198: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var LIBRARY = _dereq_(58),
	        global = _dereq_(38),
	        ctx = _dereq_(25),
	        classof = _dereq_(17),
	        $export = _dereq_(32),
	        isObject = _dereq_(49),
	        aFunction = _dereq_(3),
	        anInstance = _dereq_(6),
	        forOf = _dereq_(37),
	        speciesConstructor = _dereq_(95),
	        task = _dereq_(104).set,
	        microtask = _dereq_(64)(),
	        PROMISE = 'Promise',
	        TypeError = global.TypeError,
	        process = global.process,
	        $Promise = global[PROMISE],
	        process = global.process,
	        isNode = classof(process) == 'process',
	        empty = function empty() {/* empty */},
	        Internal,
	        GenericPromiseCapability,
	        Wrapper;
	
	    var USE_NATIVE = !!function () {
	      try {
	        // correct subclassing with @@species support
	        var promise = $Promise.resolve(1),
	            FakePromise = (promise.constructor = {})[_dereq_(117)('species')] = function (exec) {
	          exec(empty, empty);
	        };
	        // unhandled rejections tracking support, NodeJS Promise without it fails @@species test
	        return (isNode || typeof PromiseRejectionEvent == 'function') && promise.then(empty) instanceof FakePromise;
	      } catch (e) {/* empty */}
	    }();
	
	    // helpers
	    var sameConstructor = function sameConstructor(a, b) {
	      // with library wrapper special case
	      return a === b || a === $Promise && b === Wrapper;
	    };
	    var isThenable = function isThenable(it) {
	      var then;
	      return isObject(it) && typeof (then = it.then) == 'function' ? then : false;
	    };
	    var newPromiseCapability = function newPromiseCapability(C) {
	      return sameConstructor($Promise, C) ? new PromiseCapability(C) : new GenericPromiseCapability(C);
	    };
	    var PromiseCapability = GenericPromiseCapability = function GenericPromiseCapability(C) {
	      var resolve, reject;
	      this.promise = new C(function ($$resolve, $$reject) {
	        if (resolve !== undefined || reject !== undefined) throw TypeError('Bad Promise constructor');
	        resolve = $$resolve;
	        reject = $$reject;
	      });
	      this.resolve = aFunction(resolve);
	      this.reject = aFunction(reject);
	    };
	    var perform = function perform(exec) {
	      try {
	        exec();
	      } catch (e) {
	        return { error: e };
	      }
	    };
	    var notify = function notify(promise, isReject) {
	      if (promise._n) return;
	      promise._n = true;
	      var chain = promise._c;
	      microtask(function () {
	        var value = promise._v,
	            ok = promise._s == 1,
	            i = 0;
	        var run = function run(reaction) {
	          var handler = ok ? reaction.ok : reaction.fail,
	              resolve = reaction.resolve,
	              reject = reaction.reject,
	              domain = reaction.domain,
	              result,
	              then;
	          try {
	            if (handler) {
	              if (!ok) {
	                if (promise._h == 2) onHandleUnhandled(promise);
	                promise._h = 1;
	              }
	              if (handler === true) result = value;else {
	                if (domain) domain.enter();
	                result = handler(value);
	                if (domain) domain.exit();
	              }
	              if (result === reaction.promise) {
	                reject(TypeError('Promise-chain cycle'));
	              } else if (then = isThenable(result)) {
	                then.call(result, resolve, reject);
	              } else resolve(result);
	            } else reject(value);
	          } catch (e) {
	            reject(e);
	          }
	        };
	        while (chain.length > i) {
	          run(chain[i++]);
	        } // variable length - can't use forEach
	        promise._c = [];
	        promise._n = false;
	        if (isReject && !promise._h) onUnhandled(promise);
	      });
	    };
	    var onUnhandled = function onUnhandled(promise) {
	      task.call(global, function () {
	        var value = promise._v,
	            abrupt,
	            handler,
	            console;
	        if (isUnhandled(promise)) {
	          abrupt = perform(function () {
	            if (isNode) {
	              process.emit('unhandledRejection', value, promise);
	            } else if (handler = global.onunhandledrejection) {
	              handler({ promise: promise, reason: value });
	            } else if ((console = global.console) && console.error) {
	              console.error('Unhandled promise rejection', value);
	            }
	          });
	          // Browsers should not trigger `rejectionHandled` event if it was handled here, NodeJS - should
	          promise._h = isNode || isUnhandled(promise) ? 2 : 1;
	        }promise._a = undefined;
	        if (abrupt) throw abrupt.error;
	      });
	    };
	    var isUnhandled = function isUnhandled(promise) {
	      if (promise._h == 1) return false;
	      var chain = promise._a || promise._c,
	          i = 0,
	          reaction;
	      while (chain.length > i) {
	        reaction = chain[i++];
	        if (reaction.fail || !isUnhandled(reaction.promise)) return false;
	      }return true;
	    };
	    var onHandleUnhandled = function onHandleUnhandled(promise) {
	      task.call(global, function () {
	        var handler;
	        if (isNode) {
	          process.emit('rejectionHandled', promise);
	        } else if (handler = global.onrejectionhandled) {
	          handler({ promise: promise, reason: promise._v });
	        }
	      });
	    };
	    var $reject = function $reject(value) {
	      var promise = this;
	      if (promise._d) return;
	      promise._d = true;
	      promise = promise._w || promise; // unwrap
	      promise._v = value;
	      promise._s = 2;
	      if (!promise._a) promise._a = promise._c.slice();
	      notify(promise, true);
	    };
	    var $resolve = function $resolve(value) {
	      var promise = this,
	          then;
	      if (promise._d) return;
	      promise._d = true;
	      promise = promise._w || promise; // unwrap
	      try {
	        if (promise === value) throw TypeError("Promise can't be resolved itself");
	        if (then = isThenable(value)) {
	          microtask(function () {
	            var wrapper = { _w: promise, _d: false }; // wrap
	            try {
	              then.call(value, ctx($resolve, wrapper, 1), ctx($reject, wrapper, 1));
	            } catch (e) {
	              $reject.call(wrapper, e);
	            }
	          });
	        } else {
	          promise._v = value;
	          promise._s = 1;
	          notify(promise, false);
	        }
	      } catch (e) {
	        $reject.call({ _w: promise, _d: false }, e); // wrap
	      }
	    };
	
	    // constructor polyfill
	    if (!USE_NATIVE) {
	      // 25.4.3.1 Promise(executor)
	      $Promise = function Promise(executor) {
	        anInstance(this, $Promise, PROMISE, '_h');
	        aFunction(executor);
	        Internal.call(this);
	        try {
	          executor(ctx($resolve, this, 1), ctx($reject, this, 1));
	        } catch (err) {
	          $reject.call(this, err);
	        }
	      };
	      Internal = function Promise(executor) {
	        this._c = []; // <- awaiting reactions
	        this._a = undefined; // <- checked in isUnhandled reactions
	        this._s = 0; // <- state
	        this._d = false; // <- done
	        this._v = undefined; // <- value
	        this._h = 0; // <- rejection state, 0 - default, 1 - handled, 2 - unhandled
	        this._n = false; // <- notify
	      };
	      Internal.prototype = _dereq_(86)($Promise.prototype, {
	        // 25.4.5.3 Promise.prototype.then(onFulfilled, onRejected)
	        then: function then(onFulfilled, onRejected) {
	          var reaction = newPromiseCapability(speciesConstructor(this, $Promise));
	          reaction.ok = typeof onFulfilled == 'function' ? onFulfilled : true;
	          reaction.fail = typeof onRejected == 'function' && onRejected;
	          reaction.domain = isNode ? process.domain : undefined;
	          this._c.push(reaction);
	          if (this._a) this._a.push(reaction);
	          if (this._s) notify(this, false);
	          return reaction.promise;
	        },
	        // 25.4.5.1 Promise.prototype.catch(onRejected)
	        'catch': function _catch(onRejected) {
	          return this.then(undefined, onRejected);
	        }
	      });
	      PromiseCapability = function PromiseCapability() {
	        var promise = new Internal();
	        this.promise = promise;
	        this.resolve = ctx($resolve, promise, 1);
	        this.reject = ctx($reject, promise, 1);
	      };
	    }
	
	    $export($export.G + $export.W + $export.F * !USE_NATIVE, { Promise: $Promise });
	    _dereq_(92)($Promise, PROMISE);
	    _dereq_(91)(PROMISE);
	    Wrapper = _dereq_(23)[PROMISE];
	
	    // statics
	    $export($export.S + $export.F * !USE_NATIVE, PROMISE, {
	      // 25.4.4.5 Promise.reject(r)
	      reject: function reject(r) {
	        var capability = newPromiseCapability(this),
	            $$reject = capability.reject;
	        $$reject(r);
	        return capability.promise;
	      }
	    });
	    $export($export.S + $export.F * (LIBRARY || !USE_NATIVE), PROMISE, {
	      // 25.4.4.6 Promise.resolve(x)
	      resolve: function resolve(x) {
	        // instanceof instead of internal slot check because we should fix it without replacement native Promise core
	        if (x instanceof $Promise && sameConstructor(x.constructor, this)) return x;
	        var capability = newPromiseCapability(this),
	            $$resolve = capability.resolve;
	        $$resolve(x);
	        return capability.promise;
	      }
	    });
	    $export($export.S + $export.F * !(USE_NATIVE && _dereq_(54)(function (iter) {
	      $Promise.all(iter)['catch'](empty);
	    })), PROMISE, {
	      // 25.4.4.1 Promise.all(iterable)
	      all: function all(iterable) {
	        var C = this,
	            capability = newPromiseCapability(C),
	            resolve = capability.resolve,
	            reject = capability.reject;
	        var abrupt = perform(function () {
	          var values = [],
	              index = 0,
	              remaining = 1;
	          forOf(iterable, false, function (promise) {
	            var $index = index++,
	                alreadyCalled = false;
	            values.push(undefined);
	            remaining++;
	            C.resolve(promise).then(function (value) {
	              if (alreadyCalled) return;
	              alreadyCalled = true;
	              values[$index] = value;
	              --remaining || resolve(values);
	            }, reject);
	          });
	          --remaining || resolve(values);
	        });
	        if (abrupt) reject(abrupt.error);
	        return capability.promise;
	      },
	      // 25.4.4.4 Promise.race(iterable)
	      race: function race(iterable) {
	        var C = this,
	            capability = newPromiseCapability(C),
	            reject = capability.reject;
	        var abrupt = perform(function () {
	          forOf(iterable, false, function (promise) {
	            C.resolve(promise).then(capability.resolve, reject);
	          });
	        });
	        if (abrupt) reject(abrupt.error);
	        return capability.promise;
	      }
	    });
	  }, { "104": 104, "117": 117, "17": 17, "23": 23, "25": 25, "3": 3, "32": 32, "37": 37, "38": 38, "49": 49, "54": 54, "58": 58, "6": 6, "64": 64, "86": 86, "91": 91, "92": 92, "95": 95 }], 199: [function (_dereq_, module, exports) {
	    // 26.1.1 Reflect.apply(target, thisArgument, argumentsList)
	    var $export = _dereq_(32),
	        aFunction = _dereq_(3),
	        anObject = _dereq_(7),
	        rApply = (_dereq_(38).Reflect || {}).apply,
	        fApply = Function.apply;
	    // MS Edge argumentsList argument is optional
	    $export($export.S + $export.F * !_dereq_(34)(function () {
	      rApply(function () {});
	    }), 'Reflect', {
	      apply: function apply(target, thisArgument, argumentsList) {
	        var T = aFunction(target),
	            L = anObject(argumentsList);
	        return rApply ? rApply(T, thisArgument, L) : fApply.call(T, thisArgument, L);
	      }
	    });
	  }, { "3": 3, "32": 32, "34": 34, "38": 38, "7": 7 }], 200: [function (_dereq_, module, exports) {
	    // 26.1.2 Reflect.construct(target, argumentsList [, newTarget])
	    var $export = _dereq_(32),
	        create = _dereq_(66),
	        aFunction = _dereq_(3),
	        anObject = _dereq_(7),
	        isObject = _dereq_(49),
	        fails = _dereq_(34),
	        bind = _dereq_(16),
	        rConstruct = (_dereq_(38).Reflect || {}).construct;
	
	    // MS Edge supports only 2 arguments and argumentsList argument is optional
	    // FF Nightly sets third argument as `new.target`, but does not create `this` from it
	    var NEW_TARGET_BUG = fails(function () {
	      function F() {}
	      return !(rConstruct(function () {}, [], F) instanceof F);
	    });
	    var ARGS_BUG = !fails(function () {
	      rConstruct(function () {});
	    });
	
	    $export($export.S + $export.F * (NEW_TARGET_BUG || ARGS_BUG), 'Reflect', {
	      construct: function construct(Target, args /*, newTarget*/) {
	        aFunction(Target);
	        anObject(args);
	        var newTarget = arguments.length < 3 ? Target : aFunction(arguments[2]);
	        if (ARGS_BUG && !NEW_TARGET_BUG) return rConstruct(Target, args, newTarget);
	        if (Target == newTarget) {
	          // w/o altered newTarget, optimization for 0-4 arguments
	          switch (args.length) {
	            case 0:
	              return new Target();
	            case 1:
	              return new Target(args[0]);
	            case 2:
	              return new Target(args[0], args[1]);
	            case 3:
	              return new Target(args[0], args[1], args[2]);
	            case 4:
	              return new Target(args[0], args[1], args[2], args[3]);
	          }
	          // w/o altered newTarget, lot of arguments case
	          var $args = [null];
	          $args.push.apply($args, args);
	          return new (bind.apply(Target, $args))();
	        }
	        // with altered newTarget, not support built-in constructors
	        var proto = newTarget.prototype,
	            instance = create(isObject(proto) ? proto : Object.prototype),
	            result = Function.apply.call(Target, instance, args);
	        return isObject(result) ? result : instance;
	      }
	    });
	  }, { "16": 16, "3": 3, "32": 32, "34": 34, "38": 38, "49": 49, "66": 66, "7": 7 }], 201: [function (_dereq_, module, exports) {
	    // 26.1.3 Reflect.defineProperty(target, propertyKey, attributes)
	    var dP = _dereq_(67),
	        $export = _dereq_(32),
	        anObject = _dereq_(7),
	        toPrimitive = _dereq_(110);
	
	    // MS Edge has broken Reflect.defineProperty - throwing instead of returning false
	    $export($export.S + $export.F * _dereq_(34)(function () {
	      Reflect.defineProperty(dP.f({}, 1, { value: 1 }), 1, { value: 2 });
	    }), 'Reflect', {
	      defineProperty: function defineProperty(target, propertyKey, attributes) {
	        anObject(target);
	        propertyKey = toPrimitive(propertyKey, true);
	        anObject(attributes);
	        try {
	          dP.f(target, propertyKey, attributes);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      }
	    });
	  }, { "110": 110, "32": 32, "34": 34, "67": 67, "7": 7 }], 202: [function (_dereq_, module, exports) {
	    // 26.1.4 Reflect.deleteProperty(target, propertyKey)
	    var $export = _dereq_(32),
	        gOPD = _dereq_(70).f,
	        anObject = _dereq_(7);
	
	    $export($export.S, 'Reflect', {
	      deleteProperty: function deleteProperty(target, propertyKey) {
	        var desc = gOPD(anObject(target), propertyKey);
	        return desc && !desc.configurable ? false : delete target[propertyKey];
	      }
	    });
	  }, { "32": 32, "7": 7, "70": 70 }], 203: [function (_dereq_, module, exports) {
	    'use strict';
	    // 26.1.5 Reflect.enumerate(target)
	
	    var $export = _dereq_(32),
	        anObject = _dereq_(7);
	    var Enumerate = function Enumerate(iterated) {
	      this._t = anObject(iterated); // target
	      this._i = 0; // next index
	      var keys = this._k = [] // keys
	      ,
	          key;
	      for (key in iterated) {
	        keys.push(key);
	      }
	    };
	    _dereq_(52)(Enumerate, 'Object', function () {
	      var that = this,
	          keys = that._k,
	          key;
	      do {
	        if (that._i >= keys.length) return { value: undefined, done: true };
	      } while (!((key = keys[that._i++]) in that._t));
	      return { value: key, done: false };
	    });
	
	    $export($export.S, 'Reflect', {
	      enumerate: function enumerate(target) {
	        return new Enumerate(target);
	      }
	    });
	  }, { "32": 32, "52": 52, "7": 7 }], 204: [function (_dereq_, module, exports) {
	    // 26.1.7 Reflect.getOwnPropertyDescriptor(target, propertyKey)
	    var gOPD = _dereq_(70),
	        $export = _dereq_(32),
	        anObject = _dereq_(7);
	
	    $export($export.S, 'Reflect', {
	      getOwnPropertyDescriptor: function getOwnPropertyDescriptor(target, propertyKey) {
	        return gOPD.f(anObject(target), propertyKey);
	      }
	    });
	  }, { "32": 32, "7": 7, "70": 70 }], 205: [function (_dereq_, module, exports) {
	    // 26.1.8 Reflect.getPrototypeOf(target)
	    var $export = _dereq_(32),
	        getProto = _dereq_(74),
	        anObject = _dereq_(7);
	
	    $export($export.S, 'Reflect', {
	      getPrototypeOf: function getPrototypeOf(target) {
	        return getProto(anObject(target));
	      }
	    });
	  }, { "32": 32, "7": 7, "74": 74 }], 206: [function (_dereq_, module, exports) {
	    // 26.1.6 Reflect.get(target, propertyKey [, receiver])
	    var gOPD = _dereq_(70),
	        getPrototypeOf = _dereq_(74),
	        has = _dereq_(39),
	        $export = _dereq_(32),
	        isObject = _dereq_(49),
	        anObject = _dereq_(7);
	
	    function get(target, propertyKey /*, receiver*/) {
	      var receiver = arguments.length < 3 ? target : arguments[2],
	          desc,
	          proto;
	      if (anObject(target) === receiver) return target[propertyKey];
	      if (desc = gOPD.f(target, propertyKey)) return has(desc, 'value') ? desc.value : desc.get !== undefined ? desc.get.call(receiver) : undefined;
	      if (isObject(proto = getPrototypeOf(target))) return get(proto, propertyKey, receiver);
	    }
	
	    $export($export.S, 'Reflect', { get: get });
	  }, { "32": 32, "39": 39, "49": 49, "7": 7, "70": 70, "74": 74 }], 207: [function (_dereq_, module, exports) {
	    // 26.1.9 Reflect.has(target, propertyKey)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Reflect', {
	      has: function has(target, propertyKey) {
	        return propertyKey in target;
	      }
	    });
	  }, { "32": 32 }], 208: [function (_dereq_, module, exports) {
	    // 26.1.10 Reflect.isExtensible(target)
	    var $export = _dereq_(32),
	        anObject = _dereq_(7),
	        $isExtensible = Object.isExtensible;
	
	    $export($export.S, 'Reflect', {
	      isExtensible: function isExtensible(target) {
	        anObject(target);
	        return $isExtensible ? $isExtensible(target) : true;
	      }
	    });
	  }, { "32": 32, "7": 7 }], 209: [function (_dereq_, module, exports) {
	    // 26.1.11 Reflect.ownKeys(target)
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Reflect', { ownKeys: _dereq_(80) });
	  }, { "32": 32, "80": 80 }], 210: [function (_dereq_, module, exports) {
	    // 26.1.12 Reflect.preventExtensions(target)
	    var $export = _dereq_(32),
	        anObject = _dereq_(7),
	        $preventExtensions = Object.preventExtensions;
	
	    $export($export.S, 'Reflect', {
	      preventExtensions: function preventExtensions(target) {
	        anObject(target);
	        try {
	          if ($preventExtensions) $preventExtensions(target);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      }
	    });
	  }, { "32": 32, "7": 7 }], 211: [function (_dereq_, module, exports) {
	    // 26.1.14 Reflect.setPrototypeOf(target, proto)
	    var $export = _dereq_(32),
	        setProto = _dereq_(90);
	
	    if (setProto) $export($export.S, 'Reflect', {
	      setPrototypeOf: function setPrototypeOf(target, proto) {
	        setProto.check(target, proto);
	        try {
	          setProto.set(target, proto);
	          return true;
	        } catch (e) {
	          return false;
	        }
	      }
	    });
	  }, { "32": 32, "90": 90 }], 212: [function (_dereq_, module, exports) {
	    // 26.1.13 Reflect.set(target, propertyKey, V [, receiver])
	    var dP = _dereq_(67),
	        gOPD = _dereq_(70),
	        getPrototypeOf = _dereq_(74),
	        has = _dereq_(39),
	        $export = _dereq_(32),
	        createDesc = _dereq_(85),
	        anObject = _dereq_(7),
	        isObject = _dereq_(49);
	
	    function set(target, propertyKey, V /*, receiver*/) {
	      var receiver = arguments.length < 4 ? target : arguments[3],
	          ownDesc = gOPD.f(anObject(target), propertyKey),
	          existingDescriptor,
	          proto;
	      if (!ownDesc) {
	        if (isObject(proto = getPrototypeOf(target))) {
	          return set(proto, propertyKey, V, receiver);
	        }
	        ownDesc = createDesc(0);
	      }
	      if (has(ownDesc, 'value')) {
	        if (ownDesc.writable === false || !isObject(receiver)) return false;
	        existingDescriptor = gOPD.f(receiver, propertyKey) || createDesc(0);
	        existingDescriptor.value = V;
	        dP.f(receiver, propertyKey, existingDescriptor);
	        return true;
	      }
	      return ownDesc.set === undefined ? false : (ownDesc.set.call(receiver, V), true);
	    }
	
	    $export($export.S, 'Reflect', { set: set });
	  }, { "32": 32, "39": 39, "49": 49, "67": 67, "7": 7, "70": 70, "74": 74, "85": 85 }], 213: [function (_dereq_, module, exports) {
	    var global = _dereq_(38),
	        inheritIfRequired = _dereq_(43),
	        dP = _dereq_(67).f,
	        gOPN = _dereq_(72).f,
	        isRegExp = _dereq_(50),
	        $flags = _dereq_(36),
	        $RegExp = global.RegExp,
	        Base = $RegExp,
	        proto = $RegExp.prototype,
	        re1 = /a/g,
	        re2 = /a/g
	    // "new" creates a new object, old webkit buggy here
	    ,
	        CORRECT_NEW = new $RegExp(re1) !== re1;
	
	    if (_dereq_(28) && (!CORRECT_NEW || _dereq_(34)(function () {
	      re2[_dereq_(117)('match')] = false;
	      // RegExp constructor can alter flags and IsRegExp works correct with @@match
	      return $RegExp(re1) != re1 || $RegExp(re2) == re2 || $RegExp(re1, 'i') != '/a/i';
	    }))) {
	      $RegExp = function RegExp(p, f) {
	        var tiRE = this instanceof $RegExp,
	            piRE = isRegExp(p),
	            fiU = f === undefined;
	        return !tiRE && piRE && p.constructor === $RegExp && fiU ? p : inheritIfRequired(CORRECT_NEW ? new Base(piRE && !fiU ? p.source : p, f) : Base((piRE = p instanceof $RegExp) ? p.source : p, piRE && fiU ? $flags.call(p) : f), tiRE ? this : proto, $RegExp);
	      };
	      var proxy = function proxy(key) {
	        key in $RegExp || dP($RegExp, key, {
	          configurable: true,
	          get: function get() {
	            return Base[key];
	          },
	          set: function set(it) {
	            Base[key] = it;
	          }
	        });
	      };
	      for (var keys = gOPN(Base), i = 0; keys.length > i;) {
	        proxy(keys[i++]);
	      }proto.constructor = $RegExp;
	      $RegExp.prototype = proto;
	      _dereq_(87)(global, 'RegExp', $RegExp);
	    }
	
	    _dereq_(91)('RegExp');
	  }, { "117": 117, "28": 28, "34": 34, "36": 36, "38": 38, "43": 43, "50": 50, "67": 67, "72": 72, "87": 87, "91": 91 }], 214: [function (_dereq_, module, exports) {
	    // 21.2.5.3 get RegExp.prototype.flags()
	    if (_dereq_(28) && /./g.flags != 'g') _dereq_(67).f(RegExp.prototype, 'flags', {
	      configurable: true,
	      get: _dereq_(36)
	    });
	  }, { "28": 28, "36": 36, "67": 67 }], 215: [function (_dereq_, module, exports) {
	    // @@match logic
	    _dereq_(35)('match', 1, function (defined, MATCH, $match) {
	      // 21.1.3.11 String.prototype.match(regexp)
	      return [function match(regexp) {
	        'use strict';
	
	        var O = defined(this),
	            fn = regexp == undefined ? undefined : regexp[MATCH];
	        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[MATCH](String(O));
	      }, $match];
	    });
	  }, { "35": 35 }], 216: [function (_dereq_, module, exports) {
	    // @@replace logic
	    _dereq_(35)('replace', 2, function (defined, REPLACE, $replace) {
	      // 21.1.3.14 String.prototype.replace(searchValue, replaceValue)
	      return [function replace(searchValue, replaceValue) {
	        'use strict';
	
	        var O = defined(this),
	            fn = searchValue == undefined ? undefined : searchValue[REPLACE];
	        return fn !== undefined ? fn.call(searchValue, O, replaceValue) : $replace.call(String(O), searchValue, replaceValue);
	      }, $replace];
	    });
	  }, { "35": 35 }], 217: [function (_dereq_, module, exports) {
	    // @@search logic
	    _dereq_(35)('search', 1, function (defined, SEARCH, $search) {
	      // 21.1.3.15 String.prototype.search(regexp)
	      return [function search(regexp) {
	        'use strict';
	
	        var O = defined(this),
	            fn = regexp == undefined ? undefined : regexp[SEARCH];
	        return fn !== undefined ? fn.call(regexp, O) : new RegExp(regexp)[SEARCH](String(O));
	      }, $search];
	    });
	  }, { "35": 35 }], 218: [function (_dereq_, module, exports) {
	    // @@split logic
	    _dereq_(35)('split', 2, function (defined, SPLIT, $split) {
	      'use strict';
	
	      var isRegExp = _dereq_(50),
	          _split = $split,
	          $push = [].push,
	          $SPLIT = 'split',
	          LENGTH = 'length',
	          LAST_INDEX = 'lastIndex';
	      if ('abbc'[$SPLIT](/(b)*/)[1] == 'c' || 'test'[$SPLIT](/(?:)/, -1)[LENGTH] != 4 || 'ab'[$SPLIT](/(?:ab)*/)[LENGTH] != 2 || '.'[$SPLIT](/(.?)(.?)/)[LENGTH] != 4 || '.'[$SPLIT](/()()/)[LENGTH] > 1 || ''[$SPLIT](/.?/)[LENGTH]) {
	        var NPCG = /()??/.exec('')[1] === undefined; // nonparticipating capturing group
	        // based on es5-shim implementation, need to rework it
	        $split = function $split(separator, limit) {
	          var string = String(this);
	          if (separator === undefined && limit === 0) return [];
	          // If `separator` is not a regex, use native split
	          if (!isRegExp(separator)) return _split.call(string, separator, limit);
	          var output = [];
	          var flags = (separator.ignoreCase ? 'i' : '') + (separator.multiline ? 'm' : '') + (separator.unicode ? 'u' : '') + (separator.sticky ? 'y' : '');
	          var lastLastIndex = 0;
	          var splitLimit = limit === undefined ? 4294967295 : limit >>> 0;
	          // Make `global` and avoid `lastIndex` issues by working with a copy
	          var separatorCopy = new RegExp(separator.source, flags + 'g');
	          var separator2, match, lastIndex, lastLength, i;
	          // Doesn't need flags gy, but they don't hurt
	          if (!NPCG) separator2 = new RegExp('^' + separatorCopy.source + '$(?!\\s)', flags);
	          while (match = separatorCopy.exec(string)) {
	            // `separatorCopy.lastIndex` is not reliable cross-browser
	            lastIndex = match.index + match[0][LENGTH];
	            if (lastIndex > lastLastIndex) {
	              output.push(string.slice(lastLastIndex, match.index));
	              // Fix browsers whose `exec` methods don't consistently return `undefined` for NPCG
	              if (!NPCG && match[LENGTH] > 1) match[0].replace(separator2, function () {
	                for (i = 1; i < arguments[LENGTH] - 2; i++) {
	                  if (arguments[i] === undefined) match[i] = undefined;
	                }
	              });
	              if (match[LENGTH] > 1 && match.index < string[LENGTH]) $push.apply(output, match.slice(1));
	              lastLength = match[0][LENGTH];
	              lastLastIndex = lastIndex;
	              if (output[LENGTH] >= splitLimit) break;
	            }
	            if (separatorCopy[LAST_INDEX] === match.index) separatorCopy[LAST_INDEX]++; // Avoid an infinite loop
	          }
	          if (lastLastIndex === string[LENGTH]) {
	            if (lastLength || !separatorCopy.test('')) output.push('');
	          } else output.push(string.slice(lastLastIndex));
	          return output[LENGTH] > splitLimit ? output.slice(0, splitLimit) : output;
	        };
	        // Chakra, V8
	      } else if ('0'[$SPLIT](undefined, 0)[LENGTH]) {
	        $split = function $split(separator, limit) {
	          return separator === undefined && limit === 0 ? [] : _split.call(this, separator, limit);
	        };
	      }
	      // 21.1.3.17 String.prototype.split(separator, limit)
	      return [function split(separator, limit) {
	        var O = defined(this),
	            fn = separator == undefined ? undefined : separator[SPLIT];
	        return fn !== undefined ? fn.call(separator, O, limit) : $split.call(String(O), separator, limit);
	      }, $split];
	    });
	  }, { "35": 35, "50": 50 }], 219: [function (_dereq_, module, exports) {
	    'use strict';
	
	    _dereq_(214);
	    var anObject = _dereq_(7),
	        $flags = _dereq_(36),
	        DESCRIPTORS = _dereq_(28),
	        TO_STRING = 'toString',
	        $toString = /./[TO_STRING];
	
	    var define = function define(fn) {
	      _dereq_(87)(RegExp.prototype, TO_STRING, fn, true);
	    };
	
	    // 21.2.5.14 RegExp.prototype.toString()
	    if (_dereq_(34)(function () {
	      return $toString.call({ source: 'a', flags: 'b' }) != '/a/b';
	    })) {
	      define(function toString() {
	        var R = anObject(this);
	        return '/'.concat(R.source, '/', 'flags' in R ? R.flags : !DESCRIPTORS && R instanceof RegExp ? $flags.call(R) : undefined);
	      });
	      // FF44- RegExp#toString has a wrong name
	    } else if ($toString.name != TO_STRING) {
	      define(function toString() {
	        return $toString.call(this);
	      });
	    }
	  }, { "214": 214, "28": 28, "34": 34, "36": 36, "7": 7, "87": 87 }], 220: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var strong = _dereq_(19);
	
	    // 23.2 Set Objects
	    module.exports = _dereq_(22)('Set', function (get) {
	      return function Set() {
	        return get(this, arguments.length > 0 ? arguments[0] : undefined);
	      };
	    }, {
	      // 23.2.3.1 Set.prototype.add(value)
	      add: function add(value) {
	        return strong.def(this, value = value === 0 ? 0 : value, value);
	      }
	    }, strong);
	  }, { "19": 19, "22": 22 }], 221: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.2 String.prototype.anchor(name)
	
	    _dereq_(99)('anchor', function (createHTML) {
	      return function anchor(name) {
	        return createHTML(this, 'a', 'name', name);
	      };
	    });
	  }, { "99": 99 }], 222: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.3 String.prototype.big()
	
	    _dereq_(99)('big', function (createHTML) {
	      return function big() {
	        return createHTML(this, 'big', '', '');
	      };
	    });
	  }, { "99": 99 }], 223: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.4 String.prototype.blink()
	
	    _dereq_(99)('blink', function (createHTML) {
	      return function blink() {
	        return createHTML(this, 'blink', '', '');
	      };
	    });
	  }, { "99": 99 }], 224: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.5 String.prototype.bold()
	
	    _dereq_(99)('bold', function (createHTML) {
	      return function bold() {
	        return createHTML(this, 'b', '', '');
	      };
	    });
	  }, { "99": 99 }], 225: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $at = _dereq_(97)(false);
	    $export($export.P, 'String', {
	      // 21.1.3.3 String.prototype.codePointAt(pos)
	      codePointAt: function codePointAt(pos) {
	        return $at(this, pos);
	      }
	    });
	  }, { "32": 32, "97": 97 }], 226: [function (_dereq_, module, exports) {
	    // 21.1.3.6 String.prototype.endsWith(searchString [, endPosition])
	    'use strict';
	
	    var $export = _dereq_(32),
	        toLength = _dereq_(108),
	        context = _dereq_(98),
	        ENDS_WITH = 'endsWith',
	        $endsWith = ''[ENDS_WITH];
	
	    $export($export.P + $export.F * _dereq_(33)(ENDS_WITH), 'String', {
	      endsWith: function endsWith(searchString /*, endPosition = @length */) {
	        var that = context(this, searchString, ENDS_WITH),
	            endPosition = arguments.length > 1 ? arguments[1] : undefined,
	            len = toLength(that.length),
	            end = endPosition === undefined ? len : Math.min(toLength(endPosition), len),
	            search = String(searchString);
	        return $endsWith ? $endsWith.call(that, search, end) : that.slice(end - search.length, end) === search;
	      }
	    });
	  }, { "108": 108, "32": 32, "33": 33, "98": 98 }], 227: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.6 String.prototype.fixed()
	
	    _dereq_(99)('fixed', function (createHTML) {
	      return function fixed() {
	        return createHTML(this, 'tt', '', '');
	      };
	    });
	  }, { "99": 99 }], 228: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.7 String.prototype.fontcolor(color)
	
	    _dereq_(99)('fontcolor', function (createHTML) {
	      return function fontcolor(color) {
	        return createHTML(this, 'font', 'color', color);
	      };
	    });
	  }, { "99": 99 }], 229: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.8 String.prototype.fontsize(size)
	
	    _dereq_(99)('fontsize', function (createHTML) {
	      return function fontsize(size) {
	        return createHTML(this, 'font', 'size', size);
	      };
	    });
	  }, { "99": 99 }], 230: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        toIndex = _dereq_(105),
	        fromCharCode = String.fromCharCode,
	        $fromCodePoint = String.fromCodePoint;
	
	    // length should be 1, old FF problem
	    $export($export.S + $export.F * (!!$fromCodePoint && $fromCodePoint.length != 1), 'String', {
	      // 21.1.2.2 String.fromCodePoint(...codePoints)
	      fromCodePoint: function fromCodePoint(x) {
	        // eslint-disable-line no-unused-vars
	        var res = [],
	            aLen = arguments.length,
	            i = 0,
	            code;
	        while (aLen > i) {
	          code = +arguments[i++];
	          if (toIndex(code, 0x10ffff) !== code) throw RangeError(code + ' is not a valid code point');
	          res.push(code < 0x10000 ? fromCharCode(code) : fromCharCode(((code -= 0x10000) >> 10) + 0xd800, code % 0x400 + 0xdc00));
	        }return res.join('');
	      }
	    });
	  }, { "105": 105, "32": 32 }], 231: [function (_dereq_, module, exports) {
	    // 21.1.3.7 String.prototype.includes(searchString, position = 0)
	    'use strict';
	
	    var $export = _dereq_(32),
	        context = _dereq_(98),
	        INCLUDES = 'includes';
	
	    $export($export.P + $export.F * _dereq_(33)(INCLUDES), 'String', {
	      includes: function includes(searchString /*, position = 0 */) {
	        return !!~context(this, searchString, INCLUDES).indexOf(searchString, arguments.length > 1 ? arguments[1] : undefined);
	      }
	    });
	  }, { "32": 32, "33": 33, "98": 98 }], 232: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.9 String.prototype.italics()
	
	    _dereq_(99)('italics', function (createHTML) {
	      return function italics() {
	        return createHTML(this, 'i', '', '');
	      };
	    });
	  }, { "99": 99 }], 233: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $at = _dereq_(97)(true);
	
	    // 21.1.3.27 String.prototype[@@iterator]()
	    _dereq_(53)(String, 'String', function (iterated) {
	      this._t = String(iterated); // target
	      this._i = 0; // next index
	      // 21.1.5.2.1 %StringIteratorPrototype%.next()
	    }, function () {
	      var O = this._t,
	          index = this._i,
	          point;
	      if (index >= O.length) return { value: undefined, done: true };
	      point = $at(O, index);
	      this._i += point.length;
	      return { value: point, done: false };
	    });
	  }, { "53": 53, "97": 97 }], 234: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.10 String.prototype.link(url)
	
	    _dereq_(99)('link', function (createHTML) {
	      return function link(url) {
	        return createHTML(this, 'a', 'href', url);
	      };
	    });
	  }, { "99": 99 }], 235: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        toIObject = _dereq_(107),
	        toLength = _dereq_(108);
	
	    $export($export.S, 'String', {
	      // 21.1.2.4 String.raw(callSite, ...substitutions)
	      raw: function raw(callSite) {
	        var tpl = toIObject(callSite.raw),
	            len = toLength(tpl.length),
	            aLen = arguments.length,
	            res = [],
	            i = 0;
	        while (len > i) {
	          res.push(String(tpl[i++]));
	          if (i < aLen) res.push(String(arguments[i]));
	        }return res.join('');
	      }
	    });
	  }, { "107": 107, "108": 108, "32": 32 }], 236: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32);
	
	    $export($export.P, 'String', {
	      // 21.1.3.13 String.prototype.repeat(count)
	      repeat: _dereq_(101)
	    });
	  }, { "101": 101, "32": 32 }], 237: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.11 String.prototype.small()
	
	    _dereq_(99)('small', function (createHTML) {
	      return function small() {
	        return createHTML(this, 'small', '', '');
	      };
	    });
	  }, { "99": 99 }], 238: [function (_dereq_, module, exports) {
	    // 21.1.3.18 String.prototype.startsWith(searchString [, position ])
	    'use strict';
	
	    var $export = _dereq_(32),
	        toLength = _dereq_(108),
	        context = _dereq_(98),
	        STARTS_WITH = 'startsWith',
	        $startsWith = ''[STARTS_WITH];
	
	    $export($export.P + $export.F * _dereq_(33)(STARTS_WITH), 'String', {
	      startsWith: function startsWith(searchString /*, position = 0 */) {
	        var that = context(this, searchString, STARTS_WITH),
	            index = toLength(Math.min(arguments.length > 1 ? arguments[1] : undefined, that.length)),
	            search = String(searchString);
	        return $startsWith ? $startsWith.call(that, search, index) : that.slice(index, index + search.length) === search;
	      }
	    });
	  }, { "108": 108, "32": 32, "33": 33, "98": 98 }], 239: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.12 String.prototype.strike()
	
	    _dereq_(99)('strike', function (createHTML) {
	      return function strike() {
	        return createHTML(this, 'strike', '', '');
	      };
	    });
	  }, { "99": 99 }], 240: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.13 String.prototype.sub()
	
	    _dereq_(99)('sub', function (createHTML) {
	      return function sub() {
	        return createHTML(this, 'sub', '', '');
	      };
	    });
	  }, { "99": 99 }], 241: [function (_dereq_, module, exports) {
	    'use strict';
	    // B.2.3.14 String.prototype.sup()
	
	    _dereq_(99)('sup', function (createHTML) {
	      return function sup() {
	        return createHTML(this, 'sup', '', '');
	      };
	    });
	  }, { "99": 99 }], 242: [function (_dereq_, module, exports) {
	    'use strict';
	    // 21.1.3.25 String.prototype.trim()
	
	    _dereq_(102)('trim', function ($trim) {
	      return function trim() {
	        return $trim(this, 3);
	      };
	    });
	  }, { "102": 102 }], 243: [function (_dereq_, module, exports) {
	    'use strict';
	    // ECMAScript 6 symbols shim
	
	    var global = _dereq_(38),
	        has = _dereq_(39),
	        DESCRIPTORS = _dereq_(28),
	        $export = _dereq_(32),
	        redefine = _dereq_(87),
	        META = _dereq_(62).KEY,
	        $fails = _dereq_(34),
	        shared = _dereq_(94),
	        setToStringTag = _dereq_(92),
	        uid = _dereq_(114),
	        wks = _dereq_(117),
	        wksExt = _dereq_(116),
	        wksDefine = _dereq_(115),
	        keyOf = _dereq_(57),
	        enumKeys = _dereq_(31),
	        isArray = _dereq_(47),
	        anObject = _dereq_(7),
	        toIObject = _dereq_(107),
	        toPrimitive = _dereq_(110),
	        createDesc = _dereq_(85),
	        _create = _dereq_(66),
	        gOPNExt = _dereq_(71),
	        $GOPD = _dereq_(70),
	        $DP = _dereq_(67),
	        $keys = _dereq_(76),
	        gOPD = $GOPD.f,
	        dP = $DP.f,
	        gOPN = gOPNExt.f,
	        $Symbol = global.Symbol,
	        $JSON = global.JSON,
	        _stringify = $JSON && $JSON.stringify,
	        PROTOTYPE = 'prototype',
	        HIDDEN = wks('_hidden'),
	        TO_PRIMITIVE = wks('toPrimitive'),
	        isEnum = {}.propertyIsEnumerable,
	        SymbolRegistry = shared('symbol-registry'),
	        AllSymbols = shared('symbols'),
	        OPSymbols = shared('op-symbols'),
	        ObjectProto = Object[PROTOTYPE],
	        USE_NATIVE = typeof $Symbol == 'function',
	        QObject = global.QObject;
	    // Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
	    var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;
	
	    // fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
	    var setSymbolDesc = DESCRIPTORS && $fails(function () {
	      return _create(dP({}, 'a', {
	        get: function get() {
	          return dP(this, 'a', { value: 7 }).a;
	        }
	      })).a != 7;
	    }) ? function (it, key, D) {
	      var protoDesc = gOPD(ObjectProto, key);
	      if (protoDesc) delete ObjectProto[key];
	      dP(it, key, D);
	      if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
	    } : dP;
	
	    var wrap = function wrap(tag) {
	      var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
	      sym._k = tag;
	      return sym;
	    };
	
	    var isSymbol = USE_NATIVE && _typeof($Symbol.iterator) == 'symbol' ? function (it) {
	      return (typeof it === "undefined" ? "undefined" : _typeof(it)) == 'symbol';
	    } : function (it) {
	      return it instanceof $Symbol;
	    };
	
	    var $defineProperty = function defineProperty(it, key, D) {
	      if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
	      anObject(it);
	      key = toPrimitive(key, true);
	      anObject(D);
	      if (has(AllSymbols, key)) {
	        if (!D.enumerable) {
	          if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
	          it[HIDDEN][key] = true;
	        } else {
	          if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
	          D = _create(D, { enumerable: createDesc(0, false) });
	        }return setSymbolDesc(it, key, D);
	      }return dP(it, key, D);
	    };
	    var $defineProperties = function defineProperties(it, P) {
	      anObject(it);
	      var keys = enumKeys(P = toIObject(P)),
	          i = 0,
	          l = keys.length,
	          key;
	      while (l > i) {
	        $defineProperty(it, key = keys[i++], P[key]);
	      }return it;
	    };
	    var $create = function create(it, P) {
	      return P === undefined ? _create(it) : $defineProperties(_create(it), P);
	    };
	    var $propertyIsEnumerable = function propertyIsEnumerable(key) {
	      var E = isEnum.call(this, key = toPrimitive(key, true));
	      if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
	      return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
	    };
	    var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
	      it = toIObject(it);
	      key = toPrimitive(key, true);
	      if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
	      var D = gOPD(it, key);
	      if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
	      return D;
	    };
	    var $getOwnPropertyNames = function getOwnPropertyNames(it) {
	      var names = gOPN(toIObject(it)),
	          result = [],
	          i = 0,
	          key;
	      while (names.length > i) {
	        if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
	      }return result;
	    };
	    var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
	      var IS_OP = it === ObjectProto,
	          names = gOPN(IS_OP ? OPSymbols : toIObject(it)),
	          result = [],
	          i = 0,
	          key;
	      while (names.length > i) {
	        if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
	      }return result;
	    };
	
	    // 19.4.1.1 Symbol([description])
	    if (!USE_NATIVE) {
	      $Symbol = function _Symbol2() {
	        if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
	        var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
	        var $set = function $set(value) {
	          if (this === ObjectProto) $set.call(OPSymbols, value);
	          if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
	          setSymbolDesc(this, tag, createDesc(1, value));
	        };
	        if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
	        return wrap(tag);
	      };
	      redefine($Symbol[PROTOTYPE], 'toString', function toString() {
	        return this._k;
	      });
	
	      $GOPD.f = $getOwnPropertyDescriptor;
	      $DP.f = $defineProperty;
	      _dereq_(72).f = gOPNExt.f = $getOwnPropertyNames;
	      _dereq_(77).f = $propertyIsEnumerable;
	      _dereq_(73).f = $getOwnPropertySymbols;
	
	      if (DESCRIPTORS && !_dereq_(58)) {
	        redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
	      }
	
	      wksExt.f = function (name) {
	        return wrap(wks(name));
	      };
	    }
	
	    $export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });
	
	    for (var symbols =
	    // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
	    'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'.split(','), i = 0; symbols.length > i;) {
	      wks(symbols[i++]);
	    }for (var symbols = $keys(wks.store), i = 0; symbols.length > i;) {
	      wksDefine(symbols[i++]);
	    }$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
	      // 19.4.2.1 Symbol.for(key)
	      'for': function _for(key) {
	        return has(SymbolRegistry, key += '') ? SymbolRegistry[key] : SymbolRegistry[key] = $Symbol(key);
	      },
	      // 19.4.2.5 Symbol.keyFor(sym)
	      keyFor: function keyFor(key) {
	        if (isSymbol(key)) return keyOf(SymbolRegistry, key);
	        throw TypeError(key + ' is not a symbol!');
	      },
	      useSetter: function useSetter() {
	        setter = true;
	      },
	      useSimple: function useSimple() {
	        setter = false;
	      }
	    });
	
	    $export($export.S + $export.F * !USE_NATIVE, 'Object', {
	      // 19.1.2.2 Object.create(O [, Properties])
	      create: $create,
	      // 19.1.2.4 Object.defineProperty(O, P, Attributes)
	      defineProperty: $defineProperty,
	      // 19.1.2.3 Object.defineProperties(O, Properties)
	      defineProperties: $defineProperties,
	      // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
	      getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
	      // 19.1.2.7 Object.getOwnPropertyNames(O)
	      getOwnPropertyNames: $getOwnPropertyNames,
	      // 19.1.2.8 Object.getOwnPropertySymbols(O)
	      getOwnPropertySymbols: $getOwnPropertySymbols
	    });
	
	    // 24.3.2 JSON.stringify(value [, replacer [, space]])
	    $JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
	      var S = $Symbol();
	      // MS Edge converts symbol values to JSON as {}
	      // WebKit converts symbol values to JSON as null
	      // V8 throws on boxed symbols
	      return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
	    })), 'JSON', {
	      stringify: function stringify(it) {
	        if (it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
	        var args = [it],
	            i = 1,
	            replacer,
	            $replacer;
	        while (arguments.length > i) {
	          args.push(arguments[i++]);
	        }replacer = args[1];
	        if (typeof replacer == 'function') $replacer = replacer;
	        if ($replacer || !isArray(replacer)) replacer = function replacer(key, value) {
	          if ($replacer) value = $replacer.call(this, key, value);
	          if (!isSymbol(value)) return value;
	        };
	        args[1] = replacer;
	        return _stringify.apply($JSON, args);
	      }
	    });
	
	    // 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
	    $Symbol[PROTOTYPE][TO_PRIMITIVE] || _dereq_(40)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
	    // 19.4.3.5 Symbol.prototype[@@toStringTag]
	    setToStringTag($Symbol, 'Symbol');
	    // 20.2.1.9 Math[@@toStringTag]
	    setToStringTag(Math, 'Math', true);
	    // 24.3.3 JSON[@@toStringTag]
	    setToStringTag(global.JSON, 'JSON', true);
	  }, { "107": 107, "110": 110, "114": 114, "115": 115, "116": 116, "117": 117, "28": 28, "31": 31, "32": 32, "34": 34, "38": 38, "39": 39, "40": 40, "47": 47, "57": 57, "58": 58, "62": 62, "66": 66, "67": 67, "7": 7, "70": 70, "71": 71, "72": 72, "73": 73, "76": 76, "77": 77, "85": 85, "87": 87, "92": 92, "94": 94 }], 244: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        $typed = _dereq_(113),
	        buffer = _dereq_(112),
	        anObject = _dereq_(7),
	        toIndex = _dereq_(105),
	        toLength = _dereq_(108),
	        isObject = _dereq_(49),
	        ArrayBuffer = _dereq_(38).ArrayBuffer,
	        speciesConstructor = _dereq_(95),
	        $ArrayBuffer = buffer.ArrayBuffer,
	        $DataView = buffer.DataView,
	        $isView = $typed.ABV && ArrayBuffer.isView,
	        $slice = $ArrayBuffer.prototype.slice,
	        VIEW = $typed.VIEW,
	        ARRAY_BUFFER = 'ArrayBuffer';
	
	    $export($export.G + $export.W + $export.F * (ArrayBuffer !== $ArrayBuffer), { ArrayBuffer: $ArrayBuffer });
	
	    $export($export.S + $export.F * !$typed.CONSTR, ARRAY_BUFFER, {
	      // 24.1.3.1 ArrayBuffer.isView(arg)
	      isView: function isView(it) {
	        return $isView && $isView(it) || isObject(it) && VIEW in it;
	      }
	    });
	
	    $export($export.P + $export.U + $export.F * _dereq_(34)(function () {
	      return !new $ArrayBuffer(2).slice(1, undefined).byteLength;
	    }), ARRAY_BUFFER, {
	      // 24.1.4.3 ArrayBuffer.prototype.slice(start, end)
	      slice: function slice(start, end) {
	        if ($slice !== undefined && end === undefined) return $slice.call(anObject(this), start); // FF fix
	        var len = anObject(this).byteLength,
	            first = toIndex(start, len),
	            final = toIndex(end === undefined ? len : end, len),
	            result = new (speciesConstructor(this, $ArrayBuffer))(toLength(final - first)),
	            viewS = new $DataView(this),
	            viewT = new $DataView(result),
	            index = 0;
	        while (first < final) {
	          viewT.setUint8(index++, viewS.getUint8(first++));
	        }return result;
	      }
	    });
	
	    _dereq_(91)(ARRAY_BUFFER);
	  }, { "105": 105, "108": 108, "112": 112, "113": 113, "32": 32, "34": 34, "38": 38, "49": 49, "7": 7, "91": 91, "95": 95 }], 245: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32);
	    $export($export.G + $export.W + $export.F * !_dereq_(113).ABV, {
	      DataView: _dereq_(112).DataView
	    });
	  }, { "112": 112, "113": 113, "32": 32 }], 246: [function (_dereq_, module, exports) {
	    _dereq_(111)('Float32', 4, function (init) {
	      return function Float32Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 247: [function (_dereq_, module, exports) {
	    _dereq_(111)('Float64', 8, function (init) {
	      return function Float64Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 248: [function (_dereq_, module, exports) {
	    _dereq_(111)('Int16', 2, function (init) {
	      return function Int16Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 249: [function (_dereq_, module, exports) {
	    _dereq_(111)('Int32', 4, function (init) {
	      return function Int32Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 250: [function (_dereq_, module, exports) {
	    _dereq_(111)('Int8', 1, function (init) {
	      return function Int8Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 251: [function (_dereq_, module, exports) {
	    _dereq_(111)('Uint16', 2, function (init) {
	      return function Uint16Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 252: [function (_dereq_, module, exports) {
	    _dereq_(111)('Uint32', 4, function (init) {
	      return function Uint32Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 253: [function (_dereq_, module, exports) {
	    _dereq_(111)('Uint8', 1, function (init) {
	      return function Uint8Array(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    });
	  }, { "111": 111 }], 254: [function (_dereq_, module, exports) {
	    _dereq_(111)('Uint8', 1, function (init) {
	      return function Uint8ClampedArray(data, byteOffset, length) {
	        return init(this, data, byteOffset, length);
	      };
	    }, true);
	  }, { "111": 111 }], 255: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var each = _dereq_(12)(0),
	        redefine = _dereq_(87),
	        meta = _dereq_(62),
	        assign = _dereq_(65),
	        weak = _dereq_(21),
	        isObject = _dereq_(49),
	        getWeak = meta.getWeak,
	        isExtensible = Object.isExtensible,
	        uncaughtFrozenStore = weak.ufstore,
	        tmp = {},
	        InternalMap;
	
	    var wrapper = function wrapper(get) {
	      return function WeakMap() {
	        return get(this, arguments.length > 0 ? arguments[0] : undefined);
	      };
	    };
	
	    var methods = {
	      // 23.3.3.3 WeakMap.prototype.get(key)
	      get: function get(key) {
	        if (isObject(key)) {
	          var data = getWeak(key);
	          if (data === true) return uncaughtFrozenStore(this).get(key);
	          return data ? data[this._i] : undefined;
	        }
	      },
	      // 23.3.3.5 WeakMap.prototype.set(key, value)
	      set: function set(key, value) {
	        return weak.def(this, key, value);
	      }
	    };
	
	    // 23.3 WeakMap Objects
	    var $WeakMap = module.exports = _dereq_(22)('WeakMap', wrapper, methods, weak, true, true);
	
	    // IE11 WeakMap frozen keys fix
	    if (new $WeakMap().set((Object.freeze || Object)(tmp), 7).get(tmp) != 7) {
	      InternalMap = weak.getConstructor(wrapper);
	      assign(InternalMap.prototype, methods);
	      meta.NEED = true;
	      each(['delete', 'has', 'get', 'set'], function (key) {
	        var proto = $WeakMap.prototype,
	            method = proto[key];
	        redefine(proto, key, function (a, b) {
	          // store frozen objects on internal weakmap shim
	          if (isObject(a) && !isExtensible(a)) {
	            if (!this._f) this._f = new InternalMap();
	            var result = this._f[key](a, b);
	            return key == 'set' ? this : result;
	            // store all the rest on native weakmap
	          }return method.call(this, a, b);
	        });
	      });
	    }
	  }, { "12": 12, "21": 21, "22": 22, "49": 49, "62": 62, "65": 65, "87": 87 }], 256: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var weak = _dereq_(21);
	
	    // 23.4 WeakSet Objects
	    _dereq_(22)('WeakSet', function (get) {
	      return function WeakSet() {
	        return get(this, arguments.length > 0 ? arguments[0] : undefined);
	      };
	    }, {
	      // 23.4.3.1 WeakSet.prototype.add(value)
	      add: function add(value) {
	        return weak.def(this, value, true);
	      }
	    }, weak, false, true);
	  }, { "21": 21, "22": 22 }], 257: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://github.com/tc39/Array.prototype.includes
	
	    var $export = _dereq_(32),
	        $includes = _dereq_(11)(true);
	
	    $export($export.P, 'Array', {
	      includes: function includes(el /*, fromIndex = 0 */) {
	        return $includes(this, el, arguments.length > 1 ? arguments[1] : undefined);
	      }
	    });
	
	    _dereq_(5)('includes');
	  }, { "11": 11, "32": 32, "5": 5 }], 258: [function (_dereq_, module, exports) {
	    // https://github.com/rwaldron/tc39-notes/blob/master/es6/2014-09/sept-25.md#510-globalasap-for-enqueuing-a-microtask
	    var $export = _dereq_(32),
	        microtask = _dereq_(64)(),
	        process = _dereq_(38).process,
	        isNode = _dereq_(18)(process) == 'process';
	
	    $export($export.G, {
	      asap: function asap(fn) {
	        var domain = isNode && process.domain;
	        microtask(domain ? domain.bind(fn) : fn);
	      }
	    });
	  }, { "18": 18, "32": 32, "38": 38, "64": 64 }], 259: [function (_dereq_, module, exports) {
	    // https://github.com/ljharb/proposal-is-error
	    var $export = _dereq_(32),
	        cof = _dereq_(18);
	
	    $export($export.S, 'Error', {
	      isError: function isError(it) {
	        return cof(it) === 'Error';
	      }
	    });
	  }, { "18": 18, "32": 32 }], 260: [function (_dereq_, module, exports) {
	    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
	    var $export = _dereq_(32);
	
	    $export($export.P + $export.R, 'Map', { toJSON: _dereq_(20)('Map') });
	  }, { "20": 20, "32": 32 }], 261: [function (_dereq_, module, exports) {
	    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      iaddh: function iaddh(x0, x1, y0, y1) {
	        var $x0 = x0 >>> 0,
	            $x1 = x1 >>> 0,
	            $y0 = y0 >>> 0;
	        return $x1 + (y1 >>> 0) + (($x0 & $y0 | ($x0 | $y0) & ~($x0 + $y0 >>> 0)) >>> 31) | 0;
	      }
	    });
	  }, { "32": 32 }], 262: [function (_dereq_, module, exports) {
	    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      imulh: function imulh(u, v) {
	        var UINT16 = 0xffff,
	            $u = +u,
	            $v = +v,
	            u0 = $u & UINT16,
	            v0 = $v & UINT16,
	            u1 = $u >> 16,
	            v1 = $v >> 16,
	            t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	        return u1 * v1 + (t >> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >> 16);
	      }
	    });
	  }, { "32": 32 }], 263: [function (_dereq_, module, exports) {
	    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      isubh: function isubh(x0, x1, y0, y1) {
	        var $x0 = x0 >>> 0,
	            $x1 = x1 >>> 0,
	            $y0 = y0 >>> 0;
	        return $x1 - (y1 >>> 0) - ((~$x0 & $y0 | ~($x0 ^ $y0) & $x0 - $y0 >>> 0) >>> 31) | 0;
	      }
	    });
	  }, { "32": 32 }], 264: [function (_dereq_, module, exports) {
	    // https://gist.github.com/BrendanEich/4294d5c212a6d2254703
	    var $export = _dereq_(32);
	
	    $export($export.S, 'Math', {
	      umulh: function umulh(u, v) {
	        var UINT16 = 0xffff,
	            $u = +u,
	            $v = +v,
	            u0 = $u & UINT16,
	            v0 = $v & UINT16,
	            u1 = $u >>> 16,
	            v1 = $v >>> 16,
	            t = (u1 * v0 >>> 0) + (u0 * v0 >>> 16);
	        return u1 * v1 + (t >>> 16) + ((u0 * v1 >>> 0) + (t & UINT16) >>> 16);
	      }
	    });
	  }, { "32": 32 }], 265: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        toObject = _dereq_(109),
	        aFunction = _dereq_(3),
	        $defineProperty = _dereq_(67);
	
	    // B.2.2.2 Object.prototype.__defineGetter__(P, getter)
	    _dereq_(28) && $export($export.P + _dereq_(69), 'Object', {
	      __defineGetter__: function __defineGetter__(P, getter) {
	        $defineProperty.f(toObject(this), P, { get: aFunction(getter), enumerable: true, configurable: true });
	      }
	    });
	  }, { "109": 109, "28": 28, "3": 3, "32": 32, "67": 67, "69": 69 }], 266: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        toObject = _dereq_(109),
	        aFunction = _dereq_(3),
	        $defineProperty = _dereq_(67);
	
	    // B.2.2.3 Object.prototype.__defineSetter__(P, setter)
	    _dereq_(28) && $export($export.P + _dereq_(69), 'Object', {
	      __defineSetter__: function __defineSetter__(P, setter) {
	        $defineProperty.f(toObject(this), P, { set: aFunction(setter), enumerable: true, configurable: true });
	      }
	    });
	  }, { "109": 109, "28": 28, "3": 3, "32": 32, "67": 67, "69": 69 }], 267: [function (_dereq_, module, exports) {
	    // https://github.com/tc39/proposal-object-values-entries
	    var $export = _dereq_(32),
	        $entries = _dereq_(79)(true);
	
	    $export($export.S, 'Object', {
	      entries: function entries(it) {
	        return $entries(it);
	      }
	    });
	  }, { "32": 32, "79": 79 }], 268: [function (_dereq_, module, exports) {
	    // https://github.com/tc39/proposal-object-getownpropertydescriptors
	    var $export = _dereq_(32),
	        ownKeys = _dereq_(80),
	        toIObject = _dereq_(107),
	        gOPD = _dereq_(70),
	        createProperty = _dereq_(24);
	
	    $export($export.S, 'Object', {
	      getOwnPropertyDescriptors: function getOwnPropertyDescriptors(object) {
	        var O = toIObject(object),
	            getDesc = gOPD.f,
	            keys = ownKeys(O),
	            result = {},
	            i = 0,
	            key;
	        while (keys.length > i) {
	          createProperty(result, key = keys[i++], getDesc(O, key));
	        }return result;
	      }
	    });
	  }, { "107": 107, "24": 24, "32": 32, "70": 70, "80": 80 }], 269: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        toObject = _dereq_(109),
	        toPrimitive = _dereq_(110),
	        getPrototypeOf = _dereq_(74),
	        getOwnPropertyDescriptor = _dereq_(70).f;
	
	    // B.2.2.4 Object.prototype.__lookupGetter__(P)
	    _dereq_(28) && $export($export.P + _dereq_(69), 'Object', {
	      __lookupGetter__: function __lookupGetter__(P) {
	        var O = toObject(this),
	            K = toPrimitive(P, true),
	            D;
	        do {
	          if (D = getOwnPropertyDescriptor(O, K)) return D.get;
	        } while (O = getPrototypeOf(O));
	      }
	    });
	  }, { "109": 109, "110": 110, "28": 28, "32": 32, "69": 69, "70": 70, "74": 74 }], 270: [function (_dereq_, module, exports) {
	    'use strict';
	
	    var $export = _dereq_(32),
	        toObject = _dereq_(109),
	        toPrimitive = _dereq_(110),
	        getPrototypeOf = _dereq_(74),
	        getOwnPropertyDescriptor = _dereq_(70).f;
	
	    // B.2.2.5 Object.prototype.__lookupSetter__(P)
	    _dereq_(28) && $export($export.P + _dereq_(69), 'Object', {
	      __lookupSetter__: function __lookupSetter__(P) {
	        var O = toObject(this),
	            K = toPrimitive(P, true),
	            D;
	        do {
	          if (D = getOwnPropertyDescriptor(O, K)) return D.set;
	        } while (O = getPrototypeOf(O));
	      }
	    });
	  }, { "109": 109, "110": 110, "28": 28, "32": 32, "69": 69, "70": 70, "74": 74 }], 271: [function (_dereq_, module, exports) {
	    // https://github.com/tc39/proposal-object-values-entries
	    var $export = _dereq_(32),
	        $values = _dereq_(79)(false);
	
	    $export($export.S, 'Object', {
	      values: function values(it) {
	        return $values(it);
	      }
	    });
	  }, { "32": 32, "79": 79 }], 272: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://github.com/zenparsing/es-observable
	
	    var $export = _dereq_(32),
	        global = _dereq_(38),
	        core = _dereq_(23),
	        microtask = _dereq_(64)(),
	        OBSERVABLE = _dereq_(117)('observable'),
	        aFunction = _dereq_(3),
	        anObject = _dereq_(7),
	        anInstance = _dereq_(6),
	        redefineAll = _dereq_(86),
	        hide = _dereq_(40),
	        forOf = _dereq_(37),
	        RETURN = forOf.RETURN;
	
	    var getMethod = function getMethod(fn) {
	      return fn == null ? undefined : aFunction(fn);
	    };
	
	    var cleanupSubscription = function cleanupSubscription(subscription) {
	      var cleanup = subscription._c;
	      if (cleanup) {
	        subscription._c = undefined;
	        cleanup();
	      }
	    };
	
	    var subscriptionClosed = function subscriptionClosed(subscription) {
	      return subscription._o === undefined;
	    };
	
	    var closeSubscription = function closeSubscription(subscription) {
	      if (!subscriptionClosed(subscription)) {
	        subscription._o = undefined;
	        cleanupSubscription(subscription);
	      }
	    };
	
	    var Subscription = function Subscription(observer, subscriber) {
	      anObject(observer);
	      this._c = undefined;
	      this._o = observer;
	      observer = new SubscriptionObserver(this);
	      try {
	        var cleanup = subscriber(observer),
	            subscription = cleanup;
	        if (cleanup != null) {
	          if (typeof cleanup.unsubscribe === 'function') cleanup = function cleanup() {
	            subscription.unsubscribe();
	          };else aFunction(cleanup);
	          this._c = cleanup;
	        }
	      } catch (e) {
	        observer.error(e);
	        return;
	      }if (subscriptionClosed(this)) cleanupSubscription(this);
	    };
	
	    Subscription.prototype = redefineAll({}, {
	      unsubscribe: function unsubscribe() {
	        closeSubscription(this);
	      }
	    });
	
	    var SubscriptionObserver = function SubscriptionObserver(subscription) {
	      this._s = subscription;
	    };
	
	    SubscriptionObserver.prototype = redefineAll({}, {
	      next: function next(value) {
	        var subscription = this._s;
	        if (!subscriptionClosed(subscription)) {
	          var observer = subscription._o;
	          try {
	            var m = getMethod(observer.next);
	            if (m) return m.call(observer, value);
	          } catch (e) {
	            try {
	              closeSubscription(subscription);
	            } finally {
	              throw e;
	            }
	          }
	        }
	      },
	      error: function error(value) {
	        var subscription = this._s;
	        if (subscriptionClosed(subscription)) throw value;
	        var observer = subscription._o;
	        subscription._o = undefined;
	        try {
	          var m = getMethod(observer.error);
	          if (!m) throw value;
	          value = m.call(observer, value);
	        } catch (e) {
	          try {
	            cleanupSubscription(subscription);
	          } finally {
	            throw e;
	          }
	        }cleanupSubscription(subscription);
	        return value;
	      },
	      complete: function complete(value) {
	        var subscription = this._s;
	        if (!subscriptionClosed(subscription)) {
	          var observer = subscription._o;
	          subscription._o = undefined;
	          try {
	            var m = getMethod(observer.complete);
	            value = m ? m.call(observer, value) : undefined;
	          } catch (e) {
	            try {
	              cleanupSubscription(subscription);
	            } finally {
	              throw e;
	            }
	          }cleanupSubscription(subscription);
	          return value;
	        }
	      }
	    });
	
	    var $Observable = function Observable(subscriber) {
	      anInstance(this, $Observable, 'Observable', '_f')._f = aFunction(subscriber);
	    };
	
	    redefineAll($Observable.prototype, {
	      subscribe: function subscribe(observer) {
	        return new Subscription(observer, this._f);
	      },
	      forEach: function forEach(fn) {
	        var that = this;
	        return new (core.Promise || global.Promise)(function (resolve, reject) {
	          aFunction(fn);
	          var subscription = that.subscribe({
	            next: function next(value) {
	              try {
	                return fn(value);
	              } catch (e) {
	                reject(e);
	                subscription.unsubscribe();
	              }
	            },
	            error: reject,
	            complete: resolve
	          });
	        });
	      }
	    });
	
	    redefineAll($Observable, {
	      from: function from(x) {
	        var C = typeof this === 'function' ? this : $Observable;
	        var method = getMethod(anObject(x)[OBSERVABLE]);
	        if (method) {
	          var observable = anObject(method.call(x));
	          return observable.constructor === C ? observable : new C(function (observer) {
	            return observable.subscribe(observer);
	          });
	        }
	        return new C(function (observer) {
	          var done = false;
	          microtask(function () {
	            if (!done) {
	              try {
	                if (forOf(x, false, function (it) {
	                  observer.next(it);
	                  if (done) return RETURN;
	                }) === RETURN) return;
	              } catch (e) {
	                if (done) throw e;
	                observer.error(e);
	                return;
	              }observer.complete();
	            }
	          });
	          return function () {
	            done = true;
	          };
	        });
	      },
	      of: function of() {
	        for (var i = 0, l = arguments.length, items = Array(l); i < l;) {
	          items[i] = arguments[i++];
	        }return new (typeof this === 'function' ? this : $Observable)(function (observer) {
	          var done = false;
	          microtask(function () {
	            if (!done) {
	              for (var i = 0; i < items.length; ++i) {
	                observer.next(items[i]);
	                if (done) return;
	              }observer.complete();
	            }
	          });
	          return function () {
	            done = true;
	          };
	        });
	      }
	    });
	
	    hide($Observable.prototype, OBSERVABLE, function () {
	      return this;
	    });
	
	    $export($export.G, { Observable: $Observable });
	
	    _dereq_(91)('Observable');
	  }, { "117": 117, "23": 23, "3": 3, "32": 32, "37": 37, "38": 38, "40": 40, "6": 6, "64": 64, "7": 7, "86": 86, "91": 91 }], 273: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        toMetaKey = metadata.key,
	        ordinaryDefineOwnMetadata = metadata.set;
	
	    metadata.exp({ defineMetadata: function defineMetadata(metadataKey, metadataValue, target, targetKey) {
	        ordinaryDefineOwnMetadata(metadataKey, metadataValue, anObject(target), toMetaKey(targetKey));
	      } });
	  }, { "63": 63, "7": 7 }], 274: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        toMetaKey = metadata.key,
	        getOrCreateMetadataMap = metadata.map,
	        store = metadata.store;
	
	    metadata.exp({ deleteMetadata: function deleteMetadata(metadataKey, target /*, targetKey */) {
	        var targetKey = arguments.length < 3 ? undefined : toMetaKey(arguments[2]),
	            metadataMap = getOrCreateMetadataMap(anObject(target), targetKey, false);
	        if (metadataMap === undefined || !metadataMap['delete'](metadataKey)) return false;
	        if (metadataMap.size) return true;
	        var targetMetadata = store.get(target);
	        targetMetadata['delete'](targetKey);
	        return !!targetMetadata.size || store['delete'](target);
	      } });
	  }, { "63": 63, "7": 7 }], 275: [function (_dereq_, module, exports) {
	    var Set = _dereq_(220),
	        from = _dereq_(10),
	        metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        getPrototypeOf = _dereq_(74),
	        ordinaryOwnMetadataKeys = metadata.keys,
	        toMetaKey = metadata.key;
	
	    var ordinaryMetadataKeys = function ordinaryMetadataKeys(O, P) {
	      var oKeys = ordinaryOwnMetadataKeys(O, P),
	          parent = getPrototypeOf(O);
	      if (parent === null) return oKeys;
	      var pKeys = ordinaryMetadataKeys(parent, P);
	      return pKeys.length ? oKeys.length ? from(new Set(oKeys.concat(pKeys))) : pKeys : oKeys;
	    };
	
	    metadata.exp({ getMetadataKeys: function getMetadataKeys(target /*, targetKey */) {
	        return ordinaryMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	      } });
	  }, { "10": 10, "220": 220, "63": 63, "7": 7, "74": 74 }], 276: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        getPrototypeOf = _dereq_(74),
	        ordinaryHasOwnMetadata = metadata.has,
	        ordinaryGetOwnMetadata = metadata.get,
	        toMetaKey = metadata.key;
	
	    var ordinaryGetMetadata = function ordinaryGetMetadata(MetadataKey, O, P) {
	      var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	      if (hasOwn) return ordinaryGetOwnMetadata(MetadataKey, O, P);
	      var parent = getPrototypeOf(O);
	      return parent !== null ? ordinaryGetMetadata(MetadataKey, parent, P) : undefined;
	    };
	
	    metadata.exp({ getMetadata: function getMetadata(metadataKey, target /*, targetKey */) {
	        return ordinaryGetMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	      } });
	  }, { "63": 63, "7": 7, "74": 74 }], 277: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        ordinaryOwnMetadataKeys = metadata.keys,
	        toMetaKey = metadata.key;
	
	    metadata.exp({ getOwnMetadataKeys: function getOwnMetadataKeys(target /*, targetKey */) {
	        return ordinaryOwnMetadataKeys(anObject(target), arguments.length < 2 ? undefined : toMetaKey(arguments[1]));
	      } });
	  }, { "63": 63, "7": 7 }], 278: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        ordinaryGetOwnMetadata = metadata.get,
	        toMetaKey = metadata.key;
	
	    metadata.exp({ getOwnMetadata: function getOwnMetadata(metadataKey, target /*, targetKey */) {
	        return ordinaryGetOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	      } });
	  }, { "63": 63, "7": 7 }], 279: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        getPrototypeOf = _dereq_(74),
	        ordinaryHasOwnMetadata = metadata.has,
	        toMetaKey = metadata.key;
	
	    var ordinaryHasMetadata = function ordinaryHasMetadata(MetadataKey, O, P) {
	      var hasOwn = ordinaryHasOwnMetadata(MetadataKey, O, P);
	      if (hasOwn) return true;
	      var parent = getPrototypeOf(O);
	      return parent !== null ? ordinaryHasMetadata(MetadataKey, parent, P) : false;
	    };
	
	    metadata.exp({ hasMetadata: function hasMetadata(metadataKey, target /*, targetKey */) {
	        return ordinaryHasMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	      } });
	  }, { "63": 63, "7": 7, "74": 74 }], 280: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        ordinaryHasOwnMetadata = metadata.has,
	        toMetaKey = metadata.key;
	
	    metadata.exp({ hasOwnMetadata: function hasOwnMetadata(metadataKey, target /*, targetKey */) {
	        return ordinaryHasOwnMetadata(metadataKey, anObject(target), arguments.length < 3 ? undefined : toMetaKey(arguments[2]));
	      } });
	  }, { "63": 63, "7": 7 }], 281: [function (_dereq_, module, exports) {
	    var metadata = _dereq_(63),
	        anObject = _dereq_(7),
	        aFunction = _dereq_(3),
	        toMetaKey = metadata.key,
	        ordinaryDefineOwnMetadata = metadata.set;
	
	    metadata.exp({ metadata: function metadata(metadataKey, metadataValue) {
	        return function decorator(target, targetKey) {
	          ordinaryDefineOwnMetadata(metadataKey, metadataValue, (targetKey !== undefined ? anObject : aFunction)(target), toMetaKey(targetKey));
	        };
	      } });
	  }, { "3": 3, "63": 63, "7": 7 }], 282: [function (_dereq_, module, exports) {
	    // https://github.com/DavidBruant/Map-Set.prototype.toJSON
	    var $export = _dereq_(32);
	
	    $export($export.P + $export.R, 'Set', { toJSON: _dereq_(20)('Set') });
	  }, { "20": 20, "32": 32 }], 283: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://github.com/mathiasbynens/String.prototype.at
	
	    var $export = _dereq_(32),
	        $at = _dereq_(97)(true);
	
	    $export($export.P, 'String', {
	      at: function at(pos) {
	        return $at(this, pos);
	      }
	    });
	  }, { "32": 32, "97": 97 }], 284: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://tc39.github.io/String.prototype.matchAll/
	
	    var $export = _dereq_(32),
	        defined = _dereq_(27),
	        toLength = _dereq_(108),
	        isRegExp = _dereq_(50),
	        getFlags = _dereq_(36),
	        RegExpProto = RegExp.prototype;
	
	    var $RegExpStringIterator = function $RegExpStringIterator(regexp, string) {
	      this._r = regexp;
	      this._s = string;
	    };
	
	    _dereq_(52)($RegExpStringIterator, 'RegExp String', function next() {
	      var match = this._r.exec(this._s);
	      return { value: match, done: match === null };
	    });
	
	    $export($export.P, 'String', {
	      matchAll: function matchAll(regexp) {
	        defined(this);
	        if (!isRegExp(regexp)) throw TypeError(regexp + ' is not a regexp!');
	        var S = String(this),
	            flags = 'flags' in RegExpProto ? String(regexp.flags) : getFlags.call(regexp),
	            rx = new RegExp(regexp.source, ~flags.indexOf('g') ? flags : 'g' + flags);
	        rx.lastIndex = toLength(regexp.lastIndex);
	        return new $RegExpStringIterator(rx, S);
	      }
	    });
	  }, { "108": 108, "27": 27, "32": 32, "36": 36, "50": 50, "52": 52 }], 285: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://github.com/tc39/proposal-string-pad-start-end
	
	    var $export = _dereq_(32),
	        $pad = _dereq_(100);
	
	    $export($export.P, 'String', {
	      padEnd: function padEnd(maxLength /*, fillString = ' ' */) {
	        return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, false);
	      }
	    });
	  }, { "100": 100, "32": 32 }], 286: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://github.com/tc39/proposal-string-pad-start-end
	
	    var $export = _dereq_(32),
	        $pad = _dereq_(100);
	
	    $export($export.P, 'String', {
	      padStart: function padStart(maxLength /*, fillString = ' ' */) {
	        return $pad(this, maxLength, arguments.length > 1 ? arguments[1] : undefined, true);
	      }
	    });
	  }, { "100": 100, "32": 32 }], 287: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	
	    _dereq_(102)('trimLeft', function ($trim) {
	      return function trimLeft() {
	        return $trim(this, 1);
	      };
	    }, 'trimStart');
	  }, { "102": 102 }], 288: [function (_dereq_, module, exports) {
	    'use strict';
	    // https://github.com/sebmarkbage/ecmascript-string-left-right-trim
	
	    _dereq_(102)('trimRight', function ($trim) {
	      return function trimRight() {
	        return $trim(this, 2);
	      };
	    }, 'trimEnd');
	  }, { "102": 102 }], 289: [function (_dereq_, module, exports) {
	    _dereq_(115)('asyncIterator');
	  }, { "115": 115 }], 290: [function (_dereq_, module, exports) {
	    _dereq_(115)('observable');
	  }, { "115": 115 }], 291: [function (_dereq_, module, exports) {
	    // https://github.com/ljharb/proposal-global
	    var $export = _dereq_(32);
	
	    $export($export.S, 'System', { global: _dereq_(38) });
	  }, { "32": 32, "38": 38 }], 292: [function (_dereq_, module, exports) {
	    var $iterators = _dereq_(130),
	        redefine = _dereq_(87),
	        global = _dereq_(38),
	        hide = _dereq_(40),
	        Iterators = _dereq_(56),
	        wks = _dereq_(117),
	        ITERATOR = wks('iterator'),
	        TO_STRING_TAG = wks('toStringTag'),
	        ArrayValues = Iterators.Array;
	
	    for (var collections = ['NodeList', 'DOMTokenList', 'MediaList', 'StyleSheetList', 'CSSRuleList'], i = 0; i < 5; i++) {
	      var NAME = collections[i],
	          Collection = global[NAME],
	          proto = Collection && Collection.prototype,
	          key;
	      if (proto) {
	        if (!proto[ITERATOR]) hide(proto, ITERATOR, ArrayValues);
	        if (!proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
	        Iterators[NAME] = ArrayValues;
	        for (key in $iterators) {
	          if (!proto[key]) redefine(proto, key, $iterators[key], true);
	        }
	      }
	    }
	  }, { "117": 117, "130": 130, "38": 38, "40": 40, "56": 56, "87": 87 }], 293: [function (_dereq_, module, exports) {
	    var $export = _dereq_(32),
	        $task = _dereq_(104);
	    $export($export.G + $export.B, {
	      setImmediate: $task.set,
	      clearImmediate: $task.clear
	    });
	  }, { "104": 104, "32": 32 }], 294: [function (_dereq_, module, exports) {
	    // ie9- setTimeout & setInterval additional parameters fix
	    var global = _dereq_(38),
	        $export = _dereq_(32),
	        invoke = _dereq_(44),
	        partial = _dereq_(83),
	        navigator = global.navigator,
	        MSIE = !!navigator && /MSIE .\./.test(navigator.userAgent); // <- dirty ie9- check
	    var wrap = function wrap(set) {
	      return MSIE ? function (fn, time /*, ...args */) {
	        return set(invoke(partial, [].slice.call(arguments, 2), typeof fn == 'function' ? fn : Function(fn)), time);
	      } : set;
	    };
	    $export($export.G + $export.B + $export.F * MSIE, {
	      setTimeout: wrap(global.setTimeout),
	      setInterval: wrap(global.setInterval)
	    });
	  }, { "32": 32, "38": 38, "44": 44, "83": 83 }], 295: [function (_dereq_, module, exports) {
	    _dereq_(243);
	    _dereq_(180);
	    _dereq_(182);
	    _dereq_(181);
	    _dereq_(184);
	    _dereq_(186);
	    _dereq_(191);
	    _dereq_(185);
	    _dereq_(183);
	    _dereq_(193);
	    _dereq_(192);
	    _dereq_(188);
	    _dereq_(189);
	    _dereq_(187);
	    _dereq_(179);
	    _dereq_(190);
	    _dereq_(194);
	    _dereq_(195);
	    _dereq_(146);
	    _dereq_(148);
	    _dereq_(147);
	    _dereq_(197);
	    _dereq_(196);
	    _dereq_(167);
	    _dereq_(177);
	    _dereq_(178);
	    _dereq_(168);
	    _dereq_(169);
	    _dereq_(170);
	    _dereq_(171);
	    _dereq_(172);
	    _dereq_(173);
	    _dereq_(174);
	    _dereq_(175);
	    _dereq_(176);
	    _dereq_(150);
	    _dereq_(151);
	    _dereq_(152);
	    _dereq_(153);
	    _dereq_(154);
	    _dereq_(155);
	    _dereq_(156);
	    _dereq_(157);
	    _dereq_(158);
	    _dereq_(159);
	    _dereq_(160);
	    _dereq_(161);
	    _dereq_(162);
	    _dereq_(163);
	    _dereq_(164);
	    _dereq_(165);
	    _dereq_(166);
	    _dereq_(230);
	    _dereq_(235);
	    _dereq_(242);
	    _dereq_(233);
	    _dereq_(225);
	    _dereq_(226);
	    _dereq_(231);
	    _dereq_(236);
	    _dereq_(238);
	    _dereq_(221);
	    _dereq_(222);
	    _dereq_(223);
	    _dereq_(224);
	    _dereq_(227);
	    _dereq_(228);
	    _dereq_(229);
	    _dereq_(232);
	    _dereq_(234);
	    _dereq_(237);
	    _dereq_(239);
	    _dereq_(240);
	    _dereq_(241);
	    _dereq_(141);
	    _dereq_(143);
	    _dereq_(142);
	    _dereq_(145);
	    _dereq_(144);
	    _dereq_(129);
	    _dereq_(127);
	    _dereq_(134);
	    _dereq_(131);
	    _dereq_(137);
	    _dereq_(139);
	    _dereq_(126);
	    _dereq_(133);
	    _dereq_(123);
	    _dereq_(138);
	    _dereq_(121);
	    _dereq_(136);
	    _dereq_(135);
	    _dereq_(128);
	    _dereq_(132);
	    _dereq_(120);
	    _dereq_(122);
	    _dereq_(125);
	    _dereq_(124);
	    _dereq_(140);
	    _dereq_(130);
	    _dereq_(213);
	    _dereq_(219);
	    _dereq_(214);
	    _dereq_(215);
	    _dereq_(216);
	    _dereq_(217);
	    _dereq_(218);
	    _dereq_(198);
	    _dereq_(149);
	    _dereq_(220);
	    _dereq_(255);
	    _dereq_(256);
	    _dereq_(244);
	    _dereq_(245);
	    _dereq_(250);
	    _dereq_(253);
	    _dereq_(254);
	    _dereq_(248);
	    _dereq_(251);
	    _dereq_(249);
	    _dereq_(252);
	    _dereq_(246);
	    _dereq_(247);
	    _dereq_(199);
	    _dereq_(200);
	    _dereq_(201);
	    _dereq_(202);
	    _dereq_(203);
	    _dereq_(206);
	    _dereq_(204);
	    _dereq_(205);
	    _dereq_(207);
	    _dereq_(208);
	    _dereq_(209);
	    _dereq_(210);
	    _dereq_(212);
	    _dereq_(211);
	    _dereq_(257);
	    _dereq_(283);
	    _dereq_(286);
	    _dereq_(285);
	    _dereq_(287);
	    _dereq_(288);
	    _dereq_(284);
	    _dereq_(289);
	    _dereq_(290);
	    _dereq_(268);
	    _dereq_(271);
	    _dereq_(267);
	    _dereq_(265);
	    _dereq_(266);
	    _dereq_(269);
	    _dereq_(270);
	    _dereq_(260);
	    _dereq_(282);
	    _dereq_(291);
	    _dereq_(259);
	    _dereq_(261);
	    _dereq_(263);
	    _dereq_(262);
	    _dereq_(264);
	    _dereq_(273);
	    _dereq_(274);
	    _dereq_(276);
	    _dereq_(275);
	    _dereq_(278);
	    _dereq_(277);
	    _dereq_(279);
	    _dereq_(280);
	    _dereq_(281);
	    _dereq_(258);
	    _dereq_(272);
	    _dereq_(294);
	    _dereq_(293);
	    _dereq_(292);
	    module.exports = _dereq_(23);
	  }, { "120": 120, "121": 121, "122": 122, "123": 123, "124": 124, "125": 125, "126": 126, "127": 127, "128": 128, "129": 129, "130": 130, "131": 131, "132": 132, "133": 133, "134": 134, "135": 135, "136": 136, "137": 137, "138": 138, "139": 139, "140": 140, "141": 141, "142": 142, "143": 143, "144": 144, "145": 145, "146": 146, "147": 147, "148": 148, "149": 149, "150": 150, "151": 151, "152": 152, "153": 153, "154": 154, "155": 155, "156": 156, "157": 157, "158": 158, "159": 159, "160": 160, "161": 161, "162": 162, "163": 163, "164": 164, "165": 165, "166": 166, "167": 167, "168": 168, "169": 169, "170": 170, "171": 171, "172": 172, "173": 173, "174": 174, "175": 175, "176": 176, "177": 177, "178": 178, "179": 179, "180": 180, "181": 181, "182": 182, "183": 183, "184": 184, "185": 185, "186": 186, "187": 187, "188": 188, "189": 189, "190": 190, "191": 191, "192": 192, "193": 193, "194": 194, "195": 195, "196": 196, "197": 197, "198": 198, "199": 199, "200": 200, "201": 201, "202": 202, "203": 203, "204": 204, "205": 205, "206": 206, "207": 207, "208": 208, "209": 209, "210": 210, "211": 211, "212": 212, "213": 213, "214": 214, "215": 215, "216": 216, "217": 217, "218": 218, "219": 219, "220": 220, "221": 221, "222": 222, "223": 223, "224": 224, "225": 225, "226": 226, "227": 227, "228": 228, "229": 229, "23": 23, "230": 230, "231": 231, "232": 232, "233": 233, "234": 234, "235": 235, "236": 236, "237": 237, "238": 238, "239": 239, "240": 240, "241": 241, "242": 242, "243": 243, "244": 244, "245": 245, "246": 246, "247": 247, "248": 248, "249": 249, "250": 250, "251": 251, "252": 252, "253": 253, "254": 254, "255": 255, "256": 256, "257": 257, "258": 258, "259": 259, "260": 260, "261": 261, "262": 262, "263": 263, "264": 264, "265": 265, "266": 266, "267": 267, "268": 268, "269": 269, "270": 270, "271": 271, "272": 272, "273": 273, "274": 274, "275": 275, "276": 276, "277": 277, "278": 278, "279": 279, "280": 280, "281": 281, "282": 282, "283": 283, "284": 284, "285": 285, "286": 286, "287": 287, "288": 288, "289": 289, "290": 290, "291": 291, "292": 292, "293": 293, "294": 294 }], 296: [function (_dereq_, module, exports) {
	    (function (global) {
	      /**
	       * Copyright (c) 2014, Facebook, Inc.
	       * All rights reserved.
	       *
	       * This source code is licensed under the BSD-style license found in the
	       * https://raw.github.com/facebook/regenerator/master/LICENSE file. An
	       * additional grant of patent rights can be found in the PATENTS file in
	       * the same directory.
	       */
	
	      !function (global) {
	        "use strict";
	
	        var Op = Object.prototype;
	        var hasOwn = Op.hasOwnProperty;
	        var undefined; // More compressible than void 0.
	        var $Symbol = typeof Symbol === "function" ? Symbol : {};
	        var iteratorSymbol = $Symbol.iterator || "@@iterator";
	        var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
	
	        var inModule = (typeof module === "undefined" ? "undefined" : _typeof(module)) === "object";
	        var runtime = global.regeneratorRuntime;
	        if (runtime) {
	          if (inModule) {
	            // If regeneratorRuntime is defined globally and we're in a module,
	            // make the exports object identical to regeneratorRuntime.
	            module.exports = runtime;
	          }
	          // Don't bother evaluating the rest of this file if the runtime was
	          // already defined globally.
	          return;
	        }
	
	        // Define the runtime globally (as expected by generated code) as either
	        // module.exports (if we're in a module) or a new, empty object.
	        runtime = global.regeneratorRuntime = inModule ? module.exports : {};
	
	        function wrap(innerFn, outerFn, self, tryLocsList) {
	          // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
	          var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
	          var generator = Object.create(protoGenerator.prototype);
	          var context = new Context(tryLocsList || []);
	
	          // The ._invoke method unifies the implementations of the .next,
	          // .throw, and .return methods.
	          generator._invoke = makeInvokeMethod(innerFn, self, context);
	
	          return generator;
	        }
	        runtime.wrap = wrap;
	
	        // Try/catch helper to minimize deoptimizations. Returns a completion
	        // record like context.tryEntries[i].completion. This interface could
	        // have been (and was previously) designed to take a closure to be
	        // invoked without arguments, but in all the cases we care about we
	        // already have an existing method we want to call, so there's no need
	        // to create a new function object. We can even get away with assuming
	        // the method takes exactly one argument, since that happens to be true
	        // in every case, so we don't have to touch the arguments object. The
	        // only additional allocation required is the completion record, which
	        // has a stable shape and so hopefully should be cheap to allocate.
	        function tryCatch(fn, obj, arg) {
	          try {
	            return { type: "normal", arg: fn.call(obj, arg) };
	          } catch (err) {
	            return { type: "throw", arg: err };
	          }
	        }
	
	        var GenStateSuspendedStart = "suspendedStart";
	        var GenStateSuspendedYield = "suspendedYield";
	        var GenStateExecuting = "executing";
	        var GenStateCompleted = "completed";
	
	        // Returning this object from the innerFn has the same effect as
	        // breaking out of the dispatch switch statement.
	        var ContinueSentinel = {};
	
	        // Dummy constructor functions that we use as the .constructor and
	        // .constructor.prototype properties for functions that return Generator
	        // objects. For full spec compliance, you may wish to configure your
	        // minifier not to mangle the names of these two functions.
	        function Generator() {}
	        function GeneratorFunction() {}
	        function GeneratorFunctionPrototype() {}
	
	        // This is a polyfill for %IteratorPrototype% for environments that
	        // don't natively support it.
	        var IteratorPrototype = {};
	        IteratorPrototype[iteratorSymbol] = function () {
	          return this;
	        };
	
	        var getProto = Object.getPrototypeOf;
	        var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
	        if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
	          // This environment has a native %IteratorPrototype%; use it instead
	          // of the polyfill.
	          IteratorPrototype = NativeIteratorPrototype;
	        }
	
	        var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
	        GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
	        GeneratorFunctionPrototype.constructor = GeneratorFunction;
	        GeneratorFunctionPrototype[toStringTagSymbol] = GeneratorFunction.displayName = "GeneratorFunction";
	
	        // Helper for defining the .next, .throw, and .return methods of the
	        // Iterator interface in terms of a single ._invoke method.
	        function defineIteratorMethods(prototype) {
	          ["next", "throw", "return"].forEach(function (method) {
	            prototype[method] = function (arg) {
	              return this._invoke(method, arg);
	            };
	          });
	        }
	
	        runtime.isGeneratorFunction = function (genFun) {
	          var ctor = typeof genFun === "function" && genFun.constructor;
	          return ctor ? ctor === GeneratorFunction ||
	          // For the native GeneratorFunction constructor, the best we can
	          // do is to check its .name property.
	          (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
	        };
	
	        runtime.mark = function (genFun) {
	          if (Object.setPrototypeOf) {
	            Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
	          } else {
	            genFun.__proto__ = GeneratorFunctionPrototype;
	            if (!(toStringTagSymbol in genFun)) {
	              genFun[toStringTagSymbol] = "GeneratorFunction";
	            }
	          }
	          genFun.prototype = Object.create(Gp);
	          return genFun;
	        };
	
	        // Within the body of any async function, `await x` is transformed to
	        // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
	        // `hasOwn.call(value, "__await")` to determine if the yielded value is
	        // meant to be awaited.
	        runtime.awrap = function (arg) {
	          return { __await: arg };
	        };
	
	        function AsyncIterator(generator) {
	          function invoke(method, arg, resolve, reject) {
	            var record = tryCatch(generator[method], generator, arg);
	            if (record.type === "throw") {
	              reject(record.arg);
	            } else {
	              var result = record.arg;
	              var value = result.value;
	              if (value && (typeof value === "undefined" ? "undefined" : _typeof(value)) === "object" && hasOwn.call(value, "__await")) {
	                return Promise.resolve(value.__await).then(function (value) {
	                  invoke("next", value, resolve, reject);
	                }, function (err) {
	                  invoke("throw", err, resolve, reject);
	                });
	              }
	
	              return Promise.resolve(value).then(function (unwrapped) {
	                // When a yielded Promise is resolved, its final value becomes
	                // the .value of the Promise<{value,done}> result for the
	                // current iteration. If the Promise is rejected, however, the
	                // result for this iteration will be rejected with the same
	                // reason. Note that rejections of yielded Promises are not
	                // thrown back into the generator function, as is the case
	                // when an awaited Promise is rejected. This difference in
	                // behavior between yield and await is important, because it
	                // allows the consumer to decide what to do with the yielded
	                // rejection (swallow it and continue, manually .throw it back
	                // into the generator, abandon iteration, whatever). With
	                // await, by contrast, there is no opportunity to examine the
	                // rejection reason outside the generator function, so the
	                // only option is to throw it from the await expression, and
	                // let the generator function handle the exception.
	                result.value = unwrapped;
	                resolve(result);
	              }, reject);
	            }
	          }
	
	          if ((typeof process === "undefined" ? "undefined" : _typeof(process)) === "object" && process.domain) {
	            invoke = process.domain.bind(invoke);
	          }
	
	          var previousPromise;
	
	          function enqueue(method, arg) {
	            function callInvokeWithMethodAndArg() {
	              return new Promise(function (resolve, reject) {
	                invoke(method, arg, resolve, reject);
	              });
	            }
	
	            return previousPromise =
	            // If enqueue has been called before, then we want to wait until
	            // all previous Promises have been resolved before calling invoke,
	            // so that results are always delivered in the correct order. If
	            // enqueue has not been called before, then it is important to
	            // call invoke immediately, without waiting on a callback to fire,
	            // so that the async generator function has the opportunity to do
	            // any necessary setup in a predictable way. This predictability
	            // is why the Promise constructor synchronously invokes its
	            // executor callback, and why async functions synchronously
	            // execute code before the first await. Since we implement simple
	            // async functions in terms of async generators, it is especially
	            // important to get this right, even though it requires care.
	            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg,
	            // Avoid propagating failures to Promises returned by later
	            // invocations of the iterator.
	            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
	          }
	
	          // Define the unified helper method that is used to implement .next,
	          // .throw, and .return (see defineIteratorMethods).
	          this._invoke = enqueue;
	        }
	
	        defineIteratorMethods(AsyncIterator.prototype);
	        runtime.AsyncIterator = AsyncIterator;
	
	        // Note that simple async functions are implemented on top of
	        // AsyncIterator objects; they just return a Promise for the value of
	        // the final result produced by the iterator.
	        runtime.async = function (innerFn, outerFn, self, tryLocsList) {
	          var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList));
	
	          return runtime.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
	          : iter.next().then(function (result) {
	            return result.done ? result.value : iter.next();
	          });
	        };
	
	        function makeInvokeMethod(innerFn, self, context) {
	          var state = GenStateSuspendedStart;
	
	          return function invoke(method, arg) {
	            if (state === GenStateExecuting) {
	              throw new Error("Generator is already running");
	            }
	
	            if (state === GenStateCompleted) {
	              if (method === "throw") {
	                throw arg;
	              }
	
	              // Be forgiving, per 25.3.3.3.3 of the spec:
	              // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
	              return doneResult();
	            }
	
	            while (true) {
	              var delegate = context.delegate;
	              if (delegate) {
	                if (method === "return" || method === "throw" && delegate.iterator[method] === undefined) {
	                  // A return or throw (when the delegate iterator has no throw
	                  // method) always terminates the yield* loop.
	                  context.delegate = null;
	
	                  // If the delegate iterator has a return method, give it a
	                  // chance to clean up.
	                  var returnMethod = delegate.iterator["return"];
	                  if (returnMethod) {
	                    var record = tryCatch(returnMethod, delegate.iterator, arg);
	                    if (record.type === "throw") {
	                      // If the return method threw an exception, let that
	                      // exception prevail over the original return or throw.
	                      method = "throw";
	                      arg = record.arg;
	                      continue;
	                    }
	                  }
	
	                  if (method === "return") {
	                    // Continue with the outer return, now that the delegate
	                    // iterator has been terminated.
	                    continue;
	                  }
	                }
	
	                var record = tryCatch(delegate.iterator[method], delegate.iterator, arg);
	
	                if (record.type === "throw") {
	                  context.delegate = null;
	
	                  // Like returning generator.throw(uncaught), but without the
	                  // overhead of an extra function call.
	                  method = "throw";
	                  arg = record.arg;
	                  continue;
	                }
	
	                // Delegate generator ran and handled its own exceptions so
	                // regardless of what the method was, we continue as if it is
	                // "next" with an undefined arg.
	                method = "next";
	                arg = undefined;
	
	                var info = record.arg;
	                if (info.done) {
	                  context[delegate.resultName] = info.value;
	                  context.next = delegate.nextLoc;
	                } else {
	                  state = GenStateSuspendedYield;
	                  return info;
	                }
	
	                context.delegate = null;
	              }
	
	              if (method === "next") {
	                // Setting context._sent for legacy support of Babel's
	                // function.sent implementation.
	                context.sent = context._sent = arg;
	              } else if (method === "throw") {
	                if (state === GenStateSuspendedStart) {
	                  state = GenStateCompleted;
	                  throw arg;
	                }
	
	                if (context.dispatchException(arg)) {
	                  // If the dispatched exception was caught by a catch block,
	                  // then let that catch block handle the exception normally.
	                  method = "next";
	                  arg = undefined;
	                }
	              } else if (method === "return") {
	                context.abrupt("return", arg);
	              }
	
	              state = GenStateExecuting;
	
	              var record = tryCatch(innerFn, self, context);
	              if (record.type === "normal") {
	                // If an exception is thrown from innerFn, we leave state ===
	                // GenStateExecuting and loop back for another invocation.
	                state = context.done ? GenStateCompleted : GenStateSuspendedYield;
	
	                var info = {
	                  value: record.arg,
	                  done: context.done
	                };
	
	                if (record.arg === ContinueSentinel) {
	                  if (context.delegate && method === "next") {
	                    // Deliberately forget the last sent value so that we don't
	                    // accidentally pass it on to the delegate.
	                    arg = undefined;
	                  }
	                } else {
	                  return info;
	                }
	              } else if (record.type === "throw") {
	                state = GenStateCompleted;
	                // Dispatch the exception by looping back around to the
	                // context.dispatchException(arg) call above.
	                method = "throw";
	                arg = record.arg;
	              }
	            }
	          };
	        }
	
	        // Define Generator.prototype.{next,throw,return} in terms of the
	        // unified ._invoke helper method.
	        defineIteratorMethods(Gp);
	
	        Gp[toStringTagSymbol] = "Generator";
	
	        Gp.toString = function () {
	          return "[object Generator]";
	        };
	
	        function pushTryEntry(locs) {
	          var entry = { tryLoc: locs[0] };
	
	          if (1 in locs) {
	            entry.catchLoc = locs[1];
	          }
	
	          if (2 in locs) {
	            entry.finallyLoc = locs[2];
	            entry.afterLoc = locs[3];
	          }
	
	          this.tryEntries.push(entry);
	        }
	
	        function resetTryEntry(entry) {
	          var record = entry.completion || {};
	          record.type = "normal";
	          delete record.arg;
	          entry.completion = record;
	        }
	
	        function Context(tryLocsList) {
	          // The root entry object (effectively a try statement without a catch
	          // or a finally block) gives us a place to store values thrown from
	          // locations where there is no enclosing try statement.
	          this.tryEntries = [{ tryLoc: "root" }];
	          tryLocsList.forEach(pushTryEntry, this);
	          this.reset(true);
	        }
	
	        runtime.keys = function (object) {
	          var keys = [];
	          for (var key in object) {
	            keys.push(key);
	          }
	          keys.reverse();
	
	          // Rather than returning an object with a next method, we keep
	          // things simple and return the next function itself.
	          return function next() {
	            while (keys.length) {
	              var key = keys.pop();
	              if (key in object) {
	                next.value = key;
	                next.done = false;
	                return next;
	              }
	            }
	
	            // To avoid creating an additional object, we just hang the .value
	            // and .done properties off the next function object itself. This
	            // also ensures that the minifier will not anonymize the function.
	            next.done = true;
	            return next;
	          };
	        };
	
	        function values(iterable) {
	          if (iterable) {
	            var iteratorMethod = iterable[iteratorSymbol];
	            if (iteratorMethod) {
	              return iteratorMethod.call(iterable);
	            }
	
	            if (typeof iterable.next === "function") {
	              return iterable;
	            }
	
	            if (!isNaN(iterable.length)) {
	              var i = -1,
	                  next = function next() {
	                while (++i < iterable.length) {
	                  if (hasOwn.call(iterable, i)) {
	                    next.value = iterable[i];
	                    next.done = false;
	                    return next;
	                  }
	                }
	
	                next.value = undefined;
	                next.done = true;
	
	                return next;
	              };
	
	              return next.next = next;
	            }
	          }
	
	          // Return an iterator with no values.
	          return { next: doneResult };
	        }
	        runtime.values = values;
	
	        function doneResult() {
	          return { value: undefined, done: true };
	        }
	
	        Context.prototype = {
	          constructor: Context,
	
	          reset: function reset(skipTempReset) {
	            this.prev = 0;
	            this.next = 0;
	            // Resetting context._sent for legacy support of Babel's
	            // function.sent implementation.
	            this.sent = this._sent = undefined;
	            this.done = false;
	            this.delegate = null;
	
	            this.tryEntries.forEach(resetTryEntry);
	
	            if (!skipTempReset) {
	              for (var name in this) {
	                // Not sure about the optimal order of these conditions:
	                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) {
	                  this[name] = undefined;
	                }
	              }
	            }
	          },
	
	          stop: function stop() {
	            this.done = true;
	
	            var rootEntry = this.tryEntries[0];
	            var rootRecord = rootEntry.completion;
	            if (rootRecord.type === "throw") {
	              throw rootRecord.arg;
	            }
	
	            return this.rval;
	          },
	
	          dispatchException: function dispatchException(exception) {
	            if (this.done) {
	              throw exception;
	            }
	
	            var context = this;
	            function handle(loc, caught) {
	              record.type = "throw";
	              record.arg = exception;
	              context.next = loc;
	              return !!caught;
	            }
	
	            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	              var entry = this.tryEntries[i];
	              var record = entry.completion;
	
	              if (entry.tryLoc === "root") {
	                // Exception thrown outside of any try block that could handle
	                // it, so set the completion value of the entire function to
	                // throw the exception.
	                return handle("end");
	              }
	
	              if (entry.tryLoc <= this.prev) {
	                var hasCatch = hasOwn.call(entry, "catchLoc");
	                var hasFinally = hasOwn.call(entry, "finallyLoc");
	
	                if (hasCatch && hasFinally) {
	                  if (this.prev < entry.catchLoc) {
	                    return handle(entry.catchLoc, true);
	                  } else if (this.prev < entry.finallyLoc) {
	                    return handle(entry.finallyLoc);
	                  }
	                } else if (hasCatch) {
	                  if (this.prev < entry.catchLoc) {
	                    return handle(entry.catchLoc, true);
	                  }
	                } else if (hasFinally) {
	                  if (this.prev < entry.finallyLoc) {
	                    return handle(entry.finallyLoc);
	                  }
	                } else {
	                  throw new Error("try statement without catch or finally");
	                }
	              }
	            }
	          },
	
	          abrupt: function abrupt(type, arg) {
	            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	              var entry = this.tryEntries[i];
	              if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
	                var finallyEntry = entry;
	                break;
	              }
	            }
	
	            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) {
	              // Ignore the finally entry if control is not jumping to a
	              // location outside the try/catch block.
	              finallyEntry = null;
	            }
	
	            var record = finallyEntry ? finallyEntry.completion : {};
	            record.type = type;
	            record.arg = arg;
	
	            if (finallyEntry) {
	              this.next = finallyEntry.finallyLoc;
	            } else {
	              this.complete(record);
	            }
	
	            return ContinueSentinel;
	          },
	
	          complete: function complete(record, afterLoc) {
	            if (record.type === "throw") {
	              throw record.arg;
	            }
	
	            if (record.type === "break" || record.type === "continue") {
	              this.next = record.arg;
	            } else if (record.type === "return") {
	              this.rval = record.arg;
	              this.next = "end";
	            } else if (record.type === "normal" && afterLoc) {
	              this.next = afterLoc;
	            }
	          },
	
	          finish: function finish(finallyLoc) {
	            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	              var entry = this.tryEntries[i];
	              if (entry.finallyLoc === finallyLoc) {
	                this.complete(entry.completion, entry.afterLoc);
	                resetTryEntry(entry);
	                return ContinueSentinel;
	              }
	            }
	          },
	
	          "catch": function _catch(tryLoc) {
	            for (var i = this.tryEntries.length - 1; i >= 0; --i) {
	              var entry = this.tryEntries[i];
	              if (entry.tryLoc === tryLoc) {
	                var record = entry.completion;
	                if (record.type === "throw") {
	                  var thrown = record.arg;
	                  resetTryEntry(entry);
	                }
	                return thrown;
	              }
	            }
	
	            // The context.catch method must only be called with a location
	            // argument that corresponds to a known catch block.
	            throw new Error("illegal catch attempt");
	          },
	
	          delegateYield: function delegateYield(iterable, resultName, nextLoc) {
	            this.delegate = {
	              iterator: values(iterable),
	              resultName: resultName,
	              nextLoc: nextLoc
	            };
	
	            return ContinueSentinel;
	          }
	        };
	      }(
	      // Among the various tricks for obtaining a reference to the global
	      // object, this seems to be the most reliable technique that does not
	      // use indirect eval (which violates Content Security Policy).
	      (typeof global === "undefined" ? "undefined" : _typeof(global)) === "object" ? global : (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" ? window : (typeof self === "undefined" ? "undefined" : _typeof(self)) === "object" ? self : this);
	    }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
	  }, {}] }, {}, [1]);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(/*! ./../../../~/process/browser.js */ 30)))

/***/ }),

/***/ 1536:
/*!***************************************************************************!*\
  !*** ./~/imports-loader!./Scripts/vendor/isOnScreen/jquery.isonscreen.js ***!
  \***************************************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	'use strict';
	
	(function ($) {
	
	        $.fn.isOnScreen = function (x, y) {
	
	                if (x == null || typeof x == 'undefined') x = 1;
	                if (y == null || typeof y == 'undefined') y = 1;
	
	                var win = $(window);
	
	                var viewport = {
	                        top: win.scrollTop(),
	                        left: win.scrollLeft()
	                };
	                viewport.right = viewport.left + win.width();
	                viewport.bottom = viewport.top + win.height();
	
	                var height = this.outerHeight();
	                var width = this.outerWidth();
	
	                if (!width || !height) {
	                        return false;
	                }
	
	                var bounds = this.offset();
	                bounds.right = bounds.left + width;
	                bounds.bottom = bounds.top + height;
	
	                var visible = !(viewport.right < bounds.left || viewport.left > bounds.right || viewport.bottom < bounds.top || viewport.top > bounds.bottom);
	
	                if (!visible) {
	                        return false;
	                }
	
	                var deltas = {
	                        top: Math.min(1, (bounds.bottom - viewport.top) / height),
	                        bottom: Math.min(1, (viewport.bottom - bounds.top) / height),
	                        left: Math.min(1, (bounds.right - viewport.left) / width),
	                        right: Math.min(1, (viewport.right - bounds.left) / width)
	                };
	
	                return deltas.left * deltas.right >= x && deltas.top * deltas.bottom >= y;
	        };
	})(jQuery);


/***/ }),

/***/ 1537:
/*!*********************************************************************************!*\
  !*** ./~/imports-loader!./Scripts/vendor/jqueryajax/jquery.unobtrusive-ajax.js ***!
  \*********************************************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	"use strict";
	
	/*!
	** Unobtrusive Ajax support library for jQuery
	** Copyright (C) Microsoft Corporation. All rights reserved.
	*/
	
	/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
	/*global window: false, jQuery: false */
	
	(function ($) {
	    var data_click = "unobtrusiveAjaxClick",
	        data_validation = "unobtrusiveValidation";
	
	    function getFunction(code, argNames) {
	        var fn = window,
	            parts = (code || "").split(".");
	        while (fn && parts.length) {
	            fn = fn[parts.shift()];
	        }
	        if (typeof fn === "function") {
	            return fn;
	        }
	        argNames.push(code);
	        return Function.constructor.apply(null, argNames);
	    }
	
	    function isMethodProxySafe(method) {
	        return method === "GET" || method === "POST";
	    }
	
	    function asyncOnBeforeSend(xhr, method) {
	        if (!isMethodProxySafe(method)) {
	            xhr.setRequestHeader("X-HTTP-Method-Override", method);
	        }
	    }
	
	    function asyncOnSuccess(element, data, contentType) {
	        var mode;
	
	        if (contentType.indexOf("application/x-javascript") !== -1) {
	            // jQuery already executes JavaScript for us
	            return;
	        }
	
	        mode = (element.getAttribute("data-ajax-mode") || "").toUpperCase();
	        $(element.getAttribute("data-ajax-update")).each(function (i, update) {
	            var top;
	
	            switch (mode) {
	                case "BEFORE":
	                    top = update.firstChild;
	                    $("<div />").html(data).contents().each(function () {
	                        update.insertBefore(this, top);
	                    });
	                    break;
	                case "AFTER":
	                    $("<div />").html(data).contents().each(function () {
	                        update.appendChild(this);
	                    });
	                    break;
	                default:
	                    $(update).html(data);
	                    break;
	            }
	        });
	    }
	
	    function asyncRequest(element, options) {
	        var confirm, loading, method, duration;
	
	        confirm = element.getAttribute("data-ajax-confirm");
	        if (confirm && !window.confirm(confirm)) {
	            return;
	        }
	
	        loading = $(element.getAttribute("data-ajax-loading"));
	        duration = element.getAttribute("data-ajax-loading-duration") || 0;
	
	        $.extend(options, {
	            type: element.getAttribute("data-ajax-method") || undefined,
	            url: element.getAttribute("data-ajax-url") || undefined,
	            beforeSend: function beforeSend(xhr) {
	                var result;
	                asyncOnBeforeSend(xhr, method);
	                result = getFunction(element.getAttribute("data-ajax-begin"), ["xhr"]).apply(this, arguments);
	                if (result !== false) {
	                    loading.show(duration);
	                }
	                return result;
	            },
	            complete: function complete() {
	                loading.hide(duration);
	                getFunction(element.getAttribute("data-ajax-complete"), ["xhr", "status"]).apply(this, arguments);
	            },
	            success: function success(data, status, xhr) {
	                asyncOnSuccess(element, data, xhr.getResponseHeader("Content-Type") || "text/html");
	                getFunction(element.getAttribute("data-ajax-success"), ["data", "status", "xhr"]).apply(this, arguments);
	            },
	            error: getFunction(element.getAttribute("data-ajax-failure"), ["xhr", "status", "error"])
	        });
	
	        options.data.push({ name: "X-Requested-With", value: "XMLHttpRequest" });
	
	        method = options.type.toUpperCase();
	        if (!isMethodProxySafe(method)) {
	            options.type = "POST";
	            options.data.push({ name: "X-HTTP-Method-Override", value: method });
	        }
	
	        $.ajax(options);
	    }
	
	    function validate(form) {
	        var validationInfo = $(form).data(data_validation);
	        return !validationInfo || !validationInfo.validate || validationInfo.validate();
	    }
	
	    $("a[data-ajax=true]").live("click", function (evt) {
	        evt.preventDefault();
	        asyncRequest(this, {
	            url: this.href,
	            type: "GET",
	            data: []
	        });
	    });
	
	    $("form[data-ajax=true] input[type=image]").live("click", function (evt) {
	        var name = evt.target.name,
	            $target = $(evt.target),
	            form = $target.parents("form")[0],
	            offset = $target.offset();
	
	        $(form).data(data_click, [{ name: name + ".x", value: Math.round(evt.pageX - offset.left) }, { name: name + ".y", value: Math.round(evt.pageY - offset.top) }]);
	
	        setTimeout(function () {
	            $(form).removeData(data_click);
	        }, 0);
	    });
	
	    $("form[data-ajax=true] :submit").live("click", function (evt) {
	        var name = evt.target.name,
	            form = $(evt.target).parents("form")[0];
	
	        $(form).data(data_click, name ? [{ name: name, value: evt.target.value }] : []);
	
	        setTimeout(function () {
	            $(form).removeData(data_click);
	        }, 0);
	    });
	
	    $("form[data-ajax=true]").live("submit", function (evt) {
	        var clickInfo = $(this).data(data_click) || [];
	        evt.preventDefault();
	        if (!validate(this)) {
	            return;
	        }
	        asyncRequest(this, {
	            url: this.action,
	            type: this.method || "GET",
	            data: clickInfo.concat($(this).serializeArray())
	        });
	    });
	})(jQuery);


/***/ }),

/***/ 1538:
/*!*******************************************************************************!*\
  !*** ./~/imports-loader!./Scripts/vendor/jquerydotdotdot/jquery.dotdotdot.js ***!
  \*******************************************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	'use strict';
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*
	 *	jQuery dotdotdot 1.7.4
	 *
	 *	Copyright (c) Fred Heusschen
	 *	www.frebsite.nl
	 *
	 *	Plugin website:
	 *	dotdotdot.frebsite.nl
	 *
	 *	Licensed under the MIT license.
	 *	http://en.wikipedia.org/wiki/MIT_License
	 */
	
	(function ($, undef) {
		if ($.fn.dotdotdot) {
			return;
		}
	
		$.fn.dotdotdot = function (o) {
			if (this.length == 0) {
				$.fn.dotdotdot.debug('No element found for "' + this.selector + '".');
				return this;
			}
			if (this.length > 1) {
				return this.each(function () {
					$(this).dotdotdot(o);
				});
			}
	
			var $dot = this;
	
			if ($dot.data('dotdotdot')) {
				$dot.trigger('destroy.dot');
			}
	
			$dot.data('dotdotdot-style', $dot.attr('style') || '');
			$dot.css('word-wrap', 'break-word');
			if ($dot.css('white-space') === 'nowrap') {
				$dot.css('white-space', 'normal');
			}
	
			$dot.bind_events = function () {
				$dot.bind('update.dot', function (e, c) {
					$dot.removeClass("is-truncated");
					e.preventDefault();
					e.stopPropagation();
	
					switch (_typeof(opts.height)) {
						case 'number':
							opts.maxHeight = opts.height;
							break;
	
						case 'function':
							opts.maxHeight = opts.height.call($dot[0]);
							break;
	
						default:
							opts.maxHeight = getTrueInnerHeight($dot);
							break;
					}
	
					opts.maxHeight += opts.tolerance;
	
					if (typeof c != 'undefined') {
						if (typeof c == 'string' || 'nodeType' in c && c.nodeType === 1) {
							c = $('<div />').append(c).contents();
						}
						if (c instanceof $) {
							orgContent = c;
						}
					}
	
					$inr = $dot.wrapInner('<div class="dotdotdot" />').children();
					$inr.contents().detach().end().append(orgContent.clone(true)).find('br').replaceWith('  <br />  ').end().css({
						'height': 'auto',
						'width': 'auto',
						'border': 'none',
						'padding': 0,
						'margin': 0
					});
	
					var after = false,
					    trunc = false;
	
					if (conf.afterElement) {
						after = conf.afterElement.clone(true);
						after.show();
						conf.afterElement.detach();
					}
	
					if (test($inr, opts)) {
						if (opts.wrap == 'children') {
							trunc = children($inr, opts, after);
						} else {
							trunc = ellipsis($inr, $dot, $inr, opts, after);
						}
					}
					$inr.replaceWith($inr.contents());
					$inr = null;
	
					if ($.isFunction(opts.callback)) {
						opts.callback.call($dot[0], trunc, orgContent);
					}
	
					conf.isTruncated = trunc;
					return trunc;
				}).bind('isTruncated.dot', function (e, fn) {
					e.preventDefault();
					e.stopPropagation();
	
					if (typeof fn == 'function') {
						fn.call($dot[0], conf.isTruncated);
					}
					return conf.isTruncated;
				}).bind('originalContent.dot', function (e, fn) {
					e.preventDefault();
					e.stopPropagation();
	
					if (typeof fn == 'function') {
						fn.call($dot[0], orgContent);
					}
					return orgContent;
				}).bind('destroy.dot', function (e) {
					e.preventDefault();
					e.stopPropagation();
	
					$dot.unwatch().unbind_events().contents().detach().end().append(orgContent).attr('style', $dot.data('dotdotdot-style') || '').data('dotdotdot', false);
				});
				return $dot;
			}; //	/bind_events
	
			$dot.unbind_events = function () {
				$dot.unbind('.dot');
				return $dot;
			}; //	/unbind_events
	
			$dot.watch = function () {
				$dot.unwatch();
				if (opts.watch == 'window') {
					var $window = $(window),
					    _wWidth = $window.width(),
					    _wHeight = $window.height();
	
					$window.bind('resize.dot' + conf.dotId, function () {
						if (_wWidth != $window.width() || _wHeight != $window.height() || !opts.windowResizeFix) {
							_wWidth = $window.width();
							_wHeight = $window.height();
	
							if (watchInt) {
								clearInterval(watchInt);
							}
							watchInt = setTimeout(function () {
								$dot.trigger('update.dot');
							}, 100);
						}
					});
				} else {
					watchOrg = getSizes($dot);
					watchInt = setInterval(function () {
						if ($dot.is(':visible')) {
							var watchNew = getSizes($dot);
							if (watchOrg.width != watchNew.width || watchOrg.height != watchNew.height) {
								$dot.trigger('update.dot');
								watchOrg = watchNew;
							}
						}
					}, 500);
				}
				return $dot;
			};
			$dot.unwatch = function () {
				$(window).unbind('resize.dot' + conf.dotId);
				if (watchInt) {
					clearInterval(watchInt);
				}
				return $dot;
			};
	
			var orgContent = $dot.contents(),
			    opts = $.extend(true, {}, $.fn.dotdotdot.defaults, o),
			    conf = {},
			    watchOrg = {},
			    watchInt = null,
			    $inr = null;
	
			if (!(opts.lastCharacter.remove instanceof Array)) {
				opts.lastCharacter.remove = $.fn.dotdotdot.defaultArrays.lastCharacter.remove;
			}
			if (!(opts.lastCharacter.noEllipsis instanceof Array)) {
				opts.lastCharacter.noEllipsis = $.fn.dotdotdot.defaultArrays.lastCharacter.noEllipsis;
			}
	
			conf.afterElement = getElement(opts.after, $dot);
			conf.isTruncated = false;
			conf.dotId = dotId++;
	
			$dot.data('dotdotdot', true).bind_events().trigger('update.dot');
	
			if (opts.watch) {
				$dot.watch();
			}
	
			return $dot;
		};
	
		//	public
		$.fn.dotdotdot.defaults = {
			'ellipsis': '... ',
			'wrap': 'word',
			'fallbackToLetter': true,
			'lastCharacter': {},
			'tolerance': 0,
			'callback': null,
			'after': null,
			'height': null,
			'watch': false,
			'windowResizeFix': true
		};
		$.fn.dotdotdot.defaultArrays = {
			'lastCharacter': {
				'remove': [' ', '\u3000', ',', ';', '.', '!', '?'],
				'noEllipsis': []
			}
		};
		$.fn.dotdotdot.debug = function (msg) {};
	
		//	private
		var dotId = 1;
	
		function children($elem, o, after) {
			var $elements = $elem.children(),
			    isTruncated = false;
	
			$elem.empty();
	
			for (var a = 0, l = $elements.length; a < l; a++) {
				var $e = $elements.eq(a);
				$elem.append($e);
				if (after) {
					$elem.append(after);
				}
				if (test($elem, o)) {
					$e.remove();
					isTruncated = true;
					break;
				} else {
					if (after) {
						after.detach();
					}
				}
			}
			return isTruncated;
		}
		function ellipsis($elem, $d, $i, o, after) {
			var isTruncated = false;
	
			//	Don't put the ellipsis directly inside these elements
			var notx = 'a, table, thead, tbody, tfoot, tr, col, colgroup, object, embed, param, ol, ul, dl, blockquote, select, optgroup, option, textarea, script, style';
	
			//	Don't remove these elements even if they are after the ellipsis
			var noty = 'script, .dotdotdot-keep';
	
			$elem.contents().detach().each(function () {
	
				var e = this,
				    $e = $(e);
	
				if (typeof e == 'undefined') {
					return true;
				} else if ($e.is(noty)) {
					$elem.append($e);
				} else if (isTruncated) {
					return true;
				} else {
					$elem.append($e);
					if (after && !$e.is(o.after) && !$e.find(o.after).length) {
						$elem[$elem.is(notx) ? 'after' : 'append'](after);
					}
					if (test($i, o)) {
						if (e.nodeType == 3) // node is TEXT
							{
								isTruncated = ellipsisElement($e, $d, $i, o, after);
							} else {
							isTruncated = ellipsis($e, $d, $i, o, after);
						}
	
						if (!isTruncated) {
							$e.detach();
							isTruncated = true;
						}
					}
	
					if (!isTruncated) {
						if (after) {
							after.detach();
						}
					}
				}
			});
			$d.addClass("is-truncated");
			return isTruncated;
		}
		function ellipsisElement($e, $d, $i, o, after) {
			var e = $e[0];
	
			if (!e) {
				return false;
			}
	
			var txt = getTextContent(e),
			    space = txt.indexOf(' ') !== -1 ? ' ' : '\u3000',
			    separator = o.wrap == 'letter' ? '' : space,
			    textArr = txt.split(separator),
			    position = -1,
			    midPos = -1,
			    startPos = 0,
			    endPos = textArr.length - 1;
	
			//	Only one word
			if (o.fallbackToLetter && startPos == 0 && endPos == 0) {
				separator = '';
				textArr = txt.split(separator);
				endPos = textArr.length - 1;
			}
	
			while (startPos <= endPos && !(startPos == 0 && endPos == 0)) {
				var m = Math.floor((startPos + endPos) / 2);
				if (m == midPos) {
					break;
				}
				midPos = m;
	
				setTextContent(e, textArr.slice(0, midPos + 1).join(separator) + o.ellipsis);
				$i.children().each(function () {
					$(this).toggle().toggle();
				});
	
				if (!test($i, o)) {
					position = midPos;
					startPos = midPos;
				} else {
					endPos = midPos;
	
					//	Fallback to letter
					if (o.fallbackToLetter && startPos == 0 && endPos == 0) {
						separator = '';
						textArr = textArr[0].split(separator);
						position = -1;
						midPos = -1;
						startPos = 0;
						endPos = textArr.length - 1;
					}
				}
			}
	
			if (position != -1 && !(textArr.length == 1 && textArr[0].length == 0)) {
				txt = addEllipsis(textArr.slice(0, position + 1).join(separator), o);
				setTextContent(e, txt);
			} else {
				var $w = $e.parent();
				$e.detach();
	
				var afterLength = after && after.closest($w).length ? after.length : 0;
	
				if ($w.contents().length > afterLength) {
					e = findLastTextNode($w.contents().eq(-1 - afterLength), $d);
				} else {
					e = findLastTextNode($w, $d, true);
					if (!afterLength) {
						$w.detach();
					}
				}
				if (e) {
					txt = addEllipsis(getTextContent(e), o);
					setTextContent(e, txt);
					if (afterLength && after) {
						$(e).parent().append(after);
					}
				}
			}
	
			return true;
		}
		function test($i, o) {
			return $i.innerHeight() > o.maxHeight;
		}
		function addEllipsis(txt, o) {
			while ($.inArray(txt.slice(-1), o.lastCharacter.remove) > -1) {
				txt = txt.slice(0, -1);
			}
			if ($.inArray(txt.slice(-1), o.lastCharacter.noEllipsis) < 0) {
				txt += o.ellipsis;
			}
			return txt;
		}
		function getSizes($d) {
			return {
				'width': $d.innerWidth(),
				'height': $d.innerHeight()
			};
		}
		function setTextContent(e, content) {
			if (e.innerText) {
				e.innerText = content;
			} else if (e.nodeValue) {
				e.nodeValue = content;
			} else if (e.textContent) {
				e.textContent = content;
			}
		}
		function getTextContent(e) {
			if (e.innerText) {
				return e.innerText;
			} else if (e.nodeValue) {
				return e.nodeValue;
			} else if (e.textContent) {
				return e.textContent;
			} else {
				return "";
			}
		}
		function getPrevNode(n) {
			do {
				n = n.previousSibling;
			} while (n && n.nodeType !== 1 && n.nodeType !== 3);
	
			return n;
		}
		function findLastTextNode($el, $top, excludeCurrent) {
			var e = $el && $el[0],
			    p;
			if (e) {
				if (!excludeCurrent) {
					if (e.nodeType === 3) {
						return e;
					}
					if ($.trim($el.text())) {
						return findLastTextNode($el.contents().last(), $top);
					}
				}
				p = getPrevNode(e);
				while (!p) {
					$el = $el.parent();
					if ($el.is($top) || !$el.length) {
						return false;
					}
					p = getPrevNode($el[0]);
				}
				if (p) {
					return findLastTextNode($(p), $top);
				}
			}
			return false;
		}
		function getElement(e, $i) {
			if (!e) {
				return false;
			}
			if (typeof e === 'string') {
				e = $(e, $i);
				return e.length ? e : false;
			}
			return !e.jquery ? false : e;
		}
		function getTrueInnerHeight($el) {
			var h = $el.innerHeight(),
			    a = ['paddingTop', 'paddingBottom'];
	
			for (var z = 0, l = a.length; z < l; z++) {
				var m = parseInt($el.css(a[z]), 10);
				if (isNaN(m)) {
					m = 0;
				}
				h -= m;
			}
			return h;
		}
	
		//	override jQuery.html
		var _orgHtml = $.fn.html;
		$.fn.html = function (str) {
			if (str != undef && !$.isFunction(str) && this.data('dotdotdot')) {
				return this.trigger('update', [str]);
			}
			return _orgHtml.apply(this, arguments);
		};
	
		//	override jQuery.text
		var _orgText = $.fn.text;
		$.fn.text = function (str) {
			if (str != undef && !$.isFunction(str) && this.data('dotdotdot')) {
				str = $('<div />').text(str).html();
				return this.trigger('update', [str]);
			}
			return _orgText.apply(this, arguments);
		};
	})(jQuery);


/***/ }),

/***/ 513:
/*!************************************************************************************!*\
  !*** ./~/imports-loader!./Scripts/vendor/jqueryvalidate/jquery.validate-1.11.1.js ***!
  \************************************************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	"use strict";
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	/*!
	 * jQuery Validation Plugin 1.11.1
	 *
	 * http://bassistance.de/jquery-plugins/jquery-plugin-validation/
	 * http://docs.jquery.com/Plugins/Validation
	 *
	 * Copyright 2013 Jörn Zaefferer
	 * Released under the MIT license:
	 *   http://www.opensource.org/licenses/mit-license.php
	 */
	
	(function ($) {
	
		$.extend($.fn, {
			// http://docs.jquery.com/Plugins/Validation/validate
			validate: function validate(options) {
				// if nothing is selected, return nothing; can't chain anyway
				if (!this.length) {
					if (options && options.debug && window.console) {
						console.warn("Nothing selected, can't validate, returning nothing.");
					}
					return;
				}
	
				// check if a validator for this form was already created
				var validator = $.data(this[0], "validator");
				if (validator) {
					return validator;
				}
	
				// Add novalidate tag if HTML5.
				this.attr("novalidate", "novalidate");
	
				validator = new $.validator(options, this[0]);
				$.data(this[0], "validator", validator);
	
				if (validator.settings.onsubmit) {
	
					this.validateDelegate(":submit", "click", function (event) {
						if (validator.settings.submitHandler) {
							validator.submitButton = event.target;
						}
						// allow suppressing validation by adding a cancel class to the submit button
						if ($(event.target).hasClass("cancel")) {
							validator.cancelSubmit = true;
						}
	
						// allow suppressing validation by adding the html5 formnovalidate attribute to the submit button
						if ($(event.target).attr("formnovalidate") !== undefined) {
							validator.cancelSubmit = true;
						}
					});
	
					// validate the form on submit
					this.submit(function (event) {
						if (validator.settings.debug) {
							// prevent form submit to be able to see console output
							event.preventDefault();
						}
						function handle() {
							var hidden;
							if (validator.settings.submitHandler) {
								if (validator.submitButton) {
									// insert a hidden input as a replacement for the missing submit button
									hidden = $("<input type='hidden'/>").attr("name", validator.submitButton.name).val($(validator.submitButton).val()).appendTo(validator.currentForm);
								}
								validator.settings.submitHandler.call(validator, validator.currentForm, event);
								if (validator.submitButton) {
									// and clean up afterwards; thanks to no-block-scope, hidden can be referenced
									hidden.remove();
								}
								return false;
							}
							return true;
						}
	
						// prevent submit for invalid forms or custom submit handlers
						if (validator.cancelSubmit) {
							validator.cancelSubmit = false;
							return handle();
						}
						if (validator.form()) {
							if (validator.pendingRequest) {
								validator.formSubmitted = true;
								return false;
							}
							return handle();
						} else {
							validator.focusInvalid();
							return false;
						}
					});
				}
	
				return validator;
			},
			// http://docs.jquery.com/Plugins/Validation/valid
			valid: function valid() {
				if ($(this[0]).is("form")) {
					return this.validate().form();
				} else {
					var valid = true;
					var validator = $(this[0].form).validate();
					this.each(function () {
						valid = valid && validator.element(this);
					});
					return valid;
				}
			},
			// attributes: space seperated list of attributes to retrieve and remove
			removeAttrs: function removeAttrs(attributes) {
				var result = {},
				    $element = this;
				$.each(attributes.split(/\s/), function (index, value) {
					result[value] = $element.attr(value);
					$element.removeAttr(value);
				});
				return result;
			},
			// http://docs.jquery.com/Plugins/Validation/rules
			rules: function rules(command, argument) {
				var element = this[0];
	
				if (command) {
					var settings = $.data(element.form, "validator").settings;
					var staticRules = settings.rules;
					var existingRules = $.validator.staticRules(element);
					switch (command) {
						case "add":
							$.extend(existingRules, $.validator.normalizeRule(argument));
							// remove messages from rules, but allow them to be set separetely
							delete existingRules.messages;
							staticRules[element.name] = existingRules;
							if (argument.messages) {
								settings.messages[element.name] = $.extend(settings.messages[element.name], argument.messages);
							}
							break;
						case "remove":
							if (!argument) {
								delete staticRules[element.name];
								return existingRules;
							}
							var filtered = {};
							$.each(argument.split(/\s/), function (index, method) {
								filtered[method] = existingRules[method];
								delete existingRules[method];
							});
							return filtered;
					}
				}
	
				var data = $.validator.normalizeRules($.extend({}, $.validator.classRules(element), $.validator.attributeRules(element), $.validator.dataRules(element), $.validator.staticRules(element)), element);
	
				// make sure required is at front
				if (data.required) {
					var param = data.required;
					delete data.required;
					data = $.extend({ required: param }, data);
				}
	
				return data;
			}
		});
	
		// Custom selectors
		$.extend($.expr[":"], {
			// http://docs.jquery.com/Plugins/Validation/blank
			blank: function blank(a) {
				return !$.trim("" + $(a).val());
			},
			// http://docs.jquery.com/Plugins/Validation/filled
			filled: function filled(a) {
				return !!$.trim("" + $(a).val());
			},
			// http://docs.jquery.com/Plugins/Validation/unchecked
			unchecked: function unchecked(a) {
				return !$(a).prop("checked");
			}
		});
	
		// constructor for validator
		$.validator = function (options, form) {
			this.settings = $.extend(true, {}, $.validator.defaults, options);
			this.currentForm = form;
			this.init();
		};
	
		$.validator.format = function (source, params) {
			if (arguments.length === 1) {
				return function () {
					var args = $.makeArray(arguments);
					args.unshift(source);
					return $.validator.format.apply(this, args);
				};
			}
			if (arguments.length > 2 && params.constructor !== Array) {
				params = $.makeArray(arguments).slice(1);
			}
			if (params.constructor !== Array) {
				params = [params];
			}
			$.each(params, function (i, n) {
				source = source.replace(new RegExp("\\{" + i + "\\}", "g"), function () {
					return n;
				});
			});
			return source;
		};
	
		$.extend($.validator, {
	
			defaults: {
				messages: {},
				groups: {},
				rules: {},
				errorClass: "error",
				validClass: "valid",
				errorElement: "label",
				focusInvalid: true,
				errorContainer: $([]),
				errorLabelContainer: $([]),
				onsubmit: true,
				ignore: ":hidden",
				ignoreTitle: false,
				onfocusin: function onfocusin(element, event) {
					this.lastActive = element;
	
					// hide error label and remove error class on focus if enabled
					if (this.settings.focusCleanup && !this.blockFocusCleanup) {
						if (this.settings.unhighlight) {
							this.settings.unhighlight.call(this, element, this.settings.errorClass, this.settings.validClass);
						}
						this.addWrapper(this.errorsFor(element)).hide();
					}
				},
				onfocusout: function onfocusout(element, event) {
					if (!this.checkable(element) && (element.name in this.submitted || !this.optional(element))) {
						this.element(element);
					}
				},
				onkeyup: function onkeyup(element, event) {
					if (event.which === 9 && this.elementValue(element) === "") {
						return;
					} else if (element.name in this.submitted || element === this.lastElement) {
						this.element(element);
					}
				},
				onclick: function onclick(element, event) {
					// click on selects, radiobuttons and checkboxes
					if (element.name in this.submitted) {
						this.element(element);
					}
					// or option elements, check parent select in that case
					else if (element.parentNode.name in this.submitted) {
							this.element(element.parentNode);
						}
				},
				highlight: function highlight(element, errorClass, validClass) {
					if (element.type === "radio") {
						this.findByName(element.name).addClass(errorClass).removeClass(validClass);
					} else {
						$(element).addClass(errorClass).removeClass(validClass);
					}
				},
				unhighlight: function unhighlight(element, errorClass, validClass) {
					if (element.type === "radio") {
						this.findByName(element.name).removeClass(errorClass).addClass(validClass);
					} else {
						$(element).removeClass(errorClass).addClass(validClass);
					}
				}
			},
	
			// http://docs.jquery.com/Plugins/Validation/Validator/setDefaults
			setDefaults: function setDefaults(settings) {
				$.extend($.validator.defaults, settings);
			},
	
			messages: {
				required: "This field is required.",
				remote: "Please fix this field.",
				email: "Please enter a valid email address.",
				url: "Please enter a valid URL.",
				date: "Please enter a valid date.",
				dateISO: "Please enter a valid date (ISO).",
				number: "Please enter a valid number.",
				digits: "Please enter only digits.",
				creditcard: "Please enter a valid credit card number.",
				equalTo: "Please enter the same value again.",
				maxlength: $.validator.format("Please enter no more than {0} characters."),
				minlength: $.validator.format("Please enter at least {0} characters."),
				rangelength: $.validator.format("Please enter a value between {0} and {1} characters long."),
				range: $.validator.format("Please enter a value between {0} and {1}."),
				max: $.validator.format("Please enter a value less than or equal to {0}."),
				min: $.validator.format("Please enter a value greater than or equal to {0}.")
			},
	
			autoCreateRanges: false,
	
			prototype: {
	
				init: function init() {
					this.labelContainer = $(this.settings.errorLabelContainer);
					this.errorContext = this.labelContainer.length && this.labelContainer || $(this.currentForm);
					this.containers = $(this.settings.errorContainer).add(this.settings.errorLabelContainer);
					this.submitted = {};
					this.valueCache = {};
					this.pendingRequest = 0;
					this.pending = {};
					this.invalid = {};
					this.reset();
	
					var groups = this.groups = {};
					$.each(this.settings.groups, function (key, value) {
						if (typeof value === "string") {
							value = value.split(/\s/);
						}
						$.each(value, function (index, name) {
							groups[name] = key;
						});
					});
					var rules = this.settings.rules;
					$.each(rules, function (key, value) {
						rules[key] = $.validator.normalizeRule(value);
					});
	
					function delegate(event) {
						var validator = $.data(this[0].form, "validator"),
						    eventType = "on" + event.type.replace(/^validate/, "");
						if (validator.settings[eventType]) {
							validator.settings[eventType].call(validator, this[0], event);
						}
					}
					$(this.currentForm).validateDelegate(":text, [type='password'], [type='file'], select, textarea, " + "[type='number'], [type='search'] ,[type='tel'], [type='url'], " + "[type='email'], [type='datetime'], [type='date'], [type='month'], " + "[type='week'], [type='time'], [type='datetime-local'], " + "[type='range'], [type='color'] ", "focusin focusout keyup", delegate).validateDelegate("[type='radio'], [type='checkbox'], select, option", "click", delegate);
	
					if (this.settings.invalidHandler) {
						$(this.currentForm).bind("invalid-form.validate", this.settings.invalidHandler);
					}
				},
	
				// http://docs.jquery.com/Plugins/Validation/Validator/form
				form: function form() {
					this.checkForm();
					$.extend(this.submitted, this.errorMap);
					this.invalid = $.extend({}, this.errorMap);
					if (!this.valid()) {
						$(this.currentForm).triggerHandler("invalid-form", [this]);
					}
					this.showErrors();
					return this.valid();
				},
	
				checkForm: function checkForm() {
					this.prepareForm();
					for (var i = 0, elements = this.currentElements = this.elements(); elements[i]; i++) {
						this.check(elements[i]);
					}
					return this.valid();
				},
	
				// http://docs.jquery.com/Plugins/Validation/Validator/element
				element: function element(_element) {
					_element = this.validationTargetFor(this.clean(_element));
					this.lastElement = _element;
					this.prepareElement(_element);
					this.currentElements = $(_element);
					var result = this.check(_element) !== false;
					if (result) {
						delete this.invalid[_element.name];
					} else {
						this.invalid[_element.name] = true;
					}
					if (!this.numberOfInvalids()) {
						// Hide error containers on last error
						this.toHide = this.toHide.add(this.containers);
					}
					this.showErrors();
					return result;
				},
	
				// http://docs.jquery.com/Plugins/Validation/Validator/showErrors
				showErrors: function showErrors(errors) {
					if (errors) {
						// add items to error list and map
						$.extend(this.errorMap, errors);
						this.errorList = [];
						for (var name in errors) {
							this.errorList.push({
								message: errors[name],
								element: this.findByName(name)[0]
							});
						}
						// remove items from success list
						this.successList = $.grep(this.successList, function (element) {
							return !(element.name in errors);
						});
					}
					if (this.settings.showErrors) {
						this.settings.showErrors.call(this, this.errorMap, this.errorList);
					} else {
						this.defaultShowErrors();
					}
				},
	
				// http://docs.jquery.com/Plugins/Validation/Validator/resetForm
				resetForm: function resetForm() {
					if ($.fn.resetForm) {
						$(this.currentForm).resetForm();
					}
					this.submitted = {};
					this.lastElement = null;
					this.prepareForm();
					this.hideErrors();
					this.elements().removeClass(this.settings.errorClass).removeData("previousValue");
				},
	
				numberOfInvalids: function numberOfInvalids() {
					return this.objectLength(this.invalid);
				},
	
				objectLength: function objectLength(obj) {
					var count = 0;
					for (var i in obj) {
						count++;
					}
					return count;
				},
	
				hideErrors: function hideErrors() {
					this.addWrapper(this.toHide).hide();
				},
	
				valid: function valid() {
					return this.size() === 0;
				},
	
				size: function size() {
					return this.errorList.length;
				},
	
				focusInvalid: function focusInvalid() {
					if (this.settings.focusInvalid) {
						try {
							$(this.findLastActive() || this.errorList.length && this.errorList[0].element || []).filter(":visible").focus()
							// manually trigger focusin event; without it, focusin handler isn't called, findLastActive won't have anything to find
							.trigger("focusin");
						} catch (e) {
							// ignore IE throwing errors when focusing hidden elements
						}
					}
				},
	
				findLastActive: function findLastActive() {
					var lastActive = this.lastActive;
					return lastActive && $.grep(this.errorList, function (n) {
						return n.element.name === lastActive.name;
					}).length === 1 && lastActive;
				},
	
				elements: function elements() {
					var validator = this,
					    rulesCache = {};
	
					// select all valid inputs inside the form (no submit or reset buttons)
					return $(this.currentForm).find("input, select, textarea").not(":submit, :reset, :image, [disabled]").not(this.settings.ignore).filter(function () {
						if (!this.name && validator.settings.debug && window.console) {
							console.error("%o has no name assigned", this);
						}
	
						// select only the first element for each name, and only those with rules specified
						if (this.name in rulesCache || !validator.objectLength($(this).rules())) {
							return false;
						}
	
						rulesCache[this.name] = true;
						return true;
					});
				},
	
				clean: function clean(selector) {
					return $(selector)[0];
				},
	
				errors: function errors() {
					var errorClass = this.settings.errorClass.replace(" ", ".");
					return $(this.settings.errorElement + "." + errorClass, this.errorContext);
				},
	
				reset: function reset() {
					this.successList = [];
					this.errorList = [];
					this.errorMap = {};
					this.toShow = $([]);
					this.toHide = $([]);
					this.currentElements = $([]);
				},
	
				prepareForm: function prepareForm() {
					this.reset();
					this.toHide = this.errors().add(this.containers);
				},
	
				prepareElement: function prepareElement(element) {
					this.reset();
					this.toHide = this.errorsFor(element);
				},
	
				elementValue: function elementValue(element) {
					var type = $(element).attr("type"),
					    val = $(element).val();
	
					if (type === "radio" || type === "checkbox") {
						return $("input[name='" + $(element).attr("name") + "']:checked").val();
					}
	
					if (typeof val === "string") {
						return val.replace(/\r/g, "");
					}
					return val;
				},
	
				check: function check(element) {
					element = this.validationTargetFor(this.clean(element));
	
					var rules = $(element).rules();
					var dependencyMismatch = false;
					var val = this.elementValue(element);
					var result;
	
					for (var method in rules) {
						var rule = { method: method, parameters: rules[method] };
						try {
	
							result = $.validator.methods[method].call(this, val, element, rule.parameters);
	
							// if a method indicates that the field is optional and therefore valid,
							// don't mark it as valid when there are no other rules
							if (result === "dependency-mismatch") {
								dependencyMismatch = true;
								continue;
							}
							dependencyMismatch = false;
	
							if (result === "pending") {
								this.toHide = this.toHide.not(this.errorsFor(element));
								return;
							}
	
							if (!result) {
								this.formatAndAdd(element, rule);
								return false;
							}
						} catch (e) {
							if (this.settings.debug && window.console) {
								console.log("Exception occurred when checking element " + element.id + ", check the '" + rule.method + "' method.", e);
							}
							throw e;
						}
					}
					if (dependencyMismatch) {
						return;
					}
					if (this.objectLength(rules)) {
						this.successList.push(element);
					}
					return true;
				},
	
				// return the custom message for the given element and validation method
				// specified in the element's HTML5 data attribute
				customDataMessage: function customDataMessage(element, method) {
					return $(element).data("msg-" + method.toLowerCase()) || element.attributes && $(element).attr("data-msg-" + method.toLowerCase());
				},
	
				// return the custom message for the given element name and validation method
				customMessage: function customMessage(name, method) {
					var m = this.settings.messages[name];
					return m && (m.constructor === String ? m : m[method]);
				},
	
				// return the first defined argument, allowing empty strings
				findDefined: function findDefined() {
					for (var i = 0; i < arguments.length; i++) {
						if (arguments[i] !== undefined) {
							return arguments[i];
						}
					}
					return undefined;
				},
	
				defaultMessage: function defaultMessage(element, method) {
					return this.findDefined(this.customMessage(element.name, method), this.customDataMessage(element, method),
					// title is never undefined, so handle empty string as undefined
					!this.settings.ignoreTitle && element.title || undefined, $.validator.messages[method], "<strong>Warning: No message defined for " + element.name + "</strong>");
				},
	
				formatAndAdd: function formatAndAdd(element, rule) {
					var message = this.defaultMessage(element, rule.method),
					    theregex = /\$?\{(\d+)\}/g;
					if (typeof message === "function") {
						message = message.call(this, rule.parameters, element);
					} else if (theregex.test(message)) {
						message = $.validator.format(message.replace(theregex, "{$1}"), rule.parameters);
					}
					this.errorList.push({
						message: message,
						element: element
					});
	
					this.errorMap[element.name] = message;
					this.submitted[element.name] = message;
				},
	
				addWrapper: function addWrapper(toToggle) {
					if (this.settings.wrapper) {
						toToggle = toToggle.add(toToggle.parent(this.settings.wrapper));
					}
					return toToggle;
				},
	
				defaultShowErrors: function defaultShowErrors() {
					var i, elements;
					for (i = 0; this.errorList[i]; i++) {
						var error = this.errorList[i];
						if (this.settings.highlight) {
							this.settings.highlight.call(this, error.element, this.settings.errorClass, this.settings.validClass);
						}
						this.showLabel(error.element, error.message);
					}
					if (this.errorList.length) {
						this.toShow = this.toShow.add(this.containers);
					}
					if (this.settings.success) {
						for (i = 0; this.successList[i]; i++) {
							this.showLabel(this.successList[i]);
						}
					}
					if (this.settings.unhighlight) {
						for (i = 0, elements = this.validElements(); elements[i]; i++) {
							this.settings.unhighlight.call(this, elements[i], this.settings.errorClass, this.settings.validClass);
						}
					}
					this.toHide = this.toHide.not(this.toShow);
					this.hideErrors();
					this.addWrapper(this.toShow).show();
				},
	
				validElements: function validElements() {
					return this.currentElements.not(this.invalidElements());
				},
	
				invalidElements: function invalidElements() {
					return $(this.errorList).map(function () {
						return this.element;
					});
				},
	
				showLabel: function showLabel(element, message) {
					var label = this.errorsFor(element);
					if (label.length) {
						// refresh error/success class
						label.removeClass(this.settings.validClass).addClass(this.settings.errorClass);
						// replace message on existing label
						label.html(message);
					} else {
						// create label
						label = $("<" + this.settings.errorElement + ">").attr("for", this.idOrName(element)).addClass(this.settings.errorClass).html(message || "");
						if (this.settings.wrapper) {
							// make sure the element is visible, even in IE
							// actually showing the wrapped element is handled elsewhere
							label = label.hide().show().wrap("<" + this.settings.wrapper + "/>").parent();
						}
						if (!this.labelContainer.append(label).length) {
							if (this.settings.errorPlacement) {
								this.settings.errorPlacement(label, $(element));
							} else {
								label.insertAfter(element);
							}
						}
					}
					if (!message && this.settings.success) {
						label.text("");
						if (typeof this.settings.success === "string") {
							label.addClass(this.settings.success);
						} else {
							this.settings.success(label, element);
						}
					}
					this.toShow = this.toShow.add(label);
				},
	
				errorsFor: function errorsFor(element) {
					var name = this.idOrName(element);
					return this.errors().filter(function () {
						return $(this).attr("for") === name;
					});
				},
	
				idOrName: function idOrName(element) {
					return this.groups[element.name] || (this.checkable(element) ? element.name : element.id || element.name);
				},
	
				validationTargetFor: function validationTargetFor(element) {
					// if radio/checkbox, validate first element in group instead
					if (this.checkable(element)) {
						element = this.findByName(element.name).not(this.settings.ignore)[0];
					}
					return element;
				},
	
				checkable: function checkable(element) {
					return (/radio|checkbox/i.test(element.type)
					);
				},
	
				findByName: function findByName(name) {
					return $(this.currentForm).find("[name='" + name + "']");
				},
	
				getLength: function getLength(value, element) {
					switch (element.nodeName.toLowerCase()) {
						case "select":
							return $("option:selected", element).length;
						case "input":
							if (this.checkable(element)) {
								return this.findByName(element.name).filter(":checked").length;
							}
					}
					return value.length;
				},
	
				depend: function depend(param, element) {
					return this.dependTypes[typeof param === "undefined" ? "undefined" : _typeof(param)] ? this.dependTypes[typeof param === "undefined" ? "undefined" : _typeof(param)](param, element) : true;
				},
	
				dependTypes: {
					"boolean": function boolean(param, element) {
						return param;
					},
					"string": function string(param, element) {
						return !!$(param, element.form).length;
					},
					"function": function _function(param, element) {
						return param(element);
					}
				},
	
				optional: function optional(element) {
					var val = this.elementValue(element);
					return !$.validator.methods.required.call(this, val, element) && "dependency-mismatch";
				},
	
				startRequest: function startRequest(element) {
					if (!this.pending[element.name]) {
						this.pendingRequest++;
						this.pending[element.name] = true;
					}
				},
	
				stopRequest: function stopRequest(element, valid) {
					this.pendingRequest--;
					// sometimes synchronization fails, make sure pendingRequest is never < 0
					if (this.pendingRequest < 0) {
						this.pendingRequest = 0;
					}
					delete this.pending[element.name];
					if (valid && this.pendingRequest === 0 && this.formSubmitted && this.form()) {
						$(this.currentForm).submit();
						this.formSubmitted = false;
					} else if (!valid && this.pendingRequest === 0 && this.formSubmitted) {
						$(this.currentForm).triggerHandler("invalid-form", [this]);
						this.formSubmitted = false;
					}
				},
	
				previousValue: function previousValue(element) {
					return $.data(element, "previousValue") || $.data(element, "previousValue", {
						old: null,
						valid: true,
						message: this.defaultMessage(element, "remote")
					});
				}
	
			},
	
			classRuleSettings: {
				required: { required: true },
				email: { email: true },
				url: { url: true },
				date: { date: true },
				dateISO: { dateISO: true },
				number: { number: true },
				digits: { digits: true },
				creditcard: { creditcard: true }
			},
	
			addClassRules: function addClassRules(className, rules) {
				if (className.constructor === String) {
					this.classRuleSettings[className] = rules;
				} else {
					$.extend(this.classRuleSettings, className);
				}
			},
	
			classRules: function classRules(element) {
				var rules = {};
				var classes = $(element).attr("class");
				if (classes) {
					$.each(classes.split(" "), function () {
						if (this in $.validator.classRuleSettings) {
							$.extend(rules, $.validator.classRuleSettings[this]);
						}
					});
				}
				return rules;
			},
	
			attributeRules: function attributeRules(element) {
				var rules = {};
				var $element = $(element);
				var type = $element[0].getAttribute("type");
	
				for (var method in $.validator.methods) {
					var value;
	
					// support for <input required> in both html5 and older browsers
					if (method === "required") {
						value = $element.get(0).getAttribute(method);
						// Some browsers return an empty string for the required attribute
						// and non-HTML5 browsers might have required="" markup
						if (value === "") {
							value = true;
						}
						// force non-HTML5 browsers to return bool
						value = !!value;
					} else {
						value = $element.attr(method);
					}
	
					// convert the value to a number for number inputs, and for text for backwards compability
					// allows type="date" and others to be compared as strings
					if (/min|max/.test(method) && (type === null || /number|range|text/.test(type))) {
						value = Number(value);
					}
	
					if (value) {
						rules[method] = value;
					} else if (type === method && type !== 'range') {
						// exception: the jquery validate 'range' method
						// does not test for the html5 'range' type
						rules[method] = true;
					}
				}
	
				// maxlength may be returned as -1, 2147483647 (IE) and 524288 (safari) for text inputs
				if (rules.maxlength && /-1|2147483647|524288/.test(rules.maxlength)) {
					delete rules.maxlength;
				}
	
				return rules;
			},
	
			dataRules: function dataRules(element) {
				var method,
				    value,
				    rules = {},
				    $element = $(element);
				for (method in $.validator.methods) {
					value = $element.data("rule-" + method.toLowerCase());
					if (value !== undefined) {
						rules[method] = value;
					}
				}
				return rules;
			},
	
			staticRules: function staticRules(element) {
				var rules = {};
				var validator = $.data(element.form, "validator");
				if (validator.settings.rules) {
					rules = $.validator.normalizeRule(validator.settings.rules[element.name]) || {};
				}
				return rules;
			},
	
			normalizeRules: function normalizeRules(rules, element) {
				// handle dependency check
				$.each(rules, function (prop, val) {
					// ignore rule when param is explicitly false, eg. required:false
					if (val === false) {
						delete rules[prop];
						return;
					}
					if (val.param || val.depends) {
						var keepRule = true;
						switch (_typeof(val.depends)) {
							case "string":
								keepRule = !!$(val.depends, element.form).length;
								break;
							case "function":
								keepRule = val.depends.call(element, element);
								break;
						}
						if (keepRule) {
							rules[prop] = val.param !== undefined ? val.param : true;
						} else {
							delete rules[prop];
						}
					}
				});
	
				// evaluate parameters
				$.each(rules, function (rule, parameter) {
					rules[rule] = $.isFunction(parameter) ? parameter(element) : parameter;
				});
	
				// clean number parameters
				$.each(['minlength', 'maxlength'], function () {
					if (rules[this]) {
						rules[this] = Number(rules[this]);
					}
				});
				$.each(['rangelength', 'range'], function () {
					var parts;
					if (rules[this]) {
						if ($.isArray(rules[this])) {
							rules[this] = [Number(rules[this][0]), Number(rules[this][1])];
						} else if (typeof rules[this] === "string") {
							parts = rules[this].split(/[\s,]+/);
							rules[this] = [Number(parts[0]), Number(parts[1])];
						}
					}
				});
	
				if ($.validator.autoCreateRanges) {
					// auto-create ranges
					if (rules.min && rules.max) {
						rules.range = [rules.min, rules.max];
						delete rules.min;
						delete rules.max;
					}
					if (rules.minlength && rules.maxlength) {
						rules.rangelength = [rules.minlength, rules.maxlength];
						delete rules.minlength;
						delete rules.maxlength;
					}
				}
	
				return rules;
			},
	
			// Converts a simple string to a {string: true} rule, e.g., "required" to {required:true}
			normalizeRule: function normalizeRule(data) {
				if (typeof data === "string") {
					var transformed = {};
					$.each(data.split(/\s/), function () {
						transformed[this] = true;
					});
					data = transformed;
				}
				return data;
			},
	
			// http://docs.jquery.com/Plugins/Validation/Validator/addMethod
			addMethod: function addMethod(name, method, message) {
				$.validator.methods[name] = method;
				$.validator.messages[name] = message !== undefined ? message : $.validator.messages[name];
				if (method.length < 3) {
					$.validator.addClassRules(name, $.validator.normalizeRule(name));
				}
			},
	
			methods: {
	
				// http://docs.jquery.com/Plugins/Validation/Methods/required
				required: function required(value, element, param) {
					// check if dependency is met
					if (!this.depend(param, element)) {
						return "dependency-mismatch";
					}
					if (element.nodeName.toLowerCase() === "select") {
						// could be an array for select-multiple or a string, both are fine this way
						var val = $(element).val();
						return val && val.length > 0;
					}
					if (this.checkable(element)) {
						return this.getLength(value, element) > 0;
					}
					return $.trim(value).length > 0;
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/email
				email: function email(value, element) {
					// contributed by Scott Gonzalez: http://projects.scottsplayground.com/email_address_validation/
					return this.optional(element) || /^((([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+(\.([a-z]|\d|[!#\$%&'\*\+\-\/=\?\^_`{\|}~]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])+)*)|((\x22)((((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(([\x01-\x08\x0b\x0c\x0e-\x1f\x7f]|\x21|[\x23-\x5b]|[\x5d-\x7e]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(\\([\x01-\x09\x0b\x0c\x0d-\x7f]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF]))))*(((\x20|\x09)*(\x0d\x0a))?(\x20|\x09)+)?(\x22)))@((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))$/i.test(value);
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/url
				url: function url(value, element) {
					// contributed by Scott Gonzalez: http://projects.scottsplayground.com/iri/
					return this.optional(element) || /^(https?|s?ftp):\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?(((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|((([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|\d|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.)+(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])*([a-z]|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])))\.?)(:\d*)?)(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)?(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(value);
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/date
				date: function date(value, element) {
					return this.optional(element) || !/Invalid|NaN/.test(new Date(value).toString());
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/dateISO
				dateISO: function dateISO(value, element) {
					return this.optional(element) || /^\d{4}[\/\-]\d{1,2}[\/\-]\d{1,2}$/.test(value);
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/number
				number: function number(value, element) {
					return this.optional(element)
					// NOTE: support for 3,0 Added by killanaca
					|| /^-?(?:\d+|\d{1,3}(?:\.\d{3})+)(?:,\d+)?$/.test(value)
					// NOTE: support for 3.0
					|| /^-?(?:\d+|\d{1,3}(?:,\d{3})+)(?:\.\d+)?$/.test(value);
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/digits
				digits: function digits(value, element) {
					return this.optional(element) || /^\d+$/.test(value);
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/creditcard
				// based on http://en.wikipedia.org/wiki/Luhn
				creditcard: function creditcard(value, element) {
					if (this.optional(element)) {
						return "dependency-mismatch";
					}
					// accept only spaces, digits and dashes
					if (/[^0-9 \-]+/.test(value)) {
						return false;
					}
					var nCheck = 0,
					    nDigit = 0,
					    bEven = false;
	
					value = value.replace(/\D/g, "");
	
					for (var n = value.length - 1; n >= 0; n--) {
						var cDigit = value.charAt(n);
						nDigit = parseInt(cDigit, 10);
						if (bEven) {
							if ((nDigit *= 2) > 9) {
								nDigit -= 9;
							}
						}
						nCheck += nDigit;
						bEven = !bEven;
					}
	
					return nCheck % 10 === 0;
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/minlength
				minlength: function minlength(value, element, param) {
					var length = $.isArray(value) ? value.length : this.getLength($.trim(value), element);
					return this.optional(element) || length >= param;
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/maxlength
				maxlength: function maxlength(value, element, param) {
					var length = $.isArray(value) ? value.length : this.getLength($.trim(value), element);
					return this.optional(element) || length <= param;
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/rangelength
				rangelength: function rangelength(value, element, param) {
					var length = $.isArray(value) ? value.length : this.getLength($.trim(value), element);
					return this.optional(element) || length >= param[0] && length <= param[1];
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/min
				min: function min(value, element, param) {
					return this.optional(element) || value >= param;
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/max
				max: function max(value, element, param) {
					return this.optional(element) || value <= param;
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/range
				range: function range(value, element, param) {
					return this.optional(element) || value >= param[0] && value <= param[1];
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/equalTo
				equalTo: function equalTo(value, element, param) {
					// bind to the blur event of the target in order to revalidate whenever the target field is updated
					// TODO find a way to bind the event just once, avoiding the unbind-rebind overhead
					var target = $(param);
					if (this.settings.onfocusout) {
						target.unbind(".validate-equalTo").bind("blur.validate-equalTo", function () {
							$(element).valid();
						});
					}
					return value === target.val();
				},
	
				// http://docs.jquery.com/Plugins/Validation/Methods/remote
				remote: function remote(value, element, param) {
					if (this.optional(element)) {
						return "dependency-mismatch";
					}
	
					var previous = this.previousValue(element);
					if (!this.settings.messages[element.name]) {
						this.settings.messages[element.name] = {};
					}
					previous.originalMessage = this.settings.messages[element.name].remote;
					this.settings.messages[element.name].remote = previous.message;
	
					param = typeof param === "string" && { url: param } || param;
	
					if (previous.old === value) {
						return previous.valid;
					}
	
					previous.old = value;
					var validator = this;
					this.startRequest(element);
					var data = {};
					data[element.name] = value;
					$.ajax($.extend(true, {
						url: param,
						mode: "abort",
						port: "validate" + element.name,
						dataType: "json",
						data: data,
						success: function success(response) {
							validator.settings.messages[element.name].remote = previous.originalMessage;
							var valid = response === true || response === "true";
							if (valid) {
								var submitted = validator.formSubmitted;
								validator.prepareElement(element);
								validator.formSubmitted = submitted;
								validator.successList.push(element);
								delete validator.invalid[element.name];
								validator.showErrors();
							} else {
								var errors = {};
								var message = response || validator.defaultMessage(element, "remote");
								errors[element.name] = previous.message = $.isFunction(message) ? message(value) : message;
								validator.invalid[element.name] = true;
								validator.showErrors(errors);
							}
							previous.valid = valid;
							validator.stopRequest(element, valid);
						}
					}, param));
					return "pending";
				}
	
			}
	
		});
	
		// deprecated, use $.validator.format instead
		$.format = $.validator.format;
	})(jQuery);
	
	// ajax mode: abort
	// usage: $.ajax({ mode: "abort"[, port: "uniqueport"]});
	// if mode:"abort" is used, the previous request on that port (port can be undefined) is aborted via XMLHttpRequest.abort()
	(function ($) {
		var pendingRequests = {};
		// Use a prefilter if available (1.5+)
		if ($.ajaxPrefilter) {
			$.ajaxPrefilter(function (settings, _, xhr) {
				var port = settings.port;
				if (settings.mode === "abort") {
					if (pendingRequests[port]) {
						pendingRequests[port].abort();
					}
					pendingRequests[port] = xhr;
				}
			});
		} else {
			// Proxy ajax
			var ajax = $.ajax;
			$.ajax = function (settings) {
				var mode = ("mode" in settings ? settings : $.ajaxSettings).mode,
				    port = ("port" in settings ? settings : $.ajaxSettings).port;
				if (mode === "abort") {
					if (pendingRequests[port]) {
						pendingRequests[port].abort();
					}
					pendingRequests[port] = ajax.apply(this, arguments);
					return pendingRequests[port];
				}
				return ajax.apply(this, arguments);
			};
		}
	})(jQuery);
	
	// provides delegate(type: String, delegate: Selector, handler: Callback) plugin for easier event delegation
	// handler is only called when $(event.target).is(delegate), in the scope of the jquery-object for event.target
	(function ($) {
		$.extend($.fn, {
			validateDelegate: function validateDelegate(delegate, type, handler) {
				return this.bind(type, function (event) {
					var target = $(event.target);
					if (target.is(delegate)) {
						return handler.apply(target, arguments);
					}
				});
			}
		});
	})(jQuery);


/***/ }),

/***/ 1539:
/*!*****************************************************************************************!*\
  !*** ./~/imports-loader!./Scripts/vendor/jqueryvalidate/jquery.validate.unobtrusive.js ***!
  \*****************************************************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	"use strict";
	
	/*!
	** Unobtrusive validation support library for jQuery and jQuery Validate
	** Copyright (C) Microsoft Corporation. All rights reserved.
	*/
	
	/*jslint white: true, browser: true, onevar: true, undef: true, nomen: true, eqeqeq: true, plusplus: true, bitwise: true, regexp: true, newcap: true, immed: true, strict: false */
	/*global document: false, jQuery: false */
	
	(function ($) {
	    var $jQval = $.validator,
	        adapters,
	        data_validation = "unobtrusiveValidation";
	
	    function setValidationValues(options, ruleName, value) {
	        options.rules[ruleName] = value;
	        if (options.message) {
	            options.messages[ruleName] = options.message;
	        }
	    }
	
	    function splitAndTrim(value) {
	        return value.replace(/^\s+|\s+$/g, "").split(/\s*,\s*/g);
	    }
	
	    function escapeAttributeValue(value) {
	        // As mentioned on http://api.jquery.com/category/selectors/
	        return value.replace(/([!"#$%&'()*+,./:;<=>?@\[\\\]^`{|}~])/g, "\\$1");
	    }
	
	    function getModelPrefix(fieldName) {
	        return fieldName.substr(0, fieldName.lastIndexOf(".") + 1);
	    }
	
	    function appendModelPrefix(value, prefix) {
	        if (value.indexOf("*.") === 0) {
	            value = value.replace("*.", prefix);
	        }
	        return value;
	    }
	
	    function onError(error, inputElement) {
	        // 'this' is the form element
	        var container = $(this).find("[data-valmsg-for='" + escapeAttributeValue(inputElement[0].name) + "']"),
	            replace = $.parseJSON(container.attr("data-valmsg-replace")) !== false;
	
	        container.removeClass("field-validation-valid").addClass("field-validation-error");
	        error.data("unobtrusiveContainer", container);
	
	        if (replace) {
	            container.empty();
	            error.removeClass("input-validation-error").appendTo(container);
	        } else {
	            error.hide();
	        }
	    }
	
	    function onErrors(event, validator) {
	        // 'this' is the form element
	        var container = $(this).find("[data-valmsg-summary=true]"),
	            list = container.find("ul");
	
	        if (list && list.length && validator.errorList.length) {
	            list.empty();
	            container.addClass("validation-summary-errors").removeClass("validation-summary-valid");
	
	            $.each(validator.errorList, function () {
	                $("<li />").html(this.message).appendTo(list);
	            });
	        }
	    }
	
	    function onSuccess(error) {
	        // 'this' is the form element
	        var container = error.data("unobtrusiveContainer"),
	            replace = $.parseJSON(container.attr("data-valmsg-replace"));
	
	        if (container) {
	            container.addClass("field-validation-valid").removeClass("field-validation-error");
	            error.removeData("unobtrusiveContainer");
	
	            if (replace) {
	                container.empty();
	            }
	        }
	    }
	
	    function onReset(event) {
	        // 'this' is the form element
	        var $form = $(this);
	        $form.data("validator").resetForm();
	        $form.find(".validation-summary-errors").addClass("validation-summary-valid").removeClass("validation-summary-errors");
	        $form.find(".field-validation-error").addClass("field-validation-valid").removeClass("field-validation-error").removeData("unobtrusiveContainer").find(">*") // If we were using valmsg-replace, get the underlying error
	        .removeData("unobtrusiveContainer");
	    }
	
	    function validationInfo(form) {
	        var $form = $(form),
	            result = $form.data(data_validation),
	            onResetProxy = $.proxy(onReset, form);
	
	        if (!result) {
	            result = {
	                options: { // options structure passed to jQuery Validate's validate() method
	                    errorClass: "input-validation-error",
	                    errorElement: "span",
	                    errorPlacement: $.proxy(onError, form),
	                    invalidHandler: $.proxy(onErrors, form),
	                    messages: {},
	                    rules: {},
	                    success: $.proxy(onSuccess, form)
	                },
	                attachValidation: function attachValidation() {
	                    $form.unbind("reset." + data_validation, onResetProxy).bind("reset." + data_validation, onResetProxy).validate(this.options);
	                },
	                validate: function validate() {
	                    // a validation function that is called by unobtrusive Ajax
	                    $form.validate();
	                    return $form.valid();
	                }
	            };
	            $form.data(data_validation, result);
	        }
	
	        return result;
	    }
	
	    $jQval.unobtrusive = {
	        adapters: [],
	
	        parseElement: function parseElement(element, skipAttach) {
	            /// <summary>
	            /// Parses a single HTML element for unobtrusive validation attributes.
	            /// </summary>
	            /// <param name="element" domElement="true">The HTML element to be parsed.</param>
	            /// <param name="skipAttach" type="Boolean">[Optional] true to skip attaching the
	            /// validation to the form. If parsing just this single element, you should specify true.
	            /// If parsing several elements, you should specify false, and manually attach the validation
	            /// to the form when you are finished. The default is false.</param>
	            var $element = $(element),
	                form = $element.parents("form")[0],
	                valInfo,
	                rules,
	                messages;
	
	            if (!form) {
	                // Cannot do client-side validation without a form
	                return;
	            }
	
	            valInfo = validationInfo(form);
	            valInfo.options.rules[element.name] = rules = {};
	            valInfo.options.messages[element.name] = messages = {};
	
	            $.each(this.adapters, function () {
	                var prefix = "data-val-" + this.name,
	                    message = $element.attr(prefix),
	                    paramValues = {};
	
	                if (message !== undefined) {
	                    // Compare against undefined, because an empty message is legal (and falsy)
	                    prefix += "-";
	
	                    $.each(this.params, function () {
	                        paramValues[this] = $element.attr(prefix + this);
	                    });
	
	                    this.adapt({
	                        element: element,
	                        form: form,
	                        message: message,
	                        params: paramValues,
	                        rules: rules,
	                        messages: messages
	                    });
	                }
	            });
	
	            $.extend(rules, { "__dummy__": true });
	
	            if (!skipAttach) {
	                valInfo.attachValidation();
	            }
	        },
	
	        parse: function parse(selector) {
	            /// <summary>
	            /// Parses all the HTML elements in the specified selector. It looks for input elements decorated
	            /// with the [data-val=true] attribute value and enables validation according to the data-val-*
	            /// attribute values.
	            /// </summary>
	            /// <param name="selector" type="String">Any valid jQuery selector.</param>
	            var $forms = $(selector).parents("form").andSelf().add($(selector).find("form")).filter("form");
	
	            $(selector).find(":input[data-val=true]").each(function () {
	                $jQval.unobtrusive.parseElement(this, true);
	            });
	
	            $forms.each(function () {
	                var info = validationInfo(this);
	                if (info) {
	                    info.attachValidation();
	                }
	            });
	        }
	    };
	
	    adapters = $jQval.unobtrusive.adapters;
	
	    adapters.add = function (adapterName, params, fn) {
	        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation.</summary>
	        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
	        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
	        /// <param name="params" type="Array" optional="true">[Optional] An array of parameter names (strings) that will
	        /// be extracted from the data-val-nnnn-mmmm HTML attributes (where nnnn is the adapter name, and
	        /// mmmm is the parameter name).</param>
	        /// <param name="fn" type="Function">The function to call, which adapts the values from the HTML
	        /// attributes into jQuery Validate rules and/or messages.</param>
	        /// <returns type="jQuery.validator.unobtrusive.adapters" />
	        if (!fn) {
	            // Called with no params, just a function
	            fn = params;
	            params = [];
	        }
	        this.push({ name: adapterName, params: params, adapt: fn });
	        return this;
	    };
	
	    adapters.addBool = function (adapterName, ruleName) {
	        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
	        /// the jQuery Validate validation rule has no parameter values.</summary>
	        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
	        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
	        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
	        /// of adapterName will be used instead.</param>
	        /// <returns type="jQuery.validator.unobtrusive.adapters" />
	        return this.add(adapterName, function (options) {
	            setValidationValues(options, ruleName || adapterName, true);
	        });
	    };
	
	    adapters.addMinMax = function (adapterName, minRuleName, maxRuleName, minMaxRuleName, minAttribute, maxAttribute) {
	        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
	        /// the jQuery Validate validation has three potential rules (one for min-only, one for max-only, and
	        /// one for min-and-max). The HTML parameters are expected to be named -min and -max.</summary>
	        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
	        /// in the data-val-nnnn HTML attribute (where nnnn is the adapter name).</param>
	        /// <param name="minRuleName" type="String">The name of the jQuery Validate rule to be used when you only
	        /// have a minimum value.</param>
	        /// <param name="maxRuleName" type="String">The name of the jQuery Validate rule to be used when you only
	        /// have a maximum value.</param>
	        /// <param name="minMaxRuleName" type="String">The name of the jQuery Validate rule to be used when you
	        /// have both a minimum and maximum value.</param>
	        /// <param name="minAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
	        /// contains the minimum value. The default is "min".</param>
	        /// <param name="maxAttribute" type="String" optional="true">[Optional] The name of the HTML attribute that
	        /// contains the maximum value. The default is "max".</param>
	        /// <returns type="jQuery.validator.unobtrusive.adapters" />
	        return this.add(adapterName, [minAttribute || "min", maxAttribute || "max"], function (options) {
	            var min = options.params.min,
	                max = options.params.max;
	
	            if (min && max) {
	                setValidationValues(options, minMaxRuleName, [min, max]);
	            } else if (min) {
	                setValidationValues(options, minRuleName, min);
	            } else if (max) {
	                setValidationValues(options, maxRuleName, max);
	            }
	        });
	    };
	
	    adapters.addSingleVal = function (adapterName, attribute, ruleName) {
	        /// <summary>Adds a new adapter to convert unobtrusive HTML into a jQuery Validate validation, where
	        /// the jQuery Validate validation rule has a single value.</summary>
	        /// <param name="adapterName" type="String">The name of the adapter to be added. This matches the name used
	        /// in the data-val-nnnn HTML attribute(where nnnn is the adapter name).</param>
	        /// <param name="attribute" type="String">[Optional] The name of the HTML attribute that contains the value.
	        /// The default is "val".</param>
	        /// <param name="ruleName" type="String" optional="true">[Optional] The name of the jQuery Validate rule. If not provided, the value
	        /// of adapterName will be used instead.</param>
	        /// <returns type="jQuery.validator.unobtrusive.adapters" />
	        return this.add(adapterName, [attribute || "val"], function (options) {
	            setValidationValues(options, ruleName || adapterName, options.params[attribute]);
	        });
	    };
	
	    $jQval.addMethod("__dummy__", function (value, element, params) {
	        return true;
	    });
	
	    $jQval.addMethod("regex", function (value, element, params) {
	        var match;
	        if (this.optional(element)) {
	            return true;
	        }
	
	        match = new RegExp(params).exec(value);
	        return match && match.index === 0 && match[0].length === value.length;
	    });
	
	    $jQval.addMethod("nonalphamin", function (value, element, nonalphamin) {
	        var match;
	        if (nonalphamin) {
	            match = value.match(/\W/g);
	            match = match && match.length >= nonalphamin;
	        }
	        return match;
	    });
	
	    adapters.addSingleVal("accept", "exts").addSingleVal("regex", "pattern");
	    adapters.addBool("creditcard").addBool("date").addBool("digits").addBool("email").addBool("number").addBool("url");
	    adapters.addMinMax("length", "minlength", "maxlength", "rangelength").addMinMax("range", "min", "max", "range");
	    adapters.add("equalto", ["other"], function (options) {
	        var prefix = getModelPrefix(options.element.name),
	            other = options.params.other,
	            fullOtherName = appendModelPrefix(other, prefix),
	            element = $(options.form).find(":input[name='" + escapeAttributeValue(fullOtherName) + "']")[0];
	
	        setValidationValues(options, "equalTo", element);
	    });
	    adapters.add("required", function (options) {
	        // jQuery Validate equates "required" with "mandatory" for checkbox elements
	        if (options.element.tagName.toUpperCase() !== "INPUT" || options.element.type.toUpperCase() !== "CHECKBOX") {
	            setValidationValues(options, "required", true);
	        }
	    });
	    adapters.add("remote", ["url", "type", "additionalfields"], function (options) {
	        var value = {
	            url: options.params.url,
	            type: options.params.type || "GET",
	            data: {}
	        },
	            prefix = getModelPrefix(options.element.name);
	
	        $.each(splitAndTrim(options.params.additionalfields || options.element.name), function (i, fieldName) {
	            var paramName = appendModelPrefix(fieldName, prefix);
	            value.data[paramName] = function () {
	                return $(options.form).find(":input[name='" + escapeAttributeValue(paramName) + "']").val();
	            };
	        });
	
	        setValidationValues(options, "remote", value);
	    });
	    adapters.add("password", ["min", "nonalphamin", "regex"], function (options) {
	        if (options.params.min) {
	            setValidationValues(options, "minlength", options.params.min);
	        }
	        if (options.params.nonalphamin) {
	            setValidationValues(options, "nonalphamin", options.params.nonalphamin);
	        }
	        if (options.params.regex) {
	            setValidationValues(options, "regex", options.params.regex);
	        }
	    });
	
	    $(function () {
	        $jQval.unobtrusive.parse(document);
	    });
	})(jQuery);


/***/ }),

/***/ 1542:
/*!*****************************************************!*\
  !*** ./~/imports-loader!./~/bootstrap/js/button.js ***!
  \*****************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	/* ========================================================================
	 * Bootstrap: button.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#buttons
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // BUTTON PUBLIC CLASS DEFINITION
	  // ==============================
	
	  var Button = function (element, options) {
	    this.$element  = $(element)
	    this.options   = $.extend({}, Button.DEFAULTS, options)
	    this.isLoading = false
	  }
	
	  Button.VERSION  = '3.4.1'
	
	  Button.DEFAULTS = {
	    loadingText: 'loading...'
	  }
	
	  Button.prototype.setState = function (state) {
	    var d    = 'disabled'
	    var $el  = this.$element
	    var val  = $el.is('input') ? 'val' : 'html'
	    var data = $el.data()
	
	    state += 'Text'
	
	    if (data.resetText == null) $el.data('resetText', $el[val]())
	
	    // push to event loop to allow forms to submit
	    setTimeout($.proxy(function () {
	      $el[val](data[state] == null ? this.options[state] : data[state])
	
	      if (state == 'loadingText') {
	        this.isLoading = true
	        $el.addClass(d).attr(d, d).prop(d, true)
	      } else if (this.isLoading) {
	        this.isLoading = false
	        $el.removeClass(d).removeAttr(d).prop(d, false)
	      }
	    }, this), 0)
	  }
	
	  Button.prototype.toggle = function () {
	    var changed = true
	    var $parent = this.$element.closest('[data-toggle="buttons"]')
	
	    if ($parent.length) {
	      var $input = this.$element.find('input')
	      if ($input.prop('type') == 'radio') {
	        if ($input.prop('checked')) changed = false
	        $parent.find('.active').removeClass('active')
	        this.$element.addClass('active')
	      } else if ($input.prop('type') == 'checkbox') {
	        if (($input.prop('checked')) !== this.$element.hasClass('active')) changed = false
	        this.$element.toggleClass('active')
	      }
	      $input.prop('checked', this.$element.hasClass('active'))
	      if (changed) $input.trigger('change')
	    } else {
	      this.$element.attr('aria-pressed', !this.$element.hasClass('active'))
	      this.$element.toggleClass('active')
	    }
	  }
	
	
	  // BUTTON PLUGIN DEFINITION
	  // ========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.button')
	      var options = typeof option == 'object' && option
	
	      if (!data) $this.data('bs.button', (data = new Button(this, options)))
	
	      if (option == 'toggle') data.toggle()
	      else if (option) data.setState(option)
	    })
	  }
	
	  var old = $.fn.button
	
	  $.fn.button             = Plugin
	  $.fn.button.Constructor = Button
	
	
	  // BUTTON NO CONFLICT
	  // ==================
	
	  $.fn.button.noConflict = function () {
	    $.fn.button = old
	    return this
	  }
	
	
	  // BUTTON DATA-API
	  // ===============
	
	  $(document)
	    .on('click.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      var $btn = $(e.target).closest('.btn')
	      Plugin.call($btn, 'toggle')
	      if (!($(e.target).is('input[type="radio"], input[type="checkbox"]'))) {
	        // Prevent double click on radios, and the double selections (so cancellation) on checkboxes
	        e.preventDefault()
	        // The target component still receive the focus
	        if ($btn.is('input,button')) $btn.trigger('focus')
	        else $btn.find('input:visible,button:visible').first().trigger('focus')
	      }
	    })
	    .on('focus.bs.button.data-api blur.bs.button.data-api', '[data-toggle^="button"]', function (e) {
	      $(e.target).closest('.btn').toggleClass('focus', /^focus(in)?$/.test(e.type))
	    })
	
	}(jQuery);
	


/***/ }),

/***/ 1543:
/*!*******************************************************!*\
  !*** ./~/imports-loader!./~/bootstrap/js/collapse.js ***!
  \*******************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	/* ========================================================================
	 * Bootstrap: collapse.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#collapse
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	/* jshint latedef: false */
	
	+function ($) {
	  'use strict';
	
	  // COLLAPSE PUBLIC CLASS DEFINITION
	  // ================================
	
	  var Collapse = function (element, options) {
	    this.$element      = $(element)
	    this.options       = $.extend({}, Collapse.DEFAULTS, options)
	    this.$trigger      = $('[data-toggle="collapse"][href="#' + element.id + '"],' +
	                           '[data-toggle="collapse"][data-target="#' + element.id + '"]')
	    this.transitioning = null
	
	    if (this.options.parent) {
	      this.$parent = this.getParent()
	    } else {
	      this.addAriaAndCollapsedClass(this.$element, this.$trigger)
	    }
	
	    if (this.options.toggle) this.toggle()
	  }
	
	  Collapse.VERSION  = '3.4.1'
	
	  Collapse.TRANSITION_DURATION = 350
	
	  Collapse.DEFAULTS = {
	    toggle: true
	  }
	
	  Collapse.prototype.dimension = function () {
	    var hasWidth = this.$element.hasClass('width')
	    return hasWidth ? 'width' : 'height'
	  }
	
	  Collapse.prototype.show = function () {
	    if (this.transitioning || this.$element.hasClass('in')) return
	
	    var activesData
	    var actives = this.$parent && this.$parent.children('.panel').children('.in, .collapsing')
	
	    if (actives && actives.length) {
	      activesData = actives.data('bs.collapse')
	      if (activesData && activesData.transitioning) return
	    }
	
	    var startEvent = $.Event('show.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    if (actives && actives.length) {
	      Plugin.call(actives, 'hide')
	      activesData || actives.data('bs.collapse', null)
	    }
	
	    var dimension = this.dimension()
	
	    this.$element
	      .removeClass('collapse')
	      .addClass('collapsing')[dimension](0)
	      .attr('aria-expanded', true)
	
	    this.$trigger
	      .removeClass('collapsed')
	      .attr('aria-expanded', true)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse in')[dimension]('')
	      this.transitioning = 0
	      this.$element
	        .trigger('shown.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    var scrollSize = $.camelCase(['scroll', dimension].join('-'))
	
	    this.$element
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)[dimension](this.$element[0][scrollSize])
	  }
	
	  Collapse.prototype.hide = function () {
	    if (this.transitioning || !this.$element.hasClass('in')) return
	
	    var startEvent = $.Event('hide.bs.collapse')
	    this.$element.trigger(startEvent)
	    if (startEvent.isDefaultPrevented()) return
	
	    var dimension = this.dimension()
	
	    this.$element[dimension](this.$element[dimension]())[0].offsetHeight
	
	    this.$element
	      .addClass('collapsing')
	      .removeClass('collapse in')
	      .attr('aria-expanded', false)
	
	    this.$trigger
	      .addClass('collapsed')
	      .attr('aria-expanded', false)
	
	    this.transitioning = 1
	
	    var complete = function () {
	      this.transitioning = 0
	      this.$element
	        .removeClass('collapsing')
	        .addClass('collapse')
	        .trigger('hidden.bs.collapse')
	    }
	
	    if (!$.support.transition) return complete.call(this)
	
	    this.$element
	      [dimension](0)
	      .one('bsTransitionEnd', $.proxy(complete, this))
	      .emulateTransitionEnd(Collapse.TRANSITION_DURATION)
	  }
	
	  Collapse.prototype.toggle = function () {
	    this[this.$element.hasClass('in') ? 'hide' : 'show']()
	  }
	
	  Collapse.prototype.getParent = function () {
	    return $(document).find(this.options.parent)
	      .find('[data-toggle="collapse"][data-parent="' + this.options.parent + '"]')
	      .each($.proxy(function (i, element) {
	        var $element = $(element)
	        this.addAriaAndCollapsedClass(getTargetFromTrigger($element), $element)
	      }, this))
	      .end()
	  }
	
	  Collapse.prototype.addAriaAndCollapsedClass = function ($element, $trigger) {
	    var isOpen = $element.hasClass('in')
	
	    $element.attr('aria-expanded', isOpen)
	    $trigger
	      .toggleClass('collapsed', !isOpen)
	      .attr('aria-expanded', isOpen)
	  }
	
	  function getTargetFromTrigger($trigger) {
	    var href
	    var target = $trigger.attr('data-target')
	      || (href = $trigger.attr('href')) && href.replace(/.*(?=#[^\s]+$)/, '') // strip for ie7
	
	    return $(document).find(target)
	  }
	
	
	  // COLLAPSE PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this   = $(this)
	      var data    = $this.data('bs.collapse')
	      var options = $.extend({}, Collapse.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data && options.toggle && /show|hide/.test(option)) options.toggle = false
	      if (!data) $this.data('bs.collapse', (data = new Collapse(this, options)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.collapse
	
	  $.fn.collapse             = Plugin
	  $.fn.collapse.Constructor = Collapse
	
	
	  // COLLAPSE NO CONFLICT
	  // ====================
	
	  $.fn.collapse.noConflict = function () {
	    $.fn.collapse = old
	    return this
	  }
	
	
	  // COLLAPSE DATA-API
	  // =================
	
	  $(document).on('click.bs.collapse.data-api', '[data-toggle="collapse"]', function (e) {
	    var $this   = $(this)
	
	    if (!$this.attr('data-target')) e.preventDefault()
	
	    var $target = getTargetFromTrigger($this)
	    var data    = $target.data('bs.collapse')
	    var option  = data ? 'toggle' : $this.data()
	
	    Plugin.call($target, option)
	  })
	
	}(jQuery);
	


/***/ }),

/***/ 1544:
/*!*******************************************************!*\
  !*** ./~/imports-loader!./~/bootstrap/js/dropdown.js ***!
  \*******************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	/* ========================================================================
	 * Bootstrap: dropdown.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#dropdowns
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // DROPDOWN CLASS DEFINITION
	  // =========================
	
	  var backdrop = '.dropdown-backdrop'
	  var toggle   = '[data-toggle="dropdown"]'
	  var Dropdown = function (element) {
	    $(element).on('click.bs.dropdown', this.toggle)
	  }
	
	  Dropdown.VERSION = '3.4.1'
	
	  function getParent($this) {
	    var selector = $this.attr('data-target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && /#[A-Za-z]/.test(selector) && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    var $parent = selector !== '#' ? $(document).find(selector) : null
	
	    return $parent && $parent.length ? $parent : $this.parent()
	  }
	
	  function clearMenus(e) {
	    if (e && e.which === 3) return
	    $(backdrop).remove()
	    $(toggle).each(function () {
	      var $this         = $(this)
	      var $parent       = getParent($this)
	      var relatedTarget = { relatedTarget: this }
	
	      if (!$parent.hasClass('open')) return
	
	      if (e && e.type == 'click' && /input|textarea/i.test(e.target.tagName) && $.contains($parent[0], e.target)) return
	
	      $parent.trigger(e = $.Event('hide.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this.attr('aria-expanded', 'false')
	      $parent.removeClass('open').trigger($.Event('hidden.bs.dropdown', relatedTarget))
	    })
	  }
	
	  Dropdown.prototype.toggle = function (e) {
	    var $this = $(this)
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    clearMenus()
	
	    if (!isActive) {
	      if ('ontouchstart' in document.documentElement && !$parent.closest('.navbar-nav').length) {
	        // if mobile we use a backdrop because click events don't delegate
	        $(document.createElement('div'))
	          .addClass('dropdown-backdrop')
	          .insertAfter($(this))
	          .on('click', clearMenus)
	      }
	
	      var relatedTarget = { relatedTarget: this }
	      $parent.trigger(e = $.Event('show.bs.dropdown', relatedTarget))
	
	      if (e.isDefaultPrevented()) return
	
	      $this
	        .trigger('focus')
	        .attr('aria-expanded', 'true')
	
	      $parent
	        .toggleClass('open')
	        .trigger($.Event('shown.bs.dropdown', relatedTarget))
	    }
	
	    return false
	  }
	
	  Dropdown.prototype.keydown = function (e) {
	    if (!/(38|40|27|32)/.test(e.which) || /input|textarea/i.test(e.target.tagName)) return
	
	    var $this = $(this)
	
	    e.preventDefault()
	    e.stopPropagation()
	
	    if ($this.is('.disabled, :disabled')) return
	
	    var $parent  = getParent($this)
	    var isActive = $parent.hasClass('open')
	
	    if (!isActive && e.which != 27 || isActive && e.which == 27) {
	      if (e.which == 27) $parent.find(toggle).trigger('focus')
	      return $this.trigger('click')
	    }
	
	    var desc = ' li:not(.disabled):visible a'
	    var $items = $parent.find('.dropdown-menu' + desc)
	
	    if (!$items.length) return
	
	    var index = $items.index(e.target)
	
	    if (e.which == 38 && index > 0)                 index--         // up
	    if (e.which == 40 && index < $items.length - 1) index++         // down
	    if (!~index)                                    index = 0
	
	    $items.eq(index).trigger('focus')
	  }
	
	
	  // DROPDOWN PLUGIN DEFINITION
	  // ==========================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.dropdown')
	
	      if (!data) $this.data('bs.dropdown', (data = new Dropdown(this)))
	      if (typeof option == 'string') data[option].call($this)
	    })
	  }
	
	  var old = $.fn.dropdown
	
	  $.fn.dropdown             = Plugin
	  $.fn.dropdown.Constructor = Dropdown
	
	
	  // DROPDOWN NO CONFLICT
	  // ====================
	
	  $.fn.dropdown.noConflict = function () {
	    $.fn.dropdown = old
	    return this
	  }
	
	
	  // APPLY TO STANDARD DROPDOWN ELEMENTS
	  // ===================================
	
	  $(document)
	    .on('click.bs.dropdown.data-api', clearMenus)
	    .on('click.bs.dropdown.data-api', '.dropdown form', function (e) { e.stopPropagation() })
	    .on('click.bs.dropdown.data-api', toggle, Dropdown.prototype.toggle)
	    .on('keydown.bs.dropdown.data-api', toggle, Dropdown.prototype.keydown)
	    .on('keydown.bs.dropdown.data-api', '.dropdown-menu', Dropdown.prototype.keydown)
	
	}(jQuery);
	


/***/ }),

/***/ 1545:
/*!****************************************************!*\
  !*** ./~/imports-loader!./~/bootstrap/js/modal.js ***!
  \****************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	/* ========================================================================
	 * Bootstrap: modal.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#modals
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // MODAL CLASS DEFINITION
	  // ======================
	
	  var Modal = function (element, options) {
	    this.options = options
	    this.$body = $(document.body)
	    this.$element = $(element)
	    this.$dialog = this.$element.find('.modal-dialog')
	    this.$backdrop = null
	    this.isShown = null
	    this.originalBodyPad = null
	    this.scrollbarWidth = 0
	    this.ignoreBackdropClick = false
	    this.fixedContent = '.navbar-fixed-top, .navbar-fixed-bottom'
	
	    if (this.options.remote) {
	      this.$element
	        .find('.modal-content')
	        .load(this.options.remote, $.proxy(function () {
	          this.$element.trigger('loaded.bs.modal')
	        }, this))
	    }
	  }
	
	  Modal.VERSION = '3.4.1'
	
	  Modal.TRANSITION_DURATION = 300
	  Modal.BACKDROP_TRANSITION_DURATION = 150
	
	  Modal.DEFAULTS = {
	    backdrop: true,
	    keyboard: true,
	    show: true
	  }
	
	  Modal.prototype.toggle = function (_relatedTarget) {
	    return this.isShown ? this.hide() : this.show(_relatedTarget)
	  }
	
	  Modal.prototype.show = function (_relatedTarget) {
	    var that = this
	    var e = $.Event('show.bs.modal', { relatedTarget: _relatedTarget })
	
	    this.$element.trigger(e)
	
	    if (this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = true
	
	    this.checkScrollbar()
	    this.setScrollbar()
	    this.$body.addClass('modal-open')
	
	    this.escape()
	    this.resize()
	
	    this.$element.on('click.dismiss.bs.modal', '[data-dismiss="modal"]', $.proxy(this.hide, this))
	
	    this.$dialog.on('mousedown.dismiss.bs.modal', function () {
	      that.$element.one('mouseup.dismiss.bs.modal', function (e) {
	        if ($(e.target).is(that.$element)) that.ignoreBackdropClick = true
	      })
	    })
	
	    this.backdrop(function () {
	      var transition = $.support.transition && that.$element.hasClass('fade')
	
	      if (!that.$element.parent().length) {
	        that.$element.appendTo(that.$body) // don't move modals dom position
	      }
	
	      that.$element
	        .show()
	        .scrollTop(0)
	
	      that.adjustDialog()
	
	      if (transition) {
	        that.$element[0].offsetWidth // force reflow
	      }
	
	      that.$element.addClass('in')
	
	      that.enforceFocus()
	
	      var e = $.Event('shown.bs.modal', { relatedTarget: _relatedTarget })
	
	      transition ?
	        that.$dialog // wait for modal to slide in
	          .one('bsTransitionEnd', function () {
	            that.$element.trigger('focus').trigger(e)
	          })
	          .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	        that.$element.trigger('focus').trigger(e)
	    })
	  }
	
	  Modal.prototype.hide = function (e) {
	    if (e) e.preventDefault()
	
	    e = $.Event('hide.bs.modal')
	
	    this.$element.trigger(e)
	
	    if (!this.isShown || e.isDefaultPrevented()) return
	
	    this.isShown = false
	
	    this.escape()
	    this.resize()
	
	    $(document).off('focusin.bs.modal')
	
	    this.$element
	      .removeClass('in')
	      .off('click.dismiss.bs.modal')
	      .off('mouseup.dismiss.bs.modal')
	
	    this.$dialog.off('mousedown.dismiss.bs.modal')
	
	    $.support.transition && this.$element.hasClass('fade') ?
	      this.$element
	        .one('bsTransitionEnd', $.proxy(this.hideModal, this))
	        .emulateTransitionEnd(Modal.TRANSITION_DURATION) :
	      this.hideModal()
	  }
	
	  Modal.prototype.enforceFocus = function () {
	    $(document)
	      .off('focusin.bs.modal') // guard against infinite focus loop
	      .on('focusin.bs.modal', $.proxy(function (e) {
	        if (document !== e.target &&
	          this.$element[0] !== e.target &&
	          !this.$element.has(e.target).length) {
	          this.$element.trigger('focus')
	        }
	      }, this))
	  }
	
	  Modal.prototype.escape = function () {
	    if (this.isShown && this.options.keyboard) {
	      this.$element.on('keydown.dismiss.bs.modal', $.proxy(function (e) {
	        e.which == 27 && this.hide()
	      }, this))
	    } else if (!this.isShown) {
	      this.$element.off('keydown.dismiss.bs.modal')
	    }
	  }
	
	  Modal.prototype.resize = function () {
	    if (this.isShown) {
	      $(window).on('resize.bs.modal', $.proxy(this.handleUpdate, this))
	    } else {
	      $(window).off('resize.bs.modal')
	    }
	  }
	
	  Modal.prototype.hideModal = function () {
	    var that = this
	    this.$element.hide()
	    this.backdrop(function () {
	      that.$body.removeClass('modal-open')
	      that.resetAdjustments()
	      that.resetScrollbar()
	      that.$element.trigger('hidden.bs.modal')
	    })
	  }
	
	  Modal.prototype.removeBackdrop = function () {
	    this.$backdrop && this.$backdrop.remove()
	    this.$backdrop = null
	  }
	
	  Modal.prototype.backdrop = function (callback) {
	    var that = this
	    var animate = this.$element.hasClass('fade') ? 'fade' : ''
	
	    if (this.isShown && this.options.backdrop) {
	      var doAnimate = $.support.transition && animate
	
	      this.$backdrop = $(document.createElement('div'))
	        .addClass('modal-backdrop ' + animate)
	        .appendTo(this.$body)
	
	      this.$element.on('click.dismiss.bs.modal', $.proxy(function (e) {
	        if (this.ignoreBackdropClick) {
	          this.ignoreBackdropClick = false
	          return
	        }
	        if (e.target !== e.currentTarget) return
	        this.options.backdrop == 'static'
	          ? this.$element[0].focus()
	          : this.hide()
	      }, this))
	
	      if (doAnimate) this.$backdrop[0].offsetWidth // force reflow
	
	      this.$backdrop.addClass('in')
	
	      if (!callback) return
	
	      doAnimate ?
	        this.$backdrop
	          .one('bsTransitionEnd', callback)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callback()
	
	    } else if (!this.isShown && this.$backdrop) {
	      this.$backdrop.removeClass('in')
	
	      var callbackRemove = function () {
	        that.removeBackdrop()
	        callback && callback()
	      }
	      $.support.transition && this.$element.hasClass('fade') ?
	        this.$backdrop
	          .one('bsTransitionEnd', callbackRemove)
	          .emulateTransitionEnd(Modal.BACKDROP_TRANSITION_DURATION) :
	        callbackRemove()
	
	    } else if (callback) {
	      callback()
	    }
	  }
	
	  // these following methods are used to handle overflowing modals
	
	  Modal.prototype.handleUpdate = function () {
	    this.adjustDialog()
	  }
	
	  Modal.prototype.adjustDialog = function () {
	    var modalIsOverflowing = this.$element[0].scrollHeight > document.documentElement.clientHeight
	
	    this.$element.css({
	      paddingLeft: !this.bodyIsOverflowing && modalIsOverflowing ? this.scrollbarWidth : '',
	      paddingRight: this.bodyIsOverflowing && !modalIsOverflowing ? this.scrollbarWidth : ''
	    })
	  }
	
	  Modal.prototype.resetAdjustments = function () {
	    this.$element.css({
	      paddingLeft: '',
	      paddingRight: ''
	    })
	  }
	
	  Modal.prototype.checkScrollbar = function () {
	    var fullWindowWidth = window.innerWidth
	    if (!fullWindowWidth) { // workaround for missing window.innerWidth in IE8
	      var documentElementRect = document.documentElement.getBoundingClientRect()
	      fullWindowWidth = documentElementRect.right - Math.abs(documentElementRect.left)
	    }
	    this.bodyIsOverflowing = document.body.clientWidth < fullWindowWidth
	    this.scrollbarWidth = this.measureScrollbar()
	  }
	
	  Modal.prototype.setScrollbar = function () {
	    var bodyPad = parseInt((this.$body.css('padding-right') || 0), 10)
	    this.originalBodyPad = document.body.style.paddingRight || ''
	    var scrollbarWidth = this.scrollbarWidth
	    if (this.bodyIsOverflowing) {
	      this.$body.css('padding-right', bodyPad + scrollbarWidth)
	      $(this.fixedContent).each(function (index, element) {
	        var actualPadding = element.style.paddingRight
	        var calculatedPadding = $(element).css('padding-right')
	        $(element)
	          .data('padding-right', actualPadding)
	          .css('padding-right', parseFloat(calculatedPadding) + scrollbarWidth + 'px')
	      })
	    }
	  }
	
	  Modal.prototype.resetScrollbar = function () {
	    this.$body.css('padding-right', this.originalBodyPad)
	    $(this.fixedContent).each(function (index, element) {
	      var padding = $(element).data('padding-right')
	      $(element).removeData('padding-right')
	      element.style.paddingRight = padding ? padding : ''
	    })
	  }
	
	  Modal.prototype.measureScrollbar = function () { // thx walsh
	    var scrollDiv = document.createElement('div')
	    scrollDiv.className = 'modal-scrollbar-measure'
	    this.$body.append(scrollDiv)
	    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth
	    this.$body[0].removeChild(scrollDiv)
	    return scrollbarWidth
	  }
	
	
	  // MODAL PLUGIN DEFINITION
	  // =======================
	
	  function Plugin(option, _relatedTarget) {
	    return this.each(function () {
	      var $this = $(this)
	      var data = $this.data('bs.modal')
	      var options = $.extend({}, Modal.DEFAULTS, $this.data(), typeof option == 'object' && option)
	
	      if (!data) $this.data('bs.modal', (data = new Modal(this, options)))
	      if (typeof option == 'string') data[option](_relatedTarget)
	      else if (options.show) data.show(_relatedTarget)
	    })
	  }
	
	  var old = $.fn.modal
	
	  $.fn.modal = Plugin
	  $.fn.modal.Constructor = Modal
	
	
	  // MODAL NO CONFLICT
	  // =================
	
	  $.fn.modal.noConflict = function () {
	    $.fn.modal = old
	    return this
	  }
	
	
	  // MODAL DATA-API
	  // ==============
	
	  $(document).on('click.bs.modal.data-api', '[data-toggle="modal"]', function (e) {
	    var $this = $(this)
	    var href = $this.attr('href')
	    var target = $this.attr('data-target') ||
	      (href && href.replace(/.*(?=#[^\s]+$)/, '')) // strip for ie7
	
	    var $target = $(document).find(target)
	    var option = $target.data('bs.modal') ? 'toggle' : $.extend({ remote: !/#/.test(href) && href }, $target.data(), $this.data())
	
	    if ($this.is('a')) e.preventDefault()
	
	    $target.one('show.bs.modal', function (showEvent) {
	      if (showEvent.isDefaultPrevented()) return // only register focus restorer if modal will actually get shown
	      $target.one('hidden.bs.modal', function () {
	        $this.is(':visible') && $this.trigger('focus')
	      })
	    })
	    Plugin.call($target, option, this)
	  })
	
	}(jQuery);
	


/***/ }),

/***/ 1546:
/*!**************************************************!*\
  !*** ./~/imports-loader!./~/bootstrap/js/tab.js ***!
  \**************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	/* ========================================================================
	 * Bootstrap: tab.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#tabs
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // TAB CLASS DEFINITION
	  // ====================
	
	  var Tab = function (element) {
	    // jscs:disable requireDollarBeforejQueryAssignment
	    this.element = $(element)
	    // jscs:enable requireDollarBeforejQueryAssignment
	  }
	
	  Tab.VERSION = '3.4.1'
	
	  Tab.TRANSITION_DURATION = 150
	
	  Tab.prototype.show = function () {
	    var $this    = this.element
	    var $ul      = $this.closest('ul:not(.dropdown-menu)')
	    var selector = $this.data('target')
	
	    if (!selector) {
	      selector = $this.attr('href')
	      selector = selector && selector.replace(/.*(?=#[^\s]*$)/, '') // strip for ie7
	    }
	
	    if ($this.parent('li').hasClass('active')) return
	
	    var $previous = $ul.find('.active:last a')
	    var hideEvent = $.Event('hide.bs.tab', {
	      relatedTarget: $this[0]
	    })
	    var showEvent = $.Event('show.bs.tab', {
	      relatedTarget: $previous[0]
	    })
	
	    $previous.trigger(hideEvent)
	    $this.trigger(showEvent)
	
	    if (showEvent.isDefaultPrevented() || hideEvent.isDefaultPrevented()) return
	
	    var $target = $(document).find(selector)
	
	    this.activate($this.closest('li'), $ul)
	    this.activate($target, $target.parent(), function () {
	      $previous.trigger({
	        type: 'hidden.bs.tab',
	        relatedTarget: $this[0]
	      })
	      $this.trigger({
	        type: 'shown.bs.tab',
	        relatedTarget: $previous[0]
	      })
	    })
	  }
	
	  Tab.prototype.activate = function (element, container, callback) {
	    var $active    = container.find('> .active')
	    var transition = callback
	      && $.support.transition
	      && ($active.length && $active.hasClass('fade') || !!container.find('> .fade').length)
	
	    function next() {
	      $active
	        .removeClass('active')
	        .find('> .dropdown-menu > .active')
	        .removeClass('active')
	        .end()
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', false)
	
	      element
	        .addClass('active')
	        .find('[data-toggle="tab"]')
	        .attr('aria-expanded', true)
	
	      if (transition) {
	        element[0].offsetWidth // reflow for transition
	        element.addClass('in')
	      } else {
	        element.removeClass('fade')
	      }
	
	      if (element.parent('.dropdown-menu').length) {
	        element
	          .closest('li.dropdown')
	          .addClass('active')
	          .end()
	          .find('[data-toggle="tab"]')
	          .attr('aria-expanded', true)
	      }
	
	      callback && callback()
	    }
	
	    $active.length && transition ?
	      $active
	        .one('bsTransitionEnd', next)
	        .emulateTransitionEnd(Tab.TRANSITION_DURATION) :
	      next()
	
	    $active.removeClass('in')
	  }
	
	
	  // TAB PLUGIN DEFINITION
	  // =====================
	
	  function Plugin(option) {
	    return this.each(function () {
	      var $this = $(this)
	      var data  = $this.data('bs.tab')
	
	      if (!data) $this.data('bs.tab', (data = new Tab(this)))
	      if (typeof option == 'string') data[option]()
	    })
	  }
	
	  var old = $.fn.tab
	
	  $.fn.tab             = Plugin
	  $.fn.tab.Constructor = Tab
	
	
	  // TAB NO CONFLICT
	  // ===============
	
	  $.fn.tab.noConflict = function () {
	    $.fn.tab = old
	    return this
	  }
	
	
	  // TAB DATA-API
	  // ============
	
	  var clickHandler = function (e) {
	    e.preventDefault()
	    Plugin.call($(this), 'show')
	  }
	
	  $(document)
	    .on('click.bs.tab.data-api', '[data-toggle="tab"]', clickHandler)
	    .on('click.bs.tab.data-api', '[data-toggle="pill"]', clickHandler)
	
	}(jQuery);
	


/***/ }),

/***/ 1547:
/*!*********************************************************!*\
  !*** ./~/imports-loader!./~/bootstrap/js/transition.js ***!
  \*********************************************************/
/***/ (function(module, exports) {

	/*** IMPORTS FROM imports-loader ***/
	
	
	/* ========================================================================
	 * Bootstrap: transition.js v3.4.1
	 * https://getbootstrap.com/docs/3.4/javascript/#transitions
	 * ========================================================================
	 * Copyright 2011-2019 Twitter, Inc.
	 * Licensed under MIT (https://github.com/twbs/bootstrap/blob/master/LICENSE)
	 * ======================================================================== */
	
	
	+function ($) {
	  'use strict';
	
	  // CSS TRANSITION SUPPORT (Shoutout: https://modernizr.com/)
	  // ============================================================
	
	  function transitionEnd() {
	    var el = document.createElement('bootstrap')
	
	    var transEndEventNames = {
	      WebkitTransition : 'webkitTransitionEnd',
	      MozTransition    : 'transitionend',
	      OTransition      : 'oTransitionEnd otransitionend',
	      transition       : 'transitionend'
	    }
	
	    for (var name in transEndEventNames) {
	      if (el.style[name] !== undefined) {
	        return { end: transEndEventNames[name] }
	      }
	    }
	
	    return false // explicit for ie8 (  ._.)
	  }
	
	  // https://blog.alexmaccaw.com/css-transitions
	  $.fn.emulateTransitionEnd = function (duration) {
	    var called = false
	    var $el = this
	    $(this).one('bsTransitionEnd', function () { called = true })
	    var callback = function () { if (!called) $($el).trigger($.support.transition.end) }
	    setTimeout(callback, duration)
	    return this
	  }
	
	  $(function () {
	    $.support.transition = transitionEnd()
	
	    if (!$.support.transition) return
	
	    $.event.special.bsTransitionEnd = {
	      bindType: $.support.transition.end,
	      delegateType: $.support.transition.end,
	      handle: function (e) {
	        if ($(e.target).is(this)) return e.handleObj.handler.apply(this, arguments)
	      }
	    }
	  })
	
	}(jQuery);
	


/***/ }),

/***/ 1548:
/*!**************************************************************!*\
  !*** ./~/imports-loader!./~/flexslider/jquery.flexslider.js ***!
  \**************************************************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(setImmediate) {/*** IMPORTS FROM imports-loader ***/
	
	
	/*
	 * jQuery FlexSlider v2.7.2
	 * Copyright 2012 WooThemes
	 * Contributing Author: Tyler Smith
	 */
	;
	(function ($) {
	
	  var focused = true;
	
	  //FlexSlider: Object Instance
	  $.flexslider = function(el, options) {
	    var slider = $(el);
	
	    // making variables public
	
	    //if rtl value was not passed and html is in rtl..enable it by default.
	    if(typeof options.rtl=='undefined' && $('html').attr('dir')=='rtl'){
	      options.rtl=true;
	    }
	    slider.vars = $.extend({}, $.flexslider.defaults, options);
	
	    var namespace = slider.vars.namespace,
	        msGesture = window.navigator && window.navigator.msPointerEnabled && window.MSGesture,
	        touch = (( "ontouchstart" in window ) || msGesture || window.DocumentTouch && document instanceof DocumentTouch) && slider.vars.touch,
	        // deprecating this idea, as devices are being released with both of these events
	        eventType = "click touchend MSPointerUp keyup",
	        watchedEvent = "",
	        watchedEventClearTimer,
	        vertical = slider.vars.direction === "vertical",
	        reverse = slider.vars.reverse,
	        carousel = (slider.vars.itemWidth > 0),
	        fade = slider.vars.animation === "fade",
	        asNav = slider.vars.asNavFor !== "",
	        methods = {};
	
	    // Store a reference to the slider object
	    $.data(el, "flexslider", slider);
	
	    // Private slider methods
	    methods = {
	      init: function() {
	        slider.animating = false;
	        // Get current slide and make sure it is a number
	        slider.currentSlide = parseInt( ( slider.vars.startAt ? slider.vars.startAt : 0), 10 );
	        if ( isNaN( slider.currentSlide ) ) { slider.currentSlide = 0; }
	        slider.animatingTo = slider.currentSlide;
	        slider.atEnd = (slider.currentSlide === 0 || slider.currentSlide === slider.last);
	        slider.containerSelector = slider.vars.selector.substr(0,slider.vars.selector.search(' '));
	        slider.slides = $(slider.vars.selector, slider);
	        slider.container = $(slider.containerSelector, slider);
	        slider.count = slider.slides.length;
	        // SYNC:
	        slider.syncExists = $(slider.vars.sync).length > 0;
	        // SLIDE:
	        if (slider.vars.animation === "slide") { slider.vars.animation = "swing"; }
	        slider.prop = (vertical) ? "top" : ( slider.vars.rtl ? "marginRight" : "marginLeft" );
	        slider.args = {};
	        // SLIDESHOW:
	        slider.manualPause = false;
	        slider.stopped = false;
	        //PAUSE WHEN INVISIBLE
	        slider.started = false;
	        slider.startTimeout = null;
	        // TOUCH/USECSS:
	        slider.transitions = !slider.vars.video && !fade && slider.vars.useCSS && (function() {
	          var obj = document.createElement('div'),
	              props = ['perspectiveProperty', 'WebkitPerspective', 'MozPerspective', 'OPerspective', 'msPerspective'];
	          for (var i in props) {
	            if ( obj.style[ props[i] ] !== undefined ) {
	              slider.pfx = props[i].replace('Perspective','').toLowerCase();
	              slider.prop = "-" + slider.pfx + "-transform";
	              return true;
	            }
	          }
	          return false;
	        }());
	        slider.isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;
	        slider.ensureAnimationEnd = '';
	        // CONTROLSCONTAINER:
	        if (slider.vars.controlsContainer !== "") slider.controlsContainer = $(slider.vars.controlsContainer).length > 0 && $(slider.vars.controlsContainer);
	        // MANUAL:
	        if (slider.vars.manualControls !== "") slider.manualControls = $(slider.vars.manualControls).length > 0 && $(slider.vars.manualControls);
	
	        // CUSTOM DIRECTION NAV:
	        if (slider.vars.customDirectionNav !== "") slider.customDirectionNav = $(slider.vars.customDirectionNav).length === 2 && $(slider.vars.customDirectionNav);
	
	        // RANDOMIZE:
	        if (slider.vars.randomize) {
	          slider.slides.sort(function() { return (Math.round(Math.random())-0.5); });
	          slider.container.empty().append(slider.slides);
	        }
	
	        slider.doMath();
	
	        // INIT
	        slider.setup("init");
	
	        // CONTROLNAV:
	        if (slider.vars.controlNav) { methods.controlNav.setup(); }
	
	        // DIRECTIONNAV:
	        if (slider.vars.directionNav) { methods.directionNav.setup(); }
	
	        // KEYBOARD:
	        if (slider.vars.keyboard && ($(slider.containerSelector).length === 1 || slider.vars.multipleKeyboard)) {
	          $(document).bind('keyup', function(event) {
	            var keycode = event.keyCode;
	            if (!slider.animating && (keycode === 39 || keycode === 37)) {
	              var target = (slider.vars.rtl?
	                                ((keycode === 37) ? slider.getTarget('next') :
	                                (keycode === 39) ? slider.getTarget('prev') : false)
	                                :
	                                ((keycode === 39) ? slider.getTarget('next') :
	                                (keycode === 37) ? slider.getTarget('prev') : false)
	                                )
	                                ;
	              slider.flexAnimate(target, slider.vars.pauseOnAction);
	            }
	          });
	        }
	        // MOUSEWHEEL:
	        if (slider.vars.mousewheel) {
	          slider.bind('mousewheel', function(event, delta, deltaX, deltaY) {
	            event.preventDefault();
	            var target = (delta < 0) ? slider.getTarget('next') : slider.getTarget('prev');
	            slider.flexAnimate(target, slider.vars.pauseOnAction);
	          });
	        }
	
	        // PAUSEPLAY
	        if (slider.vars.pausePlay) { methods.pausePlay.setup(); }
	
	        //PAUSE WHEN INVISIBLE
	        if (slider.vars.slideshow && slider.vars.pauseInvisible) { methods.pauseInvisible.init(); }
	
	        // SLIDSESHOW
	        if (slider.vars.slideshow) {
	          if (slider.vars.pauseOnHover) {
	            slider.hover(function() {
	              if (!slider.manualPlay && !slider.manualPause) { slider.pause(); }
	            }, function() {
	              if (!slider.manualPause && !slider.manualPlay && !slider.stopped) { slider.play(); }
	            });
	          }
	          // initialize animation
	          //If we're visible, or we don't use PageVisibility API
	          if(!slider.vars.pauseInvisible || !methods.pauseInvisible.isHidden()) {
	            (slider.vars.initDelay > 0) ? slider.startTimeout = setTimeout(slider.play, slider.vars.initDelay) : slider.play();
	          }
	        }
	
	        // ASNAV:
	        if (asNav) { methods.asNav.setup(); }
	
	        // TOUCH
	        if (touch && slider.vars.touch) { methods.touch(); }
	
	        // FADE&&SMOOTHHEIGHT || SLIDE:
	        if (!fade || (fade && slider.vars.smoothHeight)) { $(window).bind("resize orientationchange focus", methods.resize); }
	
	        slider.find("img").attr("draggable", "false");
	
	        // API: start() Callback
	        setTimeout(function(){
	          slider.vars.start(slider);
	        }, 200);
	      },
	      asNav: {
	        setup: function() {
	          slider.asNav = true;
	          slider.animatingTo = Math.floor(slider.currentSlide/slider.move);
	          slider.currentItem = slider.currentSlide;
	          slider.slides.removeClass(namespace + "active-slide").eq(slider.currentItem).addClass(namespace + "active-slide");
	          if(!msGesture){
	              slider.slides.on(eventType, function(e){
	                e.preventDefault();
	                var $slide = $(this),
	                    target = $slide.index();
	                var posFromX;
	                if(slider.vars.rtl){
	                  posFromX = -1*($slide.offset().right - $(slider).scrollLeft()); // Find position of slide relative to right of slider container
	                }
	                else
	                {
	                  posFromX = $slide.offset().left - $(slider).scrollLeft(); // Find position of slide relative to left of slider container
	                }
	                if( posFromX <= 0 && $slide.hasClass( namespace + 'active-slide' ) ) {
	                  slider.flexAnimate(slider.getTarget("prev"), true);
	                } else if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass(namespace + "active-slide")) {
	                  slider.direction = (slider.currentItem < target) ? "next" : "prev";
	                  slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
	                }
	              });
	          }else{
	              el._slider = slider;
	              slider.slides.each(function (){
	                  var that = this;
	                  that._gesture = new MSGesture();
	                  that._gesture.target = that;
	                  that.addEventListener("MSPointerDown", function (e){
	                      e.preventDefault();
	                      if(e.currentTarget._gesture) {
	                        e.currentTarget._gesture.addPointer(e.pointerId);
	                      }
	                  }, false);
	                  that.addEventListener("MSGestureTap", function (e){
	                      e.preventDefault();
	                      var $slide = $(this),
	                          target = $slide.index();
	                      if (!$(slider.vars.asNavFor).data('flexslider').animating && !$slide.hasClass('active')) {
	                          slider.direction = (slider.currentItem < target) ? "next" : "prev";
	                          slider.flexAnimate(target, slider.vars.pauseOnAction, false, true, true);
	                      }
	                  });
	              });
	          }
	        }
	      },
	      controlNav: {
	        setup: function() {
	          if (!slider.manualControls) {
	            methods.controlNav.setupPaging();
	          } else { // MANUALCONTROLS:
	            methods.controlNav.setupManual();
	          }
	        },
	        setupPaging: function() {
	          var type = (slider.vars.controlNav === "thumbnails") ? 'control-thumbs' : 'control-paging',
	              j = 1,
	              item,
	              slide;
	
	          slider.controlNavScaffold = $('<ol class="'+ namespace + 'control-nav ' + namespace + type + '"></ol>');
	
	          if (slider.pagingCount > 1) {
	            for (var i = 0; i < slider.pagingCount; i++) {
	              slide = slider.slides.eq(i);
	
	              if ( undefined === slide.attr( 'data-thumb-alt' ) ) { 
	                slide.attr( 'data-thumb-alt', '' ); 
	              }
	              
	              item = $( '<a></a>' ).attr( 'href', '#' ).text( j );
	              if ( slider.vars.controlNav === "thumbnails" ) {
	                item = $( '<img/>' ).attr( 'src', slide.attr( 'data-thumb' ) );
	              }
	              
	              if ( '' !== slide.attr( 'data-thumb-alt' ) ) {
	                item.attr( 'alt', slide.attr( 'data-thumb-alt' ) );
	              }
	
	              if ( 'thumbnails' === slider.vars.controlNav && true === slider.vars.thumbCaptions ) {
	                var captn = slide.attr( 'data-thumbcaption' );
	                if ( '' !== captn && undefined !== captn ) { 
	                  var caption = $('<span></span>' ).addClass( namespace + 'caption' ).text( captn );
	                  item.append( caption );
	                }
	              }
	              
	              var liElement = $( '<li>' );
	              item.appendTo( liElement );
	              liElement.append( '</li>' );
	
	              slider.controlNavScaffold.append(liElement);
	              j++;
	
	            }
	          }
	
	          // CONTROLSCONTAINER:
	          (slider.controlsContainer) ? $(slider.controlsContainer).append(slider.controlNavScaffold) : slider.append(slider.controlNavScaffold);
	          methods.controlNav.set();
	
	          methods.controlNav.active();
	
	          slider.controlNavScaffold.delegate('a, img', eventType, function(event) {
	            event.preventDefault();
	
	            if (watchedEvent === "" || watchedEvent === event.type) {
	              var $this = $(this),
	                  target = slider.controlNav.index($this);
	
	              if (!$this.hasClass(namespace + 'active')) {
	                slider.direction = (target > slider.currentSlide) ? "next" : "prev";
	                slider.flexAnimate(target, slider.vars.pauseOnAction);
	              }
	            }
	
	            // setup flags to prevent event duplication
	            if (watchedEvent === "") {
	              watchedEvent = event.type;
	            }
	            methods.setToClearWatchedEvent();
	
	          });
	        },
	        setupManual: function() {
	          slider.controlNav = slider.manualControls;
	          methods.controlNav.active();
	
	          slider.controlNav.bind(eventType, function(event) {
	            event.preventDefault();
	
	            if (watchedEvent === "" || watchedEvent === event.type) {
	              var $this = $(this),
	                  target = slider.controlNav.index($this);
	
	              if (!$this.hasClass(namespace + 'active')) {
	                (target > slider.currentSlide) ? slider.direction = "next" : slider.direction = "prev";
	                slider.flexAnimate(target, slider.vars.pauseOnAction);
	              }
	            }
	
	            // setup flags to prevent event duplication
	            if (watchedEvent === "") {
	              watchedEvent = event.type;
	            }
	            methods.setToClearWatchedEvent();
	          });
	        },
	        set: function() {
	          var selector = (slider.vars.controlNav === "thumbnails") ? 'img' : 'a';
	          slider.controlNav = $('.' + namespace + 'control-nav li ' + selector, (slider.controlsContainer) ? slider.controlsContainer : slider);
	        },
	        active: function() {
	          slider.controlNav.removeClass(namespace + "active").eq(slider.animatingTo).addClass(namespace + "active");
	        },
	        update: function(action, pos) {
	          if (slider.pagingCount > 1 && action === "add") {
	            slider.controlNavScaffold.append($('<li><a href="#">' + slider.count + '</a></li>'));
	          } else if (slider.pagingCount === 1) {
	            slider.controlNavScaffold.find('li').remove();
	          } else {
	            slider.controlNav.eq(pos).closest('li').remove();
	          }
	          methods.controlNav.set();
	          (slider.pagingCount > 1 && slider.pagingCount !== slider.controlNav.length) ? slider.update(pos, action) : methods.controlNav.active();
	        }
	      },
	      directionNav: {
	        setup: function() {
	          var directionNavScaffold = $('<ul class="' + namespace + 'direction-nav"><li class="' + namespace + 'nav-prev"><a class="' + namespace + 'prev" href="#">' + slider.vars.prevText + '</a></li><li class="' + namespace + 'nav-next"><a class="' + namespace + 'next" href="#">' + slider.vars.nextText + '</a></li></ul>');
	
	          // CUSTOM DIRECTION NAV:
	          if (slider.customDirectionNav) {
	            slider.directionNav = slider.customDirectionNav;
	          // CONTROLSCONTAINER:
	          } else if (slider.controlsContainer) {
	            $(slider.controlsContainer).append(directionNavScaffold);
	            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider.controlsContainer);
	          } else {
	            slider.append(directionNavScaffold);
	            slider.directionNav = $('.' + namespace + 'direction-nav li a', slider);
	          }
	
	          methods.directionNav.update();
	
	          slider.directionNav.bind(eventType, function(event) {
	            event.preventDefault();
	            var target;
	
	            if (watchedEvent === "" || watchedEvent === event.type) {
	              target = ($(this).hasClass(namespace + 'next')) ? slider.getTarget('next') : slider.getTarget('prev');
	              slider.flexAnimate(target, slider.vars.pauseOnAction);
	            }
	
	            // setup flags to prevent event duplication
	            if (watchedEvent === "") {
	              watchedEvent = event.type;
	            }
	            methods.setToClearWatchedEvent();
	          });
	        },
	        update: function() {
	          var disabledClass = namespace + 'disabled';
	          if (slider.pagingCount === 1) {
	            slider.directionNav.addClass(disabledClass).attr('tabindex', '-1');
	          } else if (!slider.vars.animationLoop) {
	            if (slider.animatingTo === 0) {
	              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "prev").addClass(disabledClass).attr('tabindex', '-1');
	            } else if (slider.animatingTo === slider.last) {
	              slider.directionNav.removeClass(disabledClass).filter('.' + namespace + "next").addClass(disabledClass).attr('tabindex', '-1');
	            } else {
	              slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
	            }
	          } else {
	            slider.directionNav.removeClass(disabledClass).removeAttr('tabindex');
	          }
	        }
	      },
	      pausePlay: {
	        setup: function() {
	          var pausePlayScaffold = $('<div class="' + namespace + 'pauseplay"><a href="#"></a></div>');
	
	          // CONTROLSCONTAINER:
	          if (slider.controlsContainer) {
	            slider.controlsContainer.append(pausePlayScaffold);
	            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider.controlsContainer);
	          } else {
	            slider.append(pausePlayScaffold);
	            slider.pausePlay = $('.' + namespace + 'pauseplay a', slider);
	          }
	
	          methods.pausePlay.update((slider.vars.slideshow) ? namespace + 'pause' : namespace + 'play');
	
	          slider.pausePlay.bind(eventType, function(event) {
	            event.preventDefault();
	
	            if (watchedEvent === "" || watchedEvent === event.type) {
	              if ($(this).hasClass(namespace + 'pause')) {
	                slider.manualPause = true;
	                slider.manualPlay = false;
	                slider.pause();
	              } else {
	                slider.manualPause = false;
	                slider.manualPlay = true;
	                slider.play();
	              }
	            }
	
	            // setup flags to prevent event duplication
	            if (watchedEvent === "") {
	              watchedEvent = event.type;
	            }
	            methods.setToClearWatchedEvent();
	          });
	        },
	        update: function(state) {
	          (state === "play") ? slider.pausePlay.removeClass(namespace + 'pause').addClass(namespace + 'play').html(slider.vars.playText) : slider.pausePlay.removeClass(namespace + 'play').addClass(namespace + 'pause').html(slider.vars.pauseText);
	        }
	      },
	      touch: function() {
	        var startX,
	          startY,
	          offset,
	          cwidth,
	          dx,
	          startT,
	          onTouchStart,
	          onTouchMove,
	          onTouchEnd,
	          scrolling = false,
	          localX = 0,
	          localY = 0,
	          accDx = 0;
	
	        if(!msGesture){
	            onTouchStart = function(e) {
	              if (slider.animating) {
	                e.preventDefault();
	              } else if ( ( window.navigator.msPointerEnabled ) || e.touches.length === 1 ) {
	                slider.pause();
	                // CAROUSEL:
	                cwidth = (vertical) ? slider.h : slider. w;
	                startT = Number(new Date());
	                // CAROUSEL:
	
	                // Local vars for X and Y points.
	                localX = e.touches[0].pageX;
	                localY = e.touches[0].pageY;
	
	                offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
	                         (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
	                         (carousel && slider.currentSlide === slider.last) ? slider.limit :
	                         (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
	                         (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
	                startX = (vertical) ? localY : localX;
	                startY = (vertical) ? localX : localY;
	                el.addEventListener('touchmove', onTouchMove, false);
	                el.addEventListener('touchend', onTouchEnd, false);
	              }
	            };
	
	            onTouchMove = function(e) {
	              // Local vars for X and Y points.
	
	              localX = e.touches[0].pageX;
	              localY = e.touches[0].pageY;
	
	              dx = (vertical) ? startX - localY : (slider.vars.rtl?-1:1)*(startX - localX);
	              scrolling = (vertical) ? (Math.abs(dx) < Math.abs(localX - startY)) : (Math.abs(dx) < Math.abs(localY - startY));
	              var fxms = 500;
	
	              if ( ! scrolling || Number( new Date() ) - startT > fxms ) {
	                e.preventDefault();
	                if (!fade && slider.transitions) {
	                  if (!slider.vars.animationLoop) {
	                    dx = dx/((slider.currentSlide === 0 && dx < 0 || slider.currentSlide === slider.last && dx > 0) ? (Math.abs(dx)/cwidth+2) : 1);
	                  }
	                  slider.setProps(offset + dx, "setTouch");
	                }
	              }
	            };
	
	            onTouchEnd = function(e) {
	              // finish the touch by undoing the touch session
	              el.removeEventListener('touchmove', onTouchMove, false);
	
	              if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
	                var updateDx = (reverse) ? -dx : dx,
	                    target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');
	
	                if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
	                  slider.flexAnimate(target, slider.vars.pauseOnAction);
	                } else {
	                  if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
	                }
	              }
	              el.removeEventListener('touchend', onTouchEnd, false);
	
	              startX = null;
	              startY = null;
	              dx = null;
	              offset = null;
	            };
	
	            el.addEventListener('touchstart', onTouchStart, false);
	        }else{
	            el.style.msTouchAction = "none";
	            el._gesture = new MSGesture();
	            el._gesture.target = el;
	            el.addEventListener("MSPointerDown", onMSPointerDown, false);
	            el._slider = slider;
	            el.addEventListener("MSGestureChange", onMSGestureChange, false);
	            el.addEventListener("MSGestureEnd", onMSGestureEnd, false);
	
	            function onMSPointerDown(e){
	                e.stopPropagation();
	                if (slider.animating) {
	                    e.preventDefault();
	                }else{
	                    slider.pause();
	                    el._gesture.addPointer(e.pointerId);
	                    accDx = 0;
	                    cwidth = (vertical) ? slider.h : slider. w;
	                    startT = Number(new Date());
	                    // CAROUSEL:
	
	                    offset = (carousel && reverse && slider.animatingTo === slider.last) ? 0 :
	                        (carousel && reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
	                            (carousel && slider.currentSlide === slider.last) ? slider.limit :
	                                (carousel) ? ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.currentSlide :
	                                    (reverse) ? (slider.last - slider.currentSlide + slider.cloneOffset) * cwidth : (slider.currentSlide + slider.cloneOffset) * cwidth;
	                }
	            }
	
	            function onMSGestureChange(e) {
	                e.stopPropagation();
	                var slider = e.target._slider;
	                if(!slider){
	                    return;
	                }
	                var transX = -e.translationX,
	                    transY = -e.translationY;
	
	                //Accumulate translations.
	                accDx = accDx + ((vertical) ? transY : transX);
	                dx = (slider.vars.rtl?-1:1)*accDx;
	                scrolling = (vertical) ? (Math.abs(accDx) < Math.abs(-transX)) : (Math.abs(accDx) < Math.abs(-transY));
	
	                if(e.detail === e.MSGESTURE_FLAG_INERTIA){
	                    setImmediate(function (){
	                        el._gesture.stop();
	                    });
	
	                    return;
	                }
	
	                if (!scrolling || Number(new Date()) - startT > 500) {
	                    e.preventDefault();
	                    if (!fade && slider.transitions) {
	                        if (!slider.vars.animationLoop) {
	                            dx = accDx / ((slider.currentSlide === 0 && accDx < 0 || slider.currentSlide === slider.last && accDx > 0) ? (Math.abs(accDx) / cwidth + 2) : 1);
	                        }
	                        slider.setProps(offset + dx, "setTouch");
	                    }
	                }
	            }
	
	            function onMSGestureEnd(e) {
	                e.stopPropagation();
	                var slider = e.target._slider;
	                if(!slider){
	                    return;
	                }
	                if (slider.animatingTo === slider.currentSlide && !scrolling && !(dx === null)) {
	                    var updateDx = (reverse) ? -dx : dx,
	                        target = (updateDx > 0) ? slider.getTarget('next') : slider.getTarget('prev');
	
	                    if (slider.canAdvance(target) && (Number(new Date()) - startT < 550 && Math.abs(updateDx) > 50 || Math.abs(updateDx) > cwidth/2)) {
	                        slider.flexAnimate(target, slider.vars.pauseOnAction);
	                    } else {
	                        if (!fade) { slider.flexAnimate(slider.currentSlide, slider.vars.pauseOnAction, true); }
	                    }
	                }
	
	                startX = null;
	                startY = null;
	                dx = null;
	                offset = null;
	                accDx = 0;
	            }
	        }
	      },
	      resize: function() {
	        if (!slider.animating && slider.is(':visible')) {
	          if (!carousel) { slider.doMath(); }
	
	          if (fade) {
	            // SMOOTH HEIGHT:
	            methods.smoothHeight();
	          } else if (carousel) { //CAROUSEL:
	            slider.slides.width(slider.computedW);
	            slider.update(slider.pagingCount);
	            slider.setProps();
	          }
	          else if (vertical) { //VERTICAL:
	            slider.viewport.height(slider.h);
	            slider.setProps(slider.h, "setTotal");
	          } else {
	            // SMOOTH HEIGHT:
	            if (slider.vars.smoothHeight) { methods.smoothHeight(); }
	            slider.newSlides.width(slider.computedW);
	            slider.setProps(slider.computedW, "setTotal");
	          }
	        }
	      },
	      smoothHeight: function(dur) {
	        if (!vertical || fade) {
	          var $obj = (fade) ? slider : slider.viewport;
	          (dur) ? $obj.animate({"height": slider.slides.eq(slider.animatingTo).innerHeight()}, dur) : $obj.innerHeight(slider.slides.eq(slider.animatingTo).innerHeight());
	        }
	      },
	      sync: function(action) {
	        var $obj = $(slider.vars.sync).data("flexslider"),
	            target = slider.animatingTo;
	
	        switch (action) {
	          case "animate": $obj.flexAnimate(target, slider.vars.pauseOnAction, false, true); break;
	          case "play": if (!$obj.playing && !$obj.asNav) { $obj.play(); } break;
	          case "pause": $obj.pause(); break;
	        }
	      },
	      uniqueID: function($clone) {
	        // Append _clone to current level and children elements with id attributes
	        $clone.filter( '[id]' ).add($clone.find( '[id]' )).each(function() {
	          var $this = $(this);
	          $this.attr( 'id', $this.attr( 'id' ) + '_clone' );
	        });
	        return $clone;
	      },
	      pauseInvisible: {
	        visProp: null,
	        init: function() {
	          var visProp = methods.pauseInvisible.getHiddenProp();
	          if (visProp) {
	            var evtname = visProp.replace(/[H|h]idden/,'') + 'visibilitychange';
	            document.addEventListener(evtname, function() {
	              if (methods.pauseInvisible.isHidden()) {
	                if(slider.startTimeout) {
	                  clearTimeout(slider.startTimeout); //If clock is ticking, stop timer and prevent from starting while invisible
	                } else {
	                  slider.pause(); //Or just pause
	                }
	              }
	              else {
	                if(slider.started) {
	                  slider.play(); //Initiated before, just play
	                } else {
	                  if (slider.vars.initDelay > 0) {
	                    setTimeout(slider.play, slider.vars.initDelay);
	                  } else {
	                    slider.play(); //Didn't init before: simply init or wait for it
	                  }
	                }
	              }
	            });
	          }
	        },
	        isHidden: function() {
	          var prop = methods.pauseInvisible.getHiddenProp();
	          if (!prop) {
	            return false;
	          }
	          return document[prop];
	        },
	        getHiddenProp: function() {
	          var prefixes = ['webkit','moz','ms','o'];
	          // if 'hidden' is natively supported just return it
	          if ('hidden' in document) {
	            return 'hidden';
	          }
	          // otherwise loop over all the known prefixes until we find one
	          for ( var i = 0; i < prefixes.length; i++ ) {
	              if ((prefixes[i] + 'Hidden') in document) {
	                return prefixes[i] + 'Hidden';
	              }
	          }
	          // otherwise it's not supported
	          return null;
	        }
	      },
	      setToClearWatchedEvent: function() {
	        clearTimeout(watchedEventClearTimer);
	        watchedEventClearTimer = setTimeout(function() {
	          watchedEvent = "";
	        }, 3000);
	      }
	    };
	
	    // public methods
	    slider.flexAnimate = function(target, pause, override, withSync, fromNav) {
	      if (!slider.vars.animationLoop && target !== slider.currentSlide) {
	        slider.direction = (target > slider.currentSlide) ? "next" : "prev";
	      }
	
	      if (asNav && slider.pagingCount === 1) slider.direction = (slider.currentItem < target) ? "next" : "prev";
	
	      if (!slider.animating && (slider.canAdvance(target, fromNav) || override) && slider.is(":visible")) {
	        if (asNav && withSync) {
	          var master = $(slider.vars.asNavFor).data('flexslider');
	          slider.atEnd = target === 0 || target === slider.count - 1;
	          master.flexAnimate(target, true, false, true, fromNav);
	          slider.direction = (slider.currentItem < target) ? "next" : "prev";
	          master.direction = slider.direction;
	
	          if (Math.ceil((target + 1)/slider.visible) - 1 !== slider.currentSlide && target !== 0) {
	            slider.currentItem = target;
	            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
	            target = Math.floor(target/slider.visible);
	          } else {
	            slider.currentItem = target;
	            slider.slides.removeClass(namespace + "active-slide").eq(target).addClass(namespace + "active-slide");
	            return false;
	          }
	        }
	
	        slider.animating = true;
	        slider.animatingTo = target;
	
	        // SLIDESHOW:
	        if (pause) { slider.pause(); }
	
	        // API: before() animation Callback
	        slider.vars.before(slider);
	
	        // SYNC:
	        if (slider.syncExists && !fromNav) { methods.sync("animate"); }
	
	        // CONTROLNAV
	        if (slider.vars.controlNav) { methods.controlNav.active(); }
	
	        // !CAROUSEL:
	        // CANDIDATE: slide active class (for add/remove slide)
	        if (!carousel) { slider.slides.removeClass(namespace + 'active-slide').eq(target).addClass(namespace + 'active-slide'); }
	
	        // INFINITE LOOP:
	        // CANDIDATE: atEnd
	        slider.atEnd = target === 0 || target === slider.last;
	
	        // DIRECTIONNAV:
	        if (slider.vars.directionNav) { methods.directionNav.update(); }
	
	        if (target === slider.last) {
	          // API: end() of cycle Callback
	          slider.vars.end(slider);
	          // SLIDESHOW && !INFINITE LOOP:
	          if (!slider.vars.animationLoop) { slider.pause(); }
	        }
	
	        // SLIDE:
	        if (!fade) {
	          var dimension = (vertical) ? slider.slides.filter(':first').height() : slider.computedW,
	              margin, slideString, calcNext;
	
	          // INFINITE LOOP / REVERSE:
	          if (carousel) {
	            margin = slider.vars.itemMargin;
	            calcNext = ((slider.itemW + margin) * slider.move) * slider.animatingTo;
	            slideString = (calcNext > slider.limit && slider.visible !== 1) ? slider.limit : calcNext;
	          } else if (slider.currentSlide === 0 && target === slider.count - 1 && slider.vars.animationLoop && slider.direction !== "next") {
	            slideString = (reverse) ? (slider.count + slider.cloneOffset) * dimension : 0;
	          } else if (slider.currentSlide === slider.last && target === 0 && slider.vars.animationLoop && slider.direction !== "prev") {
	            slideString = (reverse) ? 0 : (slider.count + 1) * dimension;
	          } else {
	            slideString = (reverse) ? ((slider.count - 1) - target + slider.cloneOffset) * dimension : (target + slider.cloneOffset) * dimension;
	          }
	          slider.setProps(slideString, "", slider.vars.animationSpeed);
	          if (slider.transitions) {
	            if (!slider.vars.animationLoop || !slider.atEnd) {
	              slider.animating = false;
	              slider.currentSlide = slider.animatingTo;
	            }
	
	            // Unbind previous transitionEnd events and re-bind new transitionEnd event
	            slider.container.unbind("webkitTransitionEnd transitionend");
	            slider.container.bind("webkitTransitionEnd transitionend", function() {
	              clearTimeout(slider.ensureAnimationEnd);
	              slider.wrapup(dimension);
	            });
	
	            // Insurance for the ever-so-fickle transitionEnd event
	            clearTimeout(slider.ensureAnimationEnd);
	            slider.ensureAnimationEnd = setTimeout(function() {
	              slider.wrapup(dimension);
	            }, slider.vars.animationSpeed + 100);
	
	          } else {
	            slider.container.animate(slider.args, slider.vars.animationSpeed, slider.vars.easing, function(){
	              slider.wrapup(dimension);
	            });
	          }
	        } else { // FADE:
	          if (!touch) {
	            slider.slides.eq(slider.currentSlide).css({"zIndex": 1}).animate({"opacity": 0}, slider.vars.animationSpeed, slider.vars.easing);
	            slider.slides.eq(target).css({"zIndex": 2}).animate({"opacity": 1}, slider.vars.animationSpeed, slider.vars.easing, slider.wrapup);
	          } else {
	            slider.slides.eq(slider.currentSlide).css({ "opacity": 0, "zIndex": 1 });
	            slider.slides.eq(target).css({ "opacity": 1, "zIndex": 2 });
	            slider.wrapup(dimension);
	          }
	        }
	        // SMOOTH HEIGHT:
	        if (slider.vars.smoothHeight) { methods.smoothHeight(slider.vars.animationSpeed); }
	      }
	    };
	    slider.wrapup = function(dimension) {
	      // SLIDE:
	      if (!fade && !carousel) {
	        if (slider.currentSlide === 0 && slider.animatingTo === slider.last && slider.vars.animationLoop) {
	          slider.setProps(dimension, "jumpEnd");
	        } else if (slider.currentSlide === slider.last && slider.animatingTo === 0 && slider.vars.animationLoop) {
	          slider.setProps(dimension, "jumpStart");
	        }
	      }
	      slider.animating = false;
	      slider.currentSlide = slider.animatingTo;
	      // API: after() animation Callback
	      slider.vars.after(slider);
	    };
	
	    // SLIDESHOW:
	    slider.animateSlides = function() {
	      if (!slider.animating && focused ) { slider.flexAnimate(slider.getTarget("next")); }
	    };
	    // SLIDESHOW:
	    slider.pause = function() {
	      clearInterval(slider.animatedSlides);
	      slider.animatedSlides = null;
	      slider.playing = false;
	      // PAUSEPLAY:
	      if (slider.vars.pausePlay) { methods.pausePlay.update("play"); }
	      // SYNC:
	      if (slider.syncExists) { methods.sync("pause"); }
	    };
	    // SLIDESHOW:
	    slider.play = function() {
	      if (slider.playing) { clearInterval(slider.animatedSlides); }
	      slider.animatedSlides = slider.animatedSlides || setInterval(slider.animateSlides, slider.vars.slideshowSpeed);
	      slider.started = slider.playing = true;
	      // PAUSEPLAY:
	      if (slider.vars.pausePlay) { methods.pausePlay.update("pause"); }
	      // SYNC:
	      if (slider.syncExists) { methods.sync("play"); }
	    };
	    // STOP:
	    slider.stop = function () {
	      slider.pause();
	      slider.stopped = true;
	    };
	    slider.canAdvance = function(target, fromNav) {
	      // ASNAV:
	      var last = (asNav) ? slider.pagingCount - 1 : slider.last;
	      return (fromNav) ? true :
	             (asNav && slider.currentItem === slider.count - 1 && target === 0 && slider.direction === "prev") ? true :
	             (asNav && slider.currentItem === 0 && target === slider.pagingCount - 1 && slider.direction !== "next") ? false :
	             (target === slider.currentSlide && !asNav) ? false :
	             (slider.vars.animationLoop) ? true :
	             (slider.atEnd && slider.currentSlide === 0 && target === last && slider.direction !== "next") ? false :
	             (slider.atEnd && slider.currentSlide === last && target === 0 && slider.direction === "next") ? false :
	             true;
	    };
	    slider.getTarget = function(dir) {
	      slider.direction = dir;
	      if (dir === "next") {
	        return (slider.currentSlide === slider.last) ? 0 : slider.currentSlide + 1;
	      } else {
	        return (slider.currentSlide === 0) ? slider.last : slider.currentSlide - 1;
	      }
	    };
	
	    // SLIDE:
	    slider.setProps = function(pos, special, dur) {
	      var target = (function() {
	        var posCheck = (pos) ? pos : ((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo,
	            posCalc = (function() {
	              if (carousel) {
	                return (special === "setTouch") ? pos :
	                       (reverse && slider.animatingTo === slider.last) ? 0 :
	                       (reverse) ? slider.limit - (((slider.itemW + slider.vars.itemMargin) * slider.move) * slider.animatingTo) :
	                       (slider.animatingTo === slider.last) ? slider.limit : posCheck;
	              } else {
	                switch (special) {
	                  case "setTotal": return (reverse) ? ((slider.count - 1) - slider.currentSlide + slider.cloneOffset) * pos : (slider.currentSlide + slider.cloneOffset) * pos;
	                  case "setTouch": return (reverse) ? pos : pos;
	                  case "jumpEnd": return (reverse) ? pos : slider.count * pos;
	                  case "jumpStart": return (reverse) ? slider.count * pos : pos;
	                  default: return pos;
	                }
	              }
	            }());
	
	            return (posCalc * ((slider.vars.rtl)?1:-1)) + "px";
	          }());
	
	      if (slider.transitions) {
	        if (slider.isFirefox) {
	          target = (vertical) ? "translate3d(0," + target + ",0)" : "translate3d(" + (parseInt(target)+'px') + ",0,0)";
	        } else {
	          target = (vertical) ? "translate3d(0," + target + ",0)" : "translate3d(" + ((slider.vars.rtl?-1:1)*parseInt(target)+'px') + ",0,0)";
	        }
	        dur = (dur !== undefined) ? (dur/1000) + "s" : "0s";
	        slider.container.css("-" + slider.pfx + "-transition-duration", dur);
	         slider.container.css("transition-duration", dur);
	      }
	
	      slider.args[slider.prop] = target;
	      if (slider.transitions || dur === undefined) { slider.container.css(slider.args); }
	
	      slider.container.css('transform',target);
	    };
	
	    slider.setup = function(type) {
	      // SLIDE:
	      if (!fade) {
	        var sliderOffset, arr;
	
	        if (type === "init") {
	          slider.viewport = $('<div class="' + namespace + 'viewport"></div>').css({"overflow": "hidden", "position": "relative"}).appendTo(slider).append(slider.container);
	          // INFINITE LOOP:
	          slider.cloneCount = 0;
	          slider.cloneOffset = 0;
	          // REVERSE:
	          if (reverse) {
	            arr = $.makeArray(slider.slides).reverse();
	            slider.slides = $(arr);
	            slider.container.empty().append(slider.slides);
	          }
	        }
	        // INFINITE LOOP && !CAROUSEL:
	        if (slider.vars.animationLoop && !carousel) {
	          slider.cloneCount = 2;
	          slider.cloneOffset = 1;
	          // clear out old clones
	          if (type !== "init") { slider.container.find('.clone').remove(); }
	          slider.container.append(methods.uniqueID(slider.slides.first().clone().addClass('clone')).attr('aria-hidden', 'true'))
	                          .prepend(methods.uniqueID(slider.slides.last().clone().addClass('clone')).attr('aria-hidden', 'true'));
	        }
	        slider.newSlides = $(slider.vars.selector, slider);
	
	        sliderOffset = (reverse) ? slider.count - 1 - slider.currentSlide + slider.cloneOffset : slider.currentSlide + slider.cloneOffset;
	        // VERTICAL:
	        if (vertical && !carousel) {
	          slider.container.height((slider.count + slider.cloneCount) * 200 + "%").css("position", "absolute").width("100%");
	          setTimeout(function(){
	            slider.newSlides.css({"display": "block"});
	            slider.doMath();
	            slider.viewport.height(slider.h);
	            slider.setProps(sliderOffset * slider.h, "init");
	          }, (type === "init") ? 100 : 0);
	        } else {
	          slider.container.width((slider.count + slider.cloneCount) * 200 + "%");
	          slider.setProps(sliderOffset * slider.computedW, "init");
	          setTimeout(function(){
	            slider.doMath();
	          if(slider.vars.rtl){
	            if (slider.isFirefox) {
	              slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "right", "display": "block"});
	            } else {
	              slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "left", "display": "block"});
	            }
	              
	           }
	            else{
	              slider.newSlides.css({"width": slider.computedW, "marginRight" : slider.computedM, "float": "left", "display": "block"});
	            }
	            // SMOOTH HEIGHT:
	            if (slider.vars.smoothHeight) { methods.smoothHeight(); }
	          }, (type === "init") ? 100 : 0);
	        }
	      } else { // FADE:
	        if(slider.vars.rtl){
	          slider.slides.css({"width": "100%", "float": 'right', "marginLeft": "-100%", "position": "relative"});
	        }
	        else{
	          slider.slides.css({"width": "100%", "float": 'left', "marginRight": "-100%", "position": "relative"});
	        }
	        if (type === "init") {
	          if (!touch) {
	            //slider.slides.eq(slider.currentSlide).fadeIn(slider.vars.animationSpeed, slider.vars.easing);
	            if (slider.vars.fadeFirstSlide == false) {
	              slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).css({"opacity": 1});
	            } else {
	              slider.slides.css({ "opacity": 0, "display": "block", "zIndex": 1 }).eq(slider.currentSlide).css({"zIndex": 2}).animate({"opacity": 1},slider.vars.animationSpeed,slider.vars.easing);
	            }
	          } else {
	            slider.slides.css({ "opacity": 0, "display": "block", "webkitTransition": "opacity " + slider.vars.animationSpeed / 1000 + "s ease", "zIndex": 1 }).eq(slider.currentSlide).css({ "opacity": 1, "zIndex": 2});
	          }
	        }
	        // SMOOTH HEIGHT:
	        if (slider.vars.smoothHeight) { methods.smoothHeight(); }
	      }
	      // !CAROUSEL:
	      // CANDIDATE: active slide
	      if (!carousel) { slider.slides.removeClass(namespace + "active-slide").eq(slider.currentSlide).addClass(namespace + "active-slide"); }
	
	      //FlexSlider: init() Callback
	      slider.vars.init(slider);
	    };
	
	    slider.doMath = function() {
	      var slide = slider.slides.first(),
	          slideMargin = slider.vars.itemMargin,
	          minItems = slider.vars.minItems,
	          maxItems = slider.vars.maxItems;
	
	      slider.w = (slider.viewport===undefined) ? slider.width() : slider.viewport.width();
	      if (slider.isFirefox) { slider.w = slider.width(); }
	      slider.h = slide.height();
	      slider.boxPadding = slide.outerWidth() - slide.width();
	
	      // CAROUSEL:
	      if (carousel) {
	        slider.itemT = slider.vars.itemWidth + slideMargin;
	        slider.itemM = slideMargin;
	        slider.minW = (minItems) ? minItems * slider.itemT : slider.w;
	        slider.maxW = (maxItems) ? (maxItems * slider.itemT) - slideMargin : slider.w;
	        slider.itemW = (slider.minW > slider.w) ? (slider.w - (slideMargin * (minItems - 1)))/minItems :
	                       (slider.maxW < slider.w) ? (slider.w - (slideMargin * (maxItems - 1)))/maxItems :
	                       (slider.vars.itemWidth > slider.w) ? slider.w : slider.vars.itemWidth;
	
	        slider.visible = Math.floor(slider.w/(slider.itemW));
	        slider.move = (slider.vars.move > 0 && slider.vars.move < slider.visible ) ? slider.vars.move : slider.visible;
	        slider.pagingCount = Math.ceil(((slider.count - slider.visible)/slider.move) + 1);
	        slider.last =  slider.pagingCount - 1;
	        slider.limit = (slider.pagingCount === 1) ? 0 :
	                       (slider.vars.itemWidth > slider.w) ? (slider.itemW * (slider.count - 1)) + (slideMargin * (slider.count - 1)) : ((slider.itemW + slideMargin) * slider.count) - slider.w - slideMargin;
	      } else {
	        slider.itemW = slider.w;
	        slider.itemM = slideMargin;
	        slider.pagingCount = slider.count;
	        slider.last = slider.count - 1;
	      }
	      slider.computedW = slider.itemW - slider.boxPadding;
	      slider.computedM = slider.itemM;
	    };
	
	    slider.update = function(pos, action) {
	      slider.doMath();
	
	      // update currentSlide and slider.animatingTo if necessary
	      if (!carousel) {
	        if (pos < slider.currentSlide) {
	          slider.currentSlide += 1;
	        } else if (pos <= slider.currentSlide && pos !== 0) {
	          slider.currentSlide -= 1;
	        }
	        slider.animatingTo = slider.currentSlide;
	      }
	
	      // update controlNav
	      if (slider.vars.controlNav && !slider.manualControls) {
	        if ((action === "add" && !carousel) || slider.pagingCount > slider.controlNav.length) {
	          methods.controlNav.update("add");
	        } else if ((action === "remove" && !carousel) || slider.pagingCount < slider.controlNav.length) {
	          if (carousel && slider.currentSlide > slider.last) {
	            slider.currentSlide -= 1;
	            slider.animatingTo -= 1;
	          }
	          methods.controlNav.update("remove", slider.last);
	        }
	      }
	      // update directionNav
	      if (slider.vars.directionNav) { methods.directionNav.update(); }
	
	    };
	
	    slider.addSlide = function(obj, pos) {
	      var $obj = $(obj);
	
	      slider.count += 1;
	      slider.last = slider.count - 1;
	
	      // append new slide
	      if (vertical && reverse) {
	        (pos !== undefined) ? slider.slides.eq(slider.count - pos).after($obj) : slider.container.prepend($obj);
	      } else {
	        (pos !== undefined) ? slider.slides.eq(pos).before($obj) : slider.container.append($obj);
	      }
	
	      // update currentSlide, animatingTo, controlNav, and directionNav
	      slider.update(pos, "add");
	
	      // update slider.slides
	      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
	      // re-setup the slider to accomdate new slide
	      slider.setup();
	
	      //FlexSlider: added() Callback
	      slider.vars.added(slider);
	    };
	    slider.removeSlide = function(obj) {
	      var pos = (isNaN(obj)) ? slider.slides.index($(obj)) : obj;
	
	      // update count
	      slider.count -= 1;
	      slider.last = slider.count - 1;
	
	      // remove slide
	      if (isNaN(obj)) {
	        $(obj, slider.slides).remove();
	      } else {
	        (vertical && reverse) ? slider.slides.eq(slider.last).remove() : slider.slides.eq(obj).remove();
	      }
	
	      // update currentSlide, animatingTo, controlNav, and directionNav
	      slider.doMath();
	      slider.update(pos, "remove");
	
	      // update slider.slides
	      slider.slides = $(slider.vars.selector + ':not(.clone)', slider);
	      // re-setup the slider to accomdate new slide
	      slider.setup();
	
	      // FlexSlider: removed() Callback
	      slider.vars.removed(slider);
	    };
	
	    //FlexSlider: Initialize
	    methods.init();
	  };
	
	  // Ensure the slider isn't focussed if the window loses focus.
	  $( window ).blur( function ( e ) {
	    focused = false;
	  }).focus( function ( e ) {
	    focused = true;
	  });
	
	  //FlexSlider: Default Settings
	  $.flexslider.defaults = {
	    namespace: "flex-",             //{NEW} String: Prefix string attached to the class of every element generated by the plugin
	    selector: ".slides > li",       //{NEW} Selector: Must match a simple pattern. '{container} > {slide}' -- Ignore pattern at your own peril
	    animation: "fade",              //String: Select your animation type, "fade" or "slide"
	    easing: "swing",                //{NEW} String: Determines the easing method used in jQuery transitions. jQuery easing plugin is supported!
	    direction: "horizontal",        //String: Select the sliding direction, "horizontal" or "vertical"
	    reverse: false,                 //{NEW} Boolean: Reverse the animation direction
	    animationLoop: true,            //Boolean: Should the animation loop? If false, directionNav will received "disable" classes at either end
	    smoothHeight: false,            //{NEW} Boolean: Allow height of the slider to animate smoothly in horizontal mode
	    startAt: 0,                     //Integer: The slide that the slider should start on. Array notation (0 = first slide)
	    slideshow: true,                //Boolean: Animate slider automatically
	    slideshowSpeed: 7000,           //Integer: Set the speed of the slideshow cycling, in milliseconds
	    animationSpeed: 600,            //Integer: Set the speed of animations, in milliseconds
	    initDelay: 0,                   //{NEW} Integer: Set an initialization delay, in milliseconds
	    randomize: false,               //Boolean: Randomize slide order
	    fadeFirstSlide: true,           //Boolean: Fade in the first slide when animation type is "fade"
	    thumbCaptions: false,           //Boolean: Whether or not to put captions on thumbnails when using the "thumbnails" controlNav.
	
	    // Usability features
	    pauseOnAction: true,            //Boolean: Pause the slideshow when interacting with control elements, highly recommended.
	    pauseOnHover: false,            //Boolean: Pause the slideshow when hovering over slider, then resume when no longer hovering
	    pauseInvisible: true,       //{NEW} Boolean: Pause the slideshow when tab is invisible, resume when visible. Provides better UX, lower CPU usage.
	    useCSS: true,                   //{NEW} Boolean: Slider will use CSS3 transitions if available
	    touch: true,                    //{NEW} Boolean: Allow touch swipe navigation of the slider on touch-enabled devices
	    video: false,                   //{NEW} Boolean: If using video in the slider, will prevent CSS3 3D Transforms to avoid graphical glitches
	
	    // Primary Controls
	    controlNav: true,               //Boolean: Create navigation for paging control of each slide? Note: Leave true for manualControls usage
	    directionNav: true,             //Boolean: Create navigation for previous/next navigation? (true/false)
	    prevText: "Previous",           //String: Set the text for the "previous" directionNav item
	    nextText: "Next",               //String: Set the text for the "next" directionNav item
	
	    // Secondary Navigation
	    keyboard: true,                 //Boolean: Allow slider navigating via keyboard left/right keys
	    multipleKeyboard: false,        //{NEW} Boolean: Allow keyboard navigation to affect multiple sliders. Default behavior cuts out keyboard navigation with more than one slider present.
	    mousewheel: false,              //{UPDATED} Boolean: Requires jquery.mousewheel.js (https://github.com/brandonaaron/jquery-mousewheel) - Allows slider navigating via mousewheel
	    pausePlay: false,               //Boolean: Create pause/play dynamic element
	    pauseText: "Pause",             //String: Set the text for the "pause" pausePlay item
	    playText: "Play",               //String: Set the text for the "play" pausePlay item
	
	    // Special properties
	    controlsContainer: "",          //{UPDATED} jQuery Object/Selector: Declare which container the navigation elements should be appended too. Default container is the FlexSlider element. Example use would be $(".flexslider-container"). Property is ignored if given element is not found.
	    manualControls: "",             //{UPDATED} jQuery Object/Selector: Declare custom control navigation. Examples would be $(".flex-control-nav li") or "#tabs-nav li img", etc. The number of elements in your controlNav should match the number of slides/tabs.
	    customDirectionNav: "",         //{NEW} jQuery Object/Selector: Custom prev / next button. Must be two jQuery elements. In order to make the events work they have to have the classes "prev" and "next" (plus namespace)
	    sync: "",                       //{NEW} Selector: Mirror the actions performed on this slider with another slider. Use with care.
	    asNavFor: "",                   //{NEW} Selector: Internal property exposed for turning the slider into a thumbnail navigation for another slider
	
	    // Carousel Options
	    itemWidth: 0,                   //{NEW} Integer: Box-model width of individual carousel items, including horizontal borders and padding.
	    itemMargin: 0,                  //{NEW} Integer: Margin between carousel items.
	    minItems: 1,                    //{NEW} Integer: Minimum number of carousel items that should be visible. Items will resize fluidly when below this.
	    maxItems: 0,                    //{NEW} Integer: Maxmimum number of carousel items that should be visible. Items will resize fluidly when above this limit.
	    move: 0,                        //{NEW} Integer: Number of carousel items that should move on animation. If 0, slider will move all visible items.
	    allowOneSlide: true,           //{NEW} Boolean: Whether or not to allow a slider comprised of a single slide
	
	    // Browser Specific
	    isFirefox: false,             // {NEW} Boolean: Set to true when Firefox is the browser used.
	
	    // Callback API
	    start: function(){},            //Callback: function(slider) - Fires when the slider loads the first slide
	    before: function(){},           //Callback: function(slider) - Fires asynchronously with each slider animation
	    after: function(){},            //Callback: function(slider) - Fires after each slider animation completes
	    end: function(){},              //Callback: function(slider) - Fires when the slider reaches the last slide (asynchronous)
	    added: function(){},            //{NEW} Callback: function(slider) - Fires after a slide is added
	    removed: function(){},           //{NEW} Callback: function(slider) - Fires after a slide is removed
	    init: function() {},             //{NEW} Callback: function(slider) - Fires after the slider is initially setup
	  rtl: false             //{NEW} Boolean: Whether or not to enable RTL mode
	  };
	
	  //FlexSlider: Plugin Function
	  $.fn.flexslider = function(options) {
	    if (options === undefined) { options = {}; }
	
	    if (typeof options === "object") {
	      return this.each(function() {
	        var $this = $(this),
	            selector = (options.selector) ? options.selector : ".slides > li",
	            $slides = $this.find(selector);
	
	      if ( ( $slides.length === 1 && options.allowOneSlide === false ) || $slides.length === 0 ) {
	          $slides.fadeIn(400);
	          if (options.start) { options.start($this); }
	        } else if ($this.data('flexslider') === undefined) {
	          new $.flexslider(this, options);
	        }
	      });
	    } else {
	      // Helper strings to quickly perform functions on the slider
	      var $slider = $(this).data('flexslider');
	      switch (options) {
	        case "play": $slider.play(); break;
	        case "pause": $slider.pause(); break;
	        case "stop": $slider.stop(); break;
	        case "next": $slider.flexAnimate($slider.getTarget("next"), true); break;
	        case "prev":
	        case "previous": $slider.flexAnimate($slider.getTarget("prev"), true); break;
	        default: if (typeof options === "number") { $slider.flexAnimate(options, true); }
	      }
	    }
	  };
	})(jQuery);
	
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(/*! ./../timers-browserify/main.js */ 2062).setImmediate))

/***/ }),

/***/ 1530:
/*!**********************************************!*\
  !*** ./~/guillotine/js/jquery.guillotine.js ***!
  \**********************************************/
/***/ (function(module, exports) {

	// Generated by CoffeeScript 1.8.0
	
	/*
	 * jQuery Guillotine Plugin v1.3.1
	 * http://matiasgagliano.github.com/guillotine/
	 *
	 * Copyright 2014, Matías Gagliano.
	 * Dual licensed under the MIT or GPLv3 licenses.
	 * http://opensource.org/licenses/MIT
	 * http://opensource.org/licenses/GPL-3.0
	 *
	 */
	
	(function() {
	  "use strict";
	  var $, Guillotine, canTransform, defaults, events, getPointerPosition, hardwareAccelerate, isTouch, pluginName, scope, touchRegExp, validEvent, whitelist,
	    __bind = function(fn, me){ return function(){ return fn.apply(me, arguments); }; },
	    __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };
	
	  $ = jQuery;
	
	  pluginName = 'guillotine';
	
	  scope = 'guillotine';
	
	  events = {
	    start: "touchstart." + scope + " mousedown." + scope,
	    move: "touchmove." + scope + " mousemove." + scope,
	    stop: "touchend." + scope + " mouseup." + scope
	  };
	
	  defaults = {
	    width: 400,
	    height: 300,
	    zoomStep: 0.1,
	    init: null,
	    eventOnChange: null,
	    onChange: null
	  };
	
	  touchRegExp = /touch/i;
	
	  isTouch = function(e) {
	    return touchRegExp.test(e.type);
	  };
	
	  validEvent = function(e) {
	    if (isTouch(e)) {
	      return e.originalEvent.changedTouches.length === 1;
	    } else {
	      return e.which === 1;
	    }
	  };
	
	  getPointerPosition = function(e) {
	    if (isTouch(e)) {
	      e = e.originalEvent.touches[0];
	    }
	    return {
	      x: e.pageX,
	      y: e.pageY
	    };
	  };
	
	  canTransform = function() {
	    var hasTransform, helper, prefix, prefixes, prop, test, tests, value, _i, _len;
	    hasTransform = false;
	    prefixes = ['webkit', 'Moz', 'O', 'ms', 'Khtml'];
	    tests = {
	      transform: 'transform'
	    };
	    for (_i = 0, _len = prefixes.length; _i < _len; _i++) {
	      prefix = prefixes[_i];
	      tests[prefix + 'Transform'] = '-' + prefix.toLowerCase() + '-transform';
	    }
	    helper = document.createElement('img');
	    document.body.insertBefore(helper, null);
	    for (test in tests) {
	      prop = tests[test];
	      if (helper.style[test] === void 0) {
	        continue;
	      }
	      helper.style[test] = 'rotate(90deg)';
	      value = window.getComputedStyle(helper).getPropertyValue(prop);
	      if ((value != null) && value.length && value !== 'none') {
	        hasTransform = true;
	        break;
	      }
	    }
	    document.body.removeChild(helper);
	    canTransform = hasTransform ? (function() {
	      return true;
	    }) : (function() {
	      return false;
	    });
	    return canTransform();
	  };
	
	  hardwareAccelerate = function(el) {
	    return $(el).css({
	      '-webkit-perspective': 1000,
	      'perspective': 1000,
	      '-webkit-backface-visibility': 'hidden',
	      'backface-visibility': 'hidden'
	    });
	  };
	
	  Guillotine = (function() {
	    function Guillotine(element, options) {
	      this._drag = __bind(this._drag, this);
	      this._unbind = __bind(this._unbind, this);
	      this._start = __bind(this._start, this);
	      this.op = $.extend(true, {}, defaults, options, $(element).data(pluginName));
	      this.enabled = true;
	      this.zoomInFactor = 1 + this.op.zoomStep;
	      this.zoomOutFactor = 1 / this.zoomInFactor;
	      this.glltRatio = this.op.height / this.op.width;
	      this.width = this.height = this.left = this.top = this.angle = 0;
	      this.data = {
	        scale: 1,
	        angle: 0,
	        x: 0,
	        y: 0,
	        w: this.op.width,
	        h: this.op.height
	      };
	      this._wrap(element);
	      if (this.op.init != null) {
	        this._init();
	      }
	      if (this.width < 1 || this.height < 1) {
	        this._fit() && this._center();
	      }
	      hardwareAccelerate(this.$el);
	      this.$el.on(events.start, this._start);
	    }
	
	    Guillotine.prototype._wrap = function(element) {
	      var canvas, el, guillotine, height, paddingTop, width;
	      el = $(element);
	      if (element.tagName === 'IMG') {
	        if (element.naturalWidth) {
	          width = element.naturalWidth;
	          height = element.naturalHeight;
	        } else {
	          el.addClass('guillotine-sample');
	          width = el.width();
	          height = el.height();
	          el.removeClass('guillotine-sample');
	        }
	      } else {
	        width = el.width();
	        height = el.height();
	      }
	      this.width = width / this.op.width;
	      this.height = height / this.op.height;
	      canvas = $('<div>').addClass('guillotine-canvas');
	      canvas.css({
	        width: this.width * 100 + '%',
	        height: this.height * 100 + '%',
	        top: 0,
	        left: 0
	      });
	      canvas = el.wrap(canvas).parent();
	      paddingTop = this.op.height / this.op.width * 100 + '%';
	      guillotine = $('<div>').addClass('guillotine-window');
	      guillotine.css({
	        width: '100%',
	        height: 'auto',
	        'padding-top': paddingTop
	      });
	      guillotine = canvas.wrap(guillotine).parent();
	      this.$el = el;
	      this.el = el[0];
	      this.$canvas = canvas;
	      this.canvas = canvas[0];
	      this.$gllt = guillotine;
	      this.gllt = guillotine[0];
	      this.$document = $(element.ownerDocument);
	      return this.$body = $('body', this.$document);
	    };
	
	    Guillotine.prototype._unwrap = function() {
	      this.$el.removeAttr('style');
	      this.$el.insertBefore(this.gllt);
	      return this.$gllt.remove();
	    };
	
	    Guillotine.prototype._init = function() {
	      var angle, o, scale;
	      o = this.op.init;
	      if ((scale = parseFloat(o.scale))) {
	        this._zoom(scale);
	      }
	      if ((angle = parseInt(o.angle))) {
	        this._rotate(angle);
	      }
	      return this._offset(parseInt(o.x) / this.op.width || 0, parseInt(o.y) / this.op.height || 0);
	    };
	
	    Guillotine.prototype._start = function(e) {
	      if (!(this.enabled && validEvent(e))) {
	        return;
	      }
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      this.p = getPointerPosition(e);
	      return this._bind();
	    };
	
	    Guillotine.prototype._bind = function() {
	      this.$body.addClass('guillotine-dragging');
	      this.$document.on(events.move, this._drag);
	      return this.$document.on(events.stop, this._unbind);
	    };
	
	    Guillotine.prototype._unbind = function(e) {
	      this.$body.removeClass('guillotine-dragging');
	      this.$document.off(events.move, this._drag);
	      this.$document.off(events.stop, this._unbind);
	      if (e != null) {
	        return this._trigger('drag');
	      }
	    };
	
	    Guillotine.prototype._trigger = function(action) {
	      if (this.op.eventOnChange != null) {
	        this.$el.trigger(this.op.eventOnChange, [this.data, action]);
	      }
	      if (typeof this.op.onChange === 'function') {
	        return this.op.onChange.call(this.el, this.data, action);
	      }
	    };
	
	    Guillotine.prototype._drag = function(e) {
	      var dx, dy, left, p, top;
	      e.preventDefault();
	      e.stopImmediatePropagation();
	      p = getPointerPosition(e);
	      dx = p.x - this.p.x;
	      dy = p.y - this.p.y;
	      this.p = p;
	      left = dx === 0 ? null : this.left - dx / this.gllt.clientWidth;
	      top = dy === 0 ? null : this.top - dy / this.gllt.clientHeight;
	      return this._offset(left, top);
	    };
	
	    Guillotine.prototype._offset = function(left, top) {
	      if (left || left === 0) {
	        if (left < 0) {
	          left = 0;
	        }
	        if (left > this.width - 1) {
	          left = this.width - 1;
	        }
	        this.canvas.style.left = (-left * 100).toFixed(2) + '%';
	        this.left = left;
	        this.data.x = Math.round(left * this.op.width);
	      }
	      if (top || top === 0) {
	        if (top < 0) {
	          top = 0;
	        }
	        if (top > this.height - 1) {
	          top = this.height - 1;
	        }
	        this.canvas.style.top = (-top * 100).toFixed(2) + '%';
	        this.top = top;
	        return this.data.y = Math.round(top * this.op.height);
	      }
	    };
	
	    Guillotine.prototype._zoom = function(factor) {
	      var h, left, top, w;
	      if (factor <= 0 || factor === 1) {
	        return;
	      }
	      w = this.width;
	      h = this.height;
	      if (w * factor > 1 && h * factor > 1) {
	        this.width *= factor;
	        this.height *= factor;
	        this.canvas.style.width = (this.width * 100).toFixed(2) + '%';
	        this.canvas.style.height = (this.height * 100).toFixed(2) + '%';
	        this.data.scale *= factor;
	      } else {
	        this._fit();
	        factor = this.width / w;
	      }
	      left = (this.left + 0.5) * factor - 0.5;
	      top = (this.top + 0.5) * factor - 0.5;
	      return this._offset(left, top);
	    };
	
	    Guillotine.prototype._fit = function() {
	      var prevWidth, relativeRatio;
	      prevWidth = this.width;
	      relativeRatio = this.height / this.width;
	      if (relativeRatio > 1) {
	        this.width = 1;
	        this.height = relativeRatio;
	      } else {
	        this.width = 1 / relativeRatio;
	        this.height = 1;
	      }
	      this.canvas.style.width = (this.width * 100).toFixed(2) + '%';
	      this.canvas.style.height = (this.height * 100).toFixed(2) + '%';
	      return this.data.scale *= this.width / prevWidth;
	    };
	
	    Guillotine.prototype._center = function() {
	      return this._offset((this.width - 1) / 2, (this.height - 1) / 2);
	    };
	
	    Guillotine.prototype._rotate = function(angle) {
	      var canvasRatio, glltRatio, h, w, _ref, _ref1, _ref2;
	      if (!canTransform()) {
	        return;
	      }
	      if (!(angle !== 0 && angle % 90 === 0)) {
	        return;
	      }
	      this.angle = (this.angle + angle) % 360;
	      if (this.angle < 0) {
	        this.angle = 360 + this.angle;
	      }
	      if (angle % 180 !== 0) {
	        glltRatio = this.op.height / this.op.width;
	        _ref = [this.height * glltRatio, this.width / glltRatio], this.width = _ref[0], this.height = _ref[1];
	        if (this.width >= 1 && this.height >= 1) {
	          this.canvas.style.width = this.width * 100 + '%';
	          this.canvas.style.height = this.height * 100 + '%';
	        } else {
	          this._fit();
	        }
	      }
	      _ref1 = [1, 1], w = _ref1[0], h = _ref1[1];
	      if (this.angle % 180 !== 0) {
	        canvasRatio = this.height / this.width * glltRatio;
	        _ref2 = [canvasRatio, 1 / canvasRatio], w = _ref2[0], h = _ref2[1];
	      }
	      this.el.style.width = w * 100 + '%';
	      this.el.style.height = h * 100 + '%';
	      this.el.style.left = (1 - w) / 2 * 100 + '%';
	      this.el.style.top = (1 - h) / 2 * 100 + '%';
	      this.$el.css({
	        transform: "rotate(" + this.angle + "deg)"
	      });
	      this._center();
	      return this.data.angle = this.angle;
	    };
	
	    Guillotine.prototype.rotateLeft = function() {
	      return this.enabled && (this._rotate(-90), this._trigger('rotateLeft'));
	    };
	
	    Guillotine.prototype.rotateRight = function() {
	      return this.enabled && (this._rotate(90), this._trigger('rotateRight'));
	    };
	
	    Guillotine.prototype.center = function() {
	      return this.enabled && (this._center(), this._trigger('center'));
	    };
	
	    Guillotine.prototype.fit = function() {
	      return this.enabled && (this._fit(), this._center(), this._trigger('fit'));
	    };
	
	    Guillotine.prototype.zoomIn = function() {
	      return this.enabled && (this._zoom(this.zoomInFactor), this._trigger('zoomIn'));
	    };
	
	    Guillotine.prototype.zoomOut = function() {
	      return this.enabled && (this._zoom(this.zoomOutFactor), this._trigger('zoomOut'));
	    };
	
	    Guillotine.prototype.getData = function() {
	      return this.data;
	    };
	
	    Guillotine.prototype.enable = function() {
	      return this.enabled = true;
	    };
	
	    Guillotine.prototype.disable = function() {
	      return this.enabled = false;
	    };
	
	    Guillotine.prototype.remove = function() {
	      this._unbind();
	      this._unwrap();
	      this.disable();
	      this.$el.off(events.start, this._start);
	      return this.$el.removeData(pluginName + 'Instance');
	    };
	
	    return Guillotine;
	
	  })();
	
	  whitelist = ['rotateLeft', 'rotateRight', 'center', 'fit', 'zoomIn', 'zoomOut', 'instance', 'getData', 'enable', 'disable', 'remove'];
	
	  $.fn[pluginName] = function(options) {
	    if (typeof options !== 'string') {
	      return this.each(function() {
	        var guillotine;
	        if (!$.data(this, pluginName + 'Instance')) {
	          guillotine = new Guillotine(this, options);
	          return $.data(this, pluginName + 'Instance', guillotine);
	        }
	      });
	    } else if (__indexOf.call(whitelist, options) >= 0) {
	      if (options === 'instance') {
	        return $.data(this[0], pluginName + 'Instance');
	      }
	      if (options === 'getData') {
	        return $.data(this[0], pluginName + 'Instance')[options]();
	      }
	      return this.each(function() {
	        var guillotine;
	        guillotine = $.data(this, pluginName + 'Instance');
	        if (guillotine) {
	          return guillotine[options]();
	        }
	      });
	    }
	  };
	
	}).call(this);


/***/ }),

/***/ 93:
/*!**************************************!*\
  !*** ./~/js-cookie/src/js.cookie.js ***!
  \**************************************/
/***/ (function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	 * JavaScript Cookie v2.2.1
	 * https://github.com/js-cookie/js-cookie
	 *
	 * Copyright 2006, 2015 Klaus Hartl & Fagner Brack
	 * Released under the MIT license
	 */
	;(function (factory) {
		var registeredInModuleLoader;
		if (true) {
			!(__WEBPACK_AMD_DEFINE_FACTORY__ = (factory), __WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ? (__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) : __WEBPACK_AMD_DEFINE_FACTORY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
			registeredInModuleLoader = true;
		}
		if (true) {
			module.exports = factory();
			registeredInModuleLoader = true;
		}
		if (!registeredInModuleLoader) {
			var OldCookies = window.Cookies;
			var api = window.Cookies = factory();
			api.noConflict = function () {
				window.Cookies = OldCookies;
				return api;
			};
		}
	}(function () {
		function extend () {
			var i = 0;
			var result = {};
			for (; i < arguments.length; i++) {
				var attributes = arguments[ i ];
				for (var key in attributes) {
					result[key] = attributes[key];
				}
			}
			return result;
		}
	
		function decode (s) {
			return s.replace(/(%[0-9A-Z]{2})+/g, decodeURIComponent);
		}
	
		function init (converter) {
			function api() {}
	
			function set (key, value, attributes) {
				if (typeof document === 'undefined') {
					return;
				}
	
				attributes = extend({
					path: '/'
				}, api.defaults, attributes);
	
				if (typeof attributes.expires === 'number') {
					attributes.expires = new Date(new Date() * 1 + attributes.expires * 864e+5);
				}
	
				// We're using "expires" because "max-age" is not supported by IE
				attributes.expires = attributes.expires ? attributes.expires.toUTCString() : '';
	
				try {
					var result = JSON.stringify(value);
					if (/^[\{\[]/.test(result)) {
						value = result;
					}
				} catch (e) {}
	
				value = converter.write ?
					converter.write(value, key) :
					encodeURIComponent(String(value))
						.replace(/%(23|24|26|2B|3A|3C|3E|3D|2F|3F|40|5B|5D|5E|60|7B|7D|7C)/g, decodeURIComponent);
	
				key = encodeURIComponent(String(key))
					.replace(/%(23|24|26|2B|5E|60|7C)/g, decodeURIComponent)
					.replace(/[\(\)]/g, escape);
	
				var stringifiedAttributes = '';
				for (var attributeName in attributes) {
					if (!attributes[attributeName]) {
						continue;
					}
					stringifiedAttributes += '; ' + attributeName;
					if (attributes[attributeName] === true) {
						continue;
					}
	
					// Considers RFC 6265 section 5.2:
					// ...
					// 3.  If the remaining unparsed-attributes contains a %x3B (";")
					//     character:
					// Consume the characters of the unparsed-attributes up to,
					// not including, the first %x3B (";") character.
					// ...
					stringifiedAttributes += '=' + attributes[attributeName].split(';')[0];
				}
	
				return (document.cookie = key + '=' + value + stringifiedAttributes);
			}
	
			function get (key, json) {
				if (typeof document === 'undefined') {
					return;
				}
	
				var jar = {};
				// To prevent the for loop in the first place assign an empty array
				// in case there are no cookies at all.
				var cookies = document.cookie ? document.cookie.split('; ') : [];
				var i = 0;
	
				for (; i < cookies.length; i++) {
					var parts = cookies[i].split('=');
					var cookie = parts.slice(1).join('=');
	
					if (!json && cookie.charAt(0) === '"') {
						cookie = cookie.slice(1, -1);
					}
	
					try {
						var name = decode(parts[0]);
						cookie = (converter.read || converter)(cookie, name) ||
							decode(cookie);
	
						if (json) {
							try {
								cookie = JSON.parse(cookie);
							} catch (e) {}
						}
	
						jar[name] = cookie;
	
						if (key === name) {
							break;
						}
					} catch (e) {}
				}
	
				return key ? jar[key] : jar;
			}
	
			api.set = set;
			api.get = function (key) {
				return get(key, false /* read as raw */);
			};
			api.getJSON = function (key) {
				return get(key, true /* read as json */);
			};
			api.remove = function (key, attributes) {
				set(key, '', extend(attributes, {
					expires: -1
				}));
			};
	
			api.defaults = {};
	
			api.withConverter = init;
	
			return api;
		}
	
		return init(function () {});
	}));


/***/ }),

/***/ 30:
/*!******************************!*\
  !*** ./~/process/browser.js ***!
  \******************************/
/***/ (function(module, exports) {

	// shim for using process in browser
	var process = module.exports = {};
	
	// cached from whatever global is present so that test runners that stub it
	// don't break things.  But we need to wrap it in a try catch in case it is
	// wrapped in strict mode code which doesn't define any globals.  It's inside a
	// function because try/catches deoptimize in certain engines.
	
	var cachedSetTimeout;
	var cachedClearTimeout;
	
	function defaultSetTimout() {
	    throw new Error('setTimeout has not been defined');
	}
	function defaultClearTimeout () {
	    throw new Error('clearTimeout has not been defined');
	}
	(function () {
	    try {
	        if (typeof setTimeout === 'function') {
	            cachedSetTimeout = setTimeout;
	        } else {
	            cachedSetTimeout = defaultSetTimout;
	        }
	    } catch (e) {
	        cachedSetTimeout = defaultSetTimout;
	    }
	    try {
	        if (typeof clearTimeout === 'function') {
	            cachedClearTimeout = clearTimeout;
	        } else {
	            cachedClearTimeout = defaultClearTimeout;
	        }
	    } catch (e) {
	        cachedClearTimeout = defaultClearTimeout;
	    }
	} ())
	function runTimeout(fun) {
	    if (cachedSetTimeout === setTimeout) {
	        //normal enviroments in sane situations
	        return setTimeout(fun, 0);
	    }
	    // if setTimeout wasn't available but was latter defined
	    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
	        cachedSetTimeout = setTimeout;
	        return setTimeout(fun, 0);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedSetTimeout(fun, 0);
	    } catch(e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
	            return cachedSetTimeout.call(null, fun, 0);
	        } catch(e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
	            return cachedSetTimeout.call(this, fun, 0);
	        }
	    }
	
	
	}
	function runClearTimeout(marker) {
	    if (cachedClearTimeout === clearTimeout) {
	        //normal enviroments in sane situations
	        return clearTimeout(marker);
	    }
	    // if clearTimeout wasn't available but was latter defined
	    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
	        cachedClearTimeout = clearTimeout;
	        return clearTimeout(marker);
	    }
	    try {
	        // when when somebody has screwed with setTimeout but no I.E. maddness
	        return cachedClearTimeout(marker);
	    } catch (e){
	        try {
	            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
	            return cachedClearTimeout.call(null, marker);
	        } catch (e){
	            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
	            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
	            return cachedClearTimeout.call(this, marker);
	        }
	    }
	
	
	
	}
	var queue = [];
	var draining = false;
	var currentQueue;
	var queueIndex = -1;
	
	function cleanUpNextTick() {
	    if (!draining || !currentQueue) {
	        return;
	    }
	    draining = false;
	    if (currentQueue.length) {
	        queue = currentQueue.concat(queue);
	    } else {
	        queueIndex = -1;
	    }
	    if (queue.length) {
	        drainQueue();
	    }
	}
	
	function drainQueue() {
	    if (draining) {
	        return;
	    }
	    var timeout = runTimeout(cleanUpNextTick);
	    draining = true;
	
	    var len = queue.length;
	    while(len) {
	        currentQueue = queue;
	        queue = [];
	        while (++queueIndex < len) {
	            if (currentQueue) {
	                currentQueue[queueIndex].run();
	            }
	        }
	        queueIndex = -1;
	        len = queue.length;
	    }
	    currentQueue = null;
	    draining = false;
	    runClearTimeout(timeout);
	}
	
	process.nextTick = function (fun) {
	    var args = new Array(arguments.length - 1);
	    if (arguments.length > 1) {
	        for (var i = 1; i < arguments.length; i++) {
	            args[i - 1] = arguments[i];
	        }
	    }
	    queue.push(new Item(fun, args));
	    if (queue.length === 1 && !draining) {
	        runTimeout(drainQueue);
	    }
	};
	
	// v8 likes predictible objects
	function Item(fun, array) {
	    this.fun = fun;
	    this.array = array;
	}
	Item.prototype.run = function () {
	    this.fun.apply(null, this.array);
	};
	process.title = 'browser';
	process.browser = true;
	process.env = {};
	process.argv = [];
	process.version = ''; // empty string to avoid regexp issues
	process.versions = {};
	
	function noop() {}
	
	process.on = noop;
	process.addListener = noop;
	process.once = noop;
	process.off = noop;
	process.removeListener = noop;
	process.removeAllListeners = noop;
	process.emit = noop;
	process.prependListener = noop;
	process.prependOnceListener = noop;
	
	process.listeners = function (name) { return [] }
	
	process.binding = function (name) {
	    throw new Error('process.binding is not supported');
	};
	
	process.cwd = function () { return '/' };
	process.chdir = function (dir) {
	    throw new Error('process.chdir is not supported');
	};
	process.umask = function() { return 0; };


/***/ }),

/***/ 2056:
/*!****************************************!*\
  !*** ./~/setimmediate/setImmediate.js ***!
  \****************************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global, process) {(function (global, undefined) {
	    "use strict";
	
	    if (global.setImmediate) {
	        return;
	    }
	
	    var nextHandle = 1; // Spec says greater than zero
	    var tasksByHandle = {};
	    var currentlyRunningATask = false;
	    var doc = global.document;
	    var registerImmediate;
	
	    function setImmediate(callback) {
	      // Callback can either be a function or a string
	      if (typeof callback !== "function") {
	        callback = new Function("" + callback);
	      }
	      // Copy function arguments
	      var args = new Array(arguments.length - 1);
	      for (var i = 0; i < args.length; i++) {
	          args[i] = arguments[i + 1];
	      }
	      // Store and register the task
	      var task = { callback: callback, args: args };
	      tasksByHandle[nextHandle] = task;
	      registerImmediate(nextHandle);
	      return nextHandle++;
	    }
	
	    function clearImmediate(handle) {
	        delete tasksByHandle[handle];
	    }
	
	    function run(task) {
	        var callback = task.callback;
	        var args = task.args;
	        switch (args.length) {
	        case 0:
	            callback();
	            break;
	        case 1:
	            callback(args[0]);
	            break;
	        case 2:
	            callback(args[0], args[1]);
	            break;
	        case 3:
	            callback(args[0], args[1], args[2]);
	            break;
	        default:
	            callback.apply(undefined, args);
	            break;
	        }
	    }
	
	    function runIfPresent(handle) {
	        // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
	        // So if we're currently running a task, we'll need to delay this invocation.
	        if (currentlyRunningATask) {
	            // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
	            // "too much recursion" error.
	            setTimeout(runIfPresent, 0, handle);
	        } else {
	            var task = tasksByHandle[handle];
	            if (task) {
	                currentlyRunningATask = true;
	                try {
	                    run(task);
	                } finally {
	                    clearImmediate(handle);
	                    currentlyRunningATask = false;
	                }
	            }
	        }
	    }
	
	    function installNextTickImplementation() {
	        registerImmediate = function(handle) {
	            process.nextTick(function () { runIfPresent(handle); });
	        };
	    }
	
	    function canUsePostMessage() {
	        // The test against `importScripts` prevents this implementation from being installed inside a web worker,
	        // where `global.postMessage` means something completely different and can't be used for this purpose.
	        if (global.postMessage && !global.importScripts) {
	            var postMessageIsAsynchronous = true;
	            var oldOnMessage = global.onmessage;
	            global.onmessage = function() {
	                postMessageIsAsynchronous = false;
	            };
	            global.postMessage("", "*");
	            global.onmessage = oldOnMessage;
	            return postMessageIsAsynchronous;
	        }
	    }
	
	    function installPostMessageImplementation() {
	        // Installs an event handler on `global` for the `message` event: see
	        // * https://developer.mozilla.org/en/DOM/window.postMessage
	        // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages
	
	        var messagePrefix = "setImmediate$" + Math.random() + "$";
	        var onGlobalMessage = function(event) {
	            if (event.source === global &&
	                typeof event.data === "string" &&
	                event.data.indexOf(messagePrefix) === 0) {
	                runIfPresent(+event.data.slice(messagePrefix.length));
	            }
	        };
	
	        if (global.addEventListener) {
	            global.addEventListener("message", onGlobalMessage, false);
	        } else {
	            global.attachEvent("onmessage", onGlobalMessage);
	        }
	
	        registerImmediate = function(handle) {
	            global.postMessage(messagePrefix + handle, "*");
	        };
	    }
	
	    function installMessageChannelImplementation() {
	        var channel = new MessageChannel();
	        channel.port1.onmessage = function(event) {
	            var handle = event.data;
	            runIfPresent(handle);
	        };
	
	        registerImmediate = function(handle) {
	            channel.port2.postMessage(handle);
	        };
	    }
	
	    function installReadyStateChangeImplementation() {
	        var html = doc.documentElement;
	        registerImmediate = function(handle) {
	            // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
	            // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
	            var script = doc.createElement("script");
	            script.onreadystatechange = function () {
	                runIfPresent(handle);
	                script.onreadystatechange = null;
	                html.removeChild(script);
	                script = null;
	            };
	            html.appendChild(script);
	        };
	    }
	
	    function installSetTimeoutImplementation() {
	        registerImmediate = function(handle) {
	            setTimeout(runIfPresent, 0, handle);
	        };
	    }
	
	    // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
	    var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
	    attachTo = attachTo && attachTo.setTimeout ? attachTo : global;
	
	    // Don't get fooled by e.g. browserify environments.
	    if ({}.toString.call(global.process) === "[object process]") {
	        // For Node.js before 0.9
	        installNextTickImplementation();
	
	    } else if (canUsePostMessage()) {
	        // For non-IE10 modern browsers
	        installPostMessageImplementation();
	
	    } else if (global.MessageChannel) {
	        // For web workers, where supported
	        installMessageChannelImplementation();
	
	    } else if (doc && "onreadystatechange" in doc.createElement("script")) {
	        // For IE 6–8
	        installReadyStateChangeImplementation();
	
	    } else {
	        // For older browsers
	        installSetTimeoutImplementation();
	    }
	
	    attachTo.setImmediate = setImmediate;
	    attachTo.clearImmediate = clearImmediate;
	}(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self));
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }()), __webpack_require__(/*! ./../process/browser.js */ 30)))

/***/ }),

/***/ 2062:
/*!*************************************!*\
  !*** ./~/timers-browserify/main.js ***!
  \*************************************/
/***/ (function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {var scope = (typeof global !== "undefined" && global) ||
	            (typeof self !== "undefined" && self) ||
	            window;
	var apply = Function.prototype.apply;
	
	// DOM APIs, for completeness
	
	exports.setTimeout = function() {
	  return new Timeout(apply.call(setTimeout, scope, arguments), clearTimeout);
	};
	exports.setInterval = function() {
	  return new Timeout(apply.call(setInterval, scope, arguments), clearInterval);
	};
	exports.clearTimeout =
	exports.clearInterval = function(timeout) {
	  if (timeout) {
	    timeout.close();
	  }
	};
	
	function Timeout(id, clearFn) {
	  this._id = id;
	  this._clearFn = clearFn;
	}
	Timeout.prototype.unref = Timeout.prototype.ref = function() {};
	Timeout.prototype.close = function() {
	  this._clearFn.call(scope, this._id);
	};
	
	// Does not start the time, just sets up the members needed.
	exports.enroll = function(item, msecs) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = msecs;
	};
	
	exports.unenroll = function(item) {
	  clearTimeout(item._idleTimeoutId);
	  item._idleTimeout = -1;
	};
	
	exports._unrefActive = exports.active = function(item) {
	  clearTimeout(item._idleTimeoutId);
	
	  var msecs = item._idleTimeout;
	  if (msecs >= 0) {
	    item._idleTimeoutId = setTimeout(function onTimeout() {
	      if (item._onTimeout)
	        item._onTimeout();
	    }, msecs);
	  }
	};
	
	// setimmediate attaches itself to the global object
	__webpack_require__(/*! setimmediate */ 2056);
	// On some exotic environments, it's not clear which object `setimmediate` was
	// able to install onto.  Search each possibility in the same order as the
	// `setimmediate` library.
	exports.setImmediate = (typeof self !== "undefined" && self.setImmediate) ||
	                       (typeof global !== "undefined" && global.setImmediate) ||
	                       (this && this.setImmediate);
	exports.clearImmediate = (typeof self !== "undefined" && self.clearImmediate) ||
	                         (typeof global !== "undefined" && global.clearImmediate) ||
	                         (this && this.clearImmediate);
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ })

/******/ });


// WEBPACK FOOTER //
// vendors.e1bbf89a8d0410341b24.js